(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { isRunningLocalPartnerApi as IF, getPartnerDevApiHeaders as $F, WidgetContextProvider as EF, makeExecuteQuery as TF, makeUseLazyQuery as OF, makeUseQuery as RF, makeUseMutation as DF, validateApiHostName as PN, useTracking as hn, useWidgetContext as un, hasDownstreamApiForbiddenError as Ph, hasDownstreamApiAuthorizationError as Ah, DisplayErrors as _n, useCopyWithDelay as si, defaultDateFormat as lt, displayAttributeValue as AN, OAuthSettings as mc, useData as Lh, KlaviyoSubscribeSetting as PF, isDownstreamApiAuthorizationError as AF, isDownstreamApiPermissionError as LF, capitalizeFirstCharacter as pc, hasDownstreamApiTooManyRequestsError as VF, hasDownstreamApiPermissionError as LN, hasDownstreamApiNotFoundError as Zo, getCountryNameFromCountryCode as zF } from "@dixa/partner-widget-integration-support";
export * from "@dixa/partner-widget-integration-support";
import xe, { useMemo as Zn, useState as oe, useEffect as qe, useRef as ha, useCallback as ft, useReducer as MF, useLayoutEffect as UF, isValidElement as BF, createElement as qF, Fragment as HF } from "react";
import { Modal as St, ModalHead as Nt, ModalBody as jt, ModalFoot as Et, Text as A, FlexBox as _, Spinner as cn, Icon as he, Tooltip as Je, List as He, Badge as zn, Button as qn, IconButton as lr, Tag as En, NavigationButton as Rt, Select as Dr, CollapseCard as pr, Box as Yn, FormGrid as Kt, FormField as en, FieldWrapper as Dn, InputText as Or, Textarea as Of, TagsInput as fc, Banner as hc, Divider as Vh, InputSelectionList as yi, SelectionList as pt, FieldText as fr, FieldTextarea as WF, CopyToClipboardButton as KF, Avatar as zh, Timestamp as GF, Attachment as YF, Switch as Rf, FieldLabel as JF, EmptyState as Mh, Image as es, Table as Jn, Checkbox as Ty, TextWithHighlight as QF, ErrorBoundaryContext as VN, FieldSwitch as zN } from "@dixa/lib-shared-habla";
import { ApolloLink as Uh, Observable as MN, ApolloClient as XF, InMemoryCache as ZF, createHttpLink as eI, ApolloProvider as nI, useApolloClient as tI, ApolloConsumer as rI, gql as Si, NetworkStatus as hr, isApolloError as UN, ApolloError as iI, useQuery as aI, useMutation as Oy } from "@apollo/client";
import oI from "cross-fetch";
import { config as Ho } from "lib-shared-backend-config";
import ht from "classnames";
import Tn from "moment";
import { __rest as sI, __assign as tu } from "tslib";
import "moment-timezone";
import { useLocation as lI } from "react-router-dom";
function Bh(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Is = { exports: {} }, Wa = {};
var Ry;
function cI() {
  if (Ry) return Wa;
  Ry = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Wa.Fragment = t, Wa.jsx = s, Wa.jsxs = s, Wa;
}
var Ka = {};
var Dy;
function uI() {
  return Dy || (Dy = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c, P));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    Ka.Fragment = i, Ka.jsx = Un, Ka.jsxs = Bn;
  }()), Ka;
}
var Py;
function dI() {
  return Py || (Py = 1, process.env.NODE_ENV === "production" ? Is.exports = cI() : Is.exports = uI()), Is.exports;
}
var ze = dI();
function BN(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: mI } = Object.prototype, { getPrototypeOf: qh } = Object, { iterator: vc, toStringTag: qN } = Symbol, yc = /* @__PURE__ */ ((e) => (n) => {
  const t = mI.call(n);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Pr = (e) => (e = e.toLowerCase(), (n) => yc(n) === e), gc = (e) => (n) => typeof n === e, { isArray: Ia } = Array, xa = gc("undefined");
function ns(e) {
  return e !== null && !xa(e) && e.constructor !== null && !xa(e.constructor) && Qt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const HN = Pr("ArrayBuffer");
function pI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && HN(e.buffer), n;
}
const fI = gc("string"), Qt = gc("function"), WN = gc("number"), ts = (e) => e !== null && typeof e == "object", hI = (e) => e === !0 || e === !1, bl = (e) => {
  if (yc(e) !== "object")
    return !1;
  const n = qh(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(qN in e) && !(vc in e);
}, vI = (e) => {
  if (!ts(e) || ns(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, yI = Pr("Date"), gI = Pr("File"), kI = Pr("Blob"), bI = Pr("FileList"), _I = (e) => ts(e) && Qt(e.pipe), xI = (e) => {
  let n;
  return e && (typeof FormData == "function" && e instanceof FormData || Qt(e.append) && ((n = yc(e)) === "formdata" || // detect form-data instance
  n === "object" && Qt(e.toString) && e.toString() === "[object FormData]"));
}, SI = Pr("URLSearchParams"), [NI, jI, wI, CI] = ["ReadableStream", "Request", "Response", "Headers"].map(Pr), FI = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function rs(e, n, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Ia(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (ns(e))
      return;
    const o = t ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function KN(e, n) {
  if (ns(e))
    return null;
  n = n.toLowerCase();
  const t = Object.keys(e);
  let i = t.length, a;
  for (; i-- > 0; )
    if (a = t[i], n === a.toLowerCase())
      return a;
  return null;
}
const Di = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, GN = (e) => !xa(e) && e !== Di;
function Df() {
  const { caseless: e, skipUndefined: n } = GN(this) && this || {}, t = {}, i = (a, o) => {
    const s = e && KN(t, o) || o;
    bl(t[s]) && bl(a) ? t[s] = Df(t[s], a) : bl(a) ? t[s] = Df({}, a) : Ia(a) ? t[s] = a.slice() : (!n || !xa(a)) && (t[s] = a);
  };
  for (let a = 0, o = arguments.length; a < o; a++)
    arguments[a] && rs(arguments[a], i);
  return t;
}
const II = (e, n, t, { allOwnKeys: i } = {}) => (rs(n, (a, o) => {
  t && Qt(a) ? e[o] = BN(a, t) : e[o] = a;
}, { allOwnKeys: i }), e), $I = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), EI = (e, n, t, i) => {
  e.prototype = Object.create(n.prototype, i), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: n.prototype
  }), t && Object.assign(e.prototype, t);
}, TI = (e, n, t, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = t !== !1 && qh(e);
  } while (e && (!t || t(e, n)) && e !== Object.prototype);
  return n;
}, OI = (e, n, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= n.length;
  const i = e.indexOf(n, t);
  return i !== -1 && i === t;
}, RI = (e) => {
  if (!e) return null;
  if (Ia(e)) return e;
  let n = e.length;
  if (!WN(n)) return null;
  const t = new Array(n);
  for (; n-- > 0; )
    t[n] = e[n];
  return t;
}, DI = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && qh(Uint8Array)), PI = (e, n) => {
  const i = (e && e[vc]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, AI = (e, n) => {
  let t;
  const i = [];
  for (; (t = e.exec(n)) !== null; )
    i.push(t);
  return i;
}, LI = Pr("HTMLFormElement"), VI = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, i, a) {
    return i.toUpperCase() + a;
  }
), Ay = (({ hasOwnProperty: e }) => (n, t) => e.call(n, t))(Object.prototype), zI = Pr("RegExp"), YN = (e, n) => {
  const t = Object.getOwnPropertyDescriptors(e), i = {};
  rs(t, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, MI = (e) => {
  YN(e, (n, t) => {
    if (Qt(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const i = e[t];
    if (Qt(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, UI = (e, n) => {
  const t = {}, i = (a) => {
    a.forEach((o) => {
      t[o] = !0;
    });
  };
  return Ia(e) ? i(e) : i(String(e).split(n)), t;
}, BI = () => {
}, qI = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function HI(e) {
  return !!(e && Qt(e.append) && e[qN] === "FormData" && e[vc]);
}
const WI = (e) => {
  const n = new Array(10), t = (i, a) => {
    if (ts(i)) {
      if (n.indexOf(i) >= 0)
        return;
      if (ns(i))
        return i;
      if (!("toJSON" in i)) {
        n[a] = i;
        const o = Ia(i) ? [] : {};
        return rs(i, (s, l) => {
          const u = t(s, a + 1);
          !xa(u) && (o[l] = u);
        }), n[a] = void 0, o;
      }
    }
    return i;
  };
  return t(e, 0);
}, KI = Pr("AsyncFunction"), GI = (e) => e && (ts(e) || Qt(e)) && Qt(e.then) && Qt(e.catch), JN = ((e, n) => e ? setImmediate : n ? ((t, i) => (Di.addEventListener("message", ({ source: a, data: o }) => {
  a === Di && o === t && i.length && i.shift()();
}, !1), (a) => {
  i.push(a), Di.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  Qt(Di.postMessage)
), YI = typeof queueMicrotask < "u" ? queueMicrotask.bind(Di) : typeof process < "u" && process.nextTick || JN, JI = (e) => e != null && Qt(e[vc]), ye = {
  isArray: Ia,
  isArrayBuffer: HN,
  isBuffer: ns,
  isFormData: xI,
  isArrayBufferView: pI,
  isString: fI,
  isNumber: WN,
  isBoolean: hI,
  isObject: ts,
  isPlainObject: bl,
  isEmptyObject: vI,
  isReadableStream: NI,
  isRequest: jI,
  isResponse: wI,
  isHeaders: CI,
  isUndefined: xa,
  isDate: yI,
  isFile: gI,
  isBlob: kI,
  isRegExp: zI,
  isFunction: Qt,
  isStream: _I,
  isURLSearchParams: SI,
  isTypedArray: DI,
  isFileList: bI,
  forEach: rs,
  merge: Df,
  extend: II,
  trim: FI,
  stripBOM: $I,
  inherits: EI,
  toFlatObject: TI,
  kindOf: yc,
  kindOfTest: Pr,
  endsWith: OI,
  toArray: RI,
  forEachEntry: PI,
  matchAll: AI,
  isHTMLForm: LI,
  hasOwnProperty: Ay,
  hasOwnProp: Ay,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: YN,
  freezeMethods: MI,
  toObjectSet: UI,
  toCamelCase: VI,
  noop: BI,
  toFiniteNumber: qI,
  findKey: KN,
  global: Di,
  isContextDefined: GN,
  isSpecCompliantForm: HI,
  toJSONObject: WI,
  isAsyncFn: KI,
  isThenable: GI,
  setImmediate: JN,
  asap: YI,
  isIterable: JI
};
function bn(e, n, t, i, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", n && (this.code = n), t && (this.config = t), i && (this.request = i), a && (this.response = a, this.status = a.status ? a.status : null);
}
ye.inherits(bn, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: ye.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const QN = bn.prototype, XN = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  XN[e] = { value: e };
});
Object.defineProperties(bn, XN);
Object.defineProperty(QN, "isAxiosError", { value: !0 });
bn.from = (e, n, t, i, a, o) => {
  const s = Object.create(QN);
  ye.toFlatObject(e, s, function(d) {
    return d !== Error.prototype;
  }, (m) => m !== "isAxiosError");
  const l = e && e.message ? e.message : "Error", u = n == null && e ? e.code : n;
  return bn.call(s, l, u, t, i, a), e && s.cause == null && Object.defineProperty(s, "cause", { value: e, configurable: !0 }), s.name = e && e.name || "Error", o && Object.assign(s, o), s;
};
const QI = null;
function Pf(e) {
  return ye.isPlainObject(e) || ye.isArray(e);
}
function ZN(e) {
  return ye.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Ly(e, n, t) {
  return e ? e.concat(n).map(function(a, o) {
    return a = ZN(a), !t && o ? "[" + a + "]" : a;
  }).join(t ? "." : "") : n;
}
function XI(e) {
  return ye.isArray(e) && !e.some(Pf);
}
const ZI = ye.toFlatObject(ye, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function kc(e, n, t) {
  if (!ye.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), t = ye.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(S, N) {
    return !ye.isUndefined(N[S]);
  });
  const i = t.metaTokens, a = t.visitor || d, o = t.dots, s = t.indexes, u = (t.Blob || typeof Blob < "u" && Blob) && ye.isSpecCompliantForm(n);
  if (!ye.isFunction(a))
    throw new TypeError("visitor must be a function");
  function m(x) {
    if (x === null) return "";
    if (ye.isDate(x))
      return x.toISOString();
    if (ye.isBoolean(x))
      return x.toString();
    if (!u && ye.isBlob(x))
      throw new bn("Blob is not supported. Use a Buffer instead.");
    return ye.isArrayBuffer(x) || ye.isTypedArray(x) ? u && typeof Blob == "function" ? new Blob([x]) : Buffer.from(x) : x;
  }
  function d(x, S, N) {
    let j = x;
    if (x && !N && typeof x == "object") {
      if (ye.endsWith(S, "{}"))
        S = i ? S : S.slice(0, -2), x = JSON.stringify(x);
      else if (ye.isArray(x) && XI(x) || (ye.isFileList(x) || ye.endsWith(S, "[]")) && (j = ye.toArray(x)))
        return S = ZN(S), j.forEach(function(q, E) {
          !(ye.isUndefined(q) || q === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? Ly([S], E, o) : s === null ? S : S + "[]",
            m(q)
          );
        }), !1;
    }
    return Pf(x) ? !0 : (n.append(Ly(N, S, o), m(x)), !1);
  }
  const f = [], h = Object.assign(ZI, {
    defaultVisitor: d,
    convertValue: m,
    isVisitable: Pf
  });
  function v(x, S) {
    if (!ye.isUndefined(x)) {
      if (f.indexOf(x) !== -1)
        throw Error("Circular reference detected in " + S.join("."));
      f.push(x), ye.forEach(x, function(j, y) {
        (!(ye.isUndefined(j) || j === null) && a.call(
          n,
          j,
          ye.isString(y) ? y.trim() : y,
          S,
          h
        )) === !0 && v(j, S ? S.concat(y) : [y]);
      }), f.pop();
    }
  }
  if (!ye.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), n;
}
function Vy(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(i) {
    return n[i];
  });
}
function Hh(e, n) {
  this._pairs = [], e && kc(e, this, n);
}
const ej = Hh.prototype;
ej.append = function(n, t) {
  this._pairs.push([n, t]);
};
ej.toString = function(n) {
  const t = n ? function(i) {
    return n.call(this, i, Vy);
  } : Vy;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function e$(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function nj(e, n, t) {
  if (!n)
    return e;
  const i = t && t.encode || e$;
  ye.isFunction(t) && (t = {
    serialize: t
  });
  const a = t && t.serialize;
  let o;
  if (a ? o = a(n, t) : o = ye.isURLSearchParams(n) ? n.toString() : new Hh(n, t).toString(i), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class zy {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, t, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: t,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    ye.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const tj = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, n$ = typeof URLSearchParams < "u" ? URLSearchParams : Hh, t$ = typeof FormData < "u" ? FormData : null, r$ = typeof Blob < "u" ? Blob : null, i$ = {
  isBrowser: !0,
  classes: {
    URLSearchParams: n$,
    FormData: t$,
    Blob: r$
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Wh = typeof window < "u" && typeof document < "u", Af = typeof navigator == "object" && navigator || void 0, a$ = Wh && (!Af || ["ReactNative", "NativeScript", "NS"].indexOf(Af.product) < 0), o$ = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", s$ = Wh && window.location.href || "http://localhost", l$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Wh,
  hasStandardBrowserEnv: a$,
  hasStandardBrowserWebWorkerEnv: o$,
  navigator: Af,
  origin: s$
}, Symbol.toStringTag, { value: "Module" })), Ot = {
  ...l$,
  ...i$
};
function c$(e, n) {
  return kc(e, new Ot.classes.URLSearchParams(), {
    visitor: function(t, i, a, o) {
      return Ot.isNode && ye.isBuffer(t) ? (this.append(i, t.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
function u$(e) {
  return ye.matchAll(/\w+|\[(\w*)]/g, e).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function d$(e) {
  const n = {}, t = Object.keys(e);
  let i;
  const a = t.length;
  let o;
  for (i = 0; i < a; i++)
    o = t[i], n[o] = e[o];
  return n;
}
function rj(e) {
  function n(t, i, a, o) {
    let s = t[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), u = o >= t.length;
    return s = !s && ye.isArray(a) ? a.length : s, u ? (ye.hasOwnProp(a, s) ? a[s] = [a[s], i] : a[s] = i, !l) : ((!a[s] || !ye.isObject(a[s])) && (a[s] = []), n(t, i, a[s], o) && ye.isArray(a[s]) && (a[s] = d$(a[s])), !l);
  }
  if (ye.isFormData(e) && ye.isFunction(e.entries)) {
    const t = {};
    return ye.forEachEntry(e, (i, a) => {
      n(u$(i), a, t, 0);
    }), t;
  }
  return null;
}
function m$(e, n, t) {
  if (ye.isString(e))
    try {
      return (n || JSON.parse)(e), ye.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (t || JSON.stringify)(e);
}
const is = {
  transitional: tj,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(n, t) {
    const i = t.getContentType() || "", a = i.indexOf("application/json") > -1, o = ye.isObject(n);
    if (o && ye.isHTMLForm(n) && (n = new FormData(n)), ye.isFormData(n))
      return a ? JSON.stringify(rj(n)) : n;
    if (ye.isArrayBuffer(n) || ye.isBuffer(n) || ye.isStream(n) || ye.isFile(n) || ye.isBlob(n) || ye.isReadableStream(n))
      return n;
    if (ye.isArrayBufferView(n))
      return n.buffer;
    if (ye.isURLSearchParams(n))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let l;
    if (o) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return c$(n, this.formSerializer).toString();
      if ((l = ye.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return kc(
          l ? { "files[]": n } : n,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return o || a ? (t.setContentType("application/json", !1), m$(n)) : n;
  }],
  transformResponse: [function(n) {
    const t = this.transitional || is.transitional, i = t && t.forcedJSONParsing, a = this.responseType === "json";
    if (ye.isResponse(n) || ye.isReadableStream(n))
      return n;
    if (n && ye.isString(n) && (i && !this.responseType || a)) {
      const s = !(t && t.silentJSONParsing) && a;
      try {
        return JSON.parse(n, this.parseReviver);
      } catch (l) {
        if (s)
          throw l.name === "SyntaxError" ? bn.from(l, bn.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Ot.classes.FormData,
    Blob: Ot.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
ye.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  is.headers[e] = {};
});
const p$ = ye.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), f$ = (e) => {
  const n = {};
  let t, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), t = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!t || n[t] && p$[t]) && (t === "set-cookie" ? n[t] ? n[t].push(i) : n[t] = [i] : n[t] = n[t] ? n[t] + ", " + i : i);
  }), n;
}, My = Symbol("internals");
function Ga(e) {
  return e && String(e).trim().toLowerCase();
}
function _l(e) {
  return e === !1 || e == null ? e : ye.isArray(e) ? e.map(_l) : String(e);
}
function h$(e) {
  const n = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = t.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const v$ = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function ru(e, n, t, i, a) {
  if (ye.isFunction(i))
    return i.call(this, n, t);
  if (a && (n = t), !!ye.isString(n)) {
    if (ye.isString(i))
      return n.indexOf(i) !== -1;
    if (ye.isRegExp(i))
      return i.test(n);
  }
}
function y$(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, t, i) => t.toUpperCase() + i);
}
function g$(e, n) {
  const t = ye.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + t, {
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Xt = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, t, i) {
    const a = this;
    function o(l, u, m) {
      const d = Ga(u);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const f = ye.findKey(a, d);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || u] = _l(l));
    }
    const s = (l, u) => ye.forEach(l, (m, d) => o(m, d, u));
    if (ye.isPlainObject(n) || n instanceof this.constructor)
      s(n, t);
    else if (ye.isString(n) && (n = n.trim()) && !v$(n))
      s(f$(n), t);
    else if (ye.isObject(n) && ye.isIterable(n)) {
      let l = {}, u, m;
      for (const d of n) {
        if (!ye.isArray(d))
          throw TypeError("Object iterator must return a key-value pair");
        l[m = d[0]] = (u = l[m]) ? ye.isArray(u) ? [...u, d[1]] : [u, d[1]] : d[1];
      }
      s(l, t);
    } else
      n != null && o(t, n, i);
    return this;
  }
  get(n, t) {
    if (n = Ga(n), n) {
      const i = ye.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!t)
          return a;
        if (t === !0)
          return h$(a);
        if (ye.isFunction(t))
          return t.call(this, a, i);
        if (ye.isRegExp(t))
          return t.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, t) {
    if (n = Ga(n), n) {
      const i = ye.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!t || ru(this, this[i], i, t)));
    }
    return !1;
  }
  delete(n, t) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ga(s), s) {
        const l = ye.findKey(i, s);
        l && (!t || ru(i, i[l], l, t)) && (delete i[l], a = !0);
      }
    }
    return ye.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const t = Object.keys(this);
    let i = t.length, a = !1;
    for (; i--; ) {
      const o = t[i];
      (!n || ru(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const t = this, i = {};
    return ye.forEach(this, (a, o) => {
      const s = ye.findKey(i, o);
      if (s) {
        t[s] = _l(a), delete t[o];
        return;
      }
      const l = n ? y$(o) : String(o).trim();
      l !== o && delete t[o], t[l] = _l(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const t = /* @__PURE__ */ Object.create(null);
    return ye.forEach(this, (i, a) => {
      i != null && i !== !1 && (t[a] = n && ye.isArray(i) ? i.join(", ") : i);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, t]) => n + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...t) {
    const i = new this(n);
    return t.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[My] = this[My] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ga(s);
      i[l] || (g$(a, s), i[l] = !0);
    }
    return ye.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Xt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
ye.reduceDescriptors(Xt.prototype, ({ value: e }, n) => {
  let t = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[t] = i;
    }
  };
});
ye.freezeMethods(Xt);
function iu(e, n) {
  const t = this || is, i = n || t, a = Xt.from(i.headers);
  let o = i.data;
  return ye.forEach(e, function(l) {
    o = l.call(t, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function ij(e) {
  return !!(e && e.__CANCEL__);
}
function $a(e, n, t) {
  bn.call(this, e ?? "canceled", bn.ERR_CANCELED, n, t), this.name = "CanceledError";
}
ye.inherits($a, bn, {
  __CANCEL__: !0
});
function aj(e, n, t) {
  const i = t.config.validateStatus;
  !t.status || !i || i(t.status) ? e(t) : n(new bn(
    "Request failed with status code " + t.status,
    [bn.ERR_BAD_REQUEST, bn.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function k$(e) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return n && n[1] || "";
}
function b$(e, n) {
  e = e || 10;
  const t = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(u) {
    const m = Date.now(), d = i[o];
    s || (s = m), t[a] = u, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += t[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const v = d && m - d;
    return v ? Math.round(h * 1e3 / v) : void 0;
  };
}
function _$(e, n) {
  let t = 0, i = 1e3 / n, a, o;
  const s = (m, d = Date.now()) => {
    t = d, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const d = Date.now(), f = d - t;
    f >= i ? s(m, d) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const Vl = (e, n, t = 3) => {
  let i = 0;
  const a = b$(50, 250);
  return _$((o) => {
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, u = s - i, m = a(u), d = s <= l;
    i = s;
    const f = {
      loaded: s,
      total: l,
      progress: l ? s / l : void 0,
      bytes: u,
      rate: m || void 0,
      estimated: m && l && d ? (l - s) / m : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, t);
}, Uy = (e, n) => {
  const t = e != null;
  return [(i) => n[0]({
    lengthComputable: t,
    total: e,
    loaded: i
  }), n[1]];
}, By = (e) => (...n) => ye.asap(() => e(...n)), x$ = Ot.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (t) => (t = new URL(t, Ot.origin), e.protocol === t.protocol && e.host === t.host && (n || e.port === t.port)))(
  new URL(Ot.origin),
  Ot.navigator && /(msie|trident)/i.test(Ot.navigator.userAgent)
) : () => !0, S$ = Ot.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, t, i, a, o) {
      const s = [e + "=" + encodeURIComponent(n)];
      ye.isNumber(t) && s.push("expires=" + new Date(t).toGMTString()), ye.isString(i) && s.push("path=" + i), ye.isString(a) && s.push("domain=" + a), o === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function N$(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function j$(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
function oj(e, n, t) {
  let i = !N$(n);
  return e && (i || t == !1) ? j$(e, n) : n;
}
const qy = (e) => e instanceof Xt ? { ...e } : e;
function qi(e, n) {
  n = n || {};
  const t = {};
  function i(m, d, f, h) {
    return ye.isPlainObject(m) && ye.isPlainObject(d) ? ye.merge.call({ caseless: h }, m, d) : ye.isPlainObject(d) ? ye.merge({}, d) : ye.isArray(d) ? d.slice() : d;
  }
  function a(m, d, f, h) {
    if (ye.isUndefined(d)) {
      if (!ye.isUndefined(m))
        return i(void 0, m, f, h);
    } else return i(m, d, f, h);
  }
  function o(m, d) {
    if (!ye.isUndefined(d))
      return i(void 0, d);
  }
  function s(m, d) {
    if (ye.isUndefined(d)) {
      if (!ye.isUndefined(m))
        return i(void 0, m);
    } else return i(void 0, d);
  }
  function l(m, d, f) {
    if (f in n)
      return i(m, d);
    if (f in e)
      return i(void 0, m);
  }
  const u = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: l,
    headers: (m, d, f) => a(qy(m), qy(d), f, !0)
  };
  return ye.forEach(Object.keys({ ...e, ...n }), function(d) {
    const f = u[d] || a, h = f(e[d], n[d], d);
    ye.isUndefined(h) && f !== l || (t[d] = h);
  }), t;
}
const sj = (e) => {
  const n = qi({}, e);
  let { data: t, withXSRFToken: i, xsrfHeaderName: a, xsrfCookieName: o, headers: s, auth: l } = n;
  if (n.headers = s = Xt.from(s), n.url = nj(oj(n.baseURL, n.url, n.allowAbsoluteUrls), e.params, e.paramsSerializer), l && s.set(
    "Authorization",
    "Basic " + btoa((l.username || "") + ":" + (l.password ? unescape(encodeURIComponent(l.password)) : ""))
  ), ye.isFormData(t)) {
    if (Ot.hasStandardBrowserEnv || Ot.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if (ye.isFunction(t.getHeaders)) {
      const u = t.getHeaders(), m = ["content-type", "content-length"];
      Object.entries(u).forEach(([d, f]) => {
        m.includes(d.toLowerCase()) && s.set(d, f);
      });
    }
  }
  if (Ot.hasStandardBrowserEnv && (i && ye.isFunction(i) && (i = i(n)), i || i !== !1 && x$(n.url))) {
    const u = a && o && S$.read(o);
    u && s.set(a, u);
  }
  return n;
}, w$ = typeof XMLHttpRequest < "u", C$ = w$ && function(e) {
  return new Promise(function(t, i) {
    const a = sj(e);
    let o = a.data;
    const s = Xt.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: u, onDownloadProgress: m } = a, d, f, h, v, x;
    function S() {
      v && v(), x && x(), a.cancelToken && a.cancelToken.unsubscribe(d), a.signal && a.signal.removeEventListener("abort", d);
    }
    let N = new XMLHttpRequest();
    N.open(a.method.toUpperCase(), a.url, !0), N.timeout = a.timeout;
    function j() {
      if (!N)
        return;
      const q = Xt.from(
        "getAllResponseHeaders" in N && N.getAllResponseHeaders()
      ), C = {
        data: !l || l === "text" || l === "json" ? N.responseText : N.response,
        status: N.status,
        statusText: N.statusText,
        headers: q,
        config: e,
        request: N
      };
      aj(function(U) {
        t(U), S();
      }, function(U) {
        i(U), S();
      }, C), N = null;
    }
    "onloadend" in N ? N.onloadend = j : N.onreadystatechange = function() {
      !N || N.readyState !== 4 || N.status === 0 && !(N.responseURL && N.responseURL.indexOf("file:") === 0) || setTimeout(j);
    }, N.onabort = function() {
      N && (i(new bn("Request aborted", bn.ECONNABORTED, e, N)), N = null);
    }, N.onerror = function(E) {
      const C = E && E.message ? E.message : "Network Error", T = new bn(C, bn.ERR_NETWORK, e, N);
      T.event = E || null, i(T), N = null;
    }, N.ontimeout = function() {
      let E = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const C = a.transitional || tj;
      a.timeoutErrorMessage && (E = a.timeoutErrorMessage), i(new bn(
        E,
        C.clarifyTimeoutError ? bn.ETIMEDOUT : bn.ECONNABORTED,
        e,
        N
      )), N = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in N && ye.forEach(s.toJSON(), function(E, C) {
      N.setRequestHeader(C, E);
    }), ye.isUndefined(a.withCredentials) || (N.withCredentials = !!a.withCredentials), l && l !== "json" && (N.responseType = a.responseType), m && ([h, x] = Vl(m, !0), N.addEventListener("progress", h)), u && N.upload && ([f, v] = Vl(u), N.upload.addEventListener("progress", f), N.upload.addEventListener("loadend", v)), (a.cancelToken || a.signal) && (d = (q) => {
      N && (i(!q || q.type ? new $a(null, e, N) : q), N.abort(), N = null);
    }, a.cancelToken && a.cancelToken.subscribe(d), a.signal && (a.signal.aborted ? d() : a.signal.addEventListener("abort", d)));
    const y = k$(a.url);
    if (y && Ot.protocols.indexOf(y) === -1) {
      i(new bn("Unsupported protocol " + y + ":", bn.ERR_BAD_REQUEST, e));
      return;
    }
    N.send(o || null);
  });
}, F$ = (e, n) => {
  const { length: t } = e = e ? e.filter(Boolean) : [];
  if (n || t) {
    let i = new AbortController(), a;
    const o = function(m) {
      if (!a) {
        a = !0, l();
        const d = m instanceof Error ? m : this.reason;
        i.abort(d instanceof bn ? d : new $a(d instanceof Error ? d.message : d));
      }
    };
    let s = n && setTimeout(() => {
      s = null, o(new bn(`timeout ${n} of ms exceeded`, bn.ETIMEDOUT));
    }, n);
    const l = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((m) => {
        m.unsubscribe ? m.unsubscribe(o) : m.removeEventListener("abort", o);
      }), e = null);
    };
    e.forEach((m) => m.addEventListener("abort", o));
    const { signal: u } = i;
    return u.unsubscribe = () => ye.asap(l), u;
  }
}, I$ = function* (e, n) {
  let t = e.byteLength;
  if (t < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < t; )
    a = i + n, yield e.slice(i, a), i = a;
}, $$ = async function* (e, n) {
  for await (const t of E$(e))
    yield* I$(t, n);
}, E$ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: t, value: i } = await n.read();
      if (t)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, Hy = (e, n, t, i) => {
  const a = $$(e, n);
  let o = 0, s, l = (u) => {
    s || (s = !0, i && i(u));
  };
  return new ReadableStream({
    async pull(u) {
      try {
        const { done: m, value: d } = await a.next();
        if (m) {
          l(), u.close();
          return;
        }
        let f = d.byteLength;
        if (t) {
          let h = o += f;
          t(h);
        }
        u.enqueue(new Uint8Array(d));
      } catch (m) {
        throw l(m), m;
      }
    },
    cancel(u) {
      return l(u), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Wy = 64 * 1024, { isFunction: $s } = ye, T$ = (({ Request: e, Response: n }) => ({
  Request: e,
  Response: n
}))(ye.global), {
  ReadableStream: Ky,
  TextEncoder: Gy
} = ye.global, Yy = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, O$ = (e) => {
  e = ye.merge.call({
    skipUndefined: !0
  }, T$, e);
  const { fetch: n, Request: t, Response: i } = e, a = n ? $s(n) : typeof fetch == "function", o = $s(t), s = $s(i);
  if (!a)
    return !1;
  const l = a && $s(Ky), u = a && (typeof Gy == "function" ? /* @__PURE__ */ ((x) => (S) => x.encode(S))(new Gy()) : async (x) => new Uint8Array(await new t(x).arrayBuffer())), m = o && l && Yy(() => {
    let x = !1;
    const S = new t(Ot.origin, {
      body: new Ky(),
      method: "POST",
      get duplex() {
        return x = !0, "half";
      }
    }).headers.has("Content-Type");
    return x && !S;
  }), d = s && l && Yy(() => ye.isReadableStream(new i("").body)), f = {
    stream: d && ((x) => x.body)
  };
  a && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((x) => {
    !f[x] && (f[x] = (S, N) => {
      let j = S && S[x];
      if (j)
        return j.call(S);
      throw new bn(`Response type '${x}' is not supported`, bn.ERR_NOT_SUPPORT, N);
    });
  });
  const h = async (x) => {
    if (x == null)
      return 0;
    if (ye.isBlob(x))
      return x.size;
    if (ye.isSpecCompliantForm(x))
      return (await new t(Ot.origin, {
        method: "POST",
        body: x
      }).arrayBuffer()).byteLength;
    if (ye.isArrayBufferView(x) || ye.isArrayBuffer(x))
      return x.byteLength;
    if (ye.isURLSearchParams(x) && (x = x + ""), ye.isString(x))
      return (await u(x)).byteLength;
  }, v = async (x, S) => {
    const N = ye.toFiniteNumber(x.getContentLength());
    return N ?? h(S);
  };
  return async (x) => {
    let {
      url: S,
      method: N,
      data: j,
      signal: y,
      cancelToken: q,
      timeout: E,
      onDownloadProgress: C,
      onUploadProgress: T,
      responseType: U,
      headers: Z,
      withCredentials: Q = "same-origin",
      fetchOptions: ee
    } = sj(x), J = n || fetch;
    U = U ? (U + "").toLowerCase() : "text";
    let K = F$([y, q && q.toAbortSignal()], E), D = null;
    const G = K && K.unsubscribe && (() => {
      K.unsubscribe();
    });
    let ne;
    try {
      if (T && m && N !== "get" && N !== "head" && (ne = await v(Z, j)) !== 0) {
        let be = new t(S, {
          method: "POST",
          body: j,
          duplex: "half"
        }), je;
        if (ye.isFormData(j) && (je = be.headers.get("content-type")) && Z.setContentType(je), be.body) {
          const [W, Ue] = Uy(
            ne,
            Vl(By(T))
          );
          j = Hy(be.body, Wy, W, Ue);
        }
      }
      ye.isString(Q) || (Q = Q ? "include" : "omit");
      const de = o && "credentials" in t.prototype, ge = {
        ...ee,
        signal: K,
        method: N.toUpperCase(),
        headers: Z.normalize().toJSON(),
        body: j,
        duplex: "half",
        credentials: de ? Q : void 0
      };
      D = o && new t(S, ge);
      let ce = await (o ? J(D, ee) : J(S, ge));
      const ve = d && (U === "stream" || U === "response");
      if (d && (C || ve && G)) {
        const be = {};
        ["status", "statusText", "headers"].forEach((Me) => {
          be[Me] = ce[Me];
        });
        const je = ye.toFiniteNumber(ce.headers.get("content-length")), [W, Ue] = C && Uy(
          je,
          Vl(By(C), !0)
        ) || [];
        ce = new i(
          Hy(ce.body, Wy, W, () => {
            Ue && Ue(), G && G();
          }),
          be
        );
      }
      U = U || "text";
      let H = await f[ye.findKey(f, U) || "text"](ce, x);
      return !ve && G && G(), await new Promise((be, je) => {
        aj(be, je, {
          data: H,
          headers: Xt.from(ce.headers),
          status: ce.status,
          statusText: ce.statusText,
          config: x,
          request: D
        });
      });
    } catch (de) {
      throw G && G(), de && de.name === "TypeError" && /Load failed|fetch/i.test(de.message) ? Object.assign(
        new bn("Network Error", bn.ERR_NETWORK, x, D),
        {
          cause: de.cause || de
        }
      ) : bn.from(de, de && de.code, x, D);
    }
  };
}, R$ = /* @__PURE__ */ new Map(), lj = (e) => {
  let n = e ? e.env : {};
  const { fetch: t, Request: i, Response: a } = n, o = [
    i,
    a,
    t
  ];
  let s = o.length, l = s, u, m, d = R$;
  for (; l--; )
    u = o[l], m = d.get(u), m === void 0 && d.set(u, m = l ? /* @__PURE__ */ new Map() : O$(n)), d = m;
  return m;
};
lj();
const Lf = {
  http: QI,
  xhr: C$,
  fetch: {
    get: lj
  }
};
ye.forEach(Lf, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: n });
  }
});
const Jy = (e) => `- ${e}`, D$ = (e) => ye.isFunction(e) || e === null || e === !1, cj = {
  getAdapter: (e, n) => {
    e = ye.isArray(e) ? e : [e];
    const { length: t } = e;
    let i, a;
    const o = {};
    for (let s = 0; s < t; s++) {
      i = e[s];
      let l;
      if (a = i, !D$(i) && (a = Lf[(l = String(i)).toLowerCase()], a === void 0))
        throw new bn(`Unknown adapter '${l}'`);
      if (a && (ye.isFunction(a) || (a = a.get(n))))
        break;
      o[l || "#" + s] = a;
    }
    if (!a) {
      const s = Object.entries(o).map(
        ([u, m]) => `adapter ${u} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = t ? s.length > 1 ? `since :
` + s.map(Jy).join(`
`) : " " + Jy(s[0]) : "as no adapter specified";
      throw new bn(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return a;
  },
  adapters: Lf
};
function au(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $a(null, e);
}
function Qy(e) {
  return au(e), e.headers = Xt.from(e.headers), e.data = iu.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), cj.getAdapter(e.adapter || is.adapter, e)(e).then(function(i) {
    return au(e), i.data = iu.call(
      e,
      e.transformResponse,
      i
    ), i.headers = Xt.from(i.headers), i;
  }, function(i) {
    return ij(i) || (au(e), i && i.response && (i.response.data = iu.call(
      e,
      e.transformResponse,
      i.response
    ), i.response.headers = Xt.from(i.response.headers))), Promise.reject(i);
  });
}
const uj = "1.12.2", bc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  bc[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Xy = {};
bc.transitional = function(n, t, i) {
  function a(o, s) {
    return "[Axios v" + uj + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new bn(
        a(s, " has been removed" + (t ? " in " + t : "")),
        bn.ERR_DEPRECATED
      );
    return t && !Xy[s] && (Xy[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
bc.spelling = function(n) {
  return (t, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function P$(e, n, t) {
  if (typeof e != "object")
    throw new bn("options must be an object", bn.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = n[o];
    if (s) {
      const l = e[o], u = l === void 0 || s(l, o, e);
      if (u !== !0)
        throw new bn("option " + o + " must be " + u, bn.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new bn("Unknown option " + o, bn.ERR_BAD_OPTION);
  }
}
const xl = {
  assertOptions: P$,
  validators: bc
}, Vr = xl.validators;
let Vi = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new zy(),
      response: new zy()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, t) {
    try {
      return await this._request(n, t);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? o && !String(i.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + o) : i.stack = o;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, t) {
    typeof n == "string" ? (t = t || {}, t.url = n) : t = n || {}, t = qi(this.defaults, t);
    const { transitional: i, paramsSerializer: a, headers: o } = t;
    i !== void 0 && xl.assertOptions(i, {
      silentJSONParsing: Vr.transitional(Vr.boolean),
      forcedJSONParsing: Vr.transitional(Vr.boolean),
      clarifyTimeoutError: Vr.transitional(Vr.boolean)
    }, !1), a != null && (ye.isFunction(a) ? t.paramsSerializer = {
      serialize: a
    } : xl.assertOptions(a, {
      encode: Vr.function,
      serialize: Vr.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), xl.assertOptions(t, {
      baseUrl: Vr.spelling("baseURL"),
      withXsrfToken: Vr.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let s = o && ye.merge(
      o.common,
      o[t.method]
    );
    o && ye.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (x) => {
        delete o[x];
      }
    ), t.headers = Xt.concat(s, o);
    const l = [];
    let u = !0;
    this.interceptors.request.forEach(function(S) {
      typeof S.runWhen == "function" && S.runWhen(t) === !1 || (u = u && S.synchronous, l.unshift(S.fulfilled, S.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(S) {
      m.push(S.fulfilled, S.rejected);
    });
    let d, f = 0, h;
    if (!u) {
      const x = [Qy.bind(this), void 0];
      for (x.unshift(...l), x.push(...m), h = x.length, d = Promise.resolve(t); f < h; )
        d = d.then(x[f++], x[f++]);
      return d;
    }
    h = l.length;
    let v = t;
    for (; f < h; ) {
      const x = l[f++], S = l[f++];
      try {
        v = x(v);
      } catch (N) {
        S.call(this, N);
        break;
      }
    }
    try {
      d = Qy.call(this, v);
    } catch (x) {
      return Promise.reject(x);
    }
    for (f = 0, h = m.length; f < h; )
      d = d.then(m[f++], m[f++]);
    return d;
  }
  getUri(n) {
    n = qi(this.defaults, n);
    const t = oj(n.baseURL, n.url, n.allowAbsoluteUrls);
    return nj(t, n.params, n.paramsSerializer);
  }
};
ye.forEach(["delete", "get", "head", "options"], function(n) {
  Vi.prototype[n] = function(t, i) {
    return this.request(qi(i || {}, {
      method: n,
      url: t,
      data: (i || {}).data
    }));
  };
});
ye.forEach(["post", "put", "patch"], function(n) {
  function t(i) {
    return function(o, s, l) {
      return this.request(qi(l || {}, {
        method: n,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  Vi.prototype[n] = t(), Vi.prototype[n + "Form"] = t(!0);
});
let A$ = class dj {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new $a(o, s, l), t(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(n);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), t = (i) => {
      n.abort(i);
    };
    return this.subscribe(t), n.signal.unsubscribe = () => this.unsubscribe(t), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new dj(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function L$(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function V$(e) {
  return ye.isObject(e) && e.isAxiosError === !0;
}
const Vf = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Vf).forEach(([e, n]) => {
  Vf[n] = e;
});
function mj(e) {
  const n = new Vi(e), t = BN(Vi.prototype.request, n);
  return ye.extend(t, Vi.prototype, n, { allOwnKeys: !0 }), ye.extend(t, n, null, { allOwnKeys: !0 }), t.create = function(a) {
    return mj(qi(e, a));
  }, t;
}
const ct = mj(is);
ct.Axios = Vi;
ct.CanceledError = $a;
ct.CancelToken = A$;
ct.isCancel = ij;
ct.VERSION = uj;
ct.toFormData = kc;
ct.AxiosError = bn;
ct.Cancel = ct.CanceledError;
ct.all = function(n) {
  return Promise.all(n);
};
ct.spread = L$;
ct.isAxiosError = V$;
ct.mergeConfig = qi;
ct.AxiosHeaders = Xt;
ct.formToJSON = (e) => rj(ye.isHTMLForm(e) ? new FormData(e) : e);
ct.getAdapter = cj.getAdapter;
ct.HttpStatusCode = Vf;
ct.default = ct;
const {
  Axios: Dne,
  AxiosError: Pne,
  CanceledError: Ane,
  isCancel: Lne,
  CancelToken: Vne,
  VERSION: zne,
  all: Mne,
  Cancel: Une,
  isAxiosError: z$,
  spread: Bne,
  toFormData: qne,
  AxiosHeaders: Hne,
  HttpStatusCode: Wne,
  formToJSON: Kne,
  getAdapter: Gne,
  mergeConfig: Yne
} = ct;
var ou = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function M$(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Es = function(e) {
  return e && e.Math === Math && e;
}, bt = (
  // eslint-disable-next-line es/no-global-this -- safe
  Es(typeof globalThis == "object" && globalThis) || Es(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Es(typeof self == "object" && self) || Es(typeof ou == "object" && ou) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || ou || Function("return this")()
), ut = function(e) {
  try {
    return !!e();
  } catch {
    return !0;
  }
}, U$ = ut, _c = !U$(function() {
  var e = (function() {
  }).bind();
  return typeof e != "function" || e.hasOwnProperty("prototype");
}), B$ = _c, pj = Function.prototype, Zy = pj.apply, eg = pj.call, Kh = typeof Reflect == "object" && Reflect.apply || (B$ ? eg.bind(Zy) : function() {
  return eg.apply(Zy, arguments);
}), fj = _c, hj = Function.prototype, zf = hj.call, q$ = fj && hj.bind.bind(zf, zf), _t = fj ? q$ : function(e) {
  return function() {
    return zf.apply(e, arguments);
  };
}, vj = _t, H$ = vj({}.toString), W$ = vj("".slice), Wi = function(e) {
  return W$(H$(e), 8, -1);
}, K$ = Wi, G$ = _t, Gh = function(e) {
  if (K$(e) === "Function") return G$(e);
}, Mf = typeof document == "object" && document.all, Y$ = typeof Mf > "u" && Mf !== void 0, yj = {
  all: Mf,
  IS_HTMLDDA: Y$
}, gj = yj, J$ = gj.all, vt = gj.IS_HTMLDDA ? function(e) {
  return typeof e == "function" || e === J$;
} : function(e) {
  return typeof e == "function";
}, Ea = {}, Q$ = ut, cr = !Q$(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), X$ = _c, Ts = Function.prototype.call, Tt = X$ ? Ts.bind(Ts) : function() {
  return Ts.apply(Ts, arguments);
}, xc = {}, kj = {}.propertyIsEnumerable, bj = Object.getOwnPropertyDescriptor, Z$ = bj && !kj.call({ 1: 2 }, 1);
xc.f = Z$ ? function(n) {
  var t = bj(this, n);
  return !!t && t.enumerable;
} : kj;
var Ki = function(e, n) {
  return {
    enumerable: !(e & 1),
    configurable: !(e & 2),
    writable: !(e & 4),
    value: n
  };
}, eE = _t, nE = ut, tE = Wi, su = Object, rE = eE("".split), Yh = nE(function() {
  return !su("z").propertyIsEnumerable(0);
}) ? function(e) {
  return tE(e) === "String" ? rE(e, "") : su(e);
} : su, Sc = function(e) {
  return e == null;
}, iE = Sc, aE = TypeError, Jh = function(e) {
  if (iE(e)) throw aE("Can't call method on " + e);
  return e;
}, oE = Yh, sE = Jh, di = function(e) {
  return oE(sE(e));
}, ng = vt, _j = yj, lE = _j.all, yr = _j.IS_HTMLDDA ? function(e) {
  return typeof e == "object" ? e !== null : ng(e) || e === lE;
} : function(e) {
  return typeof e == "object" ? e !== null : ng(e);
}, gr = {}, lu = gr, cu = bt, cE = vt, tg = function(e) {
  return cE(e) ? e : void 0;
}, kr = function(e, n) {
  return arguments.length < 2 ? tg(lu[e]) || tg(cu[e]) : lu[e] && lu[e][n] || cu[e] && cu[e][n];
}, uE = _t, as = uE({}.isPrototypeOf), Nc = typeof navigator < "u" && String(navigator.userAgent) || "", xj = bt, uu = Nc, rg = xj.process, ig = xj.Deno, ag = rg && rg.versions || ig && ig.version, og = ag && ag.v8, jr, zl;
og && (jr = og.split("."), zl = jr[0] > 0 && jr[0] < 4 ? 1 : +(jr[0] + jr[1]));
!zl && uu && (jr = uu.match(/Edge\/(\d+)/), (!jr || jr[1] >= 74) && (jr = uu.match(/Chrome\/(\d+)/), jr && (zl = +jr[1])));
var jc = zl, sg = jc, dE = ut, mE = bt, pE = mE.String, Ta = !!Object.getOwnPropertySymbols && !dE(function() {
  var e = Symbol("symbol detection");
  return !pE(e) || !(Object(e) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && sg && sg < 41;
}), fE = Ta, Sj = fE && !Symbol.sham && typeof Symbol.iterator == "symbol", hE = kr, vE = vt, yE = as, gE = Sj, kE = Object, wc = gE ? function(e) {
  return typeof e == "symbol";
} : function(e) {
  var n = hE("Symbol");
  return vE(n) && yE(n.prototype, kE(e));
}, bE = String, os = function(e) {
  try {
    return bE(e);
  } catch {
    return "Object";
  }
}, _E = vt, xE = os, SE = TypeError, Xr = function(e) {
  if (_E(e)) return e;
  throw SE(xE(e) + " is not a function");
}, NE = Xr, jE = Sc, Qh = function(e, n) {
  var t = e[n];
  return jE(t) ? void 0 : NE(t);
}, du = Tt, mu = vt, pu = yr, wE = TypeError, CE = function(e, n) {
  var t, i;
  if (n === "string" && mu(t = e.toString) && !pu(i = du(t, e)) || mu(t = e.valueOf) && !pu(i = du(t, e)) || n !== "string" && mu(t = e.toString) && !pu(i = du(t, e))) return i;
  throw wE("Can't convert object to primitive value");
}, Nj = { exports: {} }, FE = !0, lg = bt, IE = Object.defineProperty, $E = function(e, n) {
  try {
    IE(lg, e, { value: n, configurable: !0, writable: !0 });
  } catch {
    lg[e] = n;
  }
  return n;
}, EE = bt, TE = $E, cg = "__core-js_shared__", OE = EE[cg] || TE(cg, {}), Xh = OE, ug = Xh;
(Nj.exports = function(e, n) {
  return ug[e] || (ug[e] = n !== void 0 ? n : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var ss = Nj.exports, RE = Jh, DE = Object, Oa = function(e) {
  return DE(RE(e));
}, PE = _t, AE = Oa, LE = PE({}.hasOwnProperty), er = Object.hasOwn || function(n, t) {
  return LE(AE(n), t);
}, VE = _t, zE = 0, ME = Math.random(), UE = VE(1 .toString), Zh = function(e) {
  return "Symbol(" + (e === void 0 ? "" : e) + ")_" + UE(++zE + ME, 36);
}, BE = bt, qE = ss, dg = er, HE = Zh, WE = Ta, KE = Sj, ma = BE.Symbol, fu = qE("wks"), GE = KE ? ma.for || ma : ma && ma.withoutSetter || HE, dt = function(e) {
  return dg(fu, e) || (fu[e] = WE && dg(ma, e) ? ma[e] : GE("Symbol." + e)), fu[e];
}, YE = Tt, mg = yr, pg = wc, JE = Qh, QE = CE, XE = dt, ZE = TypeError, eT = XE("toPrimitive"), nT = function(e, n) {
  if (!mg(e) || pg(e)) return e;
  var t = JE(e, eT), i;
  if (t) {
    if (n === void 0 && (n = "default"), i = YE(t, e, n), !mg(i) || pg(i)) return i;
    throw ZE("Can't convert object to primitive value");
  }
  return n === void 0 && (n = "number"), QE(e, n);
}, tT = nT, rT = wc, Cc = function(e) {
  var n = tT(e, "string");
  return rT(n) ? n : n + "";
}, iT = bt, fg = yr, Uf = iT.document, aT = fg(Uf) && fg(Uf.createElement), ev = function(e) {
  return aT ? Uf.createElement(e) : {};
}, oT = cr, sT = ut, lT = ev, jj = !oT && !sT(function() {
  return Object.defineProperty(lT("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), cT = cr, uT = Tt, dT = xc, mT = Ki, pT = di, fT = Cc, hT = er, vT = jj, hg = Object.getOwnPropertyDescriptor;
Ea.f = cT ? hg : function(n, t) {
  if (n = pT(n), t = fT(t), vT) try {
    return hg(n, t);
  } catch {
  }
  if (hT(n, t)) return mT(!uT(dT.f, n, t), n[t]);
};
var yT = ut, gT = vt, kT = /#|\.prototype\./, ls = function(e, n) {
  var t = _T[bT(e)];
  return t === ST ? !0 : t === xT ? !1 : gT(n) ? yT(n) : !!n;
}, bT = ls.normalize = function(e) {
  return String(e).replace(kT, ".").toLowerCase();
}, _T = ls.data = {}, xT = ls.NATIVE = "N", ST = ls.POLYFILL = "P", wj = ls, vg = Gh, NT = Xr, jT = _c, wT = vg(vg.bind), cs = function(e, n) {
  return NT(e), n === void 0 ? e : jT ? wT(e, n) : function() {
    return e.apply(n, arguments);
  };
}, Ar = {}, CT = cr, FT = ut, Cj = CT && FT(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), IT = yr, $T = String, ET = TypeError, Lr = function(e) {
  if (IT(e)) return e;
  throw ET($T(e) + " is not an object");
}, TT = cr, OT = jj, RT = Cj, Os = Lr, yg = Cc, DT = TypeError, hu = Object.defineProperty, PT = Object.getOwnPropertyDescriptor, vu = "enumerable", yu = "configurable", gu = "writable";
Ar.f = TT ? RT ? function(n, t, i) {
  if (Os(n), t = yg(t), Os(i), typeof n == "function" && t === "prototype" && "value" in i && gu in i && !i[gu]) {
    var a = PT(n, t);
    a && a[gu] && (n[t] = i.value, i = {
      configurable: yu in i ? i[yu] : a[yu],
      enumerable: vu in i ? i[vu] : a[vu],
      writable: !1
    });
  }
  return hu(n, t, i);
} : hu : function(n, t, i) {
  if (Os(n), t = yg(t), Os(i), OT) try {
    return hu(n, t, i);
  } catch {
  }
  if ("get" in i || "set" in i) throw DT("Accessors not supported");
  return "value" in i && (n[t] = i.value), n;
};
var AT = cr, LT = Ar, VT = Ki, Ni = AT ? function(e, n, t) {
  return LT.f(e, n, VT(1, t));
} : function(e, n, t) {
  return e[n] = t, e;
}, Rs = bt, zT = Kh, MT = Gh, UT = vt, BT = Ea.f, qT = wj, Xi = gr, HT = cs, Zi = Ni, gg = er, WT = function(e) {
  var n = function(t, i, a) {
    if (this instanceof n) {
      switch (arguments.length) {
        case 0:
          return new e();
        case 1:
          return new e(t);
        case 2:
          return new e(t, i);
      }
      return new e(t, i, a);
    }
    return zT(e, this, arguments);
  };
  return n.prototype = e.prototype, n;
}, et = function(e, n) {
  var t = e.target, i = e.global, a = e.stat, o = e.proto, s = i ? Rs : a ? Rs[t] : (Rs[t] || {}).prototype, l = i ? Xi : Xi[t] || Zi(Xi, t, {})[t], u = l.prototype, m, d, f, h, v, x, S, N, j;
  for (h in n)
    m = qT(i ? h : t + (a ? "." : "#") + h, e.forced), d = !m && s && gg(s, h), x = l[h], d && (e.dontCallGetSet ? (j = BT(s, h), S = j && j.value) : S = s[h]), v = d && S ? S : n[h], !(d && typeof x == typeof v) && (e.bind && d ? N = HT(v, Rs) : e.wrap && d ? N = WT(v) : o && UT(v) ? N = MT(v) : N = v, (e.sham || v && v.sham || x && x.sham) && Zi(N, "sham", !0), Zi(l, h, N), o && (f = t + "Prototype", gg(Xi, f) || Zi(Xi, f, {}), Zi(Xi[f], h, v), e.real && u && (m || !u[h]) && Zi(u, h, v)));
}, KT = _t, GT = Xr, YT = function(e, n, t) {
  try {
    return KT(GT(Object.getOwnPropertyDescriptor(e, n)[t]));
  } catch {
  }
}, JT = vt, QT = String, XT = TypeError, ZT = function(e) {
  if (typeof e == "object" || JT(e)) return e;
  throw XT("Can't set " + QT(e) + " as a prototype");
}, eO = YT, nO = Lr, tO = ZT, Fj = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var e = !1, n = {}, t;
  try {
    t = eO(Object.prototype, "__proto__", "set"), t(n, []), e = n instanceof Array;
  } catch {
  }
  return function(a, o) {
    return nO(a), tO(o), e ? t(a, o) : a.__proto__ = o, a;
  };
}() : void 0), rO = et, iO = Fj;
rO({ target: "Object", stat: !0 }, {
  setPrototypeOf: iO
});
var aO = gr;
aO.Object.setPrototypeOf;
var nv = {}, oO = Math.ceil, sO = Math.floor, lO = Math.trunc || function(n) {
  var t = +n;
  return (t > 0 ? sO : oO)(t);
}, cO = lO, tv = function(e) {
  var n = +e;
  return n !== n || n === 0 ? 0 : cO(n);
}, uO = tv, dO = Math.max, mO = Math.min, rv = function(e, n) {
  var t = uO(e);
  return t < 0 ? dO(t + n, 0) : mO(t, n);
}, pO = tv, fO = Math.min, hO = function(e) {
  return e > 0 ? fO(pO(e), 9007199254740991) : 0;
}, vO = hO, Ra = function(e) {
  return vO(e.length);
}, yO = di, gO = rv, kO = Ra, bO = function(e) {
  return function(n, t, i) {
    for (var a = yO(n), o = kO(a), s = gO(i, o); o > s; s++)
      if (s in a && a[s] === t) return s || 0;
    return -1;
  };
}, Ij = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: bO()
}, Fc = {}, _O = _t, ku = er, xO = di, SO = Ij.indexOf, NO = Fc, kg = _O([].push), $j = function(e, n) {
  var t = xO(e), i = 0, a = [], o;
  for (o in t) !ku(NO, o) && ku(t, o) && kg(a, o);
  for (; n.length > i; ) ku(t, o = n[i++]) && (~SO(a, o) || kg(a, o));
  return a;
}, iv = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], jO = $j, wO = iv, av = Object.keys || function(n) {
  return jO(n, wO);
}, CO = cr, FO = Cj, IO = Ar, $O = Lr, EO = di, TO = av;
nv.f = CO && !FO ? Object.defineProperties : function(n, t) {
  $O(n);
  for (var i = EO(t), a = TO(t), o = a.length, s = 0, l; o > s; ) IO.f(n, l = a[s++], i[l]);
  return n;
};
var OO = kr, Ej = OO("document", "documentElement"), RO = ss, DO = Zh, bg = RO("keys"), Ic = function(e) {
  return bg[e] || (bg[e] = DO(e));
}, PO = Lr, AO = nv, _g = iv, LO = Fc, VO = Ej, zO = ev, MO = Ic, xg = ">", Sg = "<", Bf = "prototype", qf = "script", Tj = MO("IE_PROTO"), bu = function() {
}, Oj = function(e) {
  return Sg + qf + xg + e + Sg + "/" + qf + xg;
}, Ng = function(e) {
  e.write(Oj("")), e.close();
  var n = e.parentWindow.Object;
  return e = null, n;
}, UO = function() {
  var e = zO("iframe"), n = "java" + qf + ":", t;
  return e.style.display = "none", VO.appendChild(e), e.src = String(n), t = e.contentWindow.document, t.open(), t.write(Oj("document.F=Object")), t.close(), t.F;
}, Ds, Sl = function() {
  try {
    Ds = new ActiveXObject("htmlfile");
  } catch {
  }
  Sl = typeof document < "u" ? document.domain && Ds ? Ng(Ds) : UO() : Ng(Ds);
  for (var e = _g.length; e--; ) delete Sl[Bf][_g[e]];
  return Sl();
};
LO[Tj] = !0;
var us = Object.create || function(n, t) {
  var i;
  return n !== null ? (bu[Bf] = PO(n), i = new bu(), bu[Bf] = null, i[Tj] = n) : i = Sl(), t === void 0 ? i : AO.f(i, t);
}, BO = et, qO = cr, HO = us;
BO({ target: "Object", stat: !0, sham: !qO }, {
  create: HO
});
var WO = gr;
WO.Object;
var ds = {};
ds.f = Object.getOwnPropertySymbols;
var jg = cr, KO = _t, GO = Tt, YO = ut, _u = av, JO = ds, QO = xc, XO = Oa, ZO = Yh, ea = Object.assign, wg = Object.defineProperty, eR = KO([].concat), nR = !ea || YO(function() {
  if (jg && ea({ b: 1 }, ea(wg({}, "a", {
    enumerable: !0,
    get: function() {
      wg(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var e = {}, n = {}, t = Symbol("assign detection"), i = "abcdefghijklmnopqrst";
  return e[t] = 7, i.split("").forEach(function(a) {
    n[a] = a;
  }), ea({}, e)[t] !== 7 || _u(ea({}, n)).join("") !== i;
}) ? function(n, t) {
  for (var i = XO(n), a = arguments.length, o = 1, s = JO.f, l = QO.f; a > o; )
    for (var u = ZO(arguments[o++]), m = s ? eR(_u(u), s(u)) : _u(u), d = m.length, f = 0, h; d > f; )
      h = m[f++], (!jg || GO(l, u, h)) && (i[h] = u[h]);
  return i;
} : ea, tR = et, Cg = nR;
tR({ target: "Object", stat: !0, forced: Object.assign !== Cg }, {
  assign: Cg
});
var rR = gr;
rR.Object.assign;
var iR = ut, aR = function(e, n) {
  var t = [][e];
  return !!t && iR(function() {
    t.call(null, n || function() {
      return 1;
    }, 1);
  });
}, oR = et, sR = Gh, lR = Ij.indexOf, cR = aR, Hf = sR([].indexOf), Rj = !!Hf && 1 / Hf([1], 1, -0) < 0, uR = Rj || !cR("indexOf");
oR({ target: "Array", proto: !0, forced: uR }, {
  indexOf: function(n) {
    var t = arguments.length > 1 ? arguments[1] : void 0;
    return Rj ? Hf(this, n, t) || 0 : lR(this, n, t);
  }
});
var dR = gr, ov = function(e) {
  return dR[e + "Prototype"];
}, mR = ov;
mR("Array").indexOf;
var pR = dt, fR = pR("toStringTag"), Dj = {};
Dj[fR] = "z";
var sv = String(Dj) === "[object z]", hR = sv, vR = vt, Nl = Wi, yR = dt, gR = yR("toStringTag"), kR = Object, bR = Nl(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", _R = function(e, n) {
  try {
    return e[n];
  } catch {
  }
}, ms = hR ? Nl : function(e) {
  var n, t, i;
  return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (t = _R(n = kR(e), gR)) == "string" ? t : bR ? Nl(n) : (i = Nl(n)) === "Object" && vR(n.callee) ? "Arguments" : i;
}, xR = ms, SR = String, Da = function(e) {
  if (xR(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return SR(e);
}, $c = {}, NR = $j, jR = iv, wR = jR.concat("length", "prototype");
$c.f = Object.getOwnPropertyNames || function(n) {
  return NR(n, wR);
};
var Pj = {}, CR = Cc, FR = Ar, IR = Ki, lv = function(e, n, t) {
  var i = CR(n);
  i in e ? FR.f(e, i, IR(0, t)) : e[i] = t;
}, Fg = rv, $R = Ra, ER = lv, TR = Array, OR = Math.max, RR = function(e, n, t) {
  for (var i = $R(e), a = Fg(n, i), o = Fg(t === void 0 ? i : t, i), s = TR(OR(o - a, 0)), l = 0; a < o; a++, l++) ER(s, l, e[a]);
  return s.length = l, s;
}, DR = Wi, PR = di, Aj = $c.f, AR = RR, Lj = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], LR = function(e) {
  try {
    return Aj(e);
  } catch {
    return AR(Lj);
  }
};
Pj.f = function(n) {
  return Lj && DR(n) === "Window" ? LR(n) : Aj(PR(n));
};
var VR = Ni, ps = function(e, n, t, i) {
  return i && i.enumerable ? e[n] = t : VR(e, n, t), e;
}, zR = Ar, Vj = function(e, n, t) {
  return zR.f(e, n, t);
}, fs = {}, MR = dt;
fs.f = MR;
var Ig = gr, UR = er, BR = fs, qR = Ar.f, nr = function(e) {
  var n = Ig.Symbol || (Ig.Symbol = {});
  UR(n, e) || qR(n, e, {
    value: BR.f(e)
  });
}, HR = Tt, WR = kr, KR = dt, GR = ps, zj = function() {
  var e = WR("Symbol"), n = e && e.prototype, t = n && n.valueOf, i = KR("toPrimitive");
  n && !n[i] && GR(n, i, function(a) {
    return HR(t, this);
  }, {});
}, YR = sv, JR = ms, QR = YR ? {}.toString : function() {
  return "[object " + JR(this) + "]";
}, XR = sv, ZR = Ar.f, eD = Ni, nD = er, tD = QR, rD = dt, $g = rD("toStringTag"), Pa = function(e, n, t, i) {
  if (e) {
    var a = t ? e : e.prototype;
    nD(a, $g) || ZR(a, $g, { configurable: !0, value: n }), i && !XR && eD(a, "toString", tD);
  }
}, iD = bt, aD = vt, Eg = iD.WeakMap, oD = aD(Eg) && /native code/.test(String(Eg)), sD = oD, Mj = bt, lD = yr, cD = Ni, xu = er, Su = Xh, uD = Ic, dD = Fc, Tg = "Object already initialized", Wf = Mj.TypeError, mD = Mj.WeakMap, Ml, Wo, Ul, pD = function(e) {
  return Ul(e) ? Wo(e) : Ml(e, {});
}, fD = function(e) {
  return function(n) {
    var t;
    if (!lD(n) || (t = Wo(n)).type !== e)
      throw Wf("Incompatible receiver, " + e + " required");
    return t;
  };
};
if (sD || Su.state) {
  var zr = Su.state || (Su.state = new mD());
  zr.get = zr.get, zr.has = zr.has, zr.set = zr.set, Ml = function(e, n) {
    if (zr.has(e)) throw Wf(Tg);
    return n.facade = e, zr.set(e, n), n;
  }, Wo = function(e) {
    return zr.get(e) || {};
  }, Ul = function(e) {
    return zr.has(e);
  };
} else {
  var na = uD("state");
  dD[na] = !0, Ml = function(e, n) {
    if (xu(e, na)) throw Wf(Tg);
    return n.facade = e, cD(e, na, n), n;
  }, Wo = function(e) {
    return xu(e, na) ? e[na] : {};
  }, Ul = function(e) {
    return xu(e, na);
  };
}
var Ec = {
  set: Ml,
  get: Wo,
  has: Ul,
  enforce: pD,
  getterFor: fD
}, hD = Wi, Tc = Array.isArray || function(n) {
  return hD(n) === "Array";
}, vD = _t, yD = vt, Kf = Xh, gD = vD(Function.toString);
yD(Kf.inspectSource) || (Kf.inspectSource = function(e) {
  return gD(e);
});
var Uj = Kf.inspectSource, kD = _t, bD = ut, Bj = vt, _D = ms, xD = kr, SD = Uj, qj = function() {
}, ND = [], Hj = xD("Reflect", "construct"), cv = /^\s*(?:class|function)\b/, jD = kD(cv.exec), wD = !cv.exec(qj), Ya = function(n) {
  if (!Bj(n)) return !1;
  try {
    return Hj(qj, ND, n), !0;
  } catch {
    return !1;
  }
}, Wj = function(n) {
  if (!Bj(n)) return !1;
  switch (_D(n)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return wD || !!jD(cv, SD(n));
  } catch {
    return !0;
  }
};
Wj.sham = !0;
var uv = !Hj || bD(function() {
  var e;
  return Ya(Ya.call) || !Ya(Object) || !Ya(function() {
    e = !0;
  }) || e;
}) ? Wj : Ya, Og = Tc, CD = uv, FD = yr, ID = dt, $D = ID("species"), Rg = Array, ED = function(e) {
  var n;
  return Og(e) && (n = e.constructor, CD(n) && (n === Rg || Og(n.prototype)) ? n = void 0 : FD(n) && (n = n[$D], n === null && (n = void 0))), n === void 0 ? Rg : n;
}, TD = ED, OD = function(e, n) {
  return new (TD(e))(n === 0 ? 0 : n);
}, RD = cs, DD = _t, PD = Yh, AD = Oa, LD = Ra;
DD([].push);
var VD = function(e) {
  return function(n, t, i, a) {
    for (var o = AD(n), s = PD(o), l = RD(t, i), u = LD(s), m = 0, d = void 0, f; u > m; m++) m in s && (f = s[m], l(f, m, o));
    return d;
  };
}, zD = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: VD()
}, Oc = et, dv = bt, mv = Tt, MD = _t, Sa = cr, Na = Ta, UD = ut, xt = er, BD = as, Gf = Lr, Rc = di, pv = Cc, qD = Da, Yf = Ki, Ko = us, Kj = av, HD = $c, Gj = Pj, WD = ds, Yj = Ea, Jj = Ar, KD = nv, Qj = xc, Dg = ps, GD = Vj, fv = ss, YD = Ic, Xj = Fc, Pg = Zh, JD = dt, QD = fs, XD = nr, ZD = zj, eP = Pa, Zj = Ec, Dc = zD.forEach, Yt = YD("hidden"), Pc = "Symbol", Go = "prototype", nP = Zj.set, Ag = Zj.getterFor(Pc), Tr = Object[Go], zi = dv.Symbol, $o = zi && zi[Go], tP = dv.TypeError, Nu = dv.QObject, ew = Yj.f, Ri = Jj.f, nw = Gj.f, rP = Qj.f, tw = MD([].push), ci = fv("symbols"), hs = fv("op-symbols"), iP = fv("wks"), Jf = !Nu || !Nu[Go] || !Nu[Go].findChild, Qf = Sa && UD(function() {
  return Ko(Ri({}, "a", {
    get: function() {
      return Ri(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? function(e, n, t) {
  var i = ew(Tr, n);
  i && delete Tr[n], Ri(e, n, t), i && e !== Tr && Ri(Tr, n, i);
} : Ri, ju = function(e, n) {
  var t = ci[e] = Ko($o);
  return nP(t, {
    type: Pc,
    tag: e,
    description: n
  }), Sa || (t.description = n), t;
}, Ac = function(n, t, i) {
  n === Tr && Ac(hs, t, i), Gf(n);
  var a = pv(t);
  return Gf(i), xt(ci, a) ? (i.enumerable ? (xt(n, Yt) && n[Yt][a] && (n[Yt][a] = !1), i = Ko(i, { enumerable: Yf(0, !1) })) : (xt(n, Yt) || Ri(n, Yt, Yf(1, {})), n[Yt][a] = !0), Qf(n, a, i)) : Ri(n, a, i);
}, hv = function(n, t) {
  Gf(n);
  var i = Rc(t), a = Kj(i).concat(ow(i));
  return Dc(a, function(o) {
    (!Sa || mv(rw, i, o)) && Ac(n, o, i[o]);
  }), n;
}, aP = function(n, t) {
  return t === void 0 ? Ko(n) : hv(Ko(n), t);
}, rw = function(n) {
  var t = pv(n), i = mv(rP, this, t);
  return this === Tr && xt(ci, t) && !xt(hs, t) ? !1 : i || !xt(this, t) || !xt(ci, t) || xt(this, Yt) && this[Yt][t] ? i : !0;
}, iw = function(n, t) {
  var i = Rc(n), a = pv(t);
  if (!(i === Tr && xt(ci, a) && !xt(hs, a))) {
    var o = ew(i, a);
    return o && xt(ci, a) && !(xt(i, Yt) && i[Yt][a]) && (o.enumerable = !0), o;
  }
}, aw = function(n) {
  var t = nw(Rc(n)), i = [];
  return Dc(t, function(a) {
    !xt(ci, a) && !xt(Xj, a) && tw(i, a);
  }), i;
}, ow = function(e) {
  var n = e === Tr, t = nw(n ? hs : Rc(e)), i = [];
  return Dc(t, function(a) {
    xt(ci, a) && (!n || xt(Tr, a)) && tw(i, ci[a]);
  }), i;
};
Na || (zi = function() {
  if (BD($o, this)) throw tP("Symbol is not a constructor");
  var n = !arguments.length || arguments[0] === void 0 ? void 0 : qD(arguments[0]), t = Pg(n), i = function(a) {
    this === Tr && mv(i, hs, a), xt(this, Yt) && xt(this[Yt], t) && (this[Yt][t] = !1), Qf(this, t, Yf(1, a));
  };
  return Sa && Jf && Qf(Tr, t, { configurable: !0, set: i }), ju(t, n);
}, $o = zi[Go], Dg($o, "toString", function() {
  return Ag(this).tag;
}), Dg(zi, "withoutSetter", function(e) {
  return ju(Pg(e), e);
}), Qj.f = rw, Jj.f = Ac, KD.f = hv, Yj.f = iw, HD.f = Gj.f = aw, WD.f = ow, QD.f = function(e) {
  return ju(JD(e), e);
}, Sa && GD($o, "description", {
  configurable: !0,
  get: function() {
    return Ag(this).description;
  }
}));
Oc({ global: !0, wrap: !0, forced: !Na, sham: !Na }, {
  Symbol: zi
});
Dc(Kj(iP), function(e) {
  XD(e);
});
Oc({ target: Pc, stat: !0, forced: !Na }, {
  useSetter: function() {
    Jf = !0;
  },
  useSimple: function() {
    Jf = !1;
  }
});
Oc({ target: "Object", stat: !0, forced: !Na, sham: !Sa }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: aP,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: Ac,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: hv,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: iw
});
Oc({ target: "Object", stat: !0, forced: !Na }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: aw
});
ZD();
eP(zi, Pc);
Xj[Yt] = !0;
var oP = Ta, sw = oP && !!Symbol.for && !!Symbol.keyFor, sP = et, lP = kr, cP = er, uP = Da, lw = ss, dP = sw, wu = lw("string-to-symbol-registry"), mP = lw("symbol-to-string-registry");
sP({ target: "Symbol", stat: !0, forced: !dP }, {
  for: function(e) {
    var n = uP(e);
    if (cP(wu, n)) return wu[n];
    var t = lP("Symbol")(n);
    return wu[n] = t, mP[t] = n, t;
  }
});
var pP = et, fP = er, hP = wc, vP = os, yP = ss, gP = sw, Lg = yP("symbol-to-string-registry");
pP({ target: "Symbol", stat: !0, forced: !gP }, {
  keyFor: function(n) {
    if (!hP(n)) throw TypeError(vP(n) + " is not a symbol");
    if (fP(Lg, n)) return Lg[n];
  }
});
var kP = _t, vv = kP([].slice), bP = _t, Vg = Tc, _P = vt, zg = Wi, xP = Da, Mg = bP([].push), SP = function(e) {
  if (_P(e)) return e;
  if (Vg(e)) {
    for (var n = e.length, t = [], i = 0; i < n; i++) {
      var a = e[i];
      typeof a == "string" ? Mg(t, a) : (typeof a == "number" || zg(a) === "Number" || zg(a) === "String") && Mg(t, xP(a));
    }
    var o = t.length, s = !0;
    return function(l, u) {
      if (s)
        return s = !1, u;
      if (Vg(this)) return u;
      for (var m = 0; m < o; m++) if (t[m] === l) return u;
    };
  }
}, NP = et, cw = kr, uw = Kh, jP = Tt, vs = _t, dw = ut, Ug = vt, Bg = wc, mw = vv, wP = SP, CP = Ta, FP = String, _i = cw("JSON", "stringify"), Ps = vs(/./.exec), qg = vs("".charAt), IP = vs("".charCodeAt), $P = vs("".replace), EP = vs(1 .toString), TP = /[\uD800-\uDFFF]/g, Hg = /^[\uD800-\uDBFF]$/, Wg = /^[\uDC00-\uDFFF]$/, Kg = !CP || dw(function() {
  var e = cw("Symbol")("stringify detection");
  return _i([e]) !== "[null]" || _i({ a: e }) !== "{}" || _i(Object(e)) !== "{}";
}), Gg = dw(function() {
  return _i("\uDF06\uD834") !== '"\\udf06\\ud834"' || _i("\uDEAD") !== '"\\udead"';
}), OP = function(e, n) {
  var t = mw(arguments), i = wP(n);
  if (!(!Ug(i) && (e === void 0 || Bg(e))))
    return t[1] = function(a, o) {
      if (Ug(i) && (o = jP(i, this, FP(a), o)), !Bg(o)) return o;
    }, uw(_i, null, t);
}, RP = function(e, n, t) {
  var i = qg(t, n - 1), a = qg(t, n + 1);
  return Ps(Hg, e) && !Ps(Wg, a) || Ps(Wg, e) && !Ps(Hg, i) ? "\\u" + EP(IP(e, 0), 16) : e;
};
_i && NP({ target: "JSON", stat: !0, forced: Kg || Gg }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(n, t, i) {
    var a = mw(arguments), o = uw(Kg ? OP : _i, null, a);
    return Gg && typeof o == "string" ? $P(o, TP, RP) : o;
  }
});
var DP = et, PP = Ta, AP = ut, pw = ds, LP = Oa, VP = !PP || AP(function() {
  pw.f(1);
});
DP({ target: "Object", stat: !0, forced: VP }, {
  getOwnPropertySymbols: function(n) {
    var t = pw.f;
    return t ? t(LP(n)) : [];
  }
});
var zP = gr;
zP.Object.getOwnPropertySymbols;
var MP = et, UP = ut, BP = di, fw = Ea.f, hw = cr, qP = !hw || UP(function() {
  fw(1);
});
MP({ target: "Object", stat: !0, forced: qP, sham: !hw }, {
  getOwnPropertyDescriptor: function(n, t) {
    return fw(BP(n), t);
  }
});
var HP = gr, WP = HP.Object;
WP.getOwnPropertyDescriptor.sham;
var KP = et, GP = cr, Yg = Ar.f;
KP({ target: "Object", stat: !0, forced: Object.defineProperty !== Yg, sham: !GP }, {
  defineProperty: Yg
});
var YP = gr, JP = YP.Object;
JP.defineProperty.sham;
var QP = ut, XP = !QP(function() {
  function e() {
  }
  return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
}), ZP = er, eA = vt, nA = Oa, tA = Ic, rA = XP, Jg = tA("IE_PROTO"), Xf = Object, iA = Xf.prototype, yv = rA ? Xf.getPrototypeOf : function(e) {
  var n = nA(e);
  if (ZP(n, Jg)) return n[Jg];
  var t = n.constructor;
  return eA(t) && n instanceof t ? t.prototype : n instanceof Xf ? iA : null;
}, aA = kr, oA = _t, sA = $c, lA = ds, cA = Lr, uA = oA([].concat), dA = aA("Reflect", "ownKeys") || function(n) {
  var t = sA.f(cA(n)), i = lA.f;
  return i ? uA(t, i(n)) : t;
}, Qg = er, mA = dA, pA = Ea, fA = Ar, hA = function(e, n, t) {
  for (var i = mA(n), a = fA.f, o = pA.f, s = 0; s < i.length; s++) {
    var l = i[s];
    !Qg(e, l) && !(t && Qg(t, l)) && a(e, l, o(n, l));
  }
}, vA = yr, yA = Ni, gA = function(e, n) {
  vA(n) && "cause" in n && yA(e, "cause", n.cause);
}, kA = _t, vw = Error, bA = kA("".replace), _A = function(e) {
  return String(vw(e).stack);
}("zxcasd"), yw = /\n\s*at [^:]*:[^\n]*/, xA = yw.test(_A), SA = function(e, n) {
  if (xA && typeof e == "string" && !vw.prepareStackTrace)
    for (; n--; ) e = bA(e, yw, "");
  return e;
}, NA = ut, jA = Ki, wA = !NA(function() {
  var e = Error("a");
  return "stack" in e ? (Object.defineProperty(e, "stack", jA(1, 7)), e.stack !== 7) : !0;
}), CA = Ni, FA = SA, IA = wA, Xg = Error.captureStackTrace, $A = function(e, n, t, i) {
  IA && (Xg ? Xg(e, n) : CA(e, "stack", FA(t, i)));
}, Aa = {}, EA = dt, TA = Aa, OA = EA("iterator"), RA = Array.prototype, DA = function(e) {
  return e !== void 0 && (TA.Array === e || RA[OA] === e);
}, PA = ms, Zg = Qh, AA = Sc, LA = Aa, VA = dt, zA = VA("iterator"), gw = function(e) {
  if (!AA(e)) return Zg(e, zA) || Zg(e, "@@iterator") || LA[PA(e)];
}, MA = Tt, UA = Xr, BA = Lr, qA = os, HA = gw, WA = TypeError, KA = function(e, n) {
  var t = arguments.length < 2 ? HA(e) : n;
  if (UA(t)) return BA(MA(t, e));
  throw WA(qA(e) + " is not iterable");
}, GA = Tt, ek = Lr, YA = Qh, JA = function(e, n, t) {
  var i, a;
  ek(e);
  try {
    if (i = YA(e, "return"), !i) {
      if (n === "throw") throw t;
      return t;
    }
    i = GA(i, e);
  } catch (o) {
    a = !0, i = o;
  }
  if (n === "throw") throw t;
  if (a) throw i;
  return ek(i), t;
}, QA = cs, XA = Tt, ZA = Lr, e2 = os, n2 = DA, t2 = Ra, nk = as, r2 = KA, i2 = gw, tk = JA, a2 = TypeError, jl = function(e, n) {
  this.stopped = e, this.result = n;
}, rk = jl.prototype, ys = function(e, n, t) {
  var i = t && t.that, a = !!(t && t.AS_ENTRIES), o = !!(t && t.IS_RECORD), s = !!(t && t.IS_ITERATOR), l = !!(t && t.INTERRUPTED), u = QA(n, i), m, d, f, h, v, x, S, N = function(y) {
    return m && tk(m, "normal", y), new jl(!0, y);
  }, j = function(y) {
    return a ? (ZA(y), l ? u(y[0], y[1], N) : u(y[0], y[1])) : l ? u(y, N) : u(y);
  };
  if (o)
    m = e.iterator;
  else if (s)
    m = e;
  else {
    if (d = i2(e), !d) throw a2(e2(e) + " is not iterable");
    if (n2(d)) {
      for (f = 0, h = t2(e); h > f; f++)
        if (v = j(e[f]), v && nk(rk, v)) return v;
      return new jl(!1);
    }
    m = r2(e, d);
  }
  for (x = o ? e.next : m.next; !(S = XA(x, m)).done; ) {
    try {
      v = j(S.value);
    } catch (y) {
      tk(m, "throw", y);
    }
    if (typeof v == "object" && v && nk(rk, v)) return v;
  }
  return new jl(!1);
}, o2 = Da, s2 = function(e, n) {
  return e === void 0 ? arguments.length < 2 ? "" : n : o2(e);
}, l2 = et, c2 = as, u2 = yv, Bl = Fj, d2 = hA, kw = us, Cu = Ni, Fu = Ki, m2 = gA, p2 = $A, f2 = ys, h2 = s2, v2 = dt, y2 = v2("toStringTag"), ql = Error, g2 = [].push, ja = function(n, t) {
  var i = c2(Iu, this), a;
  Bl ? a = Bl(ql(), i ? u2(this) : Iu) : (a = i ? this : kw(Iu), Cu(a, y2, "Error")), t !== void 0 && Cu(a, "message", h2(t)), p2(a, ja, a.stack, 1), arguments.length > 2 && m2(a, arguments[2]);
  var o = [];
  return f2(n, g2, { that: o }), Cu(a, "errors", o), a;
};
Bl ? Bl(ja, ql) : d2(ja, ql, { name: !0 });
var Iu = ja.prototype = kw(ql.prototype, {
  constructor: Fu(1, ja),
  message: Fu(1, ""),
  name: Fu(1, "AggregateError")
});
l2({ global: !0 }, {
  AggregateError: ja
});
var Zf = cr, k2 = er, bw = Function.prototype, b2 = Zf && Object.getOwnPropertyDescriptor, _w = k2(bw, "name"), _2 = _w && (function() {
}).name === "something";
_w && (!Zf || Zf && b2(bw, "name").configurable);
var x2 = {
  PROPER: _2
}, S2 = ut, N2 = vt, j2 = yr, w2 = us, ik = yv, C2 = ps, F2 = dt, eh = F2("iterator"), xw = !1, li, $u, Eu;
[].keys && (Eu = [].keys(), "next" in Eu ? ($u = ik(ik(Eu)), $u !== Object.prototype && (li = $u)) : xw = !0);
var I2 = !j2(li) || S2(function() {
  var e = {};
  return li[eh].call(e) !== e;
});
I2 ? li = {} : li = w2(li);
N2(li[eh]) || C2(li, eh, function() {
  return this;
});
var Sw = {
  IteratorPrototype: li,
  BUGGY_SAFARI_ITERATORS: xw
}, $2 = Sw.IteratorPrototype, E2 = us, T2 = Ki, O2 = Pa, R2 = Aa, D2 = function() {
  return this;
}, P2 = function(e, n, t, i) {
  var a = n + " Iterator";
  return e.prototype = E2($2, { next: T2(+!i, t) }), O2(e, a, !1, !0), R2[a] = D2, e;
}, A2 = et, L2 = Tt, V2 = x2, z2 = P2, M2 = yv, U2 = Pa, ak = ps, B2 = dt, ok = Aa, q2 = Sw, H2 = V2.PROPER, As = q2.BUGGY_SAFARI_ITERATORS, Tu = B2("iterator"), sk = "keys", Ls = "values", lk = "entries", W2 = function() {
  return this;
}, Nw = function(e, n, t, i, a, o, s) {
  z2(t, n, i);
  var l = function(j) {
    if (j === a && h) return h;
    if (!As && j in d) return d[j];
    switch (j) {
      case sk:
        return function() {
          return new t(this, j);
        };
      case Ls:
        return function() {
          return new t(this, j);
        };
      case lk:
        return function() {
          return new t(this, j);
        };
    }
    return function() {
      return new t(this);
    };
  }, u = n + " Iterator", m = !1, d = e.prototype, f = d[Tu] || d["@@iterator"] || a && d[a], h = !As && f || l(a), v = n === "Array" && d.entries || f, x, S, N;
  if (v && (x = M2(v.call(new e())), x !== Object.prototype && x.next && (U2(x, u, !0, !0), ok[u] = W2)), H2 && a === Ls && f && f.name !== Ls && (m = !0, h = function() {
    return L2(f, this);
  }), a)
    if (S = {
      values: l(Ls),
      keys: o ? h : l(sk),
      entries: l(lk)
    }, s) for (N in S)
      (As || m || !(N in d)) && ak(d, N, S[N]);
    else A2({ target: n, proto: !0, forced: As || m }, S);
  return s && d[Tu] !== h && ak(d, Tu, h, {}), ok[n] = h, S;
}, jw = function(e, n) {
  return { value: e, done: n };
}, K2 = di, ck = Aa, ww = Ec;
Ar.f;
var G2 = Nw, Vs = jw, Cw = "Array Iterator", Y2 = ww.set, J2 = ww.getterFor(Cw);
G2(Array, "Array", function(e, n) {
  Y2(this, {
    type: Cw,
    target: K2(e),
    // target
    index: 0,
    // next index
    kind: n
    // kind
  });
}, function() {
  var e = J2(this), n = e.target, t = e.kind, i = e.index++;
  if (!n || i >= n.length)
    return e.target = void 0, Vs(void 0, !0);
  switch (t) {
    case "keys":
      return Vs(i, !1);
    case "values":
      return Vs(n[i], !1);
  }
  return Vs([i, n[i]], !1);
}, "values");
ck.Arguments = ck.Array;
var Q2 = bt, X2 = Wi, Lc = X2(Q2.process) === "process", Z2 = kr, eL = Vj, nL = dt, tL = cr, uk = nL("species"), rL = function(e) {
  var n = Z2(e);
  tL && n && !n[uk] && eL(n, uk, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, iL = as, aL = TypeError, oL = function(e, n) {
  if (iL(n, e)) return e;
  throw aL("Incorrect invocation");
}, sL = uv, lL = os, cL = TypeError, uL = function(e) {
  if (sL(e)) return e;
  throw cL(lL(e) + " is not a constructor");
}, dk = Lr, dL = uL, mL = Sc, pL = dt, fL = pL("species"), Fw = function(e, n) {
  var t = dk(e).constructor, i;
  return t === void 0 || mL(i = dk(t)[fL]) ? n : dL(i);
}, hL = TypeError, vL = function(e, n) {
  if (e < n) throw hL("Not enough arguments");
  return e;
}, yL = Nc, Iw = /(?:ipad|iphone|ipod).*applewebkit/i.test(yL), or = bt, gL = Kh, kL = cs, mk = vt, bL = er, $w = ut, pk = Ej, _L = vv, fk = ev, xL = vL, SL = Iw, NL = Lc, nh = or.setImmediate, hk = or.clearImmediate, jL = or.process, Ou = or.Dispatch, wL = or.Function, vk = or.MessageChannel, CL = or.String, Ru = 0, To = {}, yk = "onreadystatechange", Yo, Fi, Du, Pu;
$w(function() {
  Yo = or.location;
});
var gv = function(e) {
  if (bL(To, e)) {
    var n = To[e];
    delete To[e], n();
  }
}, Au = function(e) {
  return function() {
    gv(e);
  };
}, gk = function(e) {
  gv(e.data);
}, kk = function(e) {
  or.postMessage(CL(e), Yo.protocol + "//" + Yo.host);
};
(!nh || !hk) && (nh = function(n) {
  xL(arguments.length, 1);
  var t = mk(n) ? n : wL(n), i = _L(arguments, 1);
  return To[++Ru] = function() {
    gL(t, void 0, i);
  }, Fi(Ru), Ru;
}, hk = function(n) {
  delete To[n];
}, NL ? Fi = function(e) {
  jL.nextTick(Au(e));
} : Ou && Ou.now ? Fi = function(e) {
  Ou.now(Au(e));
} : vk && !SL ? (Du = new vk(), Pu = Du.port2, Du.port1.onmessage = gk, Fi = kL(Pu.postMessage, Pu)) : or.addEventListener && mk(or.postMessage) && !or.importScripts && Yo && Yo.protocol !== "file:" && !$w(kk) ? (Fi = kk, or.addEventListener("message", gk, !1)) : yk in fk("script") ? Fi = function(e) {
  pk.appendChild(fk("script"))[yk] = function() {
    pk.removeChild(this), gv(e);
  };
} : Fi = function(e) {
  setTimeout(Au(e), 0);
});
var Ew = {
  set: nh
}, Tw = function() {
  this.head = null, this.tail = null;
};
Tw.prototype = {
  add: function(e) {
    var n = { item: e, next: null }, t = this.tail;
    t ? t.next = n : this.head = n, this.tail = n;
  },
  get: function() {
    var e = this.head;
    if (e) {
      var n = this.head = e.next;
      return n === null && (this.tail = null), e.item;
    }
  }
};
var Ow = Tw, FL = Nc, IL = /ipad|iphone|ipod/i.test(FL) && typeof Pebble < "u", $L = Nc, EL = /web0s(?!.*chrome)/i.test($L), Hi = bt, bk = cs, TL = Ea.f, Lu = Ew.set, OL = Ow, RL = Iw, DL = IL, PL = EL, Vu = Lc, _k = Hi.MutationObserver || Hi.WebKitMutationObserver, xk = Hi.document, Sk = Hi.process, zs = Hi.Promise, Nk = TL(Hi, "queueMicrotask"), th = Nk && Nk.value, ta, zu, Mu, Ms, jk;
if (!th) {
  var Us = new OL(), Bs = function() {
    var e, n;
    for (Vu && (e = Sk.domain) && e.exit(); n = Us.get(); ) try {
      n();
    } catch (t) {
      throw Us.head && ta(), t;
    }
    e && e.enter();
  };
  !RL && !Vu && !PL && _k && xk ? (zu = !0, Mu = xk.createTextNode(""), new _k(Bs).observe(Mu, { characterData: !0 }), ta = function() {
    Mu.data = zu = !zu;
  }) : !DL && zs && zs.resolve ? (Ms = zs.resolve(void 0), Ms.constructor = zs, jk = bk(Ms.then, Ms), ta = function() {
    jk(Bs);
  }) : Vu ? ta = function() {
    Sk.nextTick(Bs);
  } : (Lu = bk(Lu, Hi), ta = function() {
    Lu(Bs);
  }), th = function(e) {
    Us.head || ta(), Us.add(e);
  };
}
var AL = th, LL = function(e, n) {
  try {
    arguments.length === 1 ? console.error(e) : console.error(e, n);
  } catch {
  }
}, gs = function(e) {
  try {
    return { error: !1, value: e() };
  } catch (n) {
    return { error: !0, value: n };
  }
}, VL = bt, La = VL.Promise, Rw = typeof Deno == "object" && Deno && typeof Deno.version == "object", zL = Rw, ML = Lc, UL = !zL && !ML && typeof window == "object" && typeof document == "object", BL = bt, Oo = La, qL = vt, HL = wj, WL = Uj, KL = dt, GL = UL, YL = Rw, Uu = jc, wk = Oo && Oo.prototype, JL = KL("species"), Ck = !1, Dw = qL(BL.PromiseRejectionEvent), QL = HL("Promise", function() {
  var e = WL(Oo), n = e !== String(Oo);
  if (!n && Uu === 66 || !(wk.catch && wk.finally)) return !0;
  if (!Uu || Uu < 51 || !/native code/.test(e)) {
    var t = new Oo(function(o) {
      o(1);
    }), i = function(o) {
      o(function() {
      }, function() {
      });
    }, a = t.constructor = {};
    if (a[JL] = i, Ck = t.then(function() {
    }) instanceof i, !Ck) return !0;
  }
  return !n && (GL || YL) && !Dw;
}), ks = {
  CONSTRUCTOR: QL,
  REJECTION_EVENT: Dw
}, ji = {}, Fk = Xr, XL = TypeError, ZL = function(e) {
  var n, t;
  this.promise = new e(function(i, a) {
    if (n !== void 0 || t !== void 0) throw XL("Bad Promise constructor");
    n = i, t = a;
  }), this.resolve = Fk(n), this.reject = Fk(t);
};
ji.f = function(e) {
  return new ZL(e);
};
var eV = et, Hl = Lc, xi = bt, bs = Tt, nV = ps, tV = Pa, rV = rL, iV = Xr, rh = vt, aV = yr, oV = oL, sV = Fw, Pw = Ew.set, kv = AL, lV = LL, cV = gs, uV = Ow, Aw = Ec, ih = La, Lw = ks, Vw = ji, Vc = "Promise", zw = Lw.CONSTRUCTOR, dV = Lw.REJECTION_EVENT, Bu = Aw.getterFor(Vc), mV = Aw.set, pV = ih && ih.prototype, pa = ih, qu = pV, Mw = xi.TypeError, ah = xi.document, bv = xi.process, oh = Vw.f, fV = oh, hV = !!(ah && ah.createEvent && xi.dispatchEvent), Uw = "unhandledrejection", vV = "rejectionhandled", Ik = 0, Bw = 1, yV = 2, _v = 1, qw = 2, qs, $k, gV, Hw = function(e) {
  var n;
  return aV(e) && rh(n = e.then) ? n : !1;
}, Ww = function(e, n) {
  var t = n.value, i = n.state === Bw, a = i ? e.ok : e.fail, o = e.resolve, s = e.reject, l = e.domain, u, m, d;
  try {
    a ? (i || (n.rejection === qw && bV(n), n.rejection = _v), a === !0 ? u = t : (l && l.enter(), u = a(t), l && (l.exit(), d = !0)), u === e.promise ? s(Mw("Promise-chain cycle")) : (m = Hw(u)) ? bs(m, u, o, s) : o(u)) : s(t);
  } catch (f) {
    l && !d && l.exit(), s(f);
  }
}, Kw = function(e, n) {
  e.notified || (e.notified = !0, kv(function() {
    for (var t = e.reactions, i; i = t.get(); )
      Ww(i, e);
    e.notified = !1, n && !e.rejection && kV(e);
  }));
}, Gw = function(e, n, t) {
  var i, a;
  hV ? (i = ah.createEvent("Event"), i.promise = n, i.reason = t, i.initEvent(e, !1, !0), xi.dispatchEvent(i)) : i = { promise: n, reason: t }, !dV && (a = xi["on" + e]) ? a(i) : e === Uw && lV("Unhandled promise rejection", t);
}, kV = function(e) {
  bs(Pw, xi, function() {
    var n = e.facade, t = e.value, i = Ek(e), a;
    if (i && (a = cV(function() {
      Hl ? bv.emit("unhandledRejection", t, n) : Gw(Uw, n, t);
    }), e.rejection = Hl || Ek(e) ? qw : _v, a.error))
      throw a.value;
  });
}, Ek = function(e) {
  return e.rejection !== _v && !e.parent;
}, bV = function(e) {
  bs(Pw, xi, function() {
    var n = e.facade;
    Hl ? bv.emit("rejectionHandled", n) : Gw(vV, n, e.value);
  });
}, fa = function(e, n, t) {
  return function(i) {
    e(n, i, t);
  };
}, va = function(e, n, t) {
  e.done || (e.done = !0, t && (e = t), e.value = n, e.state = yV, Kw(e, !0));
}, sh = function(e, n, t) {
  if (!e.done) {
    e.done = !0, t && (e = t);
    try {
      if (e.facade === n) throw Mw("Promise can't be resolved itself");
      var i = Hw(n);
      i ? kv(function() {
        var a = { done: !1 };
        try {
          bs(
            i,
            n,
            fa(sh, a, e),
            fa(va, a, e)
          );
        } catch (o) {
          va(a, o, e);
        }
      }) : (e.value = n, e.state = Bw, Kw(e, !1));
    } catch (a) {
      va({ done: !1 }, a, e);
    }
  }
};
zw && (pa = function(n) {
  oV(this, qu), iV(n), bs(qs, this);
  var t = Bu(this);
  try {
    n(fa(sh, t), fa(va, t));
  } catch (i) {
    va(t, i);
  }
}, qu = pa.prototype, qs = function(n) {
  mV(this, {
    type: Vc,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new uV(),
    rejection: !1,
    state: Ik,
    value: void 0
  });
}, qs.prototype = nV(qu, "then", function(n, t) {
  var i = Bu(this), a = oh(sV(this, pa));
  return i.parent = !0, a.ok = rh(n) ? n : !0, a.fail = rh(t) && t, a.domain = Hl ? bv.domain : void 0, i.state === Ik ? i.reactions.add(a) : kv(function() {
    Ww(a, i);
  }), a.promise;
}), $k = function() {
  var e = new qs(), n = Bu(e);
  this.promise = e, this.resolve = fa(sh, n), this.reject = fa(va, n);
}, Vw.f = oh = function(e) {
  return e === pa || e === gV ? new $k(e) : fV(e);
});
eV({ global: !0, wrap: !0, forced: zw }, {
  Promise: pa
});
tV(pa, Vc, !1, !0);
rV(Vc);
var _V = dt, Yw = _V("iterator"), Jw = !1;
try {
  var xV = 0, Tk = {
    next: function() {
      return { done: !!xV++ };
    },
    return: function() {
      Jw = !0;
    }
  };
  Tk[Yw] = function() {
    return this;
  }, Array.from(Tk, function() {
    throw 2;
  });
} catch {
}
var SV = function(e, n) {
  if (!n && !Jw) return !1;
  var t = !1;
  try {
    var i = {};
    i[Yw] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, e(i);
  } catch {
  }
  return t;
}, NV = La, jV = SV, wV = ks.CONSTRUCTOR, zc = wV || !jV(function(e) {
  NV.all(e).then(void 0, function() {
  });
}), CV = et, FV = Tt, IV = Xr, $V = ji, EV = gs, TV = ys, OV = zc;
CV({ target: "Promise", stat: !0, forced: OV }, {
  all: function(n) {
    var t = this, i = $V.f(t), a = i.resolve, o = i.reject, s = EV(function() {
      var l = IV(t.resolve), u = [], m = 0, d = 1;
      TV(n, function(f) {
        var h = m++, v = !1;
        d++, FV(l, t, f).then(function(x) {
          v || (v = !0, u[h] = x, --d || a(u));
        }, o);
      }), --d || a(u);
    });
    return s.error && o(s.value), i.promise;
  }
});
var RV = et, DV = ks.CONSTRUCTOR, Ok = La;
Ok && Ok.prototype;
RV({ target: "Promise", proto: !0, forced: DV, real: !0 }, {
  catch: function(e) {
    return this.then(void 0, e);
  }
});
var PV = et, AV = Tt, LV = Xr, VV = ji, zV = gs, MV = ys, UV = zc;
PV({ target: "Promise", stat: !0, forced: UV }, {
  race: function(n) {
    var t = this, i = VV.f(t), a = i.reject, o = zV(function() {
      var s = LV(t.resolve);
      MV(n, function(l) {
        AV(s, t, l).then(i.resolve, a);
      });
    });
    return o.error && a(o.value), i.promise;
  }
});
var BV = et, qV = Tt, HV = ji, WV = ks.CONSTRUCTOR;
BV({ target: "Promise", stat: !0, forced: WV }, {
  reject: function(n) {
    var t = HV.f(this);
    return qV(t.reject, void 0, n), t.promise;
  }
});
var KV = Lr, GV = yr, YV = ji, Qw = function(e, n) {
  if (KV(e), GV(n) && n.constructor === e) return n;
  var t = YV.f(e), i = t.resolve;
  return i(n), t.promise;
}, JV = et, QV = kr, XV = FE, ZV = La, e3 = ks.CONSTRUCTOR, n3 = Qw, t3 = QV("Promise"), r3 = !e3;
JV({ target: "Promise", stat: !0, forced: XV }, {
  resolve: function(n) {
    return n3(r3 && this === t3 ? ZV : this, n);
  }
});
var i3 = et, a3 = Tt, o3 = Xr, s3 = ji, l3 = gs, c3 = ys, u3 = zc;
i3({ target: "Promise", stat: !0, forced: u3 }, {
  allSettled: function(n) {
    var t = this, i = s3.f(t), a = i.resolve, o = i.reject, s = l3(function() {
      var l = o3(t.resolve), u = [], m = 0, d = 1;
      c3(n, function(f) {
        var h = m++, v = !1;
        d++, a3(l, t, f).then(function(x) {
          v || (v = !0, u[h] = { status: "fulfilled", value: x }, --d || a(u));
        }, function(x) {
          v || (v = !0, u[h] = { status: "rejected", reason: x }, --d || a(u));
        });
      }), --d || a(u);
    });
    return s.error && o(s.value), i.promise;
  }
});
var d3 = et, m3 = Tt, p3 = Xr, f3 = kr, h3 = ji, v3 = gs, y3 = ys, g3 = zc, Rk = "No one promise resolved";
d3({ target: "Promise", stat: !0, forced: g3 }, {
  any: function(n) {
    var t = this, i = f3("AggregateError"), a = h3.f(t), o = a.resolve, s = a.reject, l = v3(function() {
      var u = p3(t.resolve), m = [], d = 0, f = 1, h = !1;
      y3(n, function(v) {
        var x = d++, S = !1;
        f++, m3(u, t, v).then(function(N) {
          S || h || (h = !0, o(N));
        }, function(N) {
          S || h || (S = !0, m[x] = N, --f || s(new i(m, Rk)));
        });
      }), --f || s(new i(m, Rk));
    });
    return l.error && s(l.value), a.promise;
  }
});
var k3 = et, lh = La, b3 = ut, _3 = kr, x3 = vt, S3 = Fw, Dk = Qw, N3 = lh && lh.prototype, j3 = !!lh && b3(function() {
  N3.finally.call({ then: function() {
  } }, function() {
  });
});
k3({ target: "Promise", proto: !0, real: !0, forced: j3 }, {
  finally: function(e) {
    var n = S3(this, _3("Promise")), t = x3(e);
    return this.then(
      t ? function(i) {
        return Dk(n, e()).then(function() {
          return i;
        });
      } : e,
      t ? function(i) {
        return Dk(n, e()).then(function() {
          throw i;
        });
      } : e
    );
  }
});
var xv = _t, w3 = tv, C3 = Da, F3 = Jh, I3 = xv("".charAt), Pk = xv("".charCodeAt), $3 = xv("".slice), E3 = function(e) {
  return function(n, t) {
    var i = C3(F3(n)), a = w3(t), o = i.length, s, l;
    return a < 0 || a >= o ? "" : (s = Pk(i, a), s < 55296 || s > 56319 || a + 1 === o || (l = Pk(i, a + 1)) < 56320 || l > 57343 ? I3(i, a) : $3(i, a, a + 2));
  };
}, T3 = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: E3()
}, O3 = T3.charAt, R3 = Da, Xw = Ec, D3 = Nw, Ak = jw, Zw = "String Iterator", P3 = Xw.set, A3 = Xw.getterFor(Zw);
D3(String, "String", function(e) {
  P3(this, {
    type: Zw,
    string: R3(e),
    index: 0
  });
}, function() {
  var n = A3(this), t = n.string, i = n.index, a;
  return i >= t.length ? Ak(void 0, !0) : (a = O3(t, i), n.index += a.length, Ak(a, !1));
});
var L3 = gr, V3 = L3.Promise, z3 = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, M3 = z3, U3 = bt, B3 = ms, q3 = Ni, Lk = Aa, H3 = dt, Vk = H3("toStringTag");
for (var Hu in M3) {
  var zk = U3[Hu], Wu = zk && zk.prototype;
  Wu && B3(Wu) !== Vk && q3(Wu, Vk, Hu), Lk[Hu] = Lk.Array;
}
var W3 = V3, K3 = W3, G3 = K3, Y3 = /* @__PURE__ */ M$(G3), J3 = TypeError, Q3 = 9007199254740991, X3 = function(e) {
  if (e > Q3) throw J3("Maximum allowed index exceeded");
  return e;
}, Z3 = ut, ez = dt, nz = jc, tz = ez("species"), eC = function(e) {
  return nz >= 51 || !Z3(function() {
    var n = [], t = n.constructor = {};
    return t[tz] = function() {
      return { foo: 1 };
    }, n[e](Boolean).foo !== 1;
  });
}, rz = et, iz = ut, az = Tc, oz = yr, sz = Oa, lz = Ra, Mk = X3, Uk = lv, cz = OD, uz = eC, dz = dt, mz = jc, nC = dz("isConcatSpreadable"), pz = mz >= 51 || !iz(function() {
  var e = [];
  return e[nC] = !1, e.concat()[0] !== e;
}), fz = function(e) {
  if (!oz(e)) return !1;
  var n = e[nC];
  return n !== void 0 ? !!n : az(e);
}, hz = !pz || !uz("concat");
rz({ target: "Array", proto: !0, forced: hz }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(n) {
    var t = sz(this), i = cz(t, 0), a = 0, o, s, l, u, m;
    for (o = -1, l = arguments.length; o < l; o++)
      if (m = o === -1 ? t : arguments[o], fz(m))
        for (u = lz(m), Mk(a + u), s = 0; s < u; s++, a++) s in m && Uk(i, a, m[s]);
      else
        Mk(a + 1), Uk(i, a++, m);
    return i.length = a, i;
  }
});
var vz = nr;
vz("asyncIterator");
var yz = nr;
yz("hasInstance");
var gz = nr;
gz("isConcatSpreadable");
var kz = nr;
kz("iterator");
var bz = nr;
bz("match");
var _z = nr;
_z("matchAll");
var xz = nr;
xz("replace");
var Sz = nr;
Sz("search");
var Nz = nr;
Nz("species");
var jz = nr;
jz("split");
var wz = nr, Cz = zj;
wz("toPrimitive");
Cz();
var Fz = kr, Iz = nr, $z = Pa;
Iz("toStringTag");
$z(Fz("Symbol"), "Symbol");
var Ez = nr;
Ez("unscopables");
var Tz = bt, Oz = Pa;
Oz(Tz.JSON, "JSON", !0);
var Rz = gr;
Rz.Symbol;
var Dz = fs;
Dz.f("iterator");
var Pz = ov;
Pz("Array").concat;
var Az = et, Bk = Tc, Lz = uv, Vz = yr, qk = rv, zz = Ra, Mz = di, Uz = lv, Bz = dt, qz = eC, Hz = vv, Wz = qz("slice"), Kz = Bz("species"), Ku = Array, Gz = Math.max;
Az({ target: "Array", proto: !0, forced: !Wz }, {
  slice: function(n, t) {
    var i = Mz(this), a = zz(i), o = qk(n, a), s = qk(t === void 0 ? a : t, a), l, u, m;
    if (Bk(i) && (l = i.constructor, Lz(l) && (l === Ku || Bk(l.prototype)) ? l = void 0 : Vz(l) && (l = l[Kz], l === null && (l = void 0)), l === Ku || l === void 0))
      return Hz(i, o, s);
    for (u = new (l === void 0 ? Ku : l)(Gz(s - o, 0)), m = 0; o < s; o++, m++) o in i && Uz(u, m, i[o]);
    return u.length = m, u;
  }
});
var Yz = ov;
Yz("Array").slice;
var Jz = fs;
Jz.f("asyncIterator");
function Gu(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = Y3))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (f) {
        s(f);
      }
    }
    function u(d) {
      try {
        m(i.throw(d));
      } catch (f) {
        s(f);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, u);
    }
    m((i = i.apply(e, [])).next());
  });
}
class Qz {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    var n;
    return window.electron ? !!window.electron : !!(!((n = process == null ? void 0 : process.versions) === null || n === void 0) && n.electron) || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  getVersion() {
    return Gu(this, void 0, void 0, function* () {
      return window.electron ? (yield window.electron.getVersion()).split("-")[0] : "0.0.0";
    });
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  isStandaloneBuild() {
    return Gu(this, void 0, void 0, function* () {
      var n;
      return !((n = window.electron) === null || n === void 0) && n.isStandaloneBuild ? yield window.electron.isStandaloneBuild() : null;
    });
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  isMsiBuild() {
    return Gu(this, void 0, void 0, function* () {
      var n;
      return !((n = window.electron) === null || n === void 0) && n.isMsiBuild ? yield window.electron.isMsiBuild() : null;
    });
  }
}
const Hk = new Qz();
function Xz(e, n) {
  return Wk(e), Wk(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Wk(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const Zz = Object.prototype.toString;
function eM(e, n) {
  return Zz.call(e) === `[object ${n}]`;
}
function nM(e) {
  return eM(e, "Object");
}
function tM(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Ro = "8.36.0", ui = globalThis;
function Sv(e, n, t) {
  const i = t || ui, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Ro] = a[Ro] || {};
  return o[e] || (o[e] = n());
}
const tC = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, rM = "Sentry Logger ", Kk = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], Gk = {};
function rC(e) {
  if (!("console" in ui))
    return e();
  const n = ui.console, t = {}, i = Object.keys(Gk);
  i.forEach((a) => {
    const o = Gk[a];
    t[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = t[a];
    });
  }
}
function iM() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return tC ? Kk.forEach((t) => {
    n[t] = (...i) => {
      e && rC(() => {
        ui.console[t](`${rM}[${t}]:`, ...i);
      });
    };
  }) : Kk.forEach((t) => {
    n[t] = () => {
    };
  }), n;
}
const wl = Sv("logger", iM);
function aM(e, n, t) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    tC && wl.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const iC = 1e3;
function Nv() {
  return Date.now() / iC;
}
function oM() {
  const { performance: e } = ui;
  if (!e || !e.now)
    return Nv;
  const n = Date.now() - e.now(), t = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (t + e.now()) / iC;
}
const sM = oM();
(() => {
  const { performance: e } = ui;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, t = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + t - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, u = typeof s == "number" ? Math.abs(s + t - i) : n, m = u < n;
  return o || m ? a <= u ? e.timeOrigin : s : i;
})();
function ya() {
  const e = ui, n = e.crypto || e.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (t = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (t() & 15) >> i / 4).toString(16)
    )
  );
}
function Yk() {
  return {
    traceId: ya(),
    spanId: ya().substring(16)
  };
}
function jv() {
  return wv(ui), ui;
}
function wv(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Ro, n[Ro] = n[Ro] || {};
}
function lM(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || sM(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : ya()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const t = e.timestamp - e.started;
    e.duration = t >= 0 ? t : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const ch = "_sentrySpan";
function Jk(e, n) {
  n ? aM(e, ch, n) : delete e[ch];
}
function Qk(e) {
  return e[ch];
}
const cM = 100;
class Cv {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Yk();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new Cv();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Jk(n, Qk(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && lM(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, t) {
    return this._tags = { ...this._tags, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, t) {
    return this._extra = { ...this._extra, [n]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, t) {
    return t === null ? delete this._contexts[n] : this._contexts[n] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const t = typeof n == "function" ? n(this) : n, [i, a] = t instanceof wa ? [t.getScopeData(), t.getRequestSession()] : nM(t) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: u, level: m, fingerprint: d = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...u }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), d.length && (this._fingerprint = d), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Jk(this, void 0), this._attachments = [], this._propagationContext = Yk(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, t) {
    const i = typeof t == "number" ? t : cM;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Nv(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Qk(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, t) {
    const i = t && t.event_id ? t.event_id : ya();
    if (!this._client)
      return wl.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...t,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, t, i) {
    const a = i && i.event_id ? i.event_id : ya();
    if (!this._client)
      return wl.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      t,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, t) {
    const i = t && t.event_id ? t.event_id : ya();
    return this._client ? (this._client.captureEvent(n, { ...t, event_id: i }, this), i) : (wl.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const wa = Cv;
function uM() {
  return Sv("defaultCurrentScope", () => new wa());
}
function dM() {
  return Sv("defaultIsolationScope", () => new wa());
}
class mM {
  constructor(n, t) {
    let i;
    n ? i = n : i = new wa();
    let a;
    t ? a = t : a = new wa(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const t = this._pushScope();
    let i;
    try {
      i = n(t);
    } catch (a) {
      throw this._popScope(), a;
    }
    return tM(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Ca() {
  const e = jv(), n = wv(e);
  return n.stack = n.stack || new mM(uM(), dM());
}
function pM(e) {
  return Ca().withScope(e);
}
function fM(e, n) {
  const t = Ca();
  return t.withScope(() => (t.getStackTop().scope = e, n(e)));
}
function Xk(e) {
  return Ca().withScope(() => e(Ca().getIsolationScope()));
}
function hM() {
  return {
    withIsolationScope: Xk,
    withScope: pM,
    withSetScope: fM,
    withSetIsolationScope: (e, n) => Xk(n),
    getCurrentScope: () => Ca().getScope(),
    getIsolationScope: () => Ca().getIsolationScope()
  };
}
function aC(e) {
  const n = wv(e);
  return n.acs ? n.acs : hM();
}
function Fv() {
  const e = jv();
  return aC(e).getCurrentScope();
}
function oC() {
  const e = jv();
  return aC(e).getIsolationScope();
}
function vM() {
  return Fv().getClient();
}
function yM(e) {
  if (e)
    return gM(e) ? { captureContext: e } : bM(e) ? {
      captureContext: e
    } : e;
}
function gM(e) {
  return e instanceof wa || typeof e == "function";
}
const kM = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function bM(e) {
  return Object.keys(e).some((n) => kM.includes(n));
}
function Zk(e, n) {
  return Fv().captureException(e, yM(n));
}
function _M(e, n) {
  const t = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return Fv().captureMessage(e, t, i);
}
function xM(e, n) {
  oC().setContext(e, n);
}
const SM = 100;
function Ei(e, n) {
  const t = vM(), i = oC();
  if (!t) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = SM } = t.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Nv(), ...e }, u = a ? rC(() => a(l, n)) : l;
  u !== null && (t.emit && t.emit("beforeAddBreadcrumb", u, n), i.addBreadcrumb(u, o));
}
var Jo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Jo || (Jo = {}));
function ga(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const t = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(t, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const NM = Ho.backendDomain ? {
  "backend-domain": Ho.backendDomain
} : void 0;
function Cl() {
  const e = new URLSearchParams(Object.assign({ noToken: "true" }, NM)).toString();
  document.location.href = `${Ho.url.logIn}?${e}`;
}
const Yu = "authData", Ju = 30, jM = 600, Qu = 5;
class wM {
  constructor() {
    Object.defineProperty(this, "authData", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "accessTokenExpiresAt", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "clientServerTimeDiff", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= Qu || this.clientServerTimeDiff <= -Qu ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + jM, a = ga(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > Qu) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Yu, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Yu), t = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(t) && (this.authData = t), t;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Yu);
  }
  getAccessToken() {
    var n;
    return ((n = this.authData) === null || n === void 0 ? void 0 : n.access_token) || null;
  }
  getRefreshToken() {
    var n;
    return ((n = this.authData) === null || n === void 0 ? void 0 : n.refresh_token) || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const t = this.accessTokenExpiresAt - Ju;
    return this.estimatedServerTime() >= t;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const t = ga(n), i = t.exp - Ju;
    return !t || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Ju - this.estimatedServerTime()) * 1e3;
  }
}
const wt = new wM();
var CM = function(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = Promise))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (f) {
        s(f);
      }
    }
    function u(d) {
      try {
        m(i.throw(d));
      } catch (f) {
        s(f);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, u);
    }
    m((i = i.apply(e, n || [])).next());
  });
};
function FM(e) {
  return CM(this, void 0, void 0, function* () {
    var n, t;
    const i = window.location.origin.replace(/^https?:\/\//, ""), a = ["localhost:8080", "uptrends-monitor"];
    if (!(!e.response || a.some((o) => i.includes(o)))) {
      try {
        const o = (n = e.response.config.headers.Authorization) !== null && n !== void 0 ? n : "", s = o ? (t = o.toString()) === null || t === void 0 ? void 0 : t.split("Basic ")[1] : "", l = s ? atob(s).split("token:")[1] : "", u = l ? ga(l).exp : "None", m = yield Mc.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), f = m?.access_token, h = m?.refresh_token, v = f ? ga(f).exp : "None", x = h ? ga(h).exp : "None", S = typeof u == "number" ? d - u : "Unknown", N = typeof v == "number" ? d - v : "Unknown", j = typeof x == "number" ? d - x : "Unknown", y = e.response.headers["x-dixa-rid"];
        xM("Expires", {
          currentTimestamp: d,
          accessTokenFromHeader: u,
          accessTokenFromHeaderDiff: S,
          accessTokenFromLocalStorage: v,
          accessTokenFromLocalStorageDiff: N,
          refreshTokenFromLocalStorage: x,
          refreshTokenFromLocalStorageDiff: j,
          xDixaRid: y,
          navigatorOnline: navigator.onLine
        });
      } catch (o) {
        console.error("Error adding Sentry error context", o);
      }
      _M("401 unauthorized interceptor", {
        level: "debug",
        tags: {
          team: Jo.Platform,
          domain: i
        }
      });
    }
  });
}
const Xu = /* @__PURE__ */ new Map(), IM = 3;
function $M(e) {
  e.interceptors.response.use((n) => (Xu.delete(n.config.url), n), (n) => {
    var t;
    if (n.response) {
      const { status: i } = n.response;
      switch (i) {
        case uh.Unauthorized:
          if (!Mc.isRefreshTokenExpired() && n.config) {
            Ei({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const a = (t = Xu.get(n.config.url)) !== null && t !== void 0 ? t : 0;
            if (console.log(`Retrying request (${a + 1}): ${n.config.url}`), a <= IM)
              return Xu.set(n.config.url, a + 1), e(n.config);
          }
          FM(n), console.error("401 unauthorized interceptor"), Cl();
          break;
      }
    }
    return Promise.reject(n);
  });
}
var vi = function(e, n, t, i) {
  function a(o) {
    return o instanceof t ? o : new t(function(s) {
      s(o);
    });
  }
  return new (t || (t = Promise))(function(o, s) {
    function l(d) {
      try {
        m(i.next(d));
      } catch (f) {
        s(f);
      }
    }
    function u(d) {
      try {
        m(i.throw(d));
      } catch (f) {
        s(f);
      }
    }
    function m(d) {
      d.done ? o(d.value) : a(d.value).then(l, u);
    }
    m((i = i.apply(e, n || [])).next());
  });
};
const sC = ct.create();
$M(sC);
const ni = console.log;
function eb(e) {
  return vi(this, void 0, void 0, function* () {
    return new Promise((n) => setTimeout(n, e * 1e3));
  });
}
class EM extends Error {
  constructor(n, t) {
    super(n, t);
  }
}
function TM(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const OM = 5;
class RM {
  constructor() {
    Object.defineProperty(this, "authDataPromise", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  init(n) {
    return vi(this, void 0, void 0, function* () {
      const t = yield this.refresh(n);
      if (t)
        wt.setAuthData(t);
      else {
        const i = wt.isRefreshTokenExpired(n) ? "expired" : "unknown";
        throw new EM("Failed to init refresh token", {
          cause: i
        });
      }
    });
  }
  getDebugInfo() {
    const n = wt.getAccessToken();
    if (!n)
      return {};
    const t = ga(n), { exp: i } = t;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  getAuthData() {
    return vi(this, arguments, void 0, function* ({ localStorageOnly: n = !1 } = {}) {
      if (n)
        return wt.getAuthData();
      if (this.authDataPromise)
        return yield this.authDataPromise;
      const t = wt.getAuthData();
      return t ? wt.isAccessTokenExpired() ? (Ei({
        category: "refreshToken",
        // Cannot include "token" in the message, as it will be redacted
        message: "expired or about to expire",
        level: "debug",
        data: this.getDebugInfo()
      }), this.authDataPromise = this.refresh(t.refresh_token).then((i) => (i && wt.setAuthData(i), this.authDataPromise = null, i)), yield this.authDataPromise) : t : null;
    });
  }
  removeAuthData() {
    return wt.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return wt.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return wt.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = wt.getAuthData();
    return n ? wt.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  isSupported() {
    return vi(this, void 0, void 0, function* () {
      if (!Hk.isElectron())
        return !0;
      const n = yield Hk.getVersion();
      return Xz(n, "3.7.0") === 1;
    });
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  refresh(n) {
    return vi(this, arguments, void 0, function* (t, i = OM) {
      try {
        return yield sC.post(`${Ho.url.rest}/v2/login/refresh`, {
          refreshToken: t
        }).then((a) => (this.retryCount = 0, a.data.data));
      } catch (a) {
        return yield this.handleRefreshError(a, t, i);
      }
    });
  }
  waitUntilOnline() {
    return vi(this, void 0, void 0, function* () {
      const n = navigator.onLine === !1;
      for (n && (ni("AUTH", "Network connection offline - waiting..."), Ei({
        category: "refreshToken",
        message: "Network connection offline - waiting...",
        level: "debug"
      })); navigator.onLine === !1; )
        yield eb(5);
      n && (ni("AUTH", "Network connection restored"), Ei({
        category: "refreshToken",
        message: "Network connection restored",
        level: "debug"
      }));
    });
  }
  retryRefresh(n, t) {
    return vi(this, void 0, void 0, function* () {
      yield this.waitUntilOnline(), this.retryCount++;
      const i = TM(this.retryCount);
      return ni("AUTH", `Retrying in ${i} seconds`), yield eb(i), yield this.refresh(n, t);
    });
  }
  handleRefreshError(n, t, i) {
    return vi(this, void 0, void 0, function* () {
      var a;
      if (wt.isRefreshTokenExpired(t))
        return ni("AUTH", "Refresh token expired"), Ei({
          category: "refreshToken",
          message: "Refresh token expired",
          level: "debug"
        }), wt.removeAuthData(), Cl(), null;
      if (z$(n)) {
        if (n.message === "timeout exceeded")
          return ni("AUTH", "Timeout exceeded"), Ei({
            category: "refreshToken",
            message: "Timeout exceeded",
            level: "debug"
          }), yield this.retryRefresh(t, i);
        if (n.message === "Network Error")
          return ni("AUTH", "Network error"), Ei({
            category: "refreshToken",
            message: "Network error",
            level: "debug"
          }), yield this.retryRefresh(t, i);
        if (((a = n.response) === null || a === void 0 ? void 0 : a.status) === 401)
          return ni("AUTH", "Refresh token invalid (401)"), wt.removeAuthData(), Cl(), null;
        Zk(n, {
          level: "error",
          tags: {
            team: Jo.Platform,
            errorSource: "authManager.refresh"
          }
        });
      }
      return i <= 0 ? (ni("AUTH", "Retries exhausted, logging out"), Zk(n, {
        level: "error",
        tags: {
          team: Jo.Platform,
          errorSource: "authManager.refresh"
        }
      }), wt.removeAuthData(), Cl(), null) : (ni("AUTH", `Retrying ${i} more times`), yield this.retryRefresh(t, i - 1));
    });
  }
  accessTokenExpiresInMs() {
    return wt.accessTokenExpiresInMs();
  }
}
const Mc = new RM();
var uh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(uh || (uh = {}));
const DM = new Uh((e, n) => new MN((t) => {
  Mc.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(t);
  }).catch((i) => t.error(i));
})), PM = new Uh(
  (e, n) => new MN((t) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Mc.getAuthData().then((u) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...IF(Ho.url.partnerIntegrations) && u?.access_token && $F(u.access_token)
      }
    }), n(e).subscribe(t))).catch((u) => t.error(u));
  })
), AM = new AbortController(), lC = (e) => new XF({
  queryDeduplication: !1,
  cache: new ZF(),
  link: Uh.from([
    DM,
    PM,
    eI({
      uri: `${e}/graphql`,
      fetch: oI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: AM.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), LM = ({
  configuration: e,
  children: n
}) => {
  const t = Zn(
    () => lC(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ ze.jsx(nI, { client: t, children: n });
};
function VM() {
  try {
    return tI(), !0;
  } catch {
    return !1;
  }
}
const zM = ({
  configuration: e,
  children: n
}) => VM() ? n : /* @__PURE__ */ ze.jsx(LM, { configuration: e, children: n }), MM = ({
  integrationId: e,
  type: n,
  showNotification: t,
  showModal: i,
  children: a
}) => /* @__PURE__ */ ze.jsx(rI, { children: (o) => /* @__PURE__ */ ze.jsx(
  EF,
  {
    value: {
      useMutation: DF(e, n),
      useQuery: RF(e, n),
      useLazyQuery: OF(e, n),
      executeQuery: TF(e, n, o),
      showNotification: t,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), cC = ({
  integrationId: e,
  type: n,
  configuration: t,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ ze.jsx(zM, { configuration: t, children: s ? /* @__PURE__ */ ze.jsx(
    MM,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, UM = Si`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        settings {
          key
          value
        }
      }
    }
  }
`;
function BM(e) {
  const [n, t] = oe([]), [i, a] = oe(!1);
  return qe(() => {
    a(!0), lC(e).query({
      query: UM
    }).then(({ data: o }) => {
      t(o?.Management?.widgetConfigurations), a(!1);
    }).catch(() => a(!1));
  }, [e]), {
    isLoading: i,
    widgets: n
  };
}
const uC = ({
  headline: e,
  text: n,
  children: t,
  onConfirm: i,
  onCancel: a,
  confirmLabel: o,
  cancelLabel: s = "Cancel",
  confirmVariant: l = "primary",
  cancelVariant: u = "secondary",
  isOpen: m,
  setIsOpen: d,
  showOnClose: f = !1
}) => /* @__PURE__ */ ze.jsxs(
  St,
  {
    isOpen: m,
    onClose: () => {
      a && a(), d(!1);
    },
    children: [
      /* @__PURE__ */ ze.jsx(
        Nt,
        {
          title: e,
          onClose: f ? a : void 0
        }
      ),
      /* @__PURE__ */ ze.jsxs(jt, { children: [
        n && /* @__PURE__ */ ze.jsx("div", { style: { width: "600px" }, children: n }),
        t
      ] }),
      /* @__PURE__ */ ze.jsx(
        Et,
        {
          confirmOnClick: i ? () => {
            i(), d(!1);
          } : void 0,
          cancelOnClick: () => {
            a && a(), d(!1);
          },
          confirmName: o,
          cancelName: s,
          confirmProps: { variant: l },
          cancelProps: { variant: u }
        }
      )
    ]
  }
);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_1wjfs_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1wjfs_53{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1wjfs_63{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1wjfs_63:last-child:not(:only-child){border-bottom:none}._collapsible_1wjfs_72{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_1wjfs_72:hover,._collapsibleIsOpen_1wjfs_80{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_1wjfs_83{cursor:pointer}._collapsibleIconTrue_1wjfs_86{color:var(--dixa-color-green-500)}._collapsibleIconFalse_1wjfs_89{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Zu = { exports: {} }, Ja = {}, nb;
function qM() {
  if (nb) return Ja;
  nb = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return Ja.Fragment = t, Ja.jsx = s, Ja.jsxs = s, Ja;
}
var Hs = {}, tb;
function HM() {
  return tb || (tb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    Hs.Fragment = i, Hs.jsx = Un, Hs.jsxs = Bn;
  }()), Hs;
}
var rb;
function WM() {
  return rb || (rb = 1, process.env.NODE_ENV === "production" ? Zu.exports = qM() : Zu.exports = HM()), Zu.exports;
}
var se = WM();
const KM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, GM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, YM = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": KM,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": GM
};
function dC(e) {
  return YM[e] ?? {};
}
const JM = dC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), QM = dC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), XM = "_copyIcon_1wjfs_48", ZM = "_list_1wjfs_53", eU = "_listItem_1wjfs_63", nU = "_collapsible_1wjfs_72", tU = "_collapsibleIsOpen_1wjfs_80", rU = "_collapsibleHeader_1wjfs_83", iU = "_collapsibleIconTrue_1wjfs_86", aU = "_collapsibleIconFalse_1wjfs_89", Rn = {
  copyIcon: XM,
  list: ZM,
  listItem: eU,
  collapsible: nU,
  collapsibleIsOpen: tU,
  collapsibleHeader: rU,
  collapsibleIconTrue: iU,
  collapsibleIconFalse: aU
}, oU = ({
  app: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: u,
    last_used: m
  } = e;
  return /* @__PURE__ */ se.jsxs(
    _,
    {
      className: ht(Rn.collapsible, {
        [Rn.collapsibleIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ se.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Rn.collapsibleHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ se.jsx(
                lr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ se.jsxs(He, { className: Rn.list, children: [
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Tn(u).format(lt) })
          ] }) }),
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Tn(m).format(lt) })
          ] }) })
        ] })
      ]
    }
  );
}, sU = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ se.jsxs(_, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ se.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ se.jsx(A.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ se.jsx(zn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ se.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((t, i) => /* @__PURE__ */ se.jsx(oU, { app: t, openByDefault: i === 0 }, i))
  ] });
}, lU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, t = Object.keys(n).length > 0;
  return /* @__PURE__ */ se.jsx(se.Fragment, { children: /* @__PURE__ */ se.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ se.jsx(A.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !t && /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    t && /* @__PURE__ */ se.jsx(He, { className: Rn.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ se.jsx(
      He.Text,
      {
        variant: "dense",
        className: Rn.listItem,
        children: /* @__PURE__ */ se.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: i }),
          AN(a)
        ] })
      },
      o
    )) })
  ] }) });
}, cU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, t = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = t && t.length > 0;
  return /* @__PURE__ */ se.jsx(se.Fragment, { children: /* @__PURE__ */ se.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ se.jsx(A.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ se.jsx(He, { className: Rn.list, children: t.map((a, o) => /* @__PURE__ */ se.jsx(
      He.Text,
      {
        variant: "dense",
        className: Rn.listItem,
        children: /* @__PURE__ */ se.jsxs(_, { justifyContent: "space-between", children: [
          /* @__PURE__ */ se.jsx(
            Je,
            {
              content: /* @__PURE__ */ se.jsxs(_, { flexDirection: "column", children: [
                /* @__PURE__ */ se.jsx(_, { children: `First ${Tn(a?.first).format(
                  lt
                )}` }),
                /* @__PURE__ */ se.jsx(_, { children: `Last ${Tn(a?.last).format(
                  lt
                )}` })
              ] }),
              children: /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, Wl = ({
  state: e,
  noTooltip: n = !1,
  isPush: t = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const u = t ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${u}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${u}.` : `Opted in: The user has explicitly confirmed they want to receive ${u}.`;
  };
  return /* @__PURE__ */ se.jsx(Je, { content: n ? null : l(), children: /* @__PURE__ */ se.jsx(_, { alignItems: "center", children: /* @__PURE__ */ se.jsx(he, { size: 14, name: o(), color: s() }) }) });
}, uU = "_wrapper_1xucg_1", dU = "_externalLink_1xucg_7", ed = {
  wrapper: uU,
  externalLink: dU
}, mU = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: t } = si(), { isCopied: i, copy: a } = si(), { isCopied: o, copy: s } = si();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: u,
    home_city: m,
    country: d,
    email: f,
    phone: h,
    dob: v,
    created_at: x,
    email_subscribe: S,
    push_subscribe: N
  } = e, j = 14, y = `${l || ""} ${u || ""}`.trim() || "A customer has no name", q = `${m ? `${m} /` : ""} ${d || ""}`.trim(), E = v ? Tn(v).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ se.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ se.jsxs(_, { className: ed.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ se.jsxs(
      _,
      {
        justifyContent: "space-between",
        className: ed.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ se.jsx(A.Heading, { variant: "heading-2", children: y }),
          E && /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    x && /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: Tn(x).format(lt) })
    ] }),
    q && /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ se.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ se.jsx(he, { size: j, name: "map-pin" }),
        /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: q })
      ] }),
      /* @__PURE__ */ se.jsx(Je, { content: "Copy location", children: /* @__PURE__ */ se.jsx(_, { alignItems: "center", children: /* @__PURE__ */ se.jsx(
        he,
        {
          size: j,
          name: o ? "done" : "copy",
          onClick: () => s(q),
          className: Rn.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ se.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ se.jsx(he, { size: j, name: "mail" }),
        /* @__PURE__ */ se.jsx("span", { className: ed.externalLink, children: f })
      ] }),
      /* @__PURE__ */ se.jsx(Je, { content: "Copy email", children: /* @__PURE__ */ se.jsx(_, { alignItems: "center", children: /* @__PURE__ */ se.jsx(
        he,
        {
          size: j,
          name: n ? "done" : "copy",
          onClick: () => t(f),
          className: Rn.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ se.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ se.jsx(he, { size: j, name: "phone" }),
        /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: h })
      ] }),
      /* @__PURE__ */ se.jsx(Je, { content: "Copy phone number", children: /* @__PURE__ */ se.jsx(_, { alignItems: "center", children: /* @__PURE__ */ se.jsx(
        he,
        {
          size: j,
          name: i ? "done" : "copy",
          onClick: () => a(h),
          className: Rn.copyIcon
        }
      ) }) })
    ] }),
    S && /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ se.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ se.jsx(he, { size: j, name: "sync" }),
        /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ se.jsx(Wl, { state: S })
    ] }),
    N && /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ se.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ se.jsx(he, { size: j, name: "bell" }),
        /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ se.jsx(Wl, { isPush: !0, state: N })
    ] })
  ] }) });
}, pU = ({
  device: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: u,
    idfa: m,
    idfv: d,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ se.jsxs(
    _,
    {
      className: ht(Rn.collapsible, {
        [Rn.collapsibleIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ se.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Rn.collapsibleHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ se.jsx(
                lr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ se.jsxs(He, { className: Rn.list, children: [
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ se.jsx(
              he,
              {
                size: a,
                className: ht({
                  [Rn.collapsibleIconTrue]: u,
                  [Rn.collapsibleIconFalse]: !u
                }),
                name: u ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ se.jsx(Je, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(
            _,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: d })
              ]
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(Je, { content: "For iOS", children: /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(
            _,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(
            _,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(
            _,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, fU = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ se.jsxs(_, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ se.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ se.jsx(A.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ se.jsx(zn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ se.jsx(
      A.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((t, i) => /* @__PURE__ */ se.jsx(pU, { device: t, openByDefault: i === 0 }, i))
  ] });
}, Qa = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, Ws = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: t
}) => {
  const { track: i } = hn(), { useMutation: a } = un(), [o, s] = oe(!1), [l] = a(
    QM,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), u = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Qa[n].parameter
        }
      }
    }), setTimeout(async () => {
      await t().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ se.jsx(Je, { content: Qa[n].tooltipContent, children: /* @__PURE__ */ se.jsx(
    qn,
    {
      variant: "secondary",
      color: Qa[n].color,
      isLoading: o,
      onClick: () => u(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ se.jsxs(_, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ se.jsx(
          Wl,
          {
            noTooltip: !0,
            state: Qa[n].parameter
          }
        ),
        Qa[n].label
      ] })
    }
  ) });
}, hU = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: t
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ se.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ se.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ se.jsx(A.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ se.jsx(He, { className: Rn.list, children: /* @__PURE__ */ se.jsx(He.Text, { variant: "dense", className: Rn.listItem, children: /* @__PURE__ */ se.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ se.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ se.jsx(he, { size: 14, name: "sync" }),
        /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ se.jsx(Wl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ se.jsxs(_, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ se.jsxs(se.Fragment, { children: [
        /* @__PURE__ */ se.jsx(
          Ws,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: t
          }
        ),
        /* @__PURE__ */ se.jsx(
          Ws,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: t
          }
        )
      ] }),
      s && /* @__PURE__ */ se.jsx(
        Ws,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: t
        }
      ),
      l && /* @__PURE__ */ se.jsx(
        Ws,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: t
        }
      )
    ] })
  ] }) });
}, vU = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, t = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = t && t.length > 0;
  return /* @__PURE__ */ se.jsx(se.Fragment, { children: /* @__PURE__ */ se.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ se.jsx(A.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ se.jsx(He, { className: Rn.list, children: t.map((a, o) => /* @__PURE__ */ se.jsx(
      He.Text,
      {
        variant: "dense",
        className: Rn.listItem,
        children: /* @__PURE__ */ se.jsxs(_, { justifyContent: "space-between", children: [
          /* @__PURE__ */ se.jsx(
            Je,
            {
              content: /* @__PURE__ */ se.jsxs(_, { flexDirection: "column", children: [
                /* @__PURE__ */ se.jsx(_, { children: `First ${Tn(a?.first).format(
                  lt
                )}` }),
                /* @__PURE__ */ se.jsx(_, { children: `Last ${Tn(a?.last).format(
                  lt
                )}` })
              ] }),
              children: /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ se.jsx(A.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, yU = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: t } = hn(), { useMutation: i } = un(), [a, o] = oe(), [s, l] = oe(!1), [u, m] = oe(!1), d = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, v = n.updateEmailSubscriptionState ?? !1, x = n.displayCustomAttributes ?? !1, S = n.displayCustomEvents ?? !1, N = n.displayPuchases ?? !1, j = n.displayDevices ?? !1, y = n.displayApps ?? !1, q = !h && !v && !x && !S && !N, [E, { error: C }] = i(
    JM,
    {
      onError: () => {
      },
      onCompleted: (U) => {
        const Z = U?.Braze?.exportUserDetails?.users?.[0];
        Z ? (o(Z), l(!1), t("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), T = async () => {
    d || f ? await E({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...d ? { email_address: d } : { phone: f },
          fields_to_export: [
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  return qe(() => {
    async function U() {
      m(!0), await T();
    }
    U().finally(() => m(!1));
  }, [d, f]), C ? Ph({ errors: C.graphQLErrors }) ? /* @__PURE__ */ se.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Ah({ errors: C.graphQLErrors }) ? /* @__PURE__ */ se.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Braze. Please contact your administrator."
    }
  ) : /* @__PURE__ */ se.jsx(_n, { error: C }) : u ? /* @__PURE__ */ se.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ se.jsx(cn, {}) }) : q ? /* @__PURE__ */ se.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ se.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ se.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ se.jsx(mU, { customerDetails: a }),
        v && !!a && /* @__PURE__ */ se.jsx(
          hU,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await T()
          }
        ),
        x && !!a && /* @__PURE__ */ se.jsx(lU, { customerDetails: a }),
        S && !!a && /* @__PURE__ */ se.jsx(cU, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ se.jsx(vU, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ se.jsx(fU, { devices: a?.devices }),
        y && !!a && /* @__PURE__ */ se.jsx(sU, { apps: a?.apps })
      ]
    }
  );
}, gU = [
  {
    key: "apiHostName",
    label: "API endpoint",
    placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => PN(e)
  },
  {
    key: "brazeApiKey",
    label: "API key",
    placeholder: "Insert your API key",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayPuchases",
    label: "Display a list of purchases",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    secret: !1,
    defaultValue: !0,
    type: "switch"
  }
];
function kU() {
  var e = ha(!1), n = ft(function() {
    return e.current;
  }, []);
  return qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var bU = function(e) {
  e === void 0 && (e = {});
  var n = oe(e), t = n[0], i = n[1], a = ft(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [t, a];
}, _U = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, ib = function(e) {
  return MF(_U, e);
}, nd, ab;
function xU() {
  return ab || (ab = 1, nd = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, t = [], i = 0; i < e.rangeCount; i++)
      t.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || t.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), nd;
}
var td, ob;
function SU() {
  if (ob) return td;
  ob = 1;
  var e = xU(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, t = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, u, m, d, f, h, v = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), d = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(S) {
        if (S.stopPropagation(), s.format)
          if (S.preventDefault(), typeof S.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var N = n[s.format] || n.default;
            window.clipboardData.setData(N, o);
          } else
            S.clipboardData.clearData(), S.clipboardData.setData(s.format, o);
        s.onCopy && (S.preventDefault(), s.onCopy(S.clipboardData));
      }), document.body.appendChild(h), d.selectNodeContents(h), f.addRange(d);
      var x = document.execCommand("copy");
      if (!x)
        throw new Error("copy command was unsuccessful");
      v = !0;
    } catch (S) {
      l && console.error("unable to copy using execCommand: ", S), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), v = !0;
      } catch (N) {
        l && console.error("unable to copy using clipboardData: ", N), l && console.error("falling back to prompt"), u = i("message" in s ? s.message : t), window.prompt(u, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(d) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return v;
  }
  return td = a, td;
}
var NU = SU();
const jU = /* @__PURE__ */ Bh(NU);
var mC = function() {
  var e = kU(), n = bU({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), t = n[0], i = n[1], a = ft(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var u = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var u = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(u), i({
            value: o,
            error: u,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = jU(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [t, a];
};
function wU(e, n) {
  var t = ha(!1), i = ha(), a = ha(e), o = ft(function() {
    return t.current;
  }, []), s = ft(function() {
    t.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      t.current = !0, a.current();
    }, n);
  }, [n]), l = ft(function() {
    t.current = null, i.current && clearTimeout(i.current);
  }, []);
  return qe(function() {
    a.current = e;
  }, [e]), qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function Va(e, n, t) {
  t === void 0 && (t = []);
  var i = wU(e, n), a = i[0], o = i[1], s = i[2];
  return qe(s, t), [a, o];
}
var CU = function(e) {
  qe(e, []);
}, FU = function(e, n) {
  var t = ha(function() {
  });
  qe(function() {
    t.current = e;
  }), qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return t.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, IU = function(e) {
  e === void 0 && (e = {});
  var n = oe(e), t = n[0], i = n[1], a = Zn(function() {
    return {
      set: function(s, l) {
        i(function(u) {
          var m;
          return tu(tu({}, u), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var u = l, m = s;
          u[m];
          var d = sI(u, [typeof m == "symbol" ? m : m + ""]);
          return d;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = tu({ get: ft(function(s) {
    return t[s];
  }, [t]) }, a);
  return [t, o];
}, $U = function(e) {
  var n = ha(e);
  n.current = e, CU(function() {
    return function() {
      return n.current();
    };
  });
}, _s = (e) => e.type === "checkbox", Pi = (e) => e instanceof Date, zt = (e) => e == null;
const pC = (e) => typeof e == "object";
var at = (e) => !zt(e) && !Array.isArray(e) && pC(e) && !Pi(e), fC = (e) => at(e) && e.target ? _s(e.target) ? e.target.checked : e.target.value : e, EU = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, hC = (e, n) => e.has(EU(n)), TU = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return at(n) && n.hasOwnProperty("isPrototypeOf");
}, Iv = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Ft(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Iv && (e instanceof Blob || i)) && (t || at(e)))
    if (n = t ? [] : {}, !t && !TU(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Ft(e[a]));
  else
    return e;
  return n;
}
var Uc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], tt = (e) => e === void 0, Ke = (e, n, t) => {
  if (!n || !at(e))
    return t;
  const i = Uc(n.split(/[,[\].]+?/)).reduce((a, o) => zt(a) ? a : a[o], e);
  return tt(i) || i === e ? tt(e[n]) ? t : e[n] : i;
}, rr = (e) => typeof e == "boolean", $v = (e) => /^\w*$/.test(e), vC = (e) => Uc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Wn = (e, n, t) => {
  let i = -1;
  const a = $v(n) ? [n] : vC(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = t;
    if (i !== s) {
      const m = e[l];
      u = at(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const Kl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, wr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ti = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, yC = xe.createContext(null), Zr = () => xe.useContext(yC), Ev = (e) => {
  const { children: n, ...t } = e;
  return xe.createElement(yC.Provider, { value: t }, n);
};
var gC = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== wr.all && (n._proxyFormState[s] = !i || wr.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function OU(e) {
  const n = Zr(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = xe.useState(t._formState), u = xe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = xe.useRef(a);
  return m.current = a, xe.useEffect(() => t._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), xe.useEffect(() => {
    u.current.isValid && t._setValid(!0);
  }, [t]), xe.useMemo(() => gC(s, t, u.current, !1), [s, t]);
}
var Kr = (e) => typeof e == "string", kC = (e, n, t, i, a) => Kr(e) ? (i && n.watch.add(e), Ke(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ke(t, o))) : (i && (n.watchAll = !0), t);
function Fl(e) {
  const n = Zr(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = xe.useRef(i), u = xe.useRef(a);
  l.current = i, xe.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(kC(l.current, t._names, f.values || t._formValues, !1, u.current))
  }), [t, o, s]);
  const [m, d] = xe.useState(t._getWatch(i, a));
  return xe.useEffect(() => t._removeUnmounted()), m;
}
function Tv(e) {
  const n = Zr(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = hC(a._names.array, t), l = Fl({
    control: a,
    name: t,
    defaultValue: Ke(a._formValues, t, Ke(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), u = OU({
    control: a,
    name: t,
    exact: !0
  }), m = xe.useRef(e), d = xe.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...rr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = xe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ke(u.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ke(u.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ke(u.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ke(u.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Ke(u.errors, t)
    }
  }), [u, t]), h = xe.useCallback((N) => d.current.onChange({
    target: {
      value: fC(N),
      name: t
    },
    type: Kl.CHANGE
  }), [t]), v = xe.useCallback(() => d.current.onBlur({
    target: {
      value: Ke(a._formValues, t),
      name: t
    },
    type: Kl.BLUR
  }), [t, a._formValues]), x = xe.useCallback((N) => {
    const j = Ke(a._fields, t);
    j && N && (j._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, t]), S = xe.useMemo(() => ({
    name: t,
    value: l,
    ...rr(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: x
  }), [t, i, u.disabled, h, v, x, l]);
  return xe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...rr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const j = (y, q) => {
      const E = Ke(a._fields, y);
      E && E._f && (E._f.mount = q);
    };
    if (j(t, !0), N) {
      const y = Ft(Ke(a._options.defaultValues, t));
      Wn(a._defaultValues, t, y), tt(Ke(a._formValues, t)) && Wn(a._formValues, t, y);
    }
    return !s && a.register(t), () => {
      (s ? N && !a._state.action : N) ? a.unregister(t) : j(t, !1);
    };
  }, [t, a, s, o]), xe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), xe.useMemo(() => ({
    field: S,
    formState: u,
    fieldState: f
  }), [S, u, f]);
}
const Bt = (e) => e.render(Tv(e));
var RU = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, Do = (e) => Array.isArray(e) ? e : [e], sb = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, dh = (e) => zt(e) || !pC(e);
function gi(e, n) {
  if (dh(e) || dh(n))
    return e === n;
  if (Pi(e) && Pi(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Pi(o) && Pi(s) || at(o) && at(s) || Array.isArray(o) && Array.isArray(s) ? !gi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var At = (e) => at(e) && !Object.keys(e).length, Ov = (e) => e.type === "file", Cr = (e) => typeof e == "function", Gl = (e) => {
  if (!Iv)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, bC = (e) => e.type === "select-multiple", Rv = (e) => e.type === "radio", DU = (e) => Rv(e) || _s(e), rd = (e) => Gl(e) && e.isConnected;
function PU(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = tt(e) ? i++ : e[n[i++]];
  return e;
}
function AU(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !tt(e[n]))
      return !1;
  return !0;
}
function yt(e, n) {
  const t = Array.isArray(n) ? n : $v(n) ? [n] : vC(n), i = t.length === 1 ? e : PU(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (at(i) && At(i) || Array.isArray(i) && AU(i)) && yt(e, t.slice(0, -1)), e;
}
var _C = (e) => {
  for (const n in e)
    if (Cr(e[n]))
      return !0;
  return !1;
};
function Yl(e, n = {}) {
  const t = Array.isArray(e);
  if (at(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || at(e[i]) && !_C(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Yl(e[i], n[i])) : zt(e[i]) || (n[i] = !0);
  return n;
}
function xC(e, n, t) {
  const i = Array.isArray(e);
  if (at(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || at(e[a]) && !_C(e[a]) ? tt(n) || dh(t[a]) ? t[a] = Array.isArray(e[a]) ? Yl(e[a], []) : { ...Yl(e[a]) } : xC(e[a], zt(n) ? {} : n[a], t[a]) : t[a] = !gi(e[a], n[a]);
  return t;
}
var Xa = (e, n) => xC(e, n, Yl(n));
const lb = {
  value: !1,
  isValid: !1
}, cb = { value: !0, isValid: !0 };
var SC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !tt(e[0].attributes.value) ? tt(e[0].value) || e[0].value === "" ? cb : { value: e[0].value, isValid: !0 } : cb
    ) : lb;
  }
  return lb;
}, NC = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => tt(e) ? e : n ? e === "" ? NaN : e && +e : t && Kr(e) ? new Date(e) : i ? i(e) : e;
const ub = {
  isValid: !1,
  value: null
};
var jC = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, ub) : ub;
function db(e) {
  const n = e.ref;
  return Ov(n) ? n.files : Rv(n) ? jC(e.refs).value : bC(n) ? [...n.selectedOptions].map(({ value: t }) => t) : _s(n) ? SC(e.refs).value : NC(tt(n.value) ? e.ref.value : n.value, e);
}
var LU = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Ke(n, o);
    s && Wn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Jl = (e) => e instanceof RegExp, Za = (e) => tt(e) ? e : Jl(e) ? e.source : at(e) ? Jl(e.value) ? e.value.source : e.value : e, mb = (e) => ({
  isOnSubmit: !e || e === wr.onSubmit,
  isOnBlur: e === wr.onBlur,
  isOnChange: e === wr.onChange,
  isOnAll: e === wr.all,
  isOnTouch: e === wr.onTouched
});
const pb = "AsyncFunction";
var VU = (e) => !!e && !!e.validate && !!(Cr(e.validate) && e.validate.constructor.name === pb || at(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === pb)), zU = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), fb = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Po = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Ke(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Po(l, n))
          break;
      } else if (at(l) && Po(l, n))
        break;
    }
  }
};
function hb(e, n, t) {
  const i = Ke(e, t);
  if (i || $v(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ke(n, o), l = Ke(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var MU = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return At(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || wr.all));
}, UU = (e, n, t) => !e || !n || e === n || Do(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), BU = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, qU = (e, n) => !Uc(Ke(e, n)).length && yt(e, n), HU = (e, n, t) => {
  const i = Do(Ke(e, t));
  return Wn(i, "root", n[t]), Wn(e, t, i), e;
}, Il = (e) => Kr(e);
function vb(e, n, t = "validate") {
  if (Il(e) || Array.isArray(e) && e.every(Il) || rr(e) && !e)
    return {
      type: t,
      message: Il(e) ? e : "",
      ref: n
    };
}
var ra = (e) => at(e) && !Jl(e) ? e : {
  value: e,
  message: ""
}, yb = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: v, validate: x, name: S, valueAsNumber: N, mount: j } = e._f, y = Ke(t, S);
  if (!j || n.has(S))
    return {};
  const q = l ? l[0] : s, E = (K) => {
    a && q.reportValidity && (q.setCustomValidity(rr(K) ? "" : K || ""), q.reportValidity());
  }, C = {}, T = Rv(s), U = _s(s), Z = T || U, Q = (N || Ov(s)) && tt(s.value) && tt(y) || Gl(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ee = RU.bind(null, S, i, C), J = (K, D, G, ne = ti.maxLength, de = ti.minLength) => {
    const ge = K ? D : G;
    C[S] = {
      type: K ? ne : de,
      message: ge,
      ref: s,
      ...ee(K ? ne : de, ge)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Z && (Q || zt(y)) || rr(y) && !y || U && !SC(l).isValid || T && !jC(l).isValid)) {
    const { value: K, message: D } = Il(u) ? { value: !!u, message: u } : ra(u);
    if (K && (C[S] = {
      type: ti.required,
      message: D,
      ref: q,
      ...ee(ti.required, D)
    }, !i))
      return E(D), C;
  }
  if (!Q && (!zt(f) || !zt(h))) {
    let K, D;
    const G = ra(h), ne = ra(f);
    if (!zt(y) && !isNaN(y)) {
      const de = s.valueAsNumber || y && +y;
      zt(G.value) || (K = de > G.value), zt(ne.value) || (D = de < ne.value);
    } else {
      const de = s.valueAsDate || new Date(y), ge = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ce = s.type == "time", ve = s.type == "week";
      Kr(G.value) && y && (K = ce ? ge(y) > ge(G.value) : ve ? y > G.value : de > new Date(G.value)), Kr(ne.value) && y && (D = ce ? ge(y) < ge(ne.value) : ve ? y < ne.value : de < new Date(ne.value));
    }
    if ((K || D) && (J(!!K, G.message, ne.message, ti.max, ti.min), !i))
      return E(C[S].message), C;
  }
  if ((m || d) && !Q && (Kr(y) || o && Array.isArray(y))) {
    const K = ra(m), D = ra(d), G = !zt(K.value) && y.length > +K.value, ne = !zt(D.value) && y.length < +D.value;
    if ((G || ne) && (J(G, K.message, D.message), !i))
      return E(C[S].message), C;
  }
  if (v && !Q && Kr(y)) {
    const { value: K, message: D } = ra(v);
    if (Jl(K) && !y.match(K) && (C[S] = {
      type: ti.pattern,
      message: D,
      ref: s,
      ...ee(ti.pattern, D)
    }, !i))
      return E(D), C;
  }
  if (x) {
    if (Cr(x)) {
      const K = await x(y, t), D = vb(K, q);
      if (D && (C[S] = {
        ...D,
        ...ee(ti.validate, D.message)
      }, !i))
        return E(D.message), C;
    } else if (at(x)) {
      let K = {};
      for (const D in x) {
        if (!At(K) && !i)
          break;
        const G = vb(await x[D](y, t), q, D);
        G && (K = {
          ...G,
          ...ee(D, G.message)
        }, E(G.message), i && (C[S] = K));
      }
      if (!At(K) && (C[S] = {
        ref: q,
        ...K
      }, !i))
        return C;
    }
  }
  return E(!0), C;
};
const WU = {
  mode: wr.onSubmit,
  reValidateMode: wr.onChange,
  shouldFocusError: !0
};
function KU(e = {}) {
  let n = {
    ...WU,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Cr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = at(n.defaultValues) || at(n.values) ? Ft(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Ft(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: sb(),
    state: sb()
  }, v = mb(n.mode), x = mb(n.reValidateMode), S = n.criteriaMode === wr.all, N = (b) => ($) => {
    clearTimeout(m), m = setTimeout(b, $);
  }, j = async (b) => {
    if (!n.disabled && (d.isValid || f.isValid || b)) {
      const $ = n.resolver ? At((await Q()).errors) : await J(i, !0);
      $ !== t.isValid && h.state.next({
        isValid: $
      });
    }
  }, y = (b, $) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((b || Array.from(l.mount)).forEach((Y) => {
      Y && ($ ? Wn(t.validatingFields, Y, $) : yt(t.validatingFields, Y));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !At(t.validatingFields)
    }));
  }, q = (b, $ = [], Y, X, R = !0, B = !0) => {
    if (X && Y && !n.disabled) {
      if (s.action = !0, B && Array.isArray(Ke(i, b))) {
        const te = Y(Ke(i, b), X.argA, X.argB);
        R && Wn(i, b, te);
      }
      if (B && Array.isArray(Ke(t.errors, b))) {
        const te = Y(Ke(t.errors, b), X.argA, X.argB);
        R && Wn(t.errors, b, te), qU(t.errors, b);
      }
      if ((d.touchedFields || f.touchedFields) && B && Array.isArray(Ke(t.touchedFields, b))) {
        const te = Y(Ke(t.touchedFields, b), X.argA, X.argB);
        R && Wn(t.touchedFields, b, te);
      }
      (d.dirtyFields || f.dirtyFields) && (t.dirtyFields = Xa(a, o)), h.state.next({
        name: b,
        isDirty: D(b, $),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Wn(o, b, $);
  }, E = (b, $) => {
    Wn(t.errors, b, $), h.state.next({
      errors: t.errors
    });
  }, C = (b) => {
    t.errors = b, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, T = (b, $, Y, X) => {
    const R = Ke(i, b);
    if (R) {
      const B = Ke(o, b, tt(Y) ? Ke(a, b) : Y);
      tt(B) || X && X.defaultChecked || $ ? Wn(o, b, $ ? B : db(R._f)) : de(b, B), s.mount && j();
    }
  }, U = (b, $, Y, X, R) => {
    let B = !1, te = !1;
    const pe = {
      name: b
    };
    if (!n.disabled) {
      if (!Y || X) {
        (d.isDirty || f.isDirty) && (te = t.isDirty, t.isDirty = pe.isDirty = D(), B = te !== pe.isDirty);
        const _e = gi(Ke(a, b), $);
        te = !!Ke(t.dirtyFields, b), _e ? yt(t.dirtyFields, b) : Wn(t.dirtyFields, b, !0), pe.dirtyFields = t.dirtyFields, B = B || (d.dirtyFields || f.dirtyFields) && te !== !_e;
      }
      if (Y) {
        const _e = Ke(t.touchedFields, b);
        _e || (Wn(t.touchedFields, b, Y), pe.touchedFields = t.touchedFields, B = B || (d.touchedFields || f.touchedFields) && _e !== Y);
      }
      B && R && h.state.next(pe);
    }
    return B ? pe : {};
  }, Z = (b, $, Y, X) => {
    const R = Ke(t.errors, b), B = (d.isValid || f.isValid) && rr($) && t.isValid !== $;
    if (n.delayError && Y ? (u = N(() => E(b, Y)), u(n.delayError)) : (clearTimeout(m), u = null, Y ? Wn(t.errors, b, Y) : yt(t.errors, b)), (Y ? !gi(R, Y) : R) || !At(X) || B) {
      const te = {
        ...X,
        ...B && rr($) ? { isValid: $ } : {},
        errors: t.errors,
        name: b
      };
      t = {
        ...t,
        ...te
      }, h.state.next(te);
    }
  }, Q = async (b) => {
    y(b, !0);
    const $ = await n.resolver(o, n.context, LU(b || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(b), $;
  }, ee = async (b) => {
    const { errors: $ } = await Q(b);
    if (b)
      for (const Y of b) {
        const X = Ke($, Y);
        X ? Wn(t.errors, Y, X) : yt(t.errors, Y);
      }
    else
      t.errors = $;
    return $;
  }, J = async (b, $, Y = {
    valid: !0
  }) => {
    for (const X in b) {
      const R = b[X];
      if (R) {
        const { _f: B, ...te } = R;
        if (B) {
          const pe = l.array.has(B.name), _e = R._f && VU(R._f);
          _e && d.validatingFields && y([X], !0);
          const Ze = await yb(R, l.disabled, o, S, n.shouldUseNativeValidation && !$, pe);
          if (_e && d.validatingFields && y([X]), Ze[B.name] && (Y.valid = !1, $))
            break;
          !$ && (Ke(Ze, B.name) ? pe ? HU(t.errors, Ze, B.name) : Wn(t.errors, B.name, Ze[B.name]) : yt(t.errors, B.name));
        }
        !At(te) && await J(te, $, Y);
      }
    }
    return Y.valid;
  }, K = () => {
    for (const b of l.unMount) {
      const $ = Ke(i, b);
      $ && ($._f.refs ? $._f.refs.every((Y) => !rd(Y)) : !rd($._f.ref)) && Ve(b);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, D = (b, $) => !n.disabled && (b && $ && Wn(o, b, $), !gi(je(), a)), G = (b, $, Y) => kC(b, l, {
    ...s.mount ? o : tt($) ? a : Kr(b) ? { [b]: $ } : $
  }, Y, $), ne = (b) => Uc(Ke(s.mount ? o : a, b, n.shouldUnregister ? Ke(a, b, []) : [])), de = (b, $, Y = {}) => {
    const X = Ke(i, b);
    let R = $;
    if (X) {
      const B = X._f;
      B && (!B.disabled && Wn(o, b, NC($, B)), R = Gl(B.ref) && zt($) ? "" : $, bC(B.ref) ? [...B.ref.options].forEach((te) => te.selected = R.includes(te.value)) : B.refs ? _s(B.ref) ? B.refs.length > 1 ? B.refs.forEach((te) => (!te.defaultChecked || !te.disabled) && (te.checked = Array.isArray(R) ? !!R.find((pe) => pe === te.value) : R === te.value)) : B.refs[0] && (B.refs[0].checked = !!R) : B.refs.forEach((te) => te.checked = te.value === R) : Ov(B.ref) ? B.ref.value = "" : (B.ref.value = R, B.ref.type || h.state.next({
        name: b,
        values: Ft(o)
      })));
    }
    (Y.shouldDirty || Y.shouldTouch) && U(b, R, Y.shouldTouch, Y.shouldDirty, !0), Y.shouldValidate && be(b);
  }, ge = (b, $, Y) => {
    for (const X in $) {
      const R = $[X], B = `${b}.${X}`, te = Ke(i, B);
      (l.array.has(b) || at(R) || te && !te._f) && !Pi(R) ? ge(B, R, Y) : de(B, R, Y);
    }
  }, ce = (b, $, Y = {}) => {
    const X = Ke(i, b), R = l.array.has(b), B = Ft($);
    Wn(o, b, B), R ? (h.array.next({
      name: b,
      values: Ft(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && Y.shouldDirty && h.state.next({
      name: b,
      dirtyFields: Xa(a, o),
      isDirty: D(b, B)
    })) : X && !X._f && !zt(B) ? ge(b, B, Y) : de(b, B, Y), fb(b, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? b : void 0,
      values: Ft(o)
    });
  }, ve = async (b) => {
    s.mount = !0;
    const $ = b.target;
    let Y = $.name, X = !0;
    const R = Ke(i, Y), B = (te) => {
      X = Number.isNaN(te) || Pi(te) && isNaN(te.getTime()) || gi(te, Ke(o, Y, te));
    };
    if (R) {
      let te, pe;
      const _e = $.type ? db(R._f) : fC(b), Ze = b.type === Kl.BLUR || b.type === Kl.FOCUS_OUT, dn = !zU(R._f) && !n.resolver && !Ke(t.errors, Y) && !R._f.deps || BU(Ze, Ke(t.touchedFields, Y), t.isSubmitted, x, v), nn = fb(Y, l, Ze);
      Wn(o, Y, _e), Ze ? (R._f.onBlur && R._f.onBlur(b), u && u(0)) : R._f.onChange && R._f.onChange(b);
      const rn = U(Y, _e, Ze), fn = !At(rn) || nn;
      if (!Ze && h.state.next({
        name: Y,
        type: b.type,
        values: Ft(o)
      }), dn)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? Ze && j() : Ze || j()), fn && h.state.next({ name: Y, ...nn ? {} : rn });
      if (!Ze && nn && h.state.next({ ...t }), n.resolver) {
        const { errors: mn } = await Q([Y]);
        if (B(_e), X) {
          const vn = hb(t.errors, i, Y), Qe = hb(mn, i, vn.name || Y);
          te = Qe.error, Y = Qe.name, pe = At(mn);
        }
      } else
        y([Y], !0), te = (await yb(R, l.disabled, o, S, n.shouldUseNativeValidation))[Y], y([Y]), B(_e), X && (te ? pe = !1 : (d.isValid || f.isValid) && (pe = await J(i, !0)));
      X && (R._f.deps && be(R._f.deps), Z(Y, pe, te, rn));
    }
  }, H = (b, $) => {
    if (Ke(t.errors, $) && b.focus)
      return b.focus(), 1;
  }, be = async (b, $ = {}) => {
    let Y, X;
    const R = Do(b);
    if (n.resolver) {
      const B = await ee(tt(b) ? b : R);
      Y = At(B), X = b ? !R.some((te) => Ke(B, te)) : Y;
    } else b ? (X = (await Promise.all(R.map(async (B) => {
      const te = Ke(i, B);
      return await J(te && te._f ? { [B]: te } : te);
    }))).every(Boolean), !(!X && !t.isValid) && j()) : X = Y = await J(i);
    return h.state.next({
      ...!Kr(b) || (d.isValid || f.isValid) && Y !== t.isValid ? {} : { name: b },
      ...n.resolver || !b ? { isValid: Y } : {},
      errors: t.errors
    }), $.shouldFocus && !X && Po(i, H, b ? R : l.mount), X;
  }, je = (b) => {
    const $ = {
      ...s.mount ? o : a
    };
    return tt(b) ? $ : Kr(b) ? Ke($, b) : b.map((Y) => Ke($, Y));
  }, W = (b, $) => ({
    invalid: !!Ke(($ || t).errors, b),
    isDirty: !!Ke(($ || t).dirtyFields, b),
    error: Ke(($ || t).errors, b),
    isValidating: !!Ke(t.validatingFields, b),
    isTouched: !!Ke(($ || t).touchedFields, b)
  }), Ue = (b) => {
    b && Do(b).forEach(($) => yt(t.errors, $)), h.state.next({
      errors: b ? t.errors : {}
    });
  }, Me = (b, $, Y) => {
    const X = (Ke(i, b, { _f: {} })._f || {}).ref, R = Ke(t.errors, b) || {}, { ref: B, message: te, type: pe, ..._e } = R;
    Wn(t.errors, b, {
      ..._e,
      ...$,
      ref: X
    }), h.state.next({
      name: b,
      errors: t.errors,
      isValid: !1
    }), Y && Y.shouldFocus && X && X.focus && X.focus();
  }, De = (b, $) => Cr(b) ? h.state.subscribe({
    next: (Y) => b(G(void 0, $), Y)
  }) : G(b, $, !0), Be = (b) => h.state.subscribe({
    next: ($) => {
      UU(b.name, $.name, b.exact) && MU($, b.formState || d, Fe, b.reRenderRoot) && b.callback({
        values: { ...o },
        ...t,
        ...$
      });
    }
  }).unsubscribe, Ee = (b) => (s.mount = !0, f = {
    ...f,
    ...b.formState
  }, Be({
    ...b,
    formState: f
  })), Ve = (b, $ = {}) => {
    for (const Y of b ? Do(b) : l.mount)
      l.mount.delete(Y), l.array.delete(Y), $.keepValue || (yt(i, Y), yt(o, Y)), !$.keepError && yt(t.errors, Y), !$.keepDirty && yt(t.dirtyFields, Y), !$.keepTouched && yt(t.touchedFields, Y), !$.keepIsValidating && yt(t.validatingFields, Y), !n.shouldUnregister && !$.keepDefaultValue && yt(a, Y);
    h.state.next({
      values: Ft(o)
    }), h.state.next({
      ...t,
      ...$.keepDirty ? { isDirty: D() } : {}
    }), !$.keepIsValid && j();
  }, Re = ({ disabled: b, name: $ }) => {
    (rr(b) && s.mount || b || l.disabled.has($)) && (b ? l.disabled.add($) : l.disabled.delete($));
  }, tn = (b, $ = {}) => {
    let Y = Ke(i, b);
    const X = rr($.disabled) || rr(n.disabled);
    return Wn(i, b, {
      ...Y || {},
      _f: {
        ...Y && Y._f ? Y._f : { ref: { name: b } },
        name: b,
        mount: !0,
        ...$
      }
    }), l.mount.add(b), Y ? Re({
      disabled: rr($.disabled) ? $.disabled : n.disabled,
      name: b
    }) : T(b, !0, $.value), {
      ...X ? { disabled: $.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!$.required,
        min: Za($.min),
        max: Za($.max),
        minLength: Za($.minLength),
        maxLength: Za($.maxLength),
        pattern: Za($.pattern)
      } : {},
      name: b,
      onChange: ve,
      onBlur: ve,
      ref: (R) => {
        if (R) {
          tn(b, $), Y = Ke(i, b);
          const B = tt(R.value) && R.querySelectorAll && R.querySelectorAll("input,select,textarea")[0] || R, te = DU(B), pe = Y._f.refs || [];
          if (te ? pe.find((_e) => _e === B) : B === Y._f.ref)
            return;
          Wn(i, b, {
            _f: {
              ...Y._f,
              ...te ? {
                refs: [
                  ...pe.filter(rd),
                  B,
                  ...Array.isArray(Ke(a, b)) ? [{}] : []
                ],
                ref: { type: B.type, name: b }
              } : { ref: B }
            }
          }), T(b, !1, void 0, B);
        } else
          Y = Ke(i, b, {}), Y._f && (Y._f.mount = !1), (n.shouldUnregister || $.shouldUnregister) && !(hC(l.array, b) && s.action) && l.unMount.add(b);
      }
    };
  }, Ne = () => n.shouldFocusError && Po(i, H, l.mount), We = (b) => {
    rr(b) && (h.state.next({ disabled: b }), Po(i, ($, Y) => {
      const X = Ke(i, Y);
      X && ($.disabled = X._f.disabled || b, Array.isArray(X._f.refs) && X._f.refs.forEach((R) => {
        R.disabled = X._f.disabled || b;
      }));
    }, 0, !1));
  }, Oe = (b, $) => async (Y) => {
    let X;
    Y && (Y.preventDefault && Y.preventDefault(), Y.persist && Y.persist());
    let R = Ft(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: B, values: te } = await Q();
      t.errors = B, R = te;
    } else
      await J(i);
    if (l.disabled.size)
      for (const B of l.disabled)
        Wn(R, B, void 0);
    if (yt(t.errors, "root"), At(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await b(R, Y);
      } catch (B) {
        X = B;
      }
    } else
      $ && await $({ ...t.errors }, Y), Ne(), setTimeout(Ne);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: At(t.errors) && !X,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), X)
      throw X;
  }, ue = (b, $ = {}) => {
    Ke(i, b) && (tt($.defaultValue) ? ce(b, Ft(Ke(a, b))) : (ce(b, $.defaultValue), Wn(a, b, Ft($.defaultValue))), $.keepTouched || yt(t.touchedFields, b), $.keepDirty || (yt(t.dirtyFields, b), t.isDirty = $.defaultValue ? D(b, Ft(Ke(a, b))) : D()), $.keepError || (yt(t.errors, b), d.isValid && j()), h.state.next({ ...t }));
  }, fe = (b, $ = {}) => {
    const Y = b ? Ft(b) : a, X = Ft(Y), R = At(b), B = R ? a : X;
    if ($.keepDefaultValues || (a = Y), !$.keepValues) {
      if ($.keepDirtyValues) {
        const te = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Xa(a, o))
        ]);
        for (const pe of Array.from(te))
          Ke(t.dirtyFields, pe) ? Wn(B, pe, Ke(o, pe)) : ce(pe, Ke(B, pe));
      } else {
        if (Iv && tt(b))
          for (const te of l.mount) {
            const pe = Ke(i, te);
            if (pe && pe._f) {
              const _e = Array.isArray(pe._f.refs) ? pe._f.refs[0] : pe._f.ref;
              if (Gl(_e)) {
                const Ze = _e.closest("form");
                if (Ze) {
                  Ze.reset();
                  break;
                }
              }
            }
          }
        for (const te of l.mount)
          ce(te, Ke(B, te));
      }
      o = Ft(B), h.array.next({
        values: { ...B }
      }), h.state.next({
        values: { ...B }
      });
    }
    l = {
      mount: $.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!$.keepIsValid || !!$.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: $.keepSubmitCount ? t.submitCount : 0,
      isDirty: R ? !1 : $.keepDirty ? t.isDirty : !!($.keepDefaultValues && !gi(b, a)),
      isSubmitted: $.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: R ? {} : $.keepDirtyValues ? $.keepDefaultValues && o ? Xa(a, o) : t.dirtyFields : $.keepDefaultValues && b ? Xa(a, b) : $.keepDirty ? t.dirtyFields : {},
      touchedFields: $.keepTouched ? t.touchedFields : {},
      errors: $.keepErrors ? t.errors : {},
      isSubmitSuccessful: $.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, we = (b, $) => fe(Cr(b) ? b(o) : b, $), Le = (b, $ = {}) => {
    const Y = Ke(i, b), X = Y && Y._f;
    if (X) {
      const R = X.refs ? X.refs[0] : X.ref;
      R.focus && (R.focus(), $.shouldSelect && Cr(R.select) && R.select());
    }
  }, Fe = (b) => {
    t = {
      ...t,
      ...b
    };
  }, F = {
    control: {
      register: tn,
      unregister: Ve,
      getFieldState: W,
      handleSubmit: Oe,
      setError: Me,
      _subscribe: Be,
      _runSchema: Q,
      _getWatch: G,
      _getDirty: D,
      _setValid: j,
      _setFieldArray: q,
      _setDisabledField: Re,
      _setErrors: C,
      _getFieldArray: ne,
      _reset: fe,
      _resetDefaultValues: () => Cr(n.defaultValues) && n.defaultValues().then((b) => {
        we(b, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: K,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(b) {
        s = b;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(b) {
        l = b;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(b) {
        n = {
          ...n,
          ...b
        };
      }
    },
    subscribe: Ee,
    trigger: be,
    register: tn,
    handleSubmit: Oe,
    watch: De,
    setValue: ce,
    getValues: je,
    reset: we,
    resetField: ue,
    clearErrors: Ue,
    unregister: Ve,
    setError: Me,
    setFocus: Le,
    getFieldState: W
  };
  return {
    ...F,
    formControl: F
  };
}
function br(e = {}) {
  const n = xe.useRef(void 0), t = xe.useRef(void 0), [i, a] = xe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Cr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Cr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : KU(e),
    formState: i
  }, e.formControl && e.defaultValues && !Cr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, xe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), xe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), xe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), xe.useEffect(() => {
    e.values && !gi(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), xe.useEffect(() => {
    e.errors && !At(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), xe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), xe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = gC(i, o), n.current;
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var id = { exports: {} }, eo = {}, gb;
function GU() {
  if (gb) return eo;
  gb = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return eo.Fragment = t, eo.jsx = s, eo.jsxs = s, eo;
}
var Ks = {}, kb;
function YU() {
  return kb || (kb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    Ks.Fragment = i, Ks.jsx = Un, Ks.jsxs = Bn;
  }()), Ks;
}
var bb;
function JU() {
  return bb || (bb = 1, process.env.NODE_ENV === "production" ? id.exports = GU() : id.exports = YU()), id.exports;
}
var ke = JU();
const QU = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, XU = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, ZU = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, e4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, n4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, t4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, r4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, i4 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, a4 = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": ZU,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": e4,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": n4,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": QU,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": XU,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": t4,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": r4,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": i4
};
function za(e) {
  return a4[e] ?? {};
}
const o4 = za(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), s4 = za(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), l4 = za(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), _b = ({
  owner: e,
  repository: n,
  number: t
}) => `https://github.com/${e}/${n}/issues/${t}`, dr = ({
  owner: e,
  repository: n,
  number: t
}) => `${e}/${n} #${t}`, c4 = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), xb = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, mh = (e, n, t) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ ke.jsxs(
    "svg",
    {
      className: t,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ ke.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ ke.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ ke.jsxs(
    "svg",
    {
      className: t,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ ke.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ ke.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ ke.jsx(
    "svg",
    {
      className: t,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ke.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ ke.jsx(
    "svg",
    {
      className: t,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ke.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ ke.jsx(
    "svg",
    {
      className: t,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ ke.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function u4({
  conversationId: e,
  githubOrganization: n
}) {
  const t = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = oe(
    []
  ), [o, s] = oe([]), [l, u] = oe([]), [m, d] = oe([]), [f, h] = oe(), { showNotification: v, showModal: x, executeQuery: S } = un(), { track: N } = hn(), {
    loading: j,
    data: y,
    error: q,
    store: E
  } = Lh(e ?? null), C = y?.github?.issues || [], T = y?.github?.pullRequests || [], [U, Z] = oe(!1), [Q, ee] = oe();
  qe(
    () => h(q || Q || void 0),
    [q, Q]
  ), qe(
    () => {
      !j && (C?.length || T?.length) ? (a(C), s(T), K(C, T)) : (a([]), s([]), u([]), d([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [y]
  );
  const J = async (ve, H) => {
    await E(ve).then(() => {
      v({
        icon: "check-circle-filled",
        severity: "success",
        title: H.success.title,
        text: H.success.text
      });
    }).catch((be) => {
      v({
        title: H.error.title,
        text: `${H.error.text} ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, K = (ve, H) => {
    if (!ve?.length && !H?.length) {
      u([]), d([]);
      return;
    }
    const be = (ve || []).map(
      (Ue) => S(s4, {
        owner: Ue.owner,
        repositoryName: Ue.repository,
        issueNumber: Ue.number
      })
    ), je = (H || []).map(
      (Ue) => S(l4, {
        owner: Ue.owner,
        repositoryName: Ue.repository,
        prNumber: Ue.number
      })
    ), W = [...be, ...je];
    Z(!0), Promise.all(W).then((Ue) => {
      const Me = [], De = [];
      Ue.forEach((Be) => {
        const Ee = Be?.data?.GitHub;
        if (!Ee) {
          u([]), d([]);
          return;
        }
        Object.keys(Ee).forEach((Ve) => {
          if (Ve.startsWith("repository")) {
            const Re = Ee[Ve];
            Object.keys(Re).forEach((tn) => {
              const Ne = Re[tn], We = {
                number: Ne?.number,
                owner: Ne?.repository?.owner?.login,
                repository: Ne?.repository?.name
              };
              tn.startsWith("issue") && Me.push({
                ...Ne,
                type: "ISSUE",
                key: We
              }), tn.startsWith("pullRequest") && De.push({
                ...Ne,
                type: "PR",
                key: We
              });
            });
          }
        });
      }), u(Me), d(De);
    }).catch(ee).finally(() => {
      Z(!1);
    });
  }, D = ({ key: ve, type: H }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = y && (C.length || T.length) ? y : t, je = H === "ISSUE" ? "issues" : "pullRequests";
    be.github[je] = Array.from(
      new Set(be.github[je]).add(ve)
    ), J(be, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${dr(
          ve
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${dr(ve)} failed. Please try again.`
      }
    });
  }, G = async ({ key: ve, type: H }) => {
    N("github:link:issue:clicked", {
      githubOrganization: n
    });
    const be = y && (C.length || T.length) ? y : t, je = H === "ISSUE" ? "issues" : "pullRequests";
    be.github[je] = Array.from(
      new Set(be.github[je]).add(ve)
    ), await E(be).catch((W) => {
      v({
        title: "Linking failed",
        text: `Linking ${ve} failed. Please try again. ${W.message && " (" + W.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, ne = ({ key: ve, type: H }) => {
    N("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const be = H === "ISSUE" ? "issue" : "pull request";
    x({
      headline: `Unlink ${be} ${dr(ve)}?`,
      text: `You are about to unlink the ${be} ${dr(
        ve
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${be}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const je = H === "ISSUE" ? "issues" : "pullRequests";
        if (!y)
          return;
        const W = {
          ...y,
          github: {
            ...y?.github,
            [je]: y?.github?.[je].filter(
              (Ue) => Ue.number !== ve.number || Ue.owner !== ve.owner || Ue.repository !== ve.repository
            )
          }
        };
        N("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), J(W, {
          success: {
            title: `GitHub ${be} unlinked`,
            text: `You unlinked the GitHub ${be} ${dr(
              ve
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${dr(ve)} failed.`
          }
        });
      },
      onCancel: () => {
        N("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, de = () => {
    N("github:unlink:all:clicked", {
      githubOrganization: n
    }), x({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        N("github:unlink:all:confirmed", {
          githubOrganization: n
        }), J(t, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        N("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ge = C.filter(
    (ve) => !i?.includes(ve)
  ) || [], ce = T.filter(
    (ve) => !o?.includes(ve)
  ) || [];
  return {
    linkGithubItem: D,
    linkGithubItemQuietly: G,
    unlinkGithubItem: ne,
    loadGithubItems: K,
    removeDanglingGithubItemLinks: () => {
      const ve = {
        ...y,
        github: {
          ...y?.github,
          issues: C.filter(
            (H) => !ge.includes(H)
          ) || [],
          pullRequests: T.filter(
            (H) => !ce.includes(H)
          ) || []
        }
      };
      E(ve);
    },
    unlinkAllGithubItems: de,
    isLoadingGithubItemLinks: j,
    danglingIssueLinks: ge,
    danglingPullRequestLinks: ce,
    isLoadingGithubItems: U,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const d4 = "_contentWrapper_1vx3c_1", m4 = "_contentWrapperHeadline_1vx3c_4", p4 = "_contentWrapperBody_1vx3c_11", f4 = "_contentWrapperAssigneeIcon_1vx3c_15", h4 = "_contentWrapperStatusTag_1vx3c_20", ri = {
  contentWrapper: d4,
  contentWrapperHeadline: m4,
  contentWrapperBody: p4,
  contentWrapperAssigneeIcon: f4,
  contentWrapperStatusTag: h4
}, wC = ({
  description: e,
  assignees: n,
  labels: t
}) => /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
  e && /* @__PURE__ */ ke.jsxs(Yn, { className: ri.contentWrapper, children: [
    /* @__PURE__ */ ke.jsx(Yn, { className: ri.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ ke.jsx(Yn, { className: ri.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ ke.jsxs(Yn, { className: ri.contentWrapper, children: [
    /* @__PURE__ */ ke.jsx(Yn, { className: ri.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ ke.jsx(Yn, { className: ri.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ ke.jsxs(Yn, { margin: "100 0", children: [
        /* @__PURE__ */ ke.jsx(
          "img",
          {
            className: ri.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  t?.nodes && t?.nodes.length > 0 && /* @__PURE__ */ ke.jsx(Yn, { className: ri.contentWrapper, children: t.nodes.map(
    (i) => i && /* @__PURE__ */ ke.jsx(
      En,
      {
        className: ri.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), v4 = "_collapse_1bdjy_1", y4 = "_collapseHeader_1bdjy_10", g4 = "_collapseHeaderKey_1bdjy_31", k4 = "_collapseHeaderKeyIcon_1bdjy_36", b4 = "_collapseHeaderKeyLink_1bdjy_41", _4 = "_collapseHeaderIcon_1bdjy_44", x4 = "_collapseHeaderTitle_1bdjy_49", S4 = "_collapseContent_1bdjy_57", N4 = "_collapseContentButtonSpacer_1bdjy_60", j4 = "_collapseContentButtonLink_1bdjy_63", Mr = {
  collapse: v4,
  collapseHeader: y4,
  collapseHeaderKey: g4,
  collapseHeaderKeyIcon: k4,
  collapseHeaderKeyLink: b4,
  collapseHeaderIcon: _4,
  collapseHeaderTitle: x4,
  collapseContent: S4,
  collapseContentButtonSpacer: N4,
  collapseContentButtonLink: j4
}, w4 = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: t
}) => {
  const i = e.reduce(
    (u, m) => ({ ...u, [m.id]: !1 }),
    {}
  ), [a, o] = oe(i), { track: s } = hn(), l = (u, m) => {
    o({ ...a, [u]: m });
  };
  return /* @__PURE__ */ ke.jsx(_, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const {
      id: m,
      number: d,
      key: f,
      title: h,
      bodyText: v,
      repository: x,
      type: S,
      state: N,
      assignees: j,
      labels: y
    } = u, q = a[m];
    return /* @__PURE__ */ ke.jsxs(
      pr,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: q,
        className: Mr.collapse,
        children: [
          /* @__PURE__ */ ke.jsx(pr.Header, { className: Mr.collapseHeader, children: /* @__PURE__ */ ke.jsxs(
            _,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ ke.jsx(Yn, { children: /* @__PURE__ */ ke.jsxs(Yn, { as: "span", className: Mr.collapseHeaderKey, children: [
                  mh(
                    S,
                    N,
                    Mr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ ke.jsxs(
                    "a",
                    {
                      href: _b(f),
                      className: Mr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (E) => {
                        E.stopPropagation();
                      },
                      children: [
                        dr(f),
                        /* @__PURE__ */ ke.jsx(
                          he,
                          {
                            className: Mr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ ke.jsx(Yn, { className: Mr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ke.jsx(pr.Content, { className: Mr.collapseContent, children: /* @__PURE__ */ ke.jsxs(_, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ ke.jsx(
              wC,
              {
                description: v,
                assignees: j,
                labels: y
              }
            ),
            /* @__PURE__ */ ke.jsxs(
              qn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Mr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: d,
                    owner: x?.owner.login,
                    repository: u.repository.name
                  },
                  type: S
                }),
                children: [
                  "Unlink ",
                  xb(S)
                ]
              }
            ),
            /* @__PURE__ */ ke.jsxs(
              Rt,
              {
                slotEnd: /* @__PURE__ */ ke.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: Mr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: t
                  }), window.open(_b(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  xb(S),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ ke.jsx(ke.Fragment, {}) });
}, C4 = "_result_1uaom_1", F4 = "_resultName_1uaom_21", I4 = "_resultItemIcon_1uaom_29", $4 = "_resultDescription_1uaom_34", E4 = "_resultLinkIcon_1uaom_46", T4 = "_tooltip_1uaom_55", O4 = "_tooltipName_1uaom_61", R4 = "_tooltipTag_1uaom_71", ii = {
  result: C4,
  resultName: F4,
  resultItemIcon: I4,
  resultDescription: $4,
  resultLinkIcon: E4,
  tooltip: T4,
  tooltipName: O4,
  tooltipTag: R4
}, D4 = ({
  item: e,
  onSelect: n
}) => {
  const { key: t, title: i, type: a, state: o, labels: s, bodyText: l, assignees: u } = e, [m, d] = oe(!1);
  return /* @__PURE__ */ ke.jsx(
    Je,
    {
      className: ii.tooltip,
      content: /* @__PURE__ */ ke.jsxs(_, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ ke.jsxs(
          _,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ ke.jsxs(Yn, { as: "span", className: ii.tooltipName, children: [
                mh(a, o, ii.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ ke.jsx(En, { className: ii.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ ke.jsx(
          wC,
          {
            description: l,
            assignees: u,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ ke.jsxs(
        "button",
        {
          className: ii.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => d(!0),
          onMouseLeave: () => d(!1),
          children: [
            /* @__PURE__ */ ke.jsxs(
              _,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ ke.jsx(_, { flexDirection: "row", children: /* @__PURE__ */ ke.jsxs(Yn, { as: "span", className: ii.resultName, children: [
                    mh(a, o, ii.resultItemIcon),
                    dr(t)
                  ] }) }),
                  /* @__PURE__ */ ke.jsx(Yn, { className: ii.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ ke.jsx(
              he,
              {
                className: ii.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, P4 = ({
  className: e,
  searched: n,
  githubOrganization: t
}) => /* @__PURE__ */ ke.jsx(
  Rt,
  {
    slotEnd: /* @__PURE__ */ ke.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${t}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), Ql = "[a-zA-z0-9_.-]+", CC = "[0-9]+", A4 = new RegExp(
  `(${Ql})/(${Ql})/(?:issues|pull)/(${CC})`,
  "i"
), Sb = new RegExp(`^${A4.source}$`), Nb = new RegExp(
  `https://github.com/(${Ql})/(${Ql})/(?:issues|pull)/(${CC})`,
  "i"
), L4 = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: t,
  linkedPullRequests: i
}) => {
  const a = Zn(() => t?.map((T) => T.id) || [], [t]), o = Zn(() => i?.map((T) => T.id) || [], [i]), [s, l] = oe([]), { useLazyQuery: u } = un(), [m, d] = oe(), [f, { loading: h, error: v, data: x, networkStatus: S }] = u(o4, {
    notifyOnNetworkStatusChange: !0
  });
  Va(
    () => {
      !h && m && S === hr.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), qe(() => {
    let T = x?.GitHub?.issues?.nodes || [], U = x?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (T = T.filter((Z) => !a.includes(Z.id))), o.length > 0 && (U = U.filter(
      (Z) => !o.includes(Z.id)
    )), l([
      ...T.map((Z) => ({
        ...Z,
        type: "ISSUE",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      })),
      ...U.map((Z) => ({
        ...Z,
        type: "PR",
        key: {
          number: Z.number,
          owner: Z.repository.owner.login,
          repository: Z.repository.name
        }
      }))
    ]);
  }, [x, a, o]);
  function N(T) {
    const U = T?.trim();
    if (Sb.test(U)) {
      const [Z, Q, ee, J] = U.match(Sb) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
    if (Nb.test(U)) {
      const [Z, Q, ee, J] = U.match(Nb) || [];
      return Q !== n ? void 0 : {
        owner: n,
        repository: ee,
        number: parseInt(J)
      };
    }
  }
  const j = (T) => {
    e({
      key: c4(T),
      type: T.type
    }), d(void 0);
  }, y = (T) => {
    const U = N(T);
    d(
      U ? `org:${U.owner} repo:${U.repository} ${U.number}` : `org:${n} ${T}`
    );
  }, q = () => {
    d(void 0);
  }, E = ({ className: T, searched: U }) => /* @__PURE__ */ ke.jsx(
    P4,
    {
      className: T,
      searched: U,
      githubOrganization: n
    }
  ), C = ({ item: T, onSelect: U }) => /* @__PURE__ */ ke.jsx(D4, { item: T, onSelect: U });
  return !h && v ? /* @__PURE__ */ ke.jsx(_n, { error: v }) : /* @__PURE__ */ ke.jsx(
    Dr,
    {
      items: s?.map((T) => ({ name: T.title, ...T })),
      loading: h,
      onSearch: y,
      onSelect: j,
      onClear: q,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: E,
      itemComponent: C,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, V4 = "_itemButton_3sxfy_1", z4 = "_result_3sxfy_6", M4 = "_resultName_3sxfy_30", U4 = "_resultCheckIcon_3sxfy_38", B4 = "_resultAssigneeIcon_3sxfy_41", no = {
  itemButton: V4,
  result: z4,
  resultName: M4,
  resultCheckIcon: U4,
  resultAssigneeIcon: B4
}, FC = ({
  item: e,
  checked: n = !1,
  onSelectItem: t
}) => /* @__PURE__ */ ke.jsx(
  _,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ ke.jsx(
      "button",
      {
        onClick: () => {
          t(e);
        },
        className: no.itemButton,
        children: /* @__PURE__ */ ke.jsxs(_, { className: no.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ ke.jsx(Yn, { margin: "100 0", children: /* @__PURE__ */ ke.jsx(
            "img",
            {
              className: no.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ ke.jsx(Yn, { className: no.resultName, children: e.name }),
          n && /* @__PURE__ */ ke.jsx(Yn, { className: no.resultCheckIcon, children: /* @__PURE__ */ ke.jsx(he, { name: "done" }) })
        ] })
      }
    )
  }
), q4 = za(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), H4 = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: t,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = un(), [o, s] = oe([]), [l, u] = oe(""), m = 2, [d, { loading: f, error: h, data: v, networkStatus: x }] = a(
    q4,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return Va(
    () => {
      !f && l && l.length >= m && x === hr.ready ? d({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const S = v?.GitHub?.organization?.teams || { edges: [] }, N = [];
    S?.edges?.forEach((j) => {
      const y = j?.node?.members?.edges;
      (y?.length || 0) > 0 && y?.forEach((q) => {
        const E = q?.node;
        E && (E?.id && N.find((C) => C.id === E.id) || N.push(E));
      });
    }), s(
      N.sort((j, y) => {
        const q = j.name?.toLowerCase() || j.login?.toLowerCase(), E = y.name?.toLowerCase() || y.login?.toLowerCase();
        return q.localeCompare(E, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [v]), !f && h ? /* @__PURE__ */ ke.jsx(_n, { error: h }) : /* @__PURE__ */ ke.jsx(
    Dr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: S, name: N, login: j, avatarUrl: y }) => ({
        id: S,
        name: N || j,
        iconUrl: y
      })) || [],
      loading: f,
      onSearch: (S) => u(S),
      onChange: (S, N) => {
        const j = S.id;
        i ? (N && !n.find(
          (y) => y.id === j
        ) && n.push(S), N || (n = n.filter(
          (y) => y.id !== j
        ))) : n = N ? [S] : [], t(n);
      },
      onClear: () => u(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: S, onSelect: N, checked: j }) => /* @__PURE__ */ ke.jsx(
        FC,
        {
          item: S,
          checked: j,
          onSelectItem: N
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, W4 = ({
  field: e,
  value: n,
  onChange: t,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ ke.jsx(Or, { onChange: t, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ ke.jsx(
        Dr,
        {
          onSelect: t,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: u }) => ({
            id: s,
            name: l || u
          }))
        }
      ) : /* @__PURE__ */ ke.jsx(
        fc,
        {
          onChange: t,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ ke.jsx(Or, { type: "number", onChange: t, value: n });
    case "option":
      return /* @__PURE__ */ ke.jsx(
        Dr,
        {
          onSelect: t,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: u }) => ({
              id: s,
              name: l || u
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ ke.jsx(Or, { onChange: t, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ ke.jsx(Of, { onChange: t, value: n || "" });
    case "user":
      return /* @__PURE__ */ ke.jsx(
        H4,
        {
          githubOrganization: i,
          onChange: t,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ ke.jsx(ke.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, K4 = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: t,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ ke.jsx(ke.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ ke.jsx(
  Bt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ ke.jsx(
      Dn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: W4({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: t
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), G4 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: t,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ ke.jsxs(
    _,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ ke.jsxs(A.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ ke.jsxs(A.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ ke.jsx(he, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ ke.jsx(Dn, { label: "GitHub issue link", children: /* @__PURE__ */ ke.jsx(
          Or,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: t ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, Y4 = "_modalBody_1hk1o_1", J4 = "_modalBodyFormFields_1hk1o_4", ad = {
  modalBody: Y4,
  modalBodyFormFields: J4
}, Q4 = za(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), X4 = za(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), Z4 = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], eB = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: t,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = un(), { track: u } = hn(), {
    control: m,
    handleSubmit: d,
    formState: { errors: f },
    reset: h,
    getValues: v
  } = br(), [x, S] = oe(""), [N, j] = oe([]), [y, q] = oe(), [E, C] = oe(!1), [T, U] = oe(!1), [Z, Q] = mC(), [
    ee,
    {
      loading: J,
      error: K,
      networkStatus: D
    }
  ] = s(Q4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (je) => {
      j(
        je.GitHub.search?.edges?.map((W) => W?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), j([]);
    }
  });
  Va(
    () => {
      !J && x && D === hr.ready ? ee({
        variables: {
          query: x,
          maxResults: 10
        }
      }) : j([]);
    },
    500,
    [x]
  );
  const [G, { error: ne }] = l(
    X4,
    {
      onError: (je) => {
        C(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", je);
      },
      onCompleted: (je) => {
        C(!1);
        const W = je.GitHub.createIssue?.issue;
        q(W), o({
          title: "Success",
          text: `GitHub issue '${W.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), t({
          owner: a,
          repository: W.repository.name,
          number: W.number
        });
      }
    }
  ), de = (je) => {
    S(`org:${a} ${je}`);
  }, ge = (je, W) => {
    W(je), S("");
  }, ce = () => {
    S("");
  }, ve = (je) => {
    u("github:create:issue:confirmed", {
      githubOrganization: a
    }), C(!0), G({
      variables: {
        input: {
          repositoryId: je.repository.id,
          title: je.title,
          body: je.body,
          assigneeIds: je.assignees?.length > 0 ? je.assignees.map((W) => W.id) : void 0
        }
      }
    });
  };
  qe(() => {
    const je = T ? window.setTimeout(() => U(!1), 2e3) : void 0;
    return () => window.clearTimeout(je);
  }, [T]);
  const H = () => {
    S(""), j([]), q(void 0), C(!1), U(!1);
  }, be = () => {
    u("github:create:issue:canceled", {
      githubOrganization: a
    }), H(), h(), n();
  };
  return /* @__PURE__ */ ke.jsxs(
    St,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: be,
      children: [
        /* @__PURE__ */ ke.jsx(
          Nt,
          {
            title: y ? "Issue creation successful" : "Create new GitHub issue",
            onClose: be
          }
        ),
        /* @__PURE__ */ ke.jsxs(jt, { className: ad.modalBody, children: [
          !J && K && /* @__PURE__ */ ke.jsx(_n, { error: K }),
          !E && ne && /* @__PURE__ */ ke.jsx(_n, { error: ne }),
          y ? /* @__PURE__ */ ke.jsx(
            G4,
            {
              createdIssue: y,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: T,
              setIssueLinkCopied: U,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ ke.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: d(ve),
              children: /* @__PURE__ */ ke.jsxs(Kt, { children: [
                /* @__PURE__ */ ke.jsx(en, { children: /* @__PURE__ */ ke.jsx(Dn, { label: "Repository", required: !0, children: /* @__PURE__ */ ke.jsx(
                  Bt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: je, value: W } }) => /* @__PURE__ */ ke.jsx(
                      Dr,
                      {
                        className: ad.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: J,
                        onSearch: de,
                        onSelect: (Ue) => ge(Ue, je),
                        onClear: ce,
                        selectedItems: [W],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: K ? "No repositories found" : "No repositories available",
                        items: N || [],
                        itemComponent: ({ item: Ue, onSelect: Me, checked: De }) => /* @__PURE__ */ ke.jsx(
                          FC,
                          {
                            item: Ue,
                            checked: De,
                            onSelectItem: Me
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ ke.jsx(en, { className: ad.modalBodyFormFields, children: /* @__PURE__ */ ke.jsx(
                  K4,
                  {
                    control: m,
                    errors: f,
                    getValues: v,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: Z4
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ ke.jsx(
          Et,
          {
            confirmOnClick: y ? be : d(ve),
            confirmProps: {
              isLoading: E,
              loadingIndicator: /* @__PURE__ */ ke.jsx(cn, { size: 16 })
            },
            confirmName: y ? "Close" : "Save",
            cancelOnClick: y ? void 0 : be
          }
        )
      ]
    }
  );
}, nB = "_wrapper_19v8w_1", tB = "_inputWrapper_19v8w_6", rB = "_buttonLink_19v8w_19", iB = "_noItemsFound_19v8w_23", aB = "_createIssueButton_19v8w_28", ia = {
  wrapper: nB,
  inputWrapper: tB,
  buttonLink: rB,
  noItemsFound: iB,
  createIssueButton: aB
}, oB = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = oe(!1), { track: a } = hn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: u,
    unlinkGithubItem: m,
    loadGithubItems: d,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: v,
    danglingIssueLinks: x,
    danglingPullRequestLinks: S,
    isLoadingGithubItems: N,
    issues: j,
    pullRequests: y,
    error: q
  } = u4({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), E = (Q) => u({ key: Q, type: "ISSUE" }), C = !(!!j?.length).valueOf() && !(!!y?.length).valueOf() && !(!!x?.length).valueOf() && !(!!S?.length).valueOf(), T = !v && !N && !!x?.length && !!S?.length && !!n?.showDanglingLinks, U = n?.enableCreateIssue, Z = !!j?.length || !!y?.length;
  return !N && q ? /* @__PURE__ */ ke.jsx(_n, { error: q, retry: () => d() }) : /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
    /* @__PURE__ */ ke.jsxs(_, { className: ia.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ ke.jsxs(_, { className: ia.inputWrapper, flexDirection: "column", children: [
        U && /* @__PURE__ */ ke.jsxs(ke.Fragment, { children: [
          /* @__PURE__ */ ke.jsx(
            qn,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: ia.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ ke.jsx("div", { className: ia.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ ke.jsx(
          L4,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: j,
            linkedPullRequests: y
          }
        )
      ] }),
      N ? /* @__PURE__ */ ke.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ ke.jsx(cn, { "data-testid": "github-widget-item-spinner" }) }) : Z ? /* @__PURE__ */ ke.jsx(
        w4,
        {
          items: [...j, ...y],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ ke.jsx(A.Paragraph, { align: "center", className: ia.noItemsFound, children: "No linked items found." }),
      T && /* @__PURE__ */ ke.jsxs(
        _,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ ke.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ ke.jsxs(_, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              x.map((Q) => /* @__PURE__ */ ke.jsx(
                En,
                {
                  onDelete: () => m({
                    key: Q,
                    type: "ISSUE"
                  }),
                  children: dr(Q)
                },
                dr(Q)
              )),
              S.map((Q) => /* @__PURE__ */ ke.jsx(
                En,
                {
                  onDelete: () => m({ key: Q, type: "PR" }),
                  children: dr(Q)
                },
                dr(Q)
              ))
            ] }),
            /* @__PURE__ */ ke.jsx(
              qn,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && Z && /* @__PURE__ */ ke.jsx(
        qn,
        {
          variant: "secondary",
          disabled: C,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ ke.jsx(
        Rt,
        {
          slotEnd: /* @__PURE__ */ ke.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: ia.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ ke.jsx(
      eB,
      {
        isOpen: t,
        onClose: () => i(!1),
        linkGithubIssueQuietly: E,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, sB = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
    secret: !1,
    type: "input",
    required: !0
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: mc
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_axxxc_48{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_axxxc_48:hover,._result_axxxc_48:focus{background-color:var(--dixa-color-neutral-100)}._resultName_axxxc_68{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_axxxc_76{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_axxxc_81{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_axxxc_93{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_axxxc_102{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_axxxc_108{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_axxxc_115{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_axxxc_120{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_axxxc_125{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_axxxc_133{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_axxxc_137{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var od = { exports: {} }, to = {}, jb;
function lB() {
  if (jb) return to;
  jb = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return to.Fragment = t, to.jsx = s, to.jsxs = s, to;
}
var Gs = {}, wb;
function cB() {
  return wb || (wb = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    Gs.Fragment = i, Gs.jsx = Un, Gs.jsxs = Bn;
  }()), Gs;
}
var Cb;
function uB() {
  return Cb || (Cb = 1, process.env.NODE_ENV === "production" ? od.exports = lB() : od.exports = cB()), od.exports;
}
var me = uB();
const Dv = (e, n) => {
  const t = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => Dv(l, s)) : [], a = n.nodes[e.type] || n.default;
  return t(
    a(e, i(e, n))
  );
}, dB = "_jiraCode_h30p6_1", mB = "_jiraCodeInline_h30p6_8", sd = {
  jiraCode: dB,
  jiraCodeInline: mB
}, IC = {
  default: (e, n) => n().every((t) => typeof t == "string") ? n().join(" ") : /* @__PURE__ */ me.jsx(me.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ me.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ me.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ me.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ me.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ me.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ me.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ me.jsx("pre", { children: /* @__PURE__ */ me.jsx("code", { className: sd.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ me.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ me.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ me.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ me.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ me.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ me.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ me.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ me.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ me.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ me.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ me.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ me.jsx("code", { className: ht(sd.jiraCode, sd.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, Xl = ({
  iconUrl: e,
  className: n,
  width: t
}) => {
  const [i, a] = oe(!1);
  return !e || i ? /* @__PURE__ */ me.jsx(he, { size: t, name: "question", className: n }) : /* @__PURE__ */ me.jsx(
    "img",
    {
      src: e,
      width: t,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, pB = "_collapse_m2gjh_1", fB = "_collapseHeader_m2gjh_10", hB = "_collapseHeaderLink_m2gjh_31", vB = "_collapseHeaderStatus_m2gjh_40", yB = "_collapseHeaderTitle_m2gjh_51", gB = "_collapseContent_m2gjh_59", kB = "_collapseContentHeadline_m2gjh_62", bB = "_collapseContentButtonSpacer_m2gjh_68", _B = "_collapseContentButtonLink_m2gjh_71", xB = "_collapseContentStatusTag_m2gjh_74", SB = "_collapseContentDescription_m2gjh_77", Sr = {
  collapse: pB,
  collapseHeader: fB,
  collapseHeaderLink: hB,
  collapseHeaderStatus: vB,
  collapseHeaderTitle: yB,
  collapseContent: gB,
  collapseContentHeadline: kB,
  collapseContentButtonSpacer: bB,
  collapseContentButtonLink: _B,
  collapseContentStatusTag: xB,
  collapseContentDescription: SB
}, $C = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: t
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : t, NB = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: t
}) => {
  const i = e.reduce(
    (u, m) => m?.id ? { ...u, [m.id]: !1 } : u,
    {}
  ), [a, o] = oe(i), { track: s } = hn(), l = (u, m) => {
    o({ ...a, [u]: m });
  };
  return /* @__PURE__ */ me.jsx(_, { flexDirection: "column", gap: "250", children: e?.length ? e.map((u) => {
    const { summary: m, description: d, status: f, issuetype: h } = u?.fields || {}, v = $C({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), x = !!(u?.id && a[u.id]);
    return /* @__PURE__ */ me.jsxs(
      pr,
      {
        onToggle: () => u?.id && l(u.id, !a[u.id]),
        isOpen: x,
        className: Sr.collapse,
        children: [
          /* @__PURE__ */ me.jsx(pr.Header, { className: Sr.collapseHeader, children: /* @__PURE__ */ me.jsxs(
            _,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ me.jsxs(_, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ me.jsxs(_, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ me.jsx(Xl, { width: 16, iconUrl: v }),
                    /* @__PURE__ */ me.jsx(
                      "a",
                      {
                        className: Sr.collapseHeaderLink,
                        href: `${n}/browse/${u?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (S) => {
                          S.stopPropagation(), u?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: u.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ me.jsxs(_, { alignItems: "center", gap: "200", children: [
                          u?.key,
                          /* @__PURE__ */ me.jsx(he, { name: "external-link", size: 16 })
                        ] })
                      },
                      u?.key
                    )
                  ] }),
                  /* @__PURE__ */ me.jsx("span", { className: Sr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ me.jsx(En, { className: Sr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ me.jsx("div", { className: Sr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ me.jsx(pr.Content, { className: Sr.collapseContent, children: /* @__PURE__ */ me.jsxs(_, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ me.jsx("div", { className: Sr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ me.jsx(Yn, { className: Sr.collapseContentDescription, children: d ? Dv(d, IC) : "" }),
            /* @__PURE__ */ me.jsx(
              qn,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Sr.collapseContentButtonSpacer,
                onClick: () => u?.key && t(u.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ me.jsx(
              Rt,
              {
                slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
                variant: "tertiary",
                className: Sr.collapseContentButtonLink,
                navigate: () => {
                  u?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: u.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${u.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      u?.id
    );
  }) : /* @__PURE__ */ me.jsx(me.Fragment, {}) });
}, jB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, wB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, CB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, FB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, IB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, $B = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, EB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, TB = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': jB,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": wB,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": CB,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": FB,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': IB,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': $B,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": EB
};
function Gi(e) {
  return TB[e] ?? {};
}
const EC = Gi(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), OB = Gi(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), RB = Gi(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), DB = Gi(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), PB = Gi(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), AB = Gi(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), LB = Gi(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), Pv = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), VB = new RegExp(`^${Pv.source}$`), zB = new RegExp(`/${Pv.source}$`), Fb = new RegExp(
  `.+?[&?]selectedIssue=(${Pv.source})[&?]?.*`
);
function TC(e, n) {
  const t = { jira: { issues: [] } }, [i, a] = oe([]), [o, s] = oe([]), [l, u] = oe(), { track: m } = hn(), { showNotification: d, showModal: f, useLazyQuery: h, useMutation: v } = un(), {
    loading: x,
    data: S,
    error: N,
    store: j
  } = Lh(e ?? null), [
    y,
    { loading: q, error: E, data: C }
  ] = h(EC, {
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    const ce = C?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    ce?.length && (s(ce), a(ce.map((ve) => ve?.key).filter(Boolean)));
  }, [C]), qe(
    () => u(N || E || void 0),
    [N, E]
  ), qe(
    () => {
      x || K();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [S?.jira?.issues, x]
  );
  const T = async (ce, ve) => {
    await j(ce).then(() => {
      d({
        icon: "check-circle-filled",
        severity: "success",
        title: ve.success.title,
        text: ve.success.text
      });
    }).catch((H) => {
      d({
        title: ve.error.title,
        text: `${ve.error.text} ${H.message && " (" + H.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [U] = v(OB, {
    onError: (ce) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${ce.message && " (" + ce.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), Z = (ce, ve) => {
    const H = window.location.href, be = ve ? H.replace(
      e?.toString() ?? "",
      ve?.toString()
    ) : H, je = ve ? `# ${ve}` : `# ${e}`;
    U({
      variables: {
        issueKey: ce,
        title: je,
        url: be,
        globalId: `system=${be}`
      }
    });
  }, [Q] = v(RB, {
    onError: (ce) => {
      d({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${ce.message && " (" + ce.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), ee = (ce) => {
    const ve = window.location.href;
    Q({
      variables: {
        issueKey: ce,
        globalId: `system=${ve}`
      }
    });
  }, J = (ce) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: ce
  }), K = () => {
    S && S.jira?.issues?.length > 0 ? y({
      variables: {
        jql: `key in (${S?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, D = async (ce, ve) => {
    m("jira:issue:link:clicked", J(ce));
    const H = S?.jira?.issues ? S : t;
    H.jira.issues = Array.from(
      new Set(H.jira.issues).add(ce)
    ), await j(H, ve?.toString()).then(() => Z(ce, ve)).catch((be) => {
      d({
        title: "Linking failed",
        text: `Linking ${ce} failed. Please try again. ${be.message && " (" + be.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, G = (ce) => {
    m("jira:issue:link:clicked", J(ce));
    const ve = S?.jira?.issues ? S : t;
    ve.jira.issues = Array.from(
      new Set(ve.jira.issues).add(ce)
    ), T(ve, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${ce} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${ce} failed. Please try again.`
      }
    }).then(() => Z(ce));
  }, ne = (ce) => {
    m("jira:issue:unlink:clicked", J(ce)), f({
      headline: `Unlink issue ${ce}?`,
      text: `You are about to unlink the issue ${ce}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", J(ce));
        const ve = {
          ...S,
          jira: {
            ...S?.jira,
            issues: S?.jira?.issues.filter((H) => H !== ce) || []
          }
        };
        T(ve, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${ce}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${ce} failed.`
          }
        }).then(() => ee(ce));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", J(ce))
    });
  }, de = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((ce) => ce?.key && ee(ce.key)), T(t, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ge = S?.jira?.issues?.filter(
    (ce) => !i?.includes(ce)
  ) || [];
  return {
    linkIssue: G,
    linkIssueQuietly: D,
    unlinkIssue: ne,
    loadIssues: K,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const ce = {
        ...S,
        jira: {
          ...S?.jira,
          issues: S?.jira?.issues.filter(
            (ve) => !ge.includes(ve)
          ) || []
        }
      };
      j(ce);
    },
    unlinkAllIssues: de,
    maybeExtractIssueKey: (ce) => {
      const ve = ce.replace(/\s/g, "");
      if (VB.test(ve))
        return ve;
      if (Fb.test(ce))
        return ce.match(Fb)?.[1];
      if (ce.startsWith(n) && zB.test(ce))
        return ce.substring(ce.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: x,
    danglingIssueLinks: ge,
    isLoadingIssues: q,
    issues: o,
    error: l
  };
}
function MB(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const UB = "_result_axxxc_48", BB = "_resultName_axxxc_68", qB = "_resultNameIcon_axxxc_76", HB = "_resultDescription_axxxc_81", WB = "_resultLinkIcon_axxxc_93", KB = "_tooltip_axxxc_102", GB = "_tooltipContent_axxxc_108", YB = "_tooltipName_axxxc_115", JB = "_tooltipNameIcon_axxxc_120", QB = "_tooltipDescription_axxxc_125", XB = "_tooltipSummary_axxxc_133", ZB = "_tooltipTag_axxxc_137", ur = {
  result: UB,
  resultName: BB,
  resultNameIcon: qB,
  resultDescription: HB,
  resultLinkIcon: WB,
  tooltip: KB,
  tooltipContent: GB,
  tooltipName: YB,
  tooltipNameIcon: JB,
  tooltipDescription: QB,
  tooltipSummary: XB,
  tooltipTag: ZB
}, e5 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: t,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: u, description: m } = e, [d, f] = oe(!1), h = $C({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ me.jsx(
    Je,
    {
      disabled: i,
      className: ur.tooltip,
      content: /* @__PURE__ */ me.jsxs("div", { className: ur.tooltipContent, children: [
        /* @__PURE__ */ me.jsxs(
          _,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ me.jsxs("span", { className: ur.tooltipName, children: [
                /* @__PURE__ */ me.jsx(
                  Xl,
                  {
                    width: 16,
                    iconUrl: h,
                    className: ur.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ me.jsx(En, { className: ur.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ me.jsx("div", { className: ur.tooltipSummary, children: m }),
        u && /* @__PURE__ */ me.jsx("div", { className: ur.tooltipDescription, children: u })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ me.jsxs(
        "button",
        {
          ...a,
          className: ur.result,
          type: "button",
          onClick: () => {
            t(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ me.jsxs(
              _,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: d ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ me.jsx(_, { flexDirection: "row", children: /* @__PURE__ */ me.jsxs("span", { className: ur.resultName, children: [
                    /* @__PURE__ */ me.jsx(
                      Xl,
                      {
                        width: 16,
                        iconUrl: h,
                        className: ur.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ me.jsx("div", { className: ur.resultDescription, children: m })
                ]
              }
            ),
            d && /* @__PURE__ */ me.jsx(
              he,
              {
                className: ur.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, n5 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: t
}) => /* @__PURE__ */ me.jsx(
  Rt,
  {
    slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${t}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), t5 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: t,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = un(), [o, s] = oe([]), [l, u] = oe(""), [m, { loading: d, error: f, data: h, networkStatus: v }] = a(EC, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: x } = TC(null, n);
  Va(
    () => {
      !d && l && v === hr.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    const E = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      E.map((C) => ({
        id: C?.key ?? "",
        name: C?.key ?? "",
        description: C?.fields.summary,
        status: C?.fields.status,
        issuetype: C?.fields.issuetype,
        text: C?.fields.description ? Dv(C?.fields.description, IC) : /* @__PURE__ */ me.jsx(me.Fragment, {})
      }))
    );
  }, [h]);
  const S = (E) => {
    e(E.id), u("");
  }, N = (E) => {
    const C = E.trim(), T = x(C);
    if (T) {
      const U = T.replaceAll("[-_|]", "\\\\$0");
      u(`key = '${U}'`);
    } else C !== "" && u(
      `text ~ '${C}'${t ? " and project = " + t : ""}`
    );
  }, j = () => {
    u("");
  }, y = (E) => /* @__PURE__ */ me.jsx(n5, { ...E, jiraInstanceUrl: n }), q = (E) => /* @__PURE__ */ me.jsx(
    e5,
    {
      ...E,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !d && f ? /* @__PURE__ */ me.jsx(_n, { error: f }) : /* @__PURE__ */ me.jsx(
    Dr,
    {
      items: o,
      loading: d,
      onSearch: N,
      onSelect: S,
      onClear: j,
      emptyMessage: l ? d ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: y,
      itemComponent: q,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, r5 = ({
  field: e,
  value: n,
  onChange: t
}) => {
  const [i, a] = oe(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: u }) => u !== s.id)
    );
  };
  return qe(() => {
    t(i);
  }, [i]), /* @__PURE__ */ me.jsx(
    Dr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: u }) => ({
          id: s,
          name: l || u
        })
      )
    }
  );
}, i5 = "_itemButton_1hl53_1", a5 = "_result_1hl53_6", o5 = "_resultIcon_1hl53_26", s5 = "_resultName_1hl53_30", l5 = "_resultCheckIcon_1hl53_38", ro = {
  itemButton: i5,
  result: a5,
  resultIcon: o5,
  resultName: s5,
  resultCheckIcon: l5
}, ph = ({
  item: e,
  checked: n = !1,
  onSelectItem: t,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ me.jsx(
    _,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ me.jsx(
        "button",
        {
          onClick: () => {
            t(e);
          },
          className: ro.itemButton,
          children: /* @__PURE__ */ me.jsxs(_, { className: ro.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ me.jsx(
              Xl,
              {
                width: 36,
                iconUrl: o || "",
                className: ro.resultIcon
              }
            ),
            /* @__PURE__ */ me.jsx(Yn, { className: ro.resultName, children: e.name }),
            n && /* @__PURE__ */ me.jsx(Yn, { className: ro.resultCheckIcon, children: /* @__PURE__ */ me.jsx(he, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, c5 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: t,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = un(), [o, s] = oe([]), [l, u] = oe(), m = 2, [d, { loading: f, error: h, data: v, networkStatus: x }] = a(LB, {
    notifyOnNetworkStatusChange: !0
  });
  return Va(
    () => {
      !f && l && l.length >= m && x === hr.ready ? d({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), qe(() => {
    n && d({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((S) => {
      if (S?.data?.Jira.findUsers?.length === 1) {
        const N = S?.data?.Jira?.findUsers[0];
        t(N.accountId), s([
          {
            id: N.accountId,
            name: N.displayName
          }
        ]);
      }
    });
  }, []), qe(() => {
    const S = v?.Jira?.findUsers || [];
    s(
      S.filter(({ active: N }) => N).map(({ accountId: N, displayName: j, avatarUrls: y, active: q }) => ({
        id: N,
        name: j,
        avatarUrls: y,
        active: q
      }))
    );
  }, [v]), !f && h ? /* @__PURE__ */ me.jsx(_n, { error: h }) : /* @__PURE__ */ me.jsx(
    Dr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (S) => u(S),
      onSelect: t,
      onClear: () => u(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: S, onSelect: N, checked: j }) => /* @__PURE__ */ me.jsx(
        ph,
        {
          item: S,
          checked: j,
          onSelectItem: N,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, Ib = ({
  field: e
}) => {
  const [n, t] = oe(!1), [i, a] = mC();
  return qe(() => {
    const o = n ? window.setTimeout(() => t(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ me.jsxs(_, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ me.jsx(_, { children: /* @__PURE__ */ me.jsx(he, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ me.jsx(A.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ me.jsx(Je, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ me.jsx(
      lr,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), t(!0);
        }
      }
    ) })
  ] });
}, u5 = ({
  field: e,
  onChange: n,
  value: t,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ me.jsx(Ib, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ me.jsx(Or, { onChange: n, value: t });
    case "string":
      return s === "description" ? /* @__PURE__ */ me.jsx(Of, { onChange: n, value: t }) : /* @__PURE__ */ me.jsx(Or, { onChange: n, value: t });
    case "textarea":
      return /* @__PURE__ */ me.jsx(Of, { onChange: n, value: t });
    case "number":
      return /* @__PURE__ */ me.jsx(Or, { type: "number", onChange: n, value: t });
    case "user":
      return /* @__PURE__ */ me.jsx(
        c5,
        {
          onSelect: n,
          selectedItems: t ? [t] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ me.jsx(
        Dr,
        {
          onSelect: n,
          selectedItems: t ? [t] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: u, value: m }) => ({
              id: l,
              name: u || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ me.jsx(r5, { field: e, value: t, onChange: n });
    default:
      return /* @__PURE__ */ me.jsx(Ib, { field: e });
  }
}, d5 = ["description", "reporter", "summary"], m5 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: t,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ me.jsx(me.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || d5.includes(o)
).map((o) => /* @__PURE__ */ me.jsx(
  Bt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ me.jsx(
      Dn,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: u5({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: t
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), p5 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: t,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ me.jsxs(
  _,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ me.jsxs(A.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ me.jsxs(
          A.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ me.jsx(he, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ me.jsx(Dn, { label: "Jira issue link", children: /* @__PURE__ */ me.jsx(
        Or,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: t ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), f5 = "_modalBody_1hk1o_1", h5 = "_modalBodyFormFields_1hk1o_4", $b = {
  modalBody: f5,
  modalBodyFormFields: h5
}, v5 = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), y5 = (e) => e?.custom?.split(":")?.[1] || null, g5 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const t = n.find((i) => i.key === e)?.schema;
    if (t)
      return t;
  }
  return null;
}, k5 = (e, n) => {
  const t = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = g5(a, n), l = y5(s) ?? a;
        return t.includes(l) ? i[a] = v5(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, b5 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: t,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, u] = oe([]), [m, d] = oe(), [f, h] = oe(0), [v, x] = oe([]), [S, N] = oe([]), [j, y] = oe(!1), [q, E] = oe(!1), [C, T] = oe({}), { track: U } = hn(), { isCopied: Z, copyToClipboard: Q } = MB(), ee = Zn(() => i?.conversationId, [e]), { useMutation: J, useLazyQuery: K, showNotification: D } = un(), {
    control: G,
    handleSubmit: ne,
    formState: { errors: de },
    reset: ge,
    setValue: ce,
    getValues: ve
  } = br({
    defaultValues: s
  }), H = S.length > 0, be = `${a}/browse`, je = Object.keys(C).length > 0, [W, { loading: Ue, error: Me }] = K(DB, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (fe) => {
      u(fe.Jira.getAllProjects);
    },
    onError: (fe) => {
      D({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", fe), u([]);
    }
  }), [
    De,
    { loading: Be, error: Ee }
  ] = K(PB, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (fe) => {
      h(0);
      const we = fe?.Jira?.getCreateIssueMeta?.projects[0];
      if (we) {
        const Le = we?.issuetypes.filter(
          ({ subtask: Fe }) => !Fe
        );
        x(Le || []), ce(
          "issuetype",
          Le.length > 0 ? Le[0] : void 0
        );
      } else
        D({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), x([]), N([]);
    },
    onError: (fe) => {
      D({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", fe), x([]), N([]), h(0);
    }
  }), [Ve, { error: Re }] = J(
    AB,
    {
      onError: () => {
        y(!1), D({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), U("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (fe) => {
        if (y(!1), fe?.Jira && "key" in fe.Jira.createIssue)
          d(fe?.Jira?.createIssue), D({
            title: "Success",
            text: `Jira issue '${fe.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), U("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: fe.Jira.createIssue.key
          }), ee && t(
            fe.Jira.createIssue.key,
            ee
          );
        else if ("errorMessages" in fe.Jira.createIssue || "errors" in fe.Jira.createIssue) {
          const we = fe?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", we), D({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), tn = (fe) => {
    y(!0), T({}), Ve({
      variables: {
        input: k5(fe, S)
      }
    });
  };
  qe(() => {
    if (e)
      try {
        W();
      } catch (fe) {
        console.warn("Error when fetching initial projects", fe);
      }
  }, [e]), qe(() => {
    const fe = q ? window.setTimeout(() => E(!1), 2e3) : void 0;
    return () => window.clearTimeout(fe);
  }, [q]), qe(() => {
    if (v?.length > 0) {
      ce("issuetype", v[f]);
      const fe = v[f]?.fields?.additionalProperties;
      if (fe?.length > 0) {
        const we = fe.map(
          ({ value: F }) => F
        ), Le = (o ? we.sort(({ name: F }, { name: b }) => F.localeCompare(b)) : we).sort(
          ({ required: F }, { required: b }) => Number(b) - Number(F)
        ), { project: Fe, issuetype: ln } = ve();
        ge({ project: Fe, issuetype: ln }), N(Le);
      }
    } else
      N([]), ce("issuetype", void 0);
  }, [v, ce, f]), qe(() => {
    if (Re && UN(Re)) {
      if (Re?.graphQLErrors?.length > 0) {
        const { graphQLErrors: fe } = Re, we = fe[0].extensions?.integration?.responseBody;
        try {
          const Le = JSON.parse(we);
          if (Le?.errors) {
            const Fe = Object.keys(Le.errors).reduce(
              (ln, F) => ({
                ...ln,
                [F]: {
                  type: "required",
                  message: Le.errors[F],
                  ref: {
                    name: F
                  }
                }
              }),
              {}
            );
            T(Fe);
          }
        } catch {
        }
      }
    } else
      T({});
  }, [Re]);
  const Ne = () => {
    u([]), N([]), x([]), d(void 0), h(0), y(!1), T({});
  }, We = () => {
    Ne(), ge(s), n();
  }, Oe = (fe) => {
    fe && De({
      variables: {
        projectKey: fe
      }
    });
  }, ue = (fe) => {
    const we = v.map((Le) => Le.id).indexOf(fe);
    h(we ?? 0);
  };
  return /* @__PURE__ */ me.jsxs(
    St,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: We,
      children: [
        /* @__PURE__ */ me.jsx(
          Nt,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: We
          }
        ),
        /* @__PURE__ */ me.jsxs(jt, { className: $b.modalBody, children: [
          !Ue && Me && /* @__PURE__ */ me.jsx(_n, { error: Me, retry: W }),
          !Be && Ee && /* @__PURE__ */ me.jsx(
            _n,
            {
              error: Ee,
              retry: De
            }
          ),
          !j && je && /* @__PURE__ */ me.jsx(_, { margin: "0 0 400", children: /* @__PURE__ */ me.jsx(
            hc,
            {
              variant: "warning",
              description: /* @__PURE__ */ me.jsxs(
                _,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ me.jsx(A.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ me.jsx(
                      qn,
                      {
                        icon: Z ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => Q(JSON.stringify(S, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ me.jsx(
            p5,
            {
              createdIssue: m,
              issueBaseLink: be,
              issueLinkCopied: q,
              setIssueLinkCopied: E,
              copyToClipboard: Q
            }
          ) : /* @__PURE__ */ me.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: ne(tn),
              children: /* @__PURE__ */ me.jsxs(Kt, { children: [
                /* @__PURE__ */ me.jsx(en, { span: 3, children: /* @__PURE__ */ me.jsx(Dn, { label: "Project", required: !0, children: /* @__PURE__ */ me.jsx(
                  Bt,
                  {
                    control: G,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: fe, value: we } }) => /* @__PURE__ */ me.jsx(
                      Dr,
                      {
                        searchable: !0,
                        loading: Ue,
                        onSelect: (Le) => {
                          Oe(Le.key), fe(Le);
                        },
                        selectedItems: [we],
                        placeholder: "Select Jira project",
                        emptyMessage: Me ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Le, onSelect: Fe, checked: ln }) => /* @__PURE__ */ me.jsx(
                          ph,
                          {
                            item: Le,
                            checked: ln,
                            onSelectItem: Fe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ me.jsx(en, { span: 3, children: /* @__PURE__ */ me.jsx(Dn, { label: "Issue type", required: !0, children: /* @__PURE__ */ me.jsx(
                  Bt,
                  {
                    control: G,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: fe, value: we } }) => /* @__PURE__ */ me.jsx(
                      Dr,
                      {
                        disabled: v.length === 0,
                        loading: Be,
                        onSelect: (Le) => {
                          ue(Le.id), fe(Le);
                        },
                        selectedItems: [we],
                        placeholder: v.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Ee ? "No issues found" : "No issues available",
                        items: v,
                        itemComponent: ({ item: Le, onSelect: Fe, checked: ln }) => /* @__PURE__ */ me.jsx(
                          ph,
                          {
                            item: Le,
                            checked: ln,
                            onSelectItem: Fe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                H && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ me.jsx(en, { className: $b.modalBodyFormFields, children: /* @__PURE__ */ me.jsx(
                  m5,
                  {
                    control: G,
                    errors: { ...de, ...C },
                    getValues: ve,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: S
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ me.jsx(
          Et,
          {
            confirmOnClick: m ? We : ne(tn),
            confirmProps: {
              disabled: !H,
              isLoading: j,
              loadingIndicator: /* @__PURE__ */ me.jsx(cn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : We
          }
        )
      ]
    }
  );
}, _5 = (e) => {
  if (!e) return "";
  const n = "https://", t = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${t}`;
}, x5 = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const t = e.startsWith(n);
  if (t) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = t ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else {
    const i = "://";
    return e.includes(i) ? `The protocol \`${e.substring(
      0,
      e.indexOf(i) + i.length
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
  }
}, S5 = "_wrapper_1bylq_1", N5 = "_inputWrapper_1bylq_6", j5 = "_inputSeparator_1bylq_18", w5 = "_buttonLink_1bylq_23", C5 = "_noIssuesFound_1bylq_27", io = {
  wrapper: S5,
  inputWrapper: N5,
  inputSeparator: j5,
  buttonLink: w5,
  noIssuesFound: C5
}, F5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: t } = hn(), i = _5(n?.jiraSiteUrl), [a, o] = oe(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: u,
    unlinkIssue: m,
    unlinkAllIssues: d,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: v,
    isLoadingIssueLinks: x,
    isLoadingIssues: S,
    issues: N,
    error: j
  } = TC(
    s ? e.conversationId : null,
    i
  ), y = !!n?.enableCreateIssue, q = !!n?.enableSortIssueTypeByLabel, E = !!(N?.length || v?.length), C = !!n?.enableRemoveAllLinks && E, T = !x && !S && v?.length > 0 && !!n?.showDanglingLinks;
  return !S && j ? /* @__PURE__ */ me.jsx(_n, { error: j, retry: () => f() }) : /* @__PURE__ */ me.jsxs(me.Fragment, { children: [
    /* @__PURE__ */ me.jsxs(_, { className: io.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ me.jsxs(_, { className: io.inputWrapper, flexDirection: "column", children: [
        y && /* @__PURE__ */ me.jsxs(me.Fragment, { children: [
          /* @__PURE__ */ me.jsx(
            qn,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ me.jsx("div", { className: io.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ me.jsx(
          t5,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      S ? /* @__PURE__ */ me.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ me.jsx(cn, { "data-testid": "jira-widget-issue-spinner" }) }) : N?.length ? /* @__PURE__ */ me.jsx(
        NB,
        {
          issues: N,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ me.jsx(A.Paragraph, { align: "center", className: io.noIssuesFound, children: "No linked issues found" }),
      C && N?.length > 0 && /* @__PURE__ */ me.jsx(
        qn,
        {
          variant: "secondary",
          disabled: !N?.length && !v?.length,
          onClick: d,
          children: "Unlink all issues"
        }
      ),
      T && /* @__PURE__ */ me.jsxs(
        _,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ me.jsx(A.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ me.jsx(_, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: v.map((U) => /* @__PURE__ */ me.jsx(En, { onDelete: () => m(U), children: U }, U)) }),
            /* @__PURE__ */ me.jsx(
              qn,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ me.jsx(
        Rt,
        {
          slotEnd: /* @__PURE__ */ me.jsx(he, { name: "external-link" }),
          variant: "tertiary",
          className: io.buttonLink,
          navigate: () => {
            t("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ me.jsx(
      b5,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: u,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: q
      }
    )
  ] });
}, Eb = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
    secret: !1,
    type: "input",
    required: !0,
    customValidation: (e) => x5(e),
    defaultValue: ""
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: mc
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    secret: !1,
    type: "switch",
    defaultValue: !1
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_1vrar_48{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_1vrar_48:hover,._messageIsOpen_1vrar_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_1vrar_59{cursor:pointer}._messageUnattended_1vrar_62{text-decoration:line-through}._messageLabel_1vrar_65{color:var(--dixa-typography-color-secondary)}._messageText_1vrar_68{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_1vrar_68::-webkit-scrollbar{width:7px;height:7px}._messageText_1vrar_68::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_1vrar_68::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var ld = { exports: {} }, ao = {}, Tb;
function I5() {
  if (Tb) return ao;
  Tb = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ao.Fragment = t, ao.jsx = s, ao.jsxs = s, ao;
}
var Ys = {}, Ob;
function $5() {
  return Ob || (Ob = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    Ys.Fragment = i, Ys.jsx = Un, Ys.jsxs = Bn;
  }()), Ys;
}
var Rb;
function E5() {
  return Rb || (Rb = 1, process.env.NODE_ENV === "production" ? ld.exports = I5() : ld.exports = $5()), ld.exports;
}
var $e = E5();
function T5({
  query: e,
  options: n,
  delayMs: t
}) {
  const { useLazyQuery: i } = un(), [a, o] = oe([]), [s] = i(e, n), [l, u] = oe(
    []
  );
  return qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const d = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((x) => {
        const S = setTimeout(x, t);
        u([...l, S]);
      });
      const v = await s({
        variables: h
      });
      d.push(v);
    }
    o(d);
  }, a];
}
const O5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, R5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, D5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, P5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, A5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, L5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, V5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "content" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_EmailMessageContent" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, z5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, M5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, U5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "EnumValue", value: "subscriptions" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, B5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_lists" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, q5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile_segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, H5 = {
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": O5,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": R5,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": P5,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": A5,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": D5,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": L5,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              content {\n                ... on Klaviyo_EmailMessageContent {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": V5,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": z5,
  "\n  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": M5,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": U5,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_lists(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": B5,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_profile_segments(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": q5
};
function mi(e) {
  return H5[e] ?? {};
}
const W5 = mi(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), K5 = mi(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageResponseCompoundDocument {
          data {
            id
            type
            attributes {
              content {
                ... on Klaviyo_EmailMessageContent {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), G5 = mi(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Y5 = mi(
  /* GraphQL */
  `
  query getProfileByFilter($emailFilter: String, $phoneNumberFilter: String) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), J5 = mi(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [subscriptions]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: subscriptions
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Q5 = mi(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_lists(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), X5 = mi(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_profile_segments(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), Z5 = mi(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), eq = mi(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function fh(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function Db(e) {
  return fh(e) && e?.attributes?.event_properties?.$message;
}
function nq(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function Pb(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function tq(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollection" && e.Klaviyo.get_metrics.data || [];
}
function rq(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function iq(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function aq(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function oq(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function sq(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function Ab(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function lq(e) {
  return e?.attributes?.content?.__typename === "Klaviyo_EmailMessageContent" && e.attributes.content.preview_text || void 0;
}
function cq(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const uq = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function dq(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function mq(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function pq({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: t, useQuery: i } = un(), { track: a } = hn(), [o, s] = oe(null), [l, u] = oe(
    null
  ), [m, d] = oe(null), [f, h] = oe(null), [v, x] = oe(
    null
  ), [S, N] = oe([]), {
    data: j,
    error: y,
    loading: q,
    networkStatus: E
  } = i(G5, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    C,
    {
      data: T,
      error: U,
      loading: Z,
      networkStatus: Q
    }
  ] = t(W5, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return qe(() => {
    if (j && !q && E === hr.ready) {
      const ee = tq(j);
      s(
        ee.find((J) => J?.attributes?.name === "Received Email")?.id || null
      ), u(
        ee.find((J) => J?.attributes?.name === "Opened Email")?.id || null
      ), d(
        ee.find((J) => J?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        ee.find((J) => J?.attributes?.name === "Bounced Email")?.id || null
      ), x(
        ee.find((J) => J?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), u(null), d(null), h(null), x(null);
  }, [j]), qe(() => {
    o && l && m && f && v && !Z && Q === hr.ready ? C({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${v}")`,
        pageSize: n
      }
    }) : N([]);
  }, [
    o,
    l,
    m,
    f,
    v
  ]), qe(() => {
    if (!Z && T) {
      const ee = rq(T), J = aq(
        T
      ).map(
        (ge) => ge?.attributes?.event_properties.$message
      ), K = oq(
        T
      ).map(
        (ge) => ge?.attributes?.event_properties.$message
      );
      ee.forEach((ge) => {
        const ce = ge.attributes?.event_properties.$message;
        ge.opened = J.includes(ce), ge.clicked = K.includes(ce);
      });
      const D = iq(T), G = sq(T), ne = [
        ...ee,
        ...G,
        ...D
      ].sort((ge, ce) => {
        const ve = Pb(ge), H = Pb(ce);
        return ve == null && H == null ? 0 : ve == null ? 1 : H == null ? -1 : H - ve;
      }).slice(0, n);
      N(ne);
      const de = ne.map((ge) => ge.id);
      a("klaviyo:messages:received", {
        emailsReceived: ee.filter(
          (ge) => de.includes(ge.id)
        ).length,
        emailsBounced: G.filter(
          (ge) => de.includes(ge.id)
        ).length,
        smsReceived: D.filter(
          (ge) => de.includes(ge.id)
        ).length,
        total: de.length
      });
    } else
      N([]);
  }, [Z, T]), Zn(
    () => ({
      receivedMessages: S,
      isLoading: q || Z,
      error: y || U
    }),
    [
      S,
      q,
      Z,
      y,
      U
    ]
  );
}
function fq({ profileId: e }) {
  const { useQuery: n } = un(), [t, i] = oe(), [a, o] = oe(), {
    data: s,
    error: l,
    loading: u,
    refetch: m
  } = n(J5, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  qe(() => {
    l && o(l);
  }, [l]), qe(() => {
    !u && s && i(s.Klaviyo.get_profile);
  }, [u, s]);
  const d = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Zn(
    () => ({
      profile: t,
      refetchProfile: d,
      isLoading: u,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, u, a]
  );
}
function hq({
  email: e,
  phoneNumber: n
}) {
  const { track: t } = hn(), { useLazyQuery: i } = un(), [a, o] = oe(), [s, l] = oe(), [
    u,
    { data: m, error: d, loading: f }
  ] = i(Y5, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    if (!f && m) {
      const v = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, x = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(v, x);
    }
  }, [f, m]);
  const h = (v, x) => {
    const S = v?.data?.length === 1 && v.data[0]?.id || void 0, N = x?.data?.length === 1 && x.data[0]?.id || void 0, j = S || N, y = !S || !N || S === N;
    if (j && y) {
      o(S || N), t("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), t("klaviyo:profile:received", { hasProfile: !1 }), y || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${S}) and phone number ${n} (profile ID ${N}).`
      )
    );
  };
  return Zn(
    () => ({
      profileId: a,
      getProfileId: u,
      isLoading: f,
      error: d || s
    }),
    [a, u, f, d, s]
  );
}
const Lb = 800, vq = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, yq = 3, gq = 1.5, kq = ({
  query: e,
  delay: n,
  delayRange: t,
  maxCount: i = yq,
  useDelayRange: a = !1
}) => {
  const o = (U) => Math.floor(Math.random() * (U.max - U.min) + U.min), [s, l] = oe(0), [u, m] = oe(n || Lb), [d, f] = oe(t || vq), [h, v] = oe(!1), [x, S] = oe(!1), N = a || !!t, j = N ? o(d) : n || Lb, [y, q] = oe(j);
  FU(
    async () => {
      const U = s + 1, Z = gq ** U;
      l(U), q(
        (N ? o(d) : u) * Z
      ), await e().then(() => {
        S(!0), T();
      });
    },
    h ? y : null
  ), $U(() => T());
  const E = ft(() => {
    l(0), q(j);
  }, [j]), C = ft(
    (U = {}) => {
      const { delay: Z, delayRange: Q } = U;
      S(!1), E(), Q && (f(Q), q(o(Q))), Z && (m(Z), q(Z)), v(!0);
    },
    [E]
  ), T = ft(() => {
    v(!1), E();
  }, [E]);
  return qe(() => {
    s >= i && T();
  }, [s, i, T]), Zn(
    () => ({ isRunning: h, isSuccessful: x, start: C, stop: T }),
    [h, x, C, T]
  );
}, bq = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, _q = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function xq({
  profileId: e,
  query: n
}) {
  const { useQuery: t } = un(), [i, a] = oe(), [o, s] = oe(), {
    data: l,
    error: u,
    loading: m,
    refetch: d,
    networkStatus: f
  } = t(
    n === "lists" ? Q5 : X5,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: v,
    stop: x
  } = kq({
    query: d,
    useDelayRange: !0
  }), S = m || h;
  return qe(() => {
    if (u)
      if (VF({
        errors: u.graphQLErrors
      })) {
        if (!h) {
          const N = bq(u);
          v({
            ...N && {
              delayRange: _q(N)
            }
          });
        }
      } else
        s(u);
  }, [u]), qe(() => {
    if (!m && l?.Klaviyo) {
      let N = {}, j = {};
      n === "lists" && (N = l?.Klaviyo?.get_profile_lists), n === "segments" && (j = l?.Klaviyo?.get_profile_segments), (N?.data || j?.data) && (x(), a(
        (n === "lists" ? N?.data : j?.data)?.map((y) => ({
          ...y,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Zn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: v,
      isLoading: S,
      error: o,
      networkStatus: f
    }),
    [i, S, o, f, v]
  );
}
const Sq = "_notificationText_1polx_1", Av = {
  notificationText: Sq
}, Bc = ({ error: e }) => {
  const { track: n } = hn();
  let t = e;
  if (UN(e)) {
    const { graphQLErrors: i } = e, a = i.length === 1 && AF({ error: i[0] }), o = i.length === 1 && LF({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), t = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), t = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ $e.jsx(_n, { error: e });
  }
  return /* @__PURE__ */ $e.jsx(_, { margin: "0 0 300", children: /* @__PURE__ */ $e.jsx(
    He.Item,
    {
      contentLeft: /* @__PURE__ */ $e.jsx(he, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: t.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, Nq = "_message_1vrar_48", jq = "_messageIsOpen_1vrar_56", wq = "_messageHeader_1vrar_59", Cq = "_messageLabel_1vrar_65", Fq = "_messageText_1vrar_68", ka = {
  message: Nq,
  messageIsOpen: jq,
  messageHeader: wq,
  messageLabel: Cq,
  messageText: Fq
}, Iq = ({ event: e, isLoadingPreview: n }) => {
  const t = e?.attributes?.event_properties, i = e.flowMessage && lq(e.flowMessage);
  return /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsxs(_, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: ka.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ $e.jsx(A.Paragraph, { children: t["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ $e.jsx(_, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ $e.jsx(cn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ $e.jsxs(
      _,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ $e.jsx(_, { children: /* @__PURE__ */ $e.jsx(
            A.Paragraph,
            {
              variant: "4",
              className: ka.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", className: ka.messageText, children: i })
        ]
      }
    )
  ] });
}, $q = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ $e.jsx($e.Fragment, { children: /* @__PURE__ */ $e.jsxs(_, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ $e.jsx(_, { children: /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ $e.jsx(_, { children: n?.extra?.["Message Body"] })
  ] }) });
}, Eq = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: t
}) => {
  const [i, a] = oe(t), { attributes: o, eventType: s } = e, l = o?.datetime, u = o?.timestamp, m = "DD MMM YYYY @ HH:mm", d = Zn(
    () => () => l ? Tn(l).format(m) : u ? Tn.unix(u).format(m) : null,
    [u, l]
  )(), f = s === "EMAIL", h = s === "SMS", v = f && e.opened, x = f && e.clicked, S = f && o?.event_properties.Subject, N = h && o?.event_properties["Message Name"], j = f ? "mail" : "sms";
  return /* @__PURE__ */ $e.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      className: ht(ka.message, {
        [ka.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ $e.jsxs(
          _,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: ka.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ $e.jsxs(_, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ $e.jsxs(_, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ $e.jsx(he, { size: 16, name: j }),
                  " ",
                  uq(s),
                  d && /* @__PURE__ */ $e.jsx(zn, { size: "small", variant: "info", children: d })
                ] }),
                S && S,
                N && N
              ] }),
              /* @__PURE__ */ $e.jsx(
                lr,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ $e.jsxs(_, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ $e.jsx(Vh, {}),
          nq(e) && /* @__PURE__ */ $e.jsx(_, { children: /* @__PURE__ */ $e.jsx(zn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
            /* @__PURE__ */ $e.jsxs(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ $e.jsx(En, { children: /* @__PURE__ */ $e.jsxs(_, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  he,
                  {
                    size: 16,
                    color: v ? "green.400" : "red.400",
                    name: v ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ $e.jsx(En, { children: /* @__PURE__ */ $e.jsxs(_, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ $e.jsx(
                  he,
                  {
                    size: 16,
                    color: x ? "green.400" : "red.400",
                    name: x ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ $e.jsx(Iq, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ $e.jsx($q, { event: e })
        ] })
      ]
    }
  );
}, Tq = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, Oq = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [t, i] = oe(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = pq({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, u] = T5({
    query: K5,
    options: Tq,
    delayMs: 1e3
  }), [m, d] = oe([]);
  qe(() => {
    if (a.length > 0) {
      d(a);
      const h = a.filter((v) => fh(v)).map((v) => Db(v));
      h.length > 0 && (i(!0), l(
        h.map((v) => ({
          messageId: v
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), qe(() => {
    u.length > 0 && d(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && fh(h) && !h.flowMessage) {
          const v = Db(h), x = u.find((N) => (N.data && Ab(N.data))?.id === v), S = x?.data && Ab(x.data);
          if (S)
            return {
              ...cq(h),
              flowMessage: S
            };
        }
        return h;
      })
    );
  }, [u]);
  const f = [];
  return s && f.push(s), u.length > 0 && f.push(
    ...u.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: f.map((h, v) => h.graphQLErrors ? /* @__PURE__ */ $e.jsx(
    _n,
    {
      error: h
    },
    `lastMessagesError${v}`
  ) : /* @__PURE__ */ $e.jsx(
    Bc,
    {
      error: h
    },
    `lastMessagesError${v}`
  )) }) : /* @__PURE__ */ $e.jsxs($e.Fragment, { children: [
    /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ $e.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : /* @__PURE__ */ $e.jsx($e.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ $e.jsx(_, { gap: "200", flexDirection: "column", children: m.map((h, v) => /* @__PURE__ */ $e.jsx(
      Eq,
      {
        event: h,
        isLoadingPreview: t,
        openByDefault: v === 0
      },
      h.id
    )) }) : /* @__PURE__ */ $e.jsx(
      _,
      {
        justifyContent: "center",
        margin: "200",
        className: Av.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, Rq = "_list_ld0hf_1", Dq = "_listItem_ld0hf_4", Eo = {
  list: Rq,
  listItem: Dq
}, Vb = ({
  profileId: e,
  type: n
}) => {
  const [t, i] = oe(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: u
  } = xq({ profileId: e, query: n });
  qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || u();
  }, d = a || [];
  return o ? /* @__PURE__ */ $e.jsx(Bc, { error: o }) : s ? /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: Eo.listItem, children: /* @__PURE__ */ $e.jsx(cn, { size: 14 }) }, "loading") : d.length > 0 ? /* @__PURE__ */ $e.jsx($e.Fragment, { children: d.map(
    ({ attributes: f, type: h }, v) => /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: Eo.listItem, children: /* @__PURE__ */ $e.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ $e.jsx(En, { children: pc(h) })
    ] }) }, v)
  ) }) : t && !a ? /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: Eo.listItem, children: /* @__PURE__ */ $e.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ $e.jsxs(_, { gap: "200", children: [
      /* @__PURE__ */ $e.jsx(he, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ $e.jsxs(A.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ $e.jsx(Je, { content: "Refresh lists and segments", children: /* @__PURE__ */ $e.jsx(qn, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ $e.jsx(He.Text, { variant: "dense", className: Eo.listItem, children: /* @__PURE__ */ $e.jsx(_, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ $e.jsx(A.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ $e.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, Pq = "_tagHover_kzbzk_1", Aq = "_channelUnsubscribed_kzbzk_6", zb = {
  tagHover: Pq,
  channelUnsubscribed: Aq
}, Mb = ({
  isSubscribed: e,
  isLoading: n,
  channelName: t,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ $e.jsx(
    Je,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ $e.jsx(
        En,
        {
          className: zb.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ $e.jsxs(
            _,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: ht({
                [zb.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ $e.jsx(cn, { size: 16 }) : /* @__PURE__ */ $e.jsx(he, { size: 16, name: i }),
                t
              ]
            }
          )
        }
      )
    }
  );
}, Lq = "_subscriptionError_1qhhx_1", Vq = {
  subscriptionError: Lq
}, zq = ({
  subscriptionListId: e,
  profile: n,
  email: t,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = oe(!1), [u, m] = oe(!1), [d, f] = oe(), { track: h } = hn(), [v, x] = IU({
    channel: null,
    request: null
  }), S = dq(n), N = mq(n), j = !!e, { useMutation: y } = un(), [q] = y(
    Z5
  ), [E] = y(
    eq
  ), C = (Z) => {
    h("klaviyo:profile:subscribe:clicked", { channel: Z }), x.setAll({
      channel: Z,
      request: "subscribed"
    }), ((Q) => q({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: "profile",
                id: a,
                attributes: {
                  email: t,
                  // eslint-disable-next-line camelcase
                  phone_number: i,
                  subscriptions: {
                    ...Q === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    },
                    ...Q === "SMS" && {
                      sms: {
                        marketing: {
                          consent: "SUBSCRIBED"
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: e
            }
          }
        }
      }
    }))(Z).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !0
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !0
      })
    );
  }, T = (Z) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: Z }), x.setAll({
      channel: Z,
      request: "unsubscribed"
    }), E({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: "profile",
                attributes: {
                  ...Z === "EMAIL" ? { email: t } : {},
                  // eslint-disable-next-line camelcase
                  ...Z === "SMS" ? { phone_number: i } : {}
                }
              }
            ]
          }
        }
      }
    }).then(
      (Q) => U({
        channel: Z,
        mutationResponse: Q,
        isSubscriptionRequest: !1
      })
    ).catch(
      (Q) => U({
        channel: Z,
        mutationErrorResponse: Q,
        isSubscriptionRequest: !1
      })
    );
  }, U = async ({
    channel: Z,
    mutationResponse: Q,
    mutationErrorResponse: ee,
    isSubscriptionRequest: J
  }) => {
    const K = ee?.networkError, D = K ? K?.statusCode : NaN, G = Q?.errors, ne = !!G && LN({
      errors: G
    });
    D === 202 ? (h(
      J ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: Z }
    ), await o()) : ne ? (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${J ? "opt-in" : "opt-out"}.`
    )) : (h(
      J ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: Z,
        reason: K?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${J ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return qe(() => {
    if (v.request === "subscribed") {
      const Z = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${v.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      v.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(Z), x.reset()), v.channel === "SMS" && !u && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(Z), x.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    u
  ]), /* @__PURE__ */ $e.jsx(
    _,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ $e.jsxs(_, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ $e.jsxs(_, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ $e.jsx(
            Mb,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: S,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: j,
              handleAction: () => {
                l(!0), f(void 0), S ? T("EMAIL") : C("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ $e.jsx(
            Mb,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: u,
              isSubscribed: N,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: j,
              handleAction: () => {
                m(!0), f(void 0), N ? T("SMS") : C("SMS");
              }
            }
          )
        ] }),
        d && /* @__PURE__ */ $e.jsx(_, { className: Vq.subscriptionError, children: d })
      ] })
    }
  );
}, Mq = ({
  profileId: e,
  email: n,
  phoneNumber: t,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  noOfMessagesToShow: s,
  subscriptionListId: l
}) => {
  const {
    profile: u,
    error: m,
    isLoading: d,
    refetchProfile: f
  } = fq({ profileId: e });
  return m ? /* @__PURE__ */ $e.jsx(Bc, { error: m }) : d ? /* @__PURE__ */ $e.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : !u && !d ? /* @__PURE__ */ $e.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200",
      className: Av.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ $e.jsxs(_, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ $e.jsxs(_, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ $e.jsx(A.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ $e.jsxs(He, { className: Eo.list, children: [
        i && /* @__PURE__ */ $e.jsx(Vb, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ $e.jsx(
          Vb,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ $e.jsx(
      zq,
      {
        profile: u,
        profileId: e,
        subscriptionListId: l,
        refetchProfile: f,
        email: n,
        phoneNumber: t
      }
    ),
    /* @__PURE__ */ $e.jsx(
      Oq,
      {
        profileId: e,
        noOfMessagesToShow: s
      }
    )
  ] });
}, Uq = ({
  conversationContext: e,
  settings: n
}) => {
  const t = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: m,
    getProfileId: d,
    isLoading: f,
    error: h
  } = hq({ email: t, phoneNumber: i });
  return UF(() => {
    (t || i) && d({
      variables: {
        emailFilter: `equals(email,"${t}")`,
        phoneNumberFilter: `equals(phone_number,"${i}")`
      }
    });
  }, [t, i]), !t && !i ? /* @__PURE__ */ $e.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : f ? /* @__PURE__ */ $e.jsx(_, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ $e.jsx(cn, {}) }) : h ? /* @__PURE__ */ $e.jsx(Bc, { error: h }) : m ? /* @__PURE__ */ $e.jsx(
    Mq,
    {
      profileId: m,
      email: t,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      noOfMessagesToShow: l,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ $e.jsx(
    _,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: Av.notificationText,
      children: "No profile ID found"
    }
  );
}, Bq = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    required: !1,
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "subscriptionListId",
    label: "Activate re-/subscription list selection",
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "subscriptionListComponent",
    label: "Select a list to subscribe to",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: PF
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    required: !0,
    secret: !1,
    type: "select",
    defaultValue: "5",
    selectItems: [
      { value: "3", label: "The three latest messages" },
      { value: "4", label: "The four latest messages" },
      { value: "5", label: "The five latest messages" }
    ]
  }
];
function qq(e, n) {
  const t = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (t.padRight ? " " : "") + "," + (t.padLeft === !1 ? "" : " ")
  ).trim();
}
const Hq = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Wq = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, Kq = {};
function Ub(e, n) {
  return (Kq.jsx ? Wq : Hq).test(e);
}
const Gq = /[ \t\n\f\r]/g;
function Yq(e) {
  return typeof e == "object" ? e.type === "text" ? Bb(e.value) : !1 : Bb(e);
}
function Bb(e) {
  return e.replace(Gq, "") === "";
}
class xs {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, t, i) {
    this.property = n, this.normal = t, i && (this.space = i);
  }
}
xs.prototype.property = {};
xs.prototype.normal = {};
xs.prototype.space = null;
function OC(e, n) {
  const t = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(t, e[a].property), Object.assign(i, e[a].normal);
  return new xs(t, i, n);
}
function hh(e) {
  return e.toLowerCase();
}
class _r {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, t) {
    this.property = n, this.attribute = t;
  }
}
_r.prototype.space = null;
_r.prototype.boolean = !1;
_r.prototype.booleanish = !1;
_r.prototype.overloadedBoolean = !1;
_r.prototype.number = !1;
_r.prototype.commaSeparated = !1;
_r.prototype.spaceSeparated = !1;
_r.prototype.commaOrSpaceSeparated = !1;
_r.prototype.mustUseProperty = !1;
_r.prototype.defined = !1;
let Jq = 0;
const kn = Yi(), mt = Yi(), RC = Yi(), Ae = Yi(), Qn = Yi(), ba = Yi(), tr = Yi();
function Yi() {
  return 2 ** ++Jq;
}
const vh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: kn,
  booleanish: mt,
  commaOrSpaceSeparated: tr,
  commaSeparated: ba,
  number: Ae,
  overloadedBoolean: RC,
  spaceSeparated: Qn
}, Symbol.toStringTag, { value: "Module" })), cd = Object.keys(vh);
class Lv extends _r {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, t, i, a) {
    let o = -1;
    if (super(n, t), qb(this, "space", a), typeof i == "number")
      for (; ++o < cd.length; ) {
        const s = cd[o];
        qb(this, cd[o], (i & vh[s]) === vh[s]);
      }
  }
}
Lv.prototype.defined = !0;
function qb(e, n, t) {
  t && (e[n] = t);
}
const Qq = {}.hasOwnProperty;
function Ma(e) {
  const n = {}, t = {};
  let i;
  for (i in e.properties)
    if (Qq.call(e.properties, i)) {
      const a = e.properties[i], o = new Lv(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, t[hh(i)] = i, t[hh(o.attribute)] = i;
    }
  return new xs(n, t, e.space);
}
const DC = Ma({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), PC = Ma({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function AC(e, n) {
  return n in e ? e[n] : n;
}
function LC(e, n) {
  return AC(e, n.toLowerCase());
}
const VC = Ma({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: LC,
  properties: { xmlns: null, xmlnsXLink: null }
}), zC = Ma({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: mt,
    ariaAutoComplete: null,
    ariaBusy: mt,
    ariaChecked: mt,
    ariaColCount: Ae,
    ariaColIndex: Ae,
    ariaColSpan: Ae,
    ariaControls: Qn,
    ariaCurrent: null,
    ariaDescribedBy: Qn,
    ariaDetails: null,
    ariaDisabled: mt,
    ariaDropEffect: Qn,
    ariaErrorMessage: null,
    ariaExpanded: mt,
    ariaFlowTo: Qn,
    ariaGrabbed: mt,
    ariaHasPopup: null,
    ariaHidden: mt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Qn,
    ariaLevel: Ae,
    ariaLive: null,
    ariaModal: mt,
    ariaMultiLine: mt,
    ariaMultiSelectable: mt,
    ariaOrientation: null,
    ariaOwns: Qn,
    ariaPlaceholder: null,
    ariaPosInSet: Ae,
    ariaPressed: mt,
    ariaReadOnly: mt,
    ariaRelevant: null,
    ariaRequired: mt,
    ariaRoleDescription: Qn,
    ariaRowCount: Ae,
    ariaRowIndex: Ae,
    ariaRowSpan: Ae,
    ariaSelected: mt,
    ariaSetSize: Ae,
    ariaSort: null,
    ariaValueMax: Ae,
    ariaValueMin: Ae,
    ariaValueNow: Ae,
    ariaValueText: null,
    role: null
  }
}), Xq = Ma({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: LC,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ba,
    acceptCharset: Qn,
    accessKey: Qn,
    action: null,
    allow: null,
    allowFullScreen: kn,
    allowPaymentRequest: kn,
    allowUserMedia: kn,
    alt: null,
    as: null,
    async: kn,
    autoCapitalize: null,
    autoComplete: Qn,
    autoFocus: kn,
    autoPlay: kn,
    blocking: Qn,
    capture: null,
    charSet: null,
    checked: kn,
    cite: null,
    className: Qn,
    cols: Ae,
    colSpan: null,
    content: null,
    contentEditable: mt,
    controls: kn,
    controlsList: Qn,
    coords: Ae | ba,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: kn,
    defer: kn,
    dir: null,
    dirName: null,
    disabled: kn,
    download: RC,
    draggable: mt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: kn,
    formTarget: null,
    headers: Qn,
    height: Ae,
    hidden: kn,
    high: Ae,
    href: null,
    hrefLang: null,
    htmlFor: Qn,
    httpEquiv: Qn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: kn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: kn,
    itemId: null,
    itemProp: Qn,
    itemRef: Qn,
    itemScope: kn,
    itemType: Qn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: kn,
    low: Ae,
    manifest: null,
    max: null,
    maxLength: Ae,
    media: null,
    method: null,
    min: null,
    minLength: Ae,
    multiple: kn,
    muted: kn,
    name: null,
    nonce: null,
    noModule: kn,
    noValidate: kn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: kn,
    optimum: Ae,
    pattern: null,
    ping: Qn,
    placeholder: null,
    playsInline: kn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: kn,
    referrerPolicy: null,
    rel: Qn,
    required: kn,
    reversed: kn,
    rows: Ae,
    rowSpan: Ae,
    sandbox: Qn,
    scope: null,
    scoped: kn,
    seamless: kn,
    selected: kn,
    shadowRootClonable: kn,
    shadowRootDelegatesFocus: kn,
    shadowRootMode: null,
    shape: null,
    size: Ae,
    sizes: null,
    slot: null,
    span: Ae,
    spellCheck: mt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ae,
    step: null,
    style: null,
    tabIndex: Ae,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: kn,
    useMap: null,
    value: mt,
    width: Ae,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Qn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ae,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ae,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: kn,
    // Lists. Use CSS to reduce space between items instead
    declare: kn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ae,
    // `<img>` and `<object>`
    leftMargin: Ae,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ae,
    // `<body>`
    marginWidth: Ae,
    // `<body>`
    noResize: kn,
    // `<frame>`
    noHref: kn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: kn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: kn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ae,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: mt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ae,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ae,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: kn,
    disableRemotePlayback: kn,
    prefix: null,
    property: null,
    results: Ae,
    security: null,
    unselectable: null
  }
}), Zq = Ma({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: AC,
  properties: {
    about: tr,
    accentHeight: Ae,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ae,
    amplitude: Ae,
    arabicForm: null,
    ascent: Ae,
    attributeName: null,
    attributeType: null,
    azimuth: Ae,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ae,
    by: null,
    calcMode: null,
    capHeight: Ae,
    className: Qn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ae,
    diffuseConstant: Ae,
    direction: null,
    display: null,
    dur: null,
    divisor: Ae,
    dominantBaseline: null,
    download: kn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ae,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ae,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ae,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ba,
    g2: ba,
    glyphName: ba,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ae,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ae,
    horizOriginX: Ae,
    horizOriginY: Ae,
    id: null,
    ideographic: Ae,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ae,
    k: Ae,
    k1: Ae,
    k2: Ae,
    k3: Ae,
    k4: Ae,
    kernelMatrix: tr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ae,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ae,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ae,
    overlineThickness: Ae,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ae,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Qn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ae,
    pointsAtY: Ae,
    pointsAtZ: Ae,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: tr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: tr,
    rev: tr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: tr,
    requiredFeatures: tr,
    requiredFonts: tr,
    requiredFormats: tr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ae,
    specularExponent: Ae,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ae,
    strikethroughThickness: Ae,
    string: null,
    stroke: null,
    strokeDashArray: tr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ae,
    strokeOpacity: Ae,
    strokeWidth: null,
    style: null,
    surfaceScale: Ae,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: tr,
    tabIndex: Ae,
    tableValues: null,
    target: null,
    targetX: Ae,
    targetY: Ae,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: tr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ae,
    underlineThickness: Ae,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ae,
    values: null,
    vAlphabetic: Ae,
    vMathematical: Ae,
    vectorEffect: null,
    vHanging: Ae,
    vIdeographic: Ae,
    version: null,
    vertAdvY: Ae,
    vertOriginX: Ae,
    vertOriginY: Ae,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ae,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), e6 = /^data[-\w.:]+$/i, Hb = /-[a-z]/g, n6 = /[A-Z]/g;
function t6(e, n) {
  const t = hh(n);
  let i = n, a = _r;
  if (t in e.normal)
    return e.property[e.normal[t]];
  if (t.length > 4 && t.slice(0, 4) === "data" && e6.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(Hb, i6);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!Hb.test(o)) {
        let s = o.replace(n6, r6);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = Lv;
  }
  return new a(i, n);
}
function r6(e) {
  return "-" + e.toLowerCase();
}
function i6(e) {
  return e.charAt(1).toUpperCase();
}
const a6 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, o6 = OC([PC, DC, VC, zC, Xq], "html"), Vv = OC([PC, DC, VC, zC, Zq], "svg");
function s6(e) {
  return e.join(" ").trim();
}
var aa = {}, ud, Wb;
function l6() {
  if (Wb) return ud;
  Wb = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, t = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, u = `
`, m = "/", d = "*", f = "", h = "comment", v = "declaration";
  ud = function(S, N) {
    if (typeof S != "string")
      throw new TypeError("First argument must be a string");
    if (!S) return [];
    N = N || {};
    var j = 1, y = 1;
    function q(D) {
      var G = D.match(n);
      G && (j += G.length);
      var ne = D.lastIndexOf(u);
      y = ~ne ? D.length - ne : y + D.length;
    }
    function E() {
      var D = { line: j, column: y };
      return function(G) {
        return G.position = new C(D), Z(), G;
      };
    }
    function C(D) {
      this.start = D, this.end = { line: j, column: y }, this.source = N.source;
    }
    C.prototype.content = S;
    function T(D) {
      var G = new Error(
        N.source + ":" + j + ":" + y + ": " + D
      );
      if (G.reason = D, G.filename = N.source, G.line = j, G.column = y, G.source = S, !N.silent) throw G;
    }
    function U(D) {
      var G = D.exec(S);
      if (G) {
        var ne = G[0];
        return q(ne), S = S.slice(ne.length), G;
      }
    }
    function Z() {
      U(t);
    }
    function Q(D) {
      var G;
      for (D = D || []; G = ee(); )
        G !== !1 && D.push(G);
      return D;
    }
    function ee() {
      var D = E();
      if (!(m != S.charAt(0) || d != S.charAt(1))) {
        for (var G = 2; f != S.charAt(G) && (d != S.charAt(G) || m != S.charAt(G + 1)); )
          ++G;
        if (G += 2, f === S.charAt(G - 1))
          return T("End of comment missing");
        var ne = S.slice(2, G - 2);
        return y += 2, q(ne), S = S.slice(G), y += 2, D({
          type: h,
          comment: ne
        });
      }
    }
    function J() {
      var D = E(), G = U(i);
      if (G) {
        if (ee(), !U(a)) return T("property missing ':'");
        var ne = U(o), de = D({
          type: v,
          property: x(G[0].replace(e, f)),
          value: ne ? x(ne[0].replace(e, f)) : f
        });
        return U(s), de;
      }
    }
    function K() {
      var D = [];
      Q(D);
      for (var G; G = J(); )
        G !== !1 && (D.push(G), Q(D));
      return D;
    }
    return Z(), K();
  };
  function x(S) {
    return S ? S.replace(l, f) : f;
  }
  return ud;
}
var Kb;
function c6() {
  if (Kb) return aa;
  Kb = 1;
  var e = aa && aa.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(aa, "__esModule", { value: !0 }), aa.default = t;
  var n = e(l6());
  function t(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(u) {
      if (u.type === "declaration") {
        var m = u.property, d = u.value;
        l ? a(m, d, u) : d && (o = o || {}, o[m] = d);
      }
    }), o;
  }
  return aa;
}
var u6 = c6();
const Gb = /* @__PURE__ */ Bh(u6), d6 = Gb.default || Gb, MC = UC("end"), zv = UC("start");
function UC(e) {
  return n;
  function n(t) {
    const i = t && t.position && t.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function m6(e) {
  const n = zv(e), t = MC(e);
  if (n && t)
    return { start: n, end: t };
}
function Ao(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Yb(e.position) : "start" in e || "end" in e ? Yb(e) : "line" in e || "column" in e ? yh(e) : "";
}
function yh(e) {
  return Jb(e && e.line) + ":" + Jb(e && e.column);
}
function Yb(e) {
  return yh(e && e.start) + "-" + yh(e && e.end);
}
function Jb(e) {
  return e && typeof e == "number" ? e : 1;
}
class Dt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, t, i) {
    super(), typeof t == "string" && (i = t, t = void 0);
    let a = "", o = {}, s = !1;
    if (t && ("line" in t && "column" in t ? o = { place: t } : "start" in t && "end" in t ? o = { place: t } : "type" in t ? o = {
      ancestors: [t],
      place: t.position
    } : o = { ...t }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const u = i.indexOf(":");
      u === -1 ? o.ruleId = i : (o.source = i.slice(0, u), o.ruleId = i.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = Ao(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Dt.prototype.file = "";
Dt.prototype.name = "";
Dt.prototype.reason = "";
Dt.prototype.message = "";
Dt.prototype.stack = "";
Dt.prototype.column = void 0;
Dt.prototype.line = void 0;
Dt.prototype.ancestors = void 0;
Dt.prototype.cause = void 0;
Dt.prototype.fatal = void 0;
Dt.prototype.place = void 0;
Dt.prototype.ruleId = void 0;
Dt.prototype.source = void 0;
const Mv = {}.hasOwnProperty, p6 = /* @__PURE__ */ new Map(), f6 = /[A-Z]/g, h6 = /-([a-z])/g, v6 = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), y6 = /* @__PURE__ */ new Set(["td", "th"]), BC = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function g6(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const t = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = w6(t, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = j6(t, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: t,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? Vv : o6,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = qC(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function qC(e, n, t) {
  if (n.type === "element")
    return k6(e, n, t);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return b6(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return x6(e, n, t);
  if (n.type === "mdxjsEsm")
    return _6(e, n);
  if (n.type === "root")
    return S6(e, n, t);
  if (n.type === "text")
    return N6(e, n);
}
function k6(e, n, t) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = Vv, e.schema = a), e.ancestors.push(n);
  const o = WC(e, n.tagName, !1), s = C6(e, n);
  let l = Bv(e, n);
  return v6.has(n.tagName) && (l = l.filter(function(u) {
    return typeof u == "string" ? !Yq(u) : !0;
  })), HC(e, s, o, n), Uv(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, t);
}
function b6(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  Qo(e, n.position);
}
function _6(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  Qo(e, n.position);
}
function x6(e, n, t) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = Vv, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : WC(e, n.name, !0), s = F6(e, n), l = Bv(e, n);
  return HC(e, s, o, n), Uv(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, t);
}
function S6(e, n, t) {
  const i = {};
  return Uv(i, Bv(e, n)), e.create(n, e.Fragment, i, t);
}
function N6(e, n) {
  return n.value;
}
function HC(e, n, t, i) {
  typeof t != "string" && t !== e.Fragment && e.passNode && (n.node = i);
}
function Uv(e, n) {
  if (n.length > 0) {
    const t = n.length > 1 ? n : n[0];
    t && (e.children = t);
  }
}
function j6(e, n, t) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? t : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function w6(e, n) {
  return t;
  function t(i, a, o, s) {
    const l = Array.isArray(o.children), u = zv(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function C6(e, n) {
  const t = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && Mv.call(n.properties, a)) {
      const o = I6(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && y6.has(n.tagName) ? i = l : t[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      t.style || (t.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return t;
}
function F6(e, n) {
  const t = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          t,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        Qo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          Qo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      t[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return t;
}
function Bv(e, n) {
  const t = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : p6;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const u = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (u) {
        const m = a.get(u) || 0;
        s = u + "-" + m, a.set(u, m + 1);
      }
    }
    const l = qC(e, o, s);
    l !== void 0 && t.push(l);
  }
  return t;
}
function I6(e, n, t) {
  const i = t6(e.schema, n);
  if (!(t == null || typeof t == "number" && Number.isNaN(t))) {
    if (Array.isArray(t) && (t = i.commaSeparated ? qq(t) : s6(t)), i.property === "style") {
      let a = typeof t == "object" ? t : $6(e, String(t));
      return e.stylePropertyNameCase === "css" && (a = E6(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? a6[i.property] || i.property : i.attribute,
      t
    ];
  }
}
function $6(e, n) {
  const t = {};
  try {
    d6(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Dt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = BC + "#cannot-parse-style-attribute", s;
    }
  }
  return t;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(h6, O6)), t[s] = o;
  }
}
function WC(e, n, t) {
  let i;
  if (!t)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = Ub(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = Ub(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return Mv.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  Qo(e);
}
function Qo(e, n) {
  const t = new Dt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw t.file = e.filePath || void 0, t.url = BC + "#cannot-handle-mdx-estrees-without-createevaluater", t;
}
function E6(e) {
  const n = {};
  let t;
  for (t in e)
    Mv.call(e, t) && (n[T6(t)] = e[t]);
  return n;
}
function T6(e) {
  let n = e.replace(f6, R6);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function O6(e, n) {
  return n.toUpperCase();
}
function R6(e) {
  return "-" + e.toLowerCase();
}
const dd = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, D6 = {};
function P6(e, n) {
  const t = D6, i = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, a = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return KC(e, i, a);
}
function KC(e, n, t) {
  if (A6(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Qb(e.children, n, t);
  }
  return Array.isArray(e) ? Qb(e, n, t) : "";
}
function Qb(e, n, t) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = KC(e[a], n, t);
  return i.join("");
}
function A6(e) {
  return !!(e && typeof e == "object");
}
const Xb = document.createElement("i");
function qv(e) {
  const n = "&" + e + ";";
  Xb.innerHTML = n;
  const t = Xb.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === n ? !1 : t;
}
function Qr(e, n, t, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, t = t > 0 ? t : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, t), e.splice(...s);
  else
    for (t && e.splice(n, t); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function mr(e, n) {
  return e.length > 0 ? (Qr(e, e.length, 0, n), e) : n;
}
const Zb = {}.hasOwnProperty;
function L6(e) {
  const n = {};
  let t = -1;
  for (; ++t < e.length; )
    V6(n, e[t]);
  return n;
}
function V6(e, n) {
  let t;
  for (t in n) {
    const a = (Zb.call(e, t) ? e[t] : void 0) || (e[t] = {}), o = n[t];
    let s;
    if (o)
      for (s in o) {
        Zb.call(a, s) || (a[s] = []);
        const l = o[s];
        z6(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function z6(e, n) {
  let t = -1;
  const i = [];
  for (; ++t < n.length; )
    (n[t].add === "after" ? e : i).push(n[t]);
  Qr(e, 0, 0, i);
}
function GC(e, n) {
  const t = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    t < 9 || t === 11 || t > 13 && t < 32 || // Control character (DEL) of C0, and C1 controls.
    t > 126 && t < 160 || // Lone high surrogates and low surrogates.
    t > 55295 && t < 57344 || // Noncharacters.
    t > 64975 && t < 65008 || /* eslint-disable no-bitwise */
    (t & 65535) === 65535 || (t & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    t > 1114111 ? "�" : String.fromCodePoint(t)
  );
}
function _a(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Hr = wi(/[A-Za-z]/), sr = wi(/[\dA-Za-z]/), M6 = wi(/[#-'*+\--9=?A-Z^-~]/);
function gh(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const kh = wi(/\d/), U6 = wi(/[\dA-Fa-f]/), B6 = wi(/[!-/:-@[-`{-~]/);
function pn(e) {
  return e !== null && e < -2;
}
function Zt(e) {
  return e !== null && (e < 0 || e === 32);
}
function An(e) {
  return e === -2 || e === -1 || e === 32;
}
const q6 = wi(new RegExp("\\p{P}|\\p{S}", "u")), H6 = wi(/\s/);
function wi(e) {
  return n;
  function n(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function Ua(e) {
  const n = [];
  let t = -1, i = 0, a = 0;
  for (; ++t < e.length; ) {
    const o = e.charCodeAt(t);
    let s = "";
    if (o === 37 && sr(e.charCodeAt(t + 1)) && sr(e.charCodeAt(t + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(t + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, t), encodeURIComponent(s)), i = t + a + 1, s = ""), a && (t += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function Xn(e, n, t, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(u) {
    return An(u) ? (e.enter(t), l(u)) : n(u);
  }
  function l(u) {
    return An(u) && o++ < a ? (e.consume(u), l) : (e.exit(t), n(u));
  }
}
const W6 = {
  tokenize: K6
};
function K6(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let t;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), Xn(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: t
    });
    return t && (t.next = u), t = u, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return pn(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const G6 = {
  tokenize: Y6
}, e_ = {
  tokenize: J6
};
function Y6(e) {
  const n = this, t = [];
  let i = 0, a, o, s;
  return l;
  function l(q) {
    if (i < t.length) {
      const E = t[i];
      return n.containerState = E[1], e.attempt(E[0].continuation, u, m)(q);
    }
    return m(q);
  }
  function u(q) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && y();
      const E = n.events.length;
      let C = E, T;
      for (; C--; )
        if (n.events[C][0] === "exit" && n.events[C][1].type === "chunkFlow") {
          T = n.events[C][1].end;
          break;
        }
      j(i);
      let U = E;
      for (; U < n.events.length; )
        n.events[U][1].end = {
          ...T
        }, U++;
      return Qr(n.events, C + 1, 0, n.events.slice(E)), n.events.length = U, m(q);
    }
    return l(q);
  }
  function m(q) {
    if (i === t.length) {
      if (!a)
        return h(q);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return x(q);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(e_, d, f)(q);
  }
  function d(q) {
    return a && y(), j(i), h(q);
  }
  function f(q) {
    return n.parser.lazy[n.now().line] = i !== t.length, s = n.now().offset, x(q);
  }
  function h(q) {
    return n.containerState = {}, e.attempt(e_, v, x)(q);
  }
  function v(q) {
    return i++, t.push([n.currentConstruct, n.containerState]), h(q);
  }
  function x(q) {
    if (q === null) {
      a && y(), j(0), e.consume(q);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), S(q);
  }
  function S(q) {
    if (q === null) {
      N(e.exit("chunkFlow"), !0), j(0), e.consume(q);
      return;
    }
    return pn(q) ? (e.consume(q), N(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(q), S);
  }
  function N(q, E) {
    const C = n.sliceStream(q);
    if (E && C.push(null), q.previous = o, o && (o.next = q), o = q, a.defineSkip(q.start), a.write(C), n.parser.lazy[q.start.line]) {
      let T = a.events.length;
      for (; T--; )
        if (
          // The token starts before the line ending…
          a.events[T][1].start.offset < s && // …and either is not ended yet…
          (!a.events[T][1].end || // …or ends after it.
          a.events[T][1].end.offset > s)
        )
          return;
      const U = n.events.length;
      let Z = U, Q, ee;
      for (; Z--; )
        if (n.events[Z][0] === "exit" && n.events[Z][1].type === "chunkFlow") {
          if (Q) {
            ee = n.events[Z][1].end;
            break;
          }
          Q = !0;
        }
      for (j(i), T = U; T < n.events.length; )
        n.events[T][1].end = {
          ...ee
        }, T++;
      Qr(n.events, Z + 1, 0, n.events.slice(U)), n.events.length = T;
    }
  }
  function j(q) {
    let E = t.length;
    for (; E-- > q; ) {
      const C = t[E];
      n.containerState = C[1], C[0].exit.call(n, e);
    }
    t.length = q;
  }
  function y() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function J6(e, n, t) {
  return Xn(e, e.attempt(this.parser.constructs.document, n, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function n_(e) {
  if (e === null || Zt(e) || H6(e))
    return 1;
  if (q6(e))
    return 2;
}
function Hv(e, n, t) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, t), i.push(o));
  }
  return n;
}
const bh = {
  name: "attention",
  resolveAll: Q6,
  tokenize: X6
};
function Q6(e, n) {
  let t = -1, i, a, o, s, l, u, m, d;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (i = t; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          u = e[i][1].end.offset - e[i][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[t][1].start
          };
          t_(f, -u), t_(h, u), s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[t][1].start
            },
            end: h
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[t][1].start
            }
          }, a = {
            type: u > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[t][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = mr(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = mr(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = mr(m, Hv(n.parser.constructs.insideSpan.null, e.slice(i + 1, t), n)), m = mr(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[t][1].end.offset - e[t][1].start.offset ? (d = 2, m = mr(m, [["enter", e[t][1], n], ["exit", e[t][1], n]])) : d = 0, Qr(e, i - 1, t - i + 3, m), t = i + m.length - d - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function X6(e, n) {
  const t = this.parser.constructs.attentionMarkers.null, i = this.previous, a = n_(i);
  let o;
  return s;
  function s(u) {
    return o = u, e.enter("attentionSequence"), l(u);
  }
  function l(u) {
    if (u === o)
      return e.consume(u), l;
    const m = e.exit("attentionSequence"), d = n_(u), f = !d || d === 2 && a || t.includes(u), h = !a || a === 2 && d || t.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (d || !f)), n(u);
  }
}
function t_(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const Z6 = {
  name: "autolink",
  tokenize: eH
};
function eH(e, n, t) {
  let i = 0;
  return a;
  function a(v) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(v) {
    return Hr(v) ? (e.consume(v), s) : v === 64 ? t(v) : m(v);
  }
  function s(v) {
    return v === 43 || v === 45 || v === 46 || sr(v) ? (i = 1, l(v)) : m(v);
  }
  function l(v) {
    return v === 58 ? (e.consume(v), i = 0, u) : (v === 43 || v === 45 || v === 46 || sr(v)) && i++ < 32 ? (e.consume(v), l) : (i = 0, m(v));
  }
  function u(v) {
    return v === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : v === null || v === 32 || v === 60 || gh(v) ? t(v) : (e.consume(v), u);
  }
  function m(v) {
    return v === 64 ? (e.consume(v), d) : M6(v) ? (e.consume(v), m) : t(v);
  }
  function d(v) {
    return sr(v) ? f(v) : t(v);
  }
  function f(v) {
    return v === 46 ? (e.consume(v), i = 0, d) : v === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(v), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(v);
  }
  function h(v) {
    if ((v === 45 || sr(v)) && i++ < 63) {
      const x = v === 45 ? h : f;
      return e.consume(v), x;
    }
    return t(v);
  }
}
const qc = {
  partial: !0,
  tokenize: nH
};
function nH(e, n, t) {
  return i;
  function i(o) {
    return An(o) ? Xn(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || pn(o) ? n(o) : t(o);
  }
}
const YC = {
  continuation: {
    tokenize: rH
  },
  exit: iH,
  name: "blockQuote",
  tokenize: tH
};
function tH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return t(s);
  }
  function o(s) {
    return An(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function rH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return An(s) ? Xn(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(YC, n, t)(s);
  }
}
function iH(e) {
  e.exit("blockQuote");
}
const JC = {
  name: "characterEscape",
  tokenize: aH
};
function aH(e, n, t) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return B6(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : t(o);
  }
}
const QC = {
  name: "characterReference",
  tokenize: oH
};
function oH(e, n, t) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = sr, d(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = U6, d) : (e.enter("characterReferenceValue"), o = 7, s = kh, d(f));
  }
  function d(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === sr && !qv(i.sliceSerialize(h)) ? t(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), d) : t(f);
  }
}
const r_ = {
  partial: !0,
  tokenize: lH
}, i_ = {
  concrete: !0,
  name: "codeFenced",
  tokenize: sH
};
function sH(e, n, t) {
  const i = this, a = {
    partial: !0,
    tokenize: C
  };
  let o = 0, s = 0, l;
  return u;
  function u(T) {
    return m(T);
  }
  function m(T) {
    const U = i.events[i.events.length - 1];
    return o = U && U[1].type === "linePrefix" ? U[2].sliceSerialize(U[1], !0).length : 0, l = T, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(T);
  }
  function d(T) {
    return T === l ? (s++, e.consume(T), d) : s < 3 ? t(T) : (e.exit("codeFencedFenceSequence"), An(T) ? Xn(e, f, "whitespace")(T) : f(T));
  }
  function f(T) {
    return T === null || pn(T) ? (e.exit("codeFencedFence"), i.interrupt ? n(T) : e.check(r_, S, E)(T)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(T));
  }
  function h(T) {
    return T === null || pn(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(T)) : An(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Xn(e, v, "whitespace")(T)) : T === 96 && T === l ? t(T) : (e.consume(T), h);
  }
  function v(T) {
    return T === null || pn(T) ? f(T) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), x(T));
  }
  function x(T) {
    return T === null || pn(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(T)) : T === 96 && T === l ? t(T) : (e.consume(T), x);
  }
  function S(T) {
    return e.attempt(a, E, N)(T);
  }
  function N(T) {
    return e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), j;
  }
  function j(T) {
    return o > 0 && An(T) ? Xn(e, y, "linePrefix", o + 1)(T) : y(T);
  }
  function y(T) {
    return T === null || pn(T) ? e.check(r_, S, E)(T) : (e.enter("codeFlowValue"), q(T));
  }
  function q(T) {
    return T === null || pn(T) ? (e.exit("codeFlowValue"), y(T)) : (e.consume(T), q);
  }
  function E(T) {
    return e.exit("codeFenced"), n(T);
  }
  function C(T, U, Z) {
    let Q = 0;
    return ee;
    function ee(ne) {
      return T.enter("lineEnding"), T.consume(ne), T.exit("lineEnding"), J;
    }
    function J(ne) {
      return T.enter("codeFencedFence"), An(ne) ? Xn(T, K, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(ne) : K(ne);
    }
    function K(ne) {
      return ne === l ? (T.enter("codeFencedFenceSequence"), D(ne)) : Z(ne);
    }
    function D(ne) {
      return ne === l ? (Q++, T.consume(ne), D) : Q >= s ? (T.exit("codeFencedFenceSequence"), An(ne) ? Xn(T, G, "whitespace")(ne) : G(ne)) : Z(ne);
    }
    function G(ne) {
      return ne === null || pn(ne) ? (T.exit("codeFencedFence"), U(ne)) : Z(ne);
    }
  }
}
function lH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? t(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? t(s) : n(s);
  }
}
const md = {
  name: "codeIndented",
  tokenize: uH
}, cH = {
  partial: !0,
  tokenize: dH
};
function uH(e, n, t) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), Xn(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const d = i.events[i.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? s(m) : t(m);
  }
  function s(m) {
    return m === null ? u(m) : pn(m) ? e.attempt(cH, s, u)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || pn(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function u(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function dH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? t(s) : pn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : Xn(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : pn(s) ? a(s) : t(s);
  }
}
const mH = {
  name: "codeText",
  previous: fH,
  resolve: pH,
  tokenize: hH
};
function pH(e) {
  let n = e.length - 4, t = 3, i, a;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = t; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", t += 2, n -= 2;
        break;
      }
  }
  for (i = t - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function fH(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function hH(e, n, t) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? t(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, d(f)) : pn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || pn(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), m);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), a++, d) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class vH {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, t) {
    const i = t ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, t, i) {
    const a = t || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && oo(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), oo(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), oo(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const t = this.left.splice(n, Number.POSITIVE_INFINITY);
        oo(this.right, t.reverse());
      } else {
        const t = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        oo(this.left, t.reverse());
      }
  }
}
function oo(e, n) {
  let t = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; t < n.length; )
      e.push(...n.slice(t, t + 1e4)), t += 1e4;
}
function XC(e) {
  const n = {};
  let t = -1, i, a, o, s, l, u, m;
  const d = new vH(e);
  for (; ++t < d.length; ) {
    for (; t in n; )
      t = n[t];
    if (i = d.get(t), t && i[1].type === "chunkFlow" && d.get(t - 1)[1].type === "listItemPrefix" && (u = i[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, yH(d, t)), t = n[t], m = !0);
    else if (i[1]._container) {
      for (o = t, a = void 0; o-- && (s = d.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (d.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...d.get(a)[1].start
      }, l = d.slice(a, t), l.unshift(i), d.splice(a, t - a + 1, l));
    }
  }
  return Qr(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !m;
}
function yH(e, n) {
  const t = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = t._tokenizer || i.parser[t.contentType](t.start), l = s.events, u = [], m = {};
  let d, f, h = -1, v = t, x = 0, S = 0;
  const N = [S];
  for (; v; ) {
    for (; e.get(++a)[1] !== v; )
      ;
    o.push(a), v._tokenizer || (d = i.sliceStream(v), v.next || d.push(null), f && s.defineSkip(v.start), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(d), v._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = v, v = v.next;
  }
  for (v = t; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (S = h + 1, N.push(S), v._tokenizer = void 0, v.previous = void 0, v = v.next);
  for (s.events = [], v ? (v._tokenizer = void 0, v.previous = void 0) : N.pop(), h = N.length; h--; ) {
    const j = l.slice(N[h], N[h + 1]), y = o.pop();
    u.push([y, y + j.length - 1]), e.splice(y, 2, j);
  }
  for (u.reverse(), h = -1; ++h < u.length; )
    m[x + u[h][0]] = x + u[h][1], x += u[h][1] - u[h][0] - 1;
  return m;
}
const gH = {
  resolve: bH,
  tokenize: _H
}, kH = {
  partial: !0,
  tokenize: xH
};
function bH(e) {
  return XC(e), e;
}
function _H(e, n) {
  let t;
  return i;
  function i(l) {
    return e.enter("content"), t = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : pn(l) ? e.check(kH, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), t.next = e.enter("chunkContent", {
      contentType: "content",
      previous: t
    }), t = t.next, a;
  }
}
function xH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Xn(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || pn(s))
      return t(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, t, n)(s);
  }
}
function ZC(e, n, t, i, a, o, s, l, u) {
  const m = u || Number.POSITIVE_INFINITY;
  let d = 0;
  return f;
  function f(j) {
    return j === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(j), e.exit(o), h) : j === null || j === 32 || j === 41 || gh(j) ? t(j) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), S(j));
  }
  function h(j) {
    return j === 62 ? (e.enter(o), e.consume(j), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), v(j));
  }
  function v(j) {
    return j === 62 ? (e.exit("chunkString"), e.exit(l), h(j)) : j === null || j === 60 || pn(j) ? t(j) : (e.consume(j), j === 92 ? x : v);
  }
  function x(j) {
    return j === 60 || j === 62 || j === 92 ? (e.consume(j), v) : v(j);
  }
  function S(j) {
    return !d && (j === null || j === 41 || Zt(j)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(j)) : d < m && j === 40 ? (e.consume(j), d++, S) : j === 41 ? (e.consume(j), d--, S) : j === null || j === 32 || j === 40 || gh(j) ? t(j) : (e.consume(j), j === 92 ? N : S);
  }
  function N(j) {
    return j === 40 || j === 41 || j === 92 ? (e.consume(j), S) : S(j);
  }
}
function e1(e, n, t, i, a, o) {
  const s = this;
  let l = 0, u;
  return m;
  function m(v) {
    return e.enter(i), e.enter(a), e.consume(v), e.exit(a), e.enter(o), d;
  }
  function d(v) {
    return l > 999 || v === null || v === 91 || v === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    v === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? t(v) : v === 93 ? (e.exit(o), e.enter(a), e.consume(v), e.exit(a), e.exit(i), n) : pn(v) ? (e.enter("lineEnding"), e.consume(v), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), f(v));
  }
  function f(v) {
    return v === null || v === 91 || v === 93 || pn(v) || l++ > 999 ? (e.exit("chunkString"), d(v)) : (e.consume(v), u || (u = !An(v)), v === 92 ? h : f);
  }
  function h(v) {
    return v === 91 || v === 92 || v === 93 ? (e.consume(v), l++, f) : f(v);
  }
}
function n1(e, n, t, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, u) : t(h);
  }
  function u(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), u(s)) : h === null ? t(h) : pn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), Xn(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === s || h === null || pn(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : d);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), d) : d(h);
  }
}
function Lo(e, n) {
  let t;
  return i;
  function i(a) {
    return pn(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), t = !0, i) : An(a) ? Xn(e, i, t ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const SH = {
  name: "definition",
  tokenize: jH
}, NH = {
  partial: !0,
  tokenize: wH
};
function jH(e, n, t) {
  const i = this;
  let a;
  return o;
  function o(v) {
    return e.enter("definition"), s(v);
  }
  function s(v) {
    return e1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(v);
  }
  function l(v) {
    return a = _a(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), v === 58 ? (e.enter("definitionMarker"), e.consume(v), e.exit("definitionMarker"), u) : t(v);
  }
  function u(v) {
    return Zt(v) ? Lo(e, m)(v) : m(v);
  }
  function m(v) {
    return ZC(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      t,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(v);
  }
  function d(v) {
    return e.attempt(NH, f, f)(v);
  }
  function f(v) {
    return An(v) ? Xn(e, h, "whitespace")(v) : h(v);
  }
  function h(v) {
    return v === null || pn(v) ? (e.exit("definition"), i.parser.defined.push(a), n(v)) : t(v);
  }
}
function wH(e, n, t) {
  return i;
  function i(l) {
    return Zt(l) ? Lo(e, a)(l) : t(l);
  }
  function a(l) {
    return n1(e, o, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return An(l) ? Xn(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || pn(l) ? n(l) : t(l);
  }
}
const CH = {
  name: "hardBreakEscape",
  tokenize: FH
};
function FH(e, n, t) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return pn(o) ? (e.exit("hardBreakEscape"), n(o)) : t(o);
  }
}
const IH = {
  name: "headingAtx",
  resolve: $H,
  tokenize: EH
};
function $H(e, n) {
  let t = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), t - 2 > i && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (i === t - 1 || t - 4 > i && e[t - 2][1].type === "whitespace") && (t -= i + 1 === t ? 2 : 4), t > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[t][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[t][1].end,
    contentType: "text"
  }, Qr(e, i, t - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function EH(e, n, t) {
  let i = 0;
  return a;
  function a(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), s(d);
  }
  function s(d) {
    return d === 35 && i++ < 6 ? (e.consume(d), s) : d === null || Zt(d) ? (e.exit("atxHeadingSequence"), l(d)) : t(d);
  }
  function l(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), u(d)) : d === null || pn(d) ? (e.exit("atxHeading"), n(d)) : An(d) ? Xn(e, l, "whitespace")(d) : (e.enter("atxHeadingText"), m(d));
  }
  function u(d) {
    return d === 35 ? (e.consume(d), u) : (e.exit("atxHeadingSequence"), l(d));
  }
  function m(d) {
    return d === null || d === 35 || Zt(d) ? (e.exit("atxHeadingText"), l(d)) : (e.consume(d), m);
  }
}
const TH = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], a_ = ["pre", "script", "style", "textarea"], OH = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: PH,
  tokenize: AH
}, RH = {
  partial: !0,
  tokenize: VH
}, DH = {
  partial: !0,
  tokenize: LH
};
function PH(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function AH(e, n, t) {
  const i = this;
  let a, o, s, l, u;
  return m;
  function m(W) {
    return d(W);
  }
  function d(W) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(W), f;
  }
  function f(W) {
    return W === 33 ? (e.consume(W), h) : W === 47 ? (e.consume(W), o = !0, S) : W === 63 ? (e.consume(W), a = 3, i.interrupt ? n : H) : Hr(W) ? (e.consume(W), s = String.fromCharCode(W), N) : t(W);
  }
  function h(W) {
    return W === 45 ? (e.consume(W), a = 2, v) : W === 91 ? (e.consume(W), a = 5, l = 0, x) : Hr(W) ? (e.consume(W), a = 4, i.interrupt ? n : H) : t(W);
  }
  function v(W) {
    return W === 45 ? (e.consume(W), i.interrupt ? n : H) : t(W);
  }
  function x(W) {
    const Ue = "CDATA[";
    return W === Ue.charCodeAt(l++) ? (e.consume(W), l === Ue.length ? i.interrupt ? n : K : x) : t(W);
  }
  function S(W) {
    return Hr(W) ? (e.consume(W), s = String.fromCharCode(W), N) : t(W);
  }
  function N(W) {
    if (W === null || W === 47 || W === 62 || Zt(W)) {
      const Ue = W === 47, Me = s.toLowerCase();
      return !Ue && !o && a_.includes(Me) ? (a = 1, i.interrupt ? n(W) : K(W)) : TH.includes(s.toLowerCase()) ? (a = 6, Ue ? (e.consume(W), j) : i.interrupt ? n(W) : K(W)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? t(W) : o ? y(W) : q(W));
    }
    return W === 45 || sr(W) ? (e.consume(W), s += String.fromCharCode(W), N) : t(W);
  }
  function j(W) {
    return W === 62 ? (e.consume(W), i.interrupt ? n : K) : t(W);
  }
  function y(W) {
    return An(W) ? (e.consume(W), y) : ee(W);
  }
  function q(W) {
    return W === 47 ? (e.consume(W), ee) : W === 58 || W === 95 || Hr(W) ? (e.consume(W), E) : An(W) ? (e.consume(W), q) : ee(W);
  }
  function E(W) {
    return W === 45 || W === 46 || W === 58 || W === 95 || sr(W) ? (e.consume(W), E) : C(W);
  }
  function C(W) {
    return W === 61 ? (e.consume(W), T) : An(W) ? (e.consume(W), C) : q(W);
  }
  function T(W) {
    return W === null || W === 60 || W === 61 || W === 62 || W === 96 ? t(W) : W === 34 || W === 39 ? (e.consume(W), u = W, U) : An(W) ? (e.consume(W), T) : Z(W);
  }
  function U(W) {
    return W === u ? (e.consume(W), u = null, Q) : W === null || pn(W) ? t(W) : (e.consume(W), U);
  }
  function Z(W) {
    return W === null || W === 34 || W === 39 || W === 47 || W === 60 || W === 61 || W === 62 || W === 96 || Zt(W) ? C(W) : (e.consume(W), Z);
  }
  function Q(W) {
    return W === 47 || W === 62 || An(W) ? q(W) : t(W);
  }
  function ee(W) {
    return W === 62 ? (e.consume(W), J) : t(W);
  }
  function J(W) {
    return W === null || pn(W) ? K(W) : An(W) ? (e.consume(W), J) : t(W);
  }
  function K(W) {
    return W === 45 && a === 2 ? (e.consume(W), de) : W === 60 && a === 1 ? (e.consume(W), ge) : W === 62 && a === 4 ? (e.consume(W), be) : W === 63 && a === 3 ? (e.consume(W), H) : W === 93 && a === 5 ? (e.consume(W), ve) : pn(W) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(RH, je, D)(W)) : W === null || pn(W) ? (e.exit("htmlFlowData"), D(W)) : (e.consume(W), K);
  }
  function D(W) {
    return e.check(DH, G, je)(W);
  }
  function G(W) {
    return e.enter("lineEnding"), e.consume(W), e.exit("lineEnding"), ne;
  }
  function ne(W) {
    return W === null || pn(W) ? D(W) : (e.enter("htmlFlowData"), K(W));
  }
  function de(W) {
    return W === 45 ? (e.consume(W), H) : K(W);
  }
  function ge(W) {
    return W === 47 ? (e.consume(W), s = "", ce) : K(W);
  }
  function ce(W) {
    if (W === 62) {
      const Ue = s.toLowerCase();
      return a_.includes(Ue) ? (e.consume(W), be) : K(W);
    }
    return Hr(W) && s.length < 8 ? (e.consume(W), s += String.fromCharCode(W), ce) : K(W);
  }
  function ve(W) {
    return W === 93 ? (e.consume(W), H) : K(W);
  }
  function H(W) {
    return W === 62 ? (e.consume(W), be) : W === 45 && a === 2 ? (e.consume(W), H) : K(W);
  }
  function be(W) {
    return W === null || pn(W) ? (e.exit("htmlFlowData"), je(W)) : (e.consume(W), be);
  }
  function je(W) {
    return e.exit("htmlFlow"), n(W);
  }
}
function LH(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return pn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : t(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? t(s) : n(s);
  }
}
function VH(e, n, t) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(qc, n, t);
  }
}
const zH = {
  name: "htmlText",
  tokenize: MH
};
function MH(e, n, t) {
  const i = this;
  let a, o, s;
  return l;
  function l(H) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(H), u;
  }
  function u(H) {
    return H === 33 ? (e.consume(H), m) : H === 47 ? (e.consume(H), C) : H === 63 ? (e.consume(H), q) : Hr(H) ? (e.consume(H), Z) : t(H);
  }
  function m(H) {
    return H === 45 ? (e.consume(H), d) : H === 91 ? (e.consume(H), o = 0, x) : Hr(H) ? (e.consume(H), y) : t(H);
  }
  function d(H) {
    return H === 45 ? (e.consume(H), v) : t(H);
  }
  function f(H) {
    return H === null ? t(H) : H === 45 ? (e.consume(H), h) : pn(H) ? (s = f, ge(H)) : (e.consume(H), f);
  }
  function h(H) {
    return H === 45 ? (e.consume(H), v) : f(H);
  }
  function v(H) {
    return H === 62 ? de(H) : H === 45 ? h(H) : f(H);
  }
  function x(H) {
    const be = "CDATA[";
    return H === be.charCodeAt(o++) ? (e.consume(H), o === be.length ? S : x) : t(H);
  }
  function S(H) {
    return H === null ? t(H) : H === 93 ? (e.consume(H), N) : pn(H) ? (s = S, ge(H)) : (e.consume(H), S);
  }
  function N(H) {
    return H === 93 ? (e.consume(H), j) : S(H);
  }
  function j(H) {
    return H === 62 ? de(H) : H === 93 ? (e.consume(H), j) : S(H);
  }
  function y(H) {
    return H === null || H === 62 ? de(H) : pn(H) ? (s = y, ge(H)) : (e.consume(H), y);
  }
  function q(H) {
    return H === null ? t(H) : H === 63 ? (e.consume(H), E) : pn(H) ? (s = q, ge(H)) : (e.consume(H), q);
  }
  function E(H) {
    return H === 62 ? de(H) : q(H);
  }
  function C(H) {
    return Hr(H) ? (e.consume(H), T) : t(H);
  }
  function T(H) {
    return H === 45 || sr(H) ? (e.consume(H), T) : U(H);
  }
  function U(H) {
    return pn(H) ? (s = U, ge(H)) : An(H) ? (e.consume(H), U) : de(H);
  }
  function Z(H) {
    return H === 45 || sr(H) ? (e.consume(H), Z) : H === 47 || H === 62 || Zt(H) ? Q(H) : t(H);
  }
  function Q(H) {
    return H === 47 ? (e.consume(H), de) : H === 58 || H === 95 || Hr(H) ? (e.consume(H), ee) : pn(H) ? (s = Q, ge(H)) : An(H) ? (e.consume(H), Q) : de(H);
  }
  function ee(H) {
    return H === 45 || H === 46 || H === 58 || H === 95 || sr(H) ? (e.consume(H), ee) : J(H);
  }
  function J(H) {
    return H === 61 ? (e.consume(H), K) : pn(H) ? (s = J, ge(H)) : An(H) ? (e.consume(H), J) : Q(H);
  }
  function K(H) {
    return H === null || H === 60 || H === 61 || H === 62 || H === 96 ? t(H) : H === 34 || H === 39 ? (e.consume(H), a = H, D) : pn(H) ? (s = K, ge(H)) : An(H) ? (e.consume(H), K) : (e.consume(H), G);
  }
  function D(H) {
    return H === a ? (e.consume(H), a = void 0, ne) : H === null ? t(H) : pn(H) ? (s = D, ge(H)) : (e.consume(H), D);
  }
  function G(H) {
    return H === null || H === 34 || H === 39 || H === 60 || H === 61 || H === 96 ? t(H) : H === 47 || H === 62 || Zt(H) ? Q(H) : (e.consume(H), G);
  }
  function ne(H) {
    return H === 47 || H === 62 || Zt(H) ? Q(H) : t(H);
  }
  function de(H) {
    return H === 62 ? (e.consume(H), e.exit("htmlTextData"), e.exit("htmlText"), n) : t(H);
  }
  function ge(H) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(H), e.exit("lineEnding"), ce;
  }
  function ce(H) {
    return An(H) ? Xn(e, ve, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(H) : ve(H);
  }
  function ve(H) {
    return e.enter("htmlTextData"), s(H);
  }
}
const Wv = {
  name: "labelEnd",
  resolveAll: HH,
  resolveTo: WH,
  tokenize: KH
}, UH = {
  tokenize: GH
}, BH = {
  tokenize: YH
}, qH = {
  tokenize: JH
};
function HH(e) {
  let n = -1;
  const t = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (t.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== t.length && Qr(e, 0, e.length, t), e;
}
function WH(e, n) {
  let t = e.length, i = 0, a, o, s, l;
  for (; t--; )
    if (a = e[t][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[t][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[t][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = t, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = t);
  const u = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, d = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", u, n], ["enter", m, n]], l = mr(l, e.slice(o + 1, o + i + 3)), l = mr(l, [["enter", d, n]]), l = mr(l, Hv(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = mr(l, [["exit", d, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = mr(l, e.slice(s + 1)), l = mr(l, [["exit", u, n]]), Qr(e, o, e.length, l), e;
}
function KH(e, n, t) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(_a(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), u) : t(h);
  }
  function u(h) {
    return h === 40 ? e.attempt(UH, d, s ? d : f)(h) : h === 91 ? e.attempt(BH, d, s ? m : f)(h) : s ? d(h) : f(h);
  }
  function m(h) {
    return e.attempt(qH, d, f)(h);
  }
  function d(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, t(h);
  }
}
function GH(e, n, t) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return Zt(f) ? Lo(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? d(f) : ZC(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Zt(f) ? Lo(e, u)(f) : d(f);
  }
  function l(f) {
    return t(f);
  }
  function u(f) {
    return f === 34 || f === 39 || f === 40 ? n1(e, m, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : d(f);
  }
  function m(f) {
    return Zt(f) ? Lo(e, d)(f) : d(f);
  }
  function d(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : t(f);
  }
}
function YH(e, n, t) {
  const i = this;
  return a;
  function a(l) {
    return e1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(_a(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : t(l);
  }
  function s(l) {
    return t(l);
  }
}
function JH(e, n, t) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : t(o);
  }
}
const QH = {
  name: "labelStartImage",
  resolveAll: Wv.resolveAll,
  tokenize: XH
};
function XH(e, n, t) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : t(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(l) : n(l);
  }
}
const ZH = {
  name: "labelStartLink",
  resolveAll: Wv.resolveAll,
  tokenize: eW
};
function eW(e, n, t) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? t(s) : n(s);
  }
}
const pd = {
  name: "lineEnding",
  tokenize: nW
};
function nW(e, n) {
  return t;
  function t(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), Xn(e, n, "linePrefix");
  }
}
const $l = {
  name: "thematicBreak",
  tokenize: tW
};
function tW(e, n, t) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), u(m)) : i >= 3 && (m === null || pn(m)) ? (e.exit("thematicBreak"), n(m)) : t(m);
  }
  function u(m) {
    return m === a ? (e.consume(m), i++, u) : (e.exit("thematicBreakSequence"), An(m) ? Xn(e, l, "whitespace")(m) : l(m));
  }
}
const Gt = {
  continuation: {
    tokenize: oW
  },
  exit: lW,
  name: "list",
  tokenize: aW
}, rW = {
  partial: !0,
  tokenize: cW
}, iW = {
  partial: !0,
  tokenize: sW
};
function aW(e, n, t) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(v) {
    const x = i.containerState.type || (v === 42 || v === 43 || v === 45 ? "listUnordered" : "listOrdered");
    if (x === "listUnordered" ? !i.containerState.marker || v === i.containerState.marker : kh(v)) {
      if (i.containerState.type || (i.containerState.type = x, e.enter(x, {
        _container: !0
      })), x === "listUnordered")
        return e.enter("listItemPrefix"), v === 42 || v === 45 ? e.check($l, t, m)(v) : m(v);
      if (!i.interrupt || v === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(v);
    }
    return t(v);
  }
  function u(v) {
    return kh(v) && ++s < 10 ? (e.consume(v), u) : (!i.interrupt || s < 2) && (i.containerState.marker ? v === i.containerState.marker : v === 41 || v === 46) ? (e.exit("listItemValue"), m(v)) : t(v);
  }
  function m(v) {
    return e.enter("listItemMarker"), e.consume(v), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || v, e.check(
      qc,
      // Can’t be empty when interrupting.
      i.interrupt ? t : d,
      e.attempt(rW, h, f)
    );
  }
  function d(v) {
    return i.containerState.initialBlankLine = !0, o++, h(v);
  }
  function f(v) {
    return An(v) ? (e.enter("listItemPrefixWhitespace"), e.consume(v), e.exit("listItemPrefixWhitespace"), h) : t(v);
  }
  function h(v) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(v);
  }
}
function oW(e, n, t) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(qc, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, Xn(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !An(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(iW, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, Xn(e, e.attempt(Gt, n, t), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function sW(e, n, t) {
  const i = this;
  return Xn(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : t(o);
  }
}
function lW(e) {
  e.exit(this.containerState.type);
}
function cW(e, n, t) {
  const i = this;
  return Xn(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !An(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : t(o);
  }
}
const o_ = {
  name: "setextUnderline",
  resolveTo: uW,
  tokenize: dW
};
function uW(e, n) {
  let t = e.length, i, a, o;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        i = t;
        break;
      }
      e[t][1].type === "paragraph" && (a = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !o && e[t][1].type === "definition" && (o = t);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function dW(e, n, t) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let d = i.events.length, f;
    for (; d--; )
      if (i.events[d][1].type !== "lineEnding" && i.events[d][1].type !== "linePrefix" && i.events[d][1].type !== "content") {
        f = i.events[d][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : t(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), An(m) ? Xn(e, u, "lineSuffix")(m) : u(m));
  }
  function u(m) {
    return m === null || pn(m) ? (e.exit("setextHeadingLine"), n(m)) : t(m);
  }
}
const mW = {
  tokenize: pW
};
function pW(e) {
  const n = this, t = e.attempt(
    // Try to parse a blank line.
    qc,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, Xn(e, e.attempt(this.parser.constructs.flow, a, e.attempt(gH, a)), "linePrefix"))
  );
  return t;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, t;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, t;
  }
}
const fW = {
  resolveAll: r1()
}, hW = t1("string"), vW = t1("text");
function t1(e) {
  return {
    resolveAll: r1(e === "text" ? yW : void 0),
    tokenize: n
  };
  function n(t) {
    const i = this, a = this.parser.constructs[e], o = t.attempt(a, s, l);
    return s;
    function s(d) {
      return m(d) ? o(d) : l(d);
    }
    function l(d) {
      if (d === null) {
        t.consume(d);
        return;
      }
      return t.enter("data"), t.consume(d), u;
    }
    function u(d) {
      return m(d) ? (t.exit("data"), o(d)) : (t.consume(d), u);
    }
    function m(d) {
      if (d === null)
        return !0;
      const f = a[d];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const v = f[h];
          if (!v.previous || v.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function r1(e) {
  return n;
  function n(t, i) {
    let a = -1, o;
    for (; ++a <= t.length; )
      o === void 0 ? t[a] && t[a][1].type === "data" && (o = a, a++) : (!t[a] || t[a][1].type !== "data") && (a !== o + 2 && (t[o][1].end = t[a - 1][1].end, t.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(t, i) : t;
  }
}
function yW(e, n) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const i = e[t - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, u;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          u = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: t === e.length || u || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(t, 0, ["enter", m, n], ["exit", m, n]), t += 2);
      }
      t++;
    }
  return e;
}
const gW = {
  42: Gt,
  43: Gt,
  45: Gt,
  48: Gt,
  49: Gt,
  50: Gt,
  51: Gt,
  52: Gt,
  53: Gt,
  54: Gt,
  55: Gt,
  56: Gt,
  57: Gt,
  62: YC
}, kW = {
  91: SH
}, bW = {
  [-2]: md,
  [-1]: md,
  32: md
}, _W = {
  35: IH,
  42: $l,
  45: [o_, $l],
  60: OH,
  61: o_,
  95: $l,
  96: i_,
  126: i_
}, xW = {
  38: QC,
  92: JC
}, SW = {
  [-5]: pd,
  [-4]: pd,
  [-3]: pd,
  33: QH,
  38: QC,
  42: bh,
  60: [Z6, zH],
  91: ZH,
  92: [CH, JC],
  93: Wv,
  95: bh,
  96: mH
}, NW = {
  null: [bh, fW]
}, jW = {
  null: [42, 95]
}, wW = {
  null: []
}, CW = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: jW,
  contentInitial: kW,
  disable: wW,
  document: gW,
  flow: _W,
  flowInitial: bW,
  insideSpan: NW,
  string: xW,
  text: SW
}, Symbol.toStringTag, { value: "Module" }));
function FW(e, n, t) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: t && t.line || 1,
    column: t && t.column || 1,
    offset: t && t.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const u = {
    attempt: U(C),
    check: U(T),
    consume: y,
    enter: q,
    exit: E,
    interrupt: U(T, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: S,
    events: [],
    now: x,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: v,
    write: f
  };
  let d = n.tokenize.call(m, u);
  return n.resolveAll && o.push(n), m;
  function f(J) {
    return s = mr(s, J), N(), s[s.length - 1] !== null ? [] : (Z(n, 0), m.events = Hv(o, m.events, m), m.events);
  }
  function h(J, K) {
    return $W(v(J), K);
  }
  function v(J) {
    return IW(s, J);
  }
  function x() {
    const {
      _bufferIndex: J,
      _index: K,
      line: D,
      column: G,
      offset: ne
    } = i;
    return {
      _bufferIndex: J,
      _index: K,
      line: D,
      column: G,
      offset: ne
    };
  }
  function S(J) {
    a[J.line] = J.column, ee();
  }
  function N() {
    let J;
    for (; i._index < s.length; ) {
      const K = s[i._index];
      if (typeof K == "string")
        for (J = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === J && i._bufferIndex < K.length; )
          j(K.charCodeAt(i._bufferIndex));
      else
        j(K);
    }
  }
  function j(J) {
    d = d(J);
  }
  function y(J) {
    pn(J) ? (i.line++, i.column = 1, i.offset += J === -3 ? 2 : 1, ee()) : J !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = J;
  }
  function q(J, K) {
    const D = K || {};
    return D.type = J, D.start = x(), m.events.push(["enter", D, m]), l.push(D), D;
  }
  function E(J) {
    const K = l.pop();
    return K.end = x(), m.events.push(["exit", K, m]), K;
  }
  function C(J, K) {
    Z(J, K.from);
  }
  function T(J, K) {
    K.restore();
  }
  function U(J, K) {
    return D;
    function D(G, ne, de) {
      let ge, ce, ve, H;
      return Array.isArray(G) ? (
        /* c8 ignore next 1 */
        je(G)
      ) : "tokenize" in G ? (
        // Looks like a construct.
        je([
          /** @type {Construct} */
          G
        ])
      ) : be(G);
      function be(De) {
        return Be;
        function Be(Ee) {
          const Ve = Ee !== null && De[Ee], Re = Ee !== null && De.null, tn = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Ve) ? Ve : Ve ? [Ve] : [],
            ...Array.isArray(Re) ? Re : Re ? [Re] : []
          ];
          return je(tn)(Ee);
        }
      }
      function je(De) {
        return ge = De, ce = 0, De.length === 0 ? de : W(De[ce]);
      }
      function W(De) {
        return Be;
        function Be(Ee) {
          return H = Q(), ve = De, De.partial || (m.currentConstruct = De), De.name && m.parser.constructs.disable.null.includes(De.name) ? Me() : De.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            K ? Object.assign(Object.create(m), K) : m,
            u,
            Ue,
            Me
          )(Ee);
        }
      }
      function Ue(De) {
        return J(ve, H), ne;
      }
      function Me(De) {
        return H.restore(), ++ce < ge.length ? W(ge[ce]) : de;
      }
    }
  }
  function Z(J, K) {
    J.resolveAll && !o.includes(J) && o.push(J), J.resolve && Qr(m.events, K, m.events.length - K, J.resolve(m.events.slice(K), m)), J.resolveTo && (m.events = J.resolveTo(m.events, m));
  }
  function Q() {
    const J = x(), K = m.previous, D = m.currentConstruct, G = m.events.length, ne = Array.from(l);
    return {
      from: G,
      restore: de
    };
    function de() {
      i = J, m.previous = K, m.currentConstruct = D, m.events.length = G, l = ne, ee();
    }
  }
  function ee() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function IW(e, n) {
  const t = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (t === a)
    s = [e[t].slice(i, o)];
  else {
    if (s = e.slice(t, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function $W(e, n) {
  let t = -1;
  const i = [];
  let a;
  for (; ++t < e.length; ) {
    const o = e[t];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function EW(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      L6([CW, ...(e || {}).extensions || []])
    ),
    content: a(W6),
    defined: [],
    document: a(G6),
    flow: a(mW),
    lazy: {},
    string: a(hW),
    text: a(vW)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return FW(i, o, l);
    }
  }
}
function TW(e) {
  for (; !XC(e); )
    ;
  return e;
}
const s_ = /[\0\t\n\r]/g;
function OW() {
  let e = 1, n = "", t = !0, i;
  return a;
  function a(o, s, l) {
    const u = [];
    let m, d, f, h, v;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", t && (o.charCodeAt(0) === 65279 && f++, t = void 0); f < o.length; ) {
      if (s_.lastIndex = f, m = s_.exec(o), h = m && m.index !== void 0 ? m.index : o.length, v = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (v === 10 && f === h && i)
        u.push(-3), i = void 0;
      else
        switch (i && (u.push(-5), i = void 0), f < h && (u.push(o.slice(f, h)), e += h - f), v) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, u.push(-2); e++ < d; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && u.push(-5), n && u.push(n), u.push(null)), u;
  }
}
const RW = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function DW(e) {
  return e.replace(RW, PW);
}
function PW(e, n, t) {
  if (n)
    return n;
  if (t.charCodeAt(0) === 35) {
    const a = t.charCodeAt(1), o = a === 120 || a === 88;
    return GC(t.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return qv(t) || e;
}
const i1 = {}.hasOwnProperty;
function AW(e, n, t) {
  return typeof n != "string" && (t = n, n = void 0), LW(t)(TW(EW(t).document().write(OW()(e, n, !0))));
}
function LW(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Fe),
      autolinkProtocol: Q,
      autolinkEmail: Q,
      atxHeading: o(ue),
      blockQuote: o(Re),
      characterEscape: Q,
      characterReference: Q,
      codeFenced: o(tn),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(tn, s),
      codeText: o(Ne, s),
      codeTextData: Q,
      data: Q,
      codeFlowValue: Q,
      definition: o(We),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(Oe),
      hardBreakEscape: o(fe),
      hardBreakTrailing: o(fe),
      htmlFlow: o(we, s),
      htmlFlowData: Q,
      htmlText: o(we, s),
      htmlTextData: Q,
      image: o(Le),
      label: s,
      link: o(Fe),
      listItem: o(F),
      listItemValue: h,
      listOrdered: o(ln, f),
      listUnordered: o(ln),
      paragraph: o(b),
      reference: W,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(ue),
      strong: o($),
      thematicBreak: o(X)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: C,
      autolink: u(),
      autolinkEmail: Ve,
      autolinkProtocol: Ee,
      blockQuote: u(),
      characterEscapeValue: ee,
      characterReferenceMarkerHexadecimal: Me,
      characterReferenceMarkerNumeric: Me,
      characterReferenceValue: De,
      characterReference: Be,
      codeFenced: u(N),
      codeFencedFence: S,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: x,
      codeFlowValue: ee,
      codeIndented: u(j),
      codeText: u(ne),
      codeTextData: ee,
      data: ee,
      definition: u(),
      definitionDestinationString: E,
      definitionLabelString: y,
      definitionTitleString: q,
      emphasis: u(),
      hardBreakEscape: u(K),
      hardBreakTrailing: u(K),
      htmlFlow: u(D),
      htmlFlowData: ee,
      htmlText: u(G),
      htmlTextData: ee,
      image: u(ge),
      label: ve,
      labelText: ce,
      lineEnding: J,
      link: u(de),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: Ue,
      resourceDestinationString: H,
      resourceTitleString: be,
      resource: je,
      setextHeading: u(Z),
      setextHeadingLineSequence: U,
      setextHeadingText: T,
      strong: u(),
      thematicBreak: u()
    }
  };
  a1(n, (e || {}).mdastExtensions || []);
  const t = {};
  return i;
  function i(R) {
    let B = {
      type: "root",
      children: []
    };
    const te = {
      stack: [B],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: d,
      data: t
    }, pe = [];
    let _e = -1;
    for (; ++_e < R.length; )
      if (R[_e][1].type === "listOrdered" || R[_e][1].type === "listUnordered")
        if (R[_e][0] === "enter")
          pe.push(_e);
        else {
          const Ze = pe.pop();
          _e = a(R, Ze, _e);
        }
    for (_e = -1; ++_e < R.length; ) {
      const Ze = n[R[_e][0]];
      i1.call(Ze, R[_e][1].type) && Ze[R[_e][1].type].call(Object.assign({
        sliceSerialize: R[_e][2].sliceSerialize
      }, te), R[_e][1]);
    }
    if (te.tokenStack.length > 0) {
      const Ze = te.tokenStack[te.tokenStack.length - 1];
      (Ze[1] || l_).call(te, void 0, Ze[0]);
    }
    for (B.position = {
      start: fi(R.length > 0 ? R[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: fi(R.length > 0 ? R[R.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, _e = -1; ++_e < n.transforms.length; )
      B = n.transforms[_e](B) || B;
    return B;
  }
  function a(R, B, te) {
    let pe = B - 1, _e = -1, Ze = !1, dn, nn, rn, fn;
    for (; ++pe <= te; ) {
      const mn = R[pe];
      switch (mn[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          mn[0] === "enter" ? _e++ : _e--, fn = void 0;
          break;
        }
        case "lineEndingBlank": {
          mn[0] === "enter" && (dn && !fn && !_e && !rn && (rn = pe), fn = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          fn = void 0;
      }
      if (!_e && mn[0] === "enter" && mn[1].type === "listItemPrefix" || _e === -1 && mn[0] === "exit" && (mn[1].type === "listUnordered" || mn[1].type === "listOrdered")) {
        if (dn) {
          let vn = pe;
          for (nn = void 0; vn--; ) {
            const Qe = R[vn];
            if (Qe[1].type === "lineEnding" || Qe[1].type === "lineEndingBlank") {
              if (Qe[0] === "exit") continue;
              nn && (R[nn][1].type = "lineEndingBlank", Ze = !0), Qe[1].type = "lineEnding", nn = vn;
            } else if (!(Qe[1].type === "linePrefix" || Qe[1].type === "blockQuotePrefix" || Qe[1].type === "blockQuotePrefixWhitespace" || Qe[1].type === "blockQuoteMarker" || Qe[1].type === "listItemIndent")) break;
          }
          rn && (!nn || rn < nn) && (dn._spread = !0), dn.end = Object.assign({}, nn ? R[nn][1].start : mn[1].end), R.splice(nn || pe, 0, ["exit", dn, mn[2]]), pe++, te++;
        }
        if (mn[1].type === "listItemPrefix") {
          const vn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, mn[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          dn = vn, R.splice(pe, 0, ["enter", vn, mn[2]]), pe++, te++, rn = void 0, fn = !0;
        }
      }
    }
    return R[B][1]._spread = Ze, te;
  }
  function o(R, B) {
    return te;
    function te(pe) {
      l.call(this, R(pe), pe), B && B.call(this, pe);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(R, B, te) {
    this.stack[this.stack.length - 1].children.push(R), this.stack.push(R), this.tokenStack.push([B, te || void 0]), R.position = {
      start: fi(B.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(R) {
    return B;
    function B(te) {
      R && R.call(this, te), m.call(this, te);
    }
  }
  function m(R, B) {
    const te = this.stack.pop(), pe = this.tokenStack.pop();
    if (pe)
      pe[0].type !== R.type && (B ? B.call(this, R, pe[0]) : (pe[1] || l_).call(this, R, pe[0]));
    else throw new Error("Cannot close `" + R.type + "` (" + Ao({
      start: R.start,
      end: R.end
    }) + "): it’s not open");
    te.position.end = fi(R.end);
  }
  function d() {
    return P6(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(R) {
    if (this.data.expectingFirstListItemValue) {
      const B = this.stack[this.stack.length - 2];
      B.start = Number.parseInt(this.sliceSerialize(R), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function v() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.lang = R;
  }
  function x() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.meta = R;
  }
  function S() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function N() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = R.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function j() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = R.replace(/(\r?\n|\r)$/g, "");
  }
  function y(R) {
    const B = this.resume(), te = this.stack[this.stack.length - 1];
    te.label = B, te.identifier = _a(this.sliceSerialize(R)).toLowerCase();
  }
  function q() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = R;
  }
  function E() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = R;
  }
  function C(R) {
    const B = this.stack[this.stack.length - 1];
    if (!B.depth) {
      const te = this.sliceSerialize(R).length;
      B.depth = te;
    }
  }
  function T() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function U(R) {
    const B = this.stack[this.stack.length - 1];
    B.depth = this.sliceSerialize(R).codePointAt(0) === 61 ? 1 : 2;
  }
  function Z() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function Q(R) {
    const te = this.stack[this.stack.length - 1].children;
    let pe = te[te.length - 1];
    (!pe || pe.type !== "text") && (pe = Y(), pe.position = {
      start: fi(R.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, te.push(pe)), this.stack.push(pe);
  }
  function ee(R) {
    const B = this.stack.pop();
    B.value += this.sliceSerialize(R), B.position.end = fi(R.end);
  }
  function J(R) {
    const B = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const te = B.children[B.children.length - 1];
      te.position.end = fi(R.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(B.type) && (Q.call(this, R), ee.call(this, R));
  }
  function K() {
    this.data.atHardBreak = !0;
  }
  function D() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = R;
  }
  function G() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = R;
  }
  function ne() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.value = R;
  }
  function de() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = B, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function ge() {
    const R = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const B = this.data.referenceType || "shortcut";
      R.type += "Reference", R.referenceType = B, delete R.url, delete R.title;
    } else
      delete R.identifier, delete R.label;
    this.data.referenceType = void 0;
  }
  function ce(R) {
    const B = this.sliceSerialize(R), te = this.stack[this.stack.length - 2];
    te.label = DW(B), te.identifier = _a(B).toLowerCase();
  }
  function ve() {
    const R = this.stack[this.stack.length - 1], B = this.resume(), te = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, te.type === "link") {
      const pe = R.children;
      te.children = pe;
    } else
      te.alt = B;
  }
  function H() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.url = R;
  }
  function be() {
    const R = this.resume(), B = this.stack[this.stack.length - 1];
    B.title = R;
  }
  function je() {
    this.data.inReference = void 0;
  }
  function W() {
    this.data.referenceType = "collapsed";
  }
  function Ue(R) {
    const B = this.resume(), te = this.stack[this.stack.length - 1];
    te.label = B, te.identifier = _a(this.sliceSerialize(R)).toLowerCase(), this.data.referenceType = "full";
  }
  function Me(R) {
    this.data.characterReferenceType = R.type;
  }
  function De(R) {
    const B = this.sliceSerialize(R), te = this.data.characterReferenceType;
    let pe;
    te ? (pe = GC(B, te === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : pe = qv(B);
    const _e = this.stack[this.stack.length - 1];
    _e.value += pe;
  }
  function Be(R) {
    const B = this.stack.pop();
    B.position.end = fi(R.end);
  }
  function Ee(R) {
    ee.call(this, R);
    const B = this.stack[this.stack.length - 1];
    B.url = this.sliceSerialize(R);
  }
  function Ve(R) {
    ee.call(this, R);
    const B = this.stack[this.stack.length - 1];
    B.url = "mailto:" + this.sliceSerialize(R);
  }
  function Re() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function tn() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Ne() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function We() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function Oe() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function ue() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function fe() {
    return {
      type: "break"
    };
  }
  function we() {
    return {
      type: "html",
      value: ""
    };
  }
  function Le() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Fe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function ln(R) {
    return {
      type: "list",
      ordered: R.type === "listOrdered",
      start: null,
      spread: R._spread,
      children: []
    };
  }
  function F(R) {
    return {
      type: "listItem",
      spread: R._spread,
      checked: null,
      children: []
    };
  }
  function b() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function $() {
    return {
      type: "strong",
      children: []
    };
  }
  function Y() {
    return {
      type: "text",
      value: ""
    };
  }
  function X() {
    return {
      type: "thematicBreak"
    };
  }
}
function fi(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function a1(e, n) {
  let t = -1;
  for (; ++t < n.length; ) {
    const i = n[t];
    Array.isArray(i) ? a1(e, i) : VW(e, i);
  }
}
function VW(e, n) {
  let t;
  for (t in n)
    if (i1.call(n, t))
      switch (t) {
        case "canContainEols": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "transforms": {
          const i = n[t];
          i && e[t].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[t];
          i && Object.assign(e[t], i);
          break;
        }
      }
}
function l_(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + Ao({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + Ao({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + Ao({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function zW(e) {
  const n = this;
  n.parser = t;
  function t(i) {
    return AW(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function MW(e, n) {
  const t = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function UW(e, n) {
  const t = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, t), [e.applyData(n, t), { type: "text", value: `
` }];
}
function BW(e, n) {
  const t = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: t }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function qW(e, n) {
  const t = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function HW(e, n) {
  const t = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function WW(e, n) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Ua(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + t + "fn-" + a,
      id: t + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, u);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function KW(e, n) {
  const t = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function GW(e, n) {
  if (e.options.allowDangerousHtml) {
    const t = { type: "raw", value: n.value };
    return e.patch(n, t), e.applyData(n, t);
  }
}
function o1(e, n) {
  const t = n.referenceType;
  let i = "]";
  if (t === "collapsed" ? i += "[]" : t === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function YW(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return o1(e, n);
  const a = { src: Ua(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function JW(e, n) {
  const t = { src: Ua(n.url) };
  n.alt !== null && n.alt !== void 0 && (t.alt = n.alt), n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = { type: "element", tagName: "img", properties: t, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function QW(e, n) {
  const t = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, t);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [t]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function XW(e, n) {
  const t = String(n.identifier).toUpperCase(), i = e.definitionById.get(t);
  if (!i)
    return o1(e, n);
  const a = { href: Ua(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function ZW(e, n) {
  const t = { href: Ua(n.url) };
  n.title !== null && n.title !== void 0 && (t.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: t,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function eK(e, n, t) {
  const i = e.all(n), a = t ? nK(t) : s1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const d = i[0];
    let f;
    d && d.type === "element" && d.tagName === "p" ? f = d : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const d = i[l];
    (a || l !== 0 || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !a ? s.push(...d.children) : s.push(d);
  }
  const u = i[i.length - 1];
  u && (a || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function nK(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const t = e.children;
    let i = -1;
    for (; !n && ++i < t.length; )
      n = s1(t[i]);
  }
  return n;
}
function s1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function tK(e, n) {
  const t = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (t.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      t.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: t,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function rK(e, n) {
  const t = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function iK(e, n) {
  const t = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, t), e.applyData(n, t);
}
function aK(e, n) {
  const t = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
function oK(e, n) {
  const t = e.all(n), i = t.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (t.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(t, !0)
    }, l = zv(n.children[1]), u = MC(n.children[n.children.length - 1]);
    l && u && (s.position = { start: l, end: u }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function sK(e, n, t) {
  const i = t ? t.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = t && t.type === "table" ? t.align : void 0, l = s ? s.length : n.children.length;
  let u = -1;
  const m = [];
  for (; ++u < l; ) {
    const f = n.children[u], h = {}, v = s ? s[u] : void 0;
    v && (h.align = v);
    let x = { type: "element", tagName: o, properties: h, children: [] };
    f && (x.children = e.all(f), e.patch(f, x), x = e.applyData(f, x)), m.push(x);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, d), e.applyData(n, d);
}
function lK(e, n) {
  const t = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, t), e.applyData(n, t);
}
const c_ = 9, u_ = 32;
function cK(e) {
  const n = String(e), t = /\r?\n|\r/g;
  let i = t.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      d_(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = t.exec(n);
  return o.push(d_(n.slice(a), a > 0, !1)), o.join("");
}
function d_(e, n, t) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === c_ || o === u_; )
      i++, o = e.codePointAt(i);
  }
  if (t) {
    let o = e.codePointAt(a - 1);
    for (; o === c_ || o === u_; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function uK(e, n) {
  const t = { type: "text", value: cK(String(n.value)) };
  return e.patch(n, t), e.applyData(n, t);
}
function dK(e, n) {
  const t = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, t), e.applyData(n, t);
}
const mK = {
  blockquote: MW,
  break: UW,
  code: BW,
  delete: qW,
  emphasis: HW,
  footnoteReference: WW,
  heading: KW,
  html: GW,
  imageReference: YW,
  image: JW,
  inlineCode: QW,
  linkReference: XW,
  link: ZW,
  listItem: eK,
  list: tK,
  paragraph: rK,
  // @ts-expect-error: root is different, but hard to type.
  root: iK,
  strong: aK,
  table: oK,
  tableCell: lK,
  tableRow: sK,
  text: uK,
  thematicBreak: dK,
  toml: Js,
  yaml: Js,
  definition: Js,
  footnoteDefinition: Js
};
function Js() {
}
const l1 = -1, Hc = 0, Zl = 1, ec = 2, Kv = 3, Gv = 4, Yv = 5, Jv = 6, c1 = 7, u1 = 8, m_ = typeof self == "object" ? self : globalThis, pK = (e, n) => {
  const t = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case Hc:
      case l1:
        return t(s, a);
      case Zl: {
        const l = t([], a);
        for (const u of s)
          l.push(i(u));
        return l;
      }
      case ec: {
        const l = t({}, a);
        for (const [u, m] of s)
          l[i(u)] = i(m);
        return l;
      }
      case Kv:
        return t(new Date(s), a);
      case Gv: {
        const { source: l, flags: u } = s;
        return t(new RegExp(l, u), a);
      }
      case Yv: {
        const l = t(/* @__PURE__ */ new Map(), a);
        for (const [u, m] of s)
          l.set(i(u), i(m));
        return l;
      }
      case Jv: {
        const l = t(/* @__PURE__ */ new Set(), a);
        for (const u of s)
          l.add(i(u));
        return l;
      }
      case c1: {
        const { name: l, message: u } = s;
        return t(new m_[l](u), a);
      }
      case u1:
        return t(BigInt(s), a);
      case "BigInt":
        return t(Object(BigInt(s)), a);
    }
    return t(new m_[o](s), a);
  };
  return i;
}, p_ = (e) => pK(/* @__PURE__ */ new Map(), e)(0), oa = "", { toString: fK } = {}, { keys: hK } = Object, so = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [Hc, n];
  const t = fK.call(e).slice(8, -1);
  switch (t) {
    case "Array":
      return [Zl, oa];
    case "Object":
      return [ec, oa];
    case "Date":
      return [Kv, oa];
    case "RegExp":
      return [Gv, oa];
    case "Map":
      return [Yv, oa];
    case "Set":
      return [Jv, oa];
  }
  return t.includes("Array") ? [Zl, t] : t.includes("Error") ? [c1, t] : [ec, t];
}, Qs = ([e, n]) => e === Hc && (n === "function" || n === "symbol"), vK = (e, n, t, i) => {
  const a = (s, l) => {
    const u = i.push(s) - 1;
    return t.set(l, u), u;
  }, o = (s) => {
    if (t.has(s))
      return t.get(s);
    let [l, u] = so(s);
    switch (l) {
      case Hc: {
        let d = s;
        switch (u) {
          case "bigint":
            l = u1, d = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            d = null;
            break;
          case "undefined":
            return a([l1], s);
        }
        return a([l, d], s);
      }
      case Zl: {
        if (u)
          return a([u, [...s]], s);
        const d = [], f = a([l, d], s);
        for (const h of s)
          d.push(o(h));
        return f;
      }
      case ec: {
        if (u)
          switch (u) {
            case "BigInt":
              return a([u, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([u, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const d = [], f = a([l, d], s);
        for (const h of hK(s))
          (e || !Qs(so(s[h]))) && d.push([o(h), o(s[h])]);
        return f;
      }
      case Kv:
        return a([l, s.toISOString()], s);
      case Gv: {
        const { source: d, flags: f } = s;
        return a([l, { source: d, flags: f }], s);
      }
      case Yv: {
        const d = [], f = a([l, d], s);
        for (const [h, v] of s)
          (e || !(Qs(so(h)) || Qs(so(v)))) && d.push([o(h), o(v)]);
        return f;
      }
      case Jv: {
        const d = [], f = a([l, d], s);
        for (const h of s)
          (e || !Qs(so(h))) && d.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: u, message: m }], s);
  };
  return o;
}, f_ = (e, { json: n, lossy: t } = {}) => {
  const i = [];
  return vK(!(n || t), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, nc = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? p_(f_(e, n)) : structuredClone(e)
) : (e, n) => p_(f_(e, n));
function yK(e, n) {
  const t = [{ type: "text", value: "↩" }];
  return n > 1 && t.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), t;
}
function gK(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function kK(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", t = e.options.footnoteBackContent || yK, i = e.options.footnoteBackLabel || gK, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!m)
      continue;
    const d = e.all(m), f = String(m.identifier).toUpperCase(), h = Ua(f.toLowerCase());
    let v = 0;
    const x = [], S = e.footnoteCounts.get(f);
    for (; S !== void 0 && ++v <= S; ) {
      x.length > 0 && x.push({ type: "text", value: " " });
      let y = typeof t == "string" ? t : t(u, v);
      typeof y == "string" && (y = { type: "text", value: y }), x.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (v > 1 ? "-" + v : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(u, v),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(y) ? y : [y]
      });
    }
    const N = d[d.length - 1];
    if (N && N.type === "element" && N.tagName === "p") {
      const y = N.children[N.children.length - 1];
      y && y.type === "text" ? y.value += " " : N.children.push({ type: "text", value: " " }), N.children.push(...x);
    } else
      d.push(...x);
    const j = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(d, !0)
    };
    e.patch(m, j), l.push(j);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...nc(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const d1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return SK;
    if (typeof e == "function")
      return Wc(e);
    if (typeof e == "object")
      return Array.isArray(e) ? bK(e) : _K(e);
    if (typeof e == "string")
      return xK(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function bK(e) {
  const n = [];
  let t = -1;
  for (; ++t < e.length; )
    n[t] = d1(e[t]);
  return Wc(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function _K(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return Wc(t);
  function t(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function xK(e) {
  return Wc(n);
  function n(t) {
    return t && t.type === e;
  }
}
function Wc(e) {
  return n;
  function n(t, i, a) {
    return !!(NK(t) && e.call(
      this,
      t,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function SK() {
  return !0;
}
function NK(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const m1 = [], jK = !0, h_ = !1, wK = "skip";
function CK(e, n, t, i) {
  let a;
  typeof n == "function" && typeof t != "function" ? (i = t, t = n) : a = n;
  const o = d1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(u, m, d) {
    const f = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof f.type == "string") {
      const v = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (u.type + (v ? "<" + v + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let v = m1, x, S, N;
      if ((!n || o(u, m, d[d.length - 1] || void 0)) && (v = FK(t(u, d)), v[0] === h_))
        return v;
      if ("children" in u && u.children) {
        const j = (
          /** @type {UnistParent} */
          u
        );
        if (j.children && v[0] !== wK)
          for (S = (i ? j.children.length : -1) + s, N = d.concat(j); S > -1 && S < j.children.length; ) {
            const y = j.children[S];
            if (x = l(y, S, N)(), x[0] === h_)
              return x;
            S = typeof x[1] == "number" ? x[1] : S + s;
          }
      }
      return v;
    }
  }
}
function FK(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [jK, e] : e == null ? m1 : [e];
}
function p1(e, n, t, i) {
  let a, o, s;
  typeof n == "function" && typeof t != "function" ? (o = void 0, s = n, a = t) : (o = n, s = t, a = i), CK(e, o, l, a);
  function l(u, m) {
    const d = m[m.length - 1], f = d ? d.children.indexOf(u) : void 0;
    return s(u, f, d);
  }
}
const _h = {}.hasOwnProperty, IK = {};
function $K(e, n) {
  const t = n || IK, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...mK, ...t.handlers }, l = {
    all: m,
    applyData: TK,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: u,
    options: t,
    patch: EK,
    wrap: RK
  };
  return p1(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const f = d.type === "definition" ? i : a, h = String(d.identifier).toUpperCase();
      f.has(h) || f.set(h, d);
    }
  }), l;
  function u(d, f) {
    const h = d.type, v = l.handlers[h];
    if (_h.call(l.handlers, h) && v)
      return v(l, d, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in d) {
        const { children: S, ...N } = d, j = nc(N);
        return j.children = l.all(d), j;
      }
      return nc(d);
    }
    return (l.options.unknownHandler || OK)(l, d, f);
  }
  function m(d) {
    const f = [];
    if ("children" in d) {
      const h = d.children;
      let v = -1;
      for (; ++v < h.length; ) {
        const x = l.one(h[v], d);
        if (x) {
          if (v && h[v - 1].type === "break" && (!Array.isArray(x) && x.type === "text" && (x.value = v_(x.value)), !Array.isArray(x) && x.type === "element")) {
            const S = x.children[0];
            S && S.type === "text" && (S.value = v_(S.value));
          }
          Array.isArray(x) ? f.push(...x) : f.push(x);
        }
      }
    }
    return f;
  }
}
function EK(e, n) {
  e.position && (n.position = m6(e));
}
function TK(e, n) {
  let t = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (t.type === "element")
        t.tagName = i;
      else {
        const s = "children" in t ? t.children : [t];
        t = { type: "element", tagName: i, properties: {}, children: s };
      }
    t.type === "element" && o && Object.assign(t.properties, nc(o)), "children" in t && t.children && a !== null && a !== void 0 && (t.children = a);
  }
  return t;
}
function OK(e, n) {
  const t = n.data || {}, i = "value" in n && !(_h.call(t, "hProperties") || _h.call(t, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function RK(e, n) {
  const t = [];
  let i = -1;
  for (n && t.push({ type: "text", value: `
` }); ++i < e.length; )
    i && t.push({ type: "text", value: `
` }), t.push(e[i]);
  return n && e.length > 0 && t.push({ type: "text", value: `
` }), t;
}
function v_(e) {
  let n = 0, t = e.charCodeAt(n);
  for (; t === 9 || t === 32; )
    n++, t = e.charCodeAt(n);
  return e.slice(n);
}
function y_(e, n) {
  const t = $K(e, n), i = t.one(e, void 0), a = kK(t), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function DK(e, n) {
  return e && "run" in e ? async function(t, i) {
    const a = (
      /** @type {HastRoot} */
      y_(t, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(t, i) {
    return (
      /** @type {HastRoot} */
      y_(t, { file: i, ...e || n })
    );
  };
}
function g_(e) {
  if (e)
    throw e;
}
var fd, k_;
function PK() {
  if (k_) return fd;
  k_ = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, t = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var d = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !d && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, d) {
    t && d.name === "__proto__" ? t(m, d.name, {
      enumerable: !0,
      configurable: !0,
      value: d.newValue,
      writable: !0
    }) : m[d.name] = d.newValue;
  }, l = function(m, d) {
    if (d === "__proto__")
      if (e.call(m, d)) {
        if (i)
          return i(m, d).value;
      } else return;
    return m[d];
  };
  return fd = function u() {
    var m, d, f, h, v, x, S = arguments[0], N = 1, j = arguments.length, y = !1;
    for (typeof S == "boolean" && (y = S, S = arguments[1] || {}, N = 2), (S == null || typeof S != "object" && typeof S != "function") && (S = {}); N < j; ++N)
      if (m = arguments[N], m != null)
        for (d in m)
          f = l(S, d), h = l(m, d), S !== h && (y && h && (o(h) || (v = a(h))) ? (v ? (v = !1, x = f && a(f) ? f : []) : x = f && o(f) ? f : {}, s(S, { name: d, newValue: u(y, x, h) })) : typeof h < "u" && s(S, { name: d, newValue: h }));
    return S;
  }, fd;
}
var AK = PK();
const hd = /* @__PURE__ */ Bh(AK);
function xh(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function LK() {
  const e = [], n = { run: t, use: i };
  return n;
  function t(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(u, ...m) {
      const d = e[++o];
      let f = -1;
      if (u) {
        s(u);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, d ? VK(d, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function VK(e, n) {
  let t;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let u;
    l && s.push(a);
    try {
      u = e.apply(this, s);
    } catch (m) {
      const d = (
        /** @type {Error} */
        m
      );
      if (l && t)
        throw d;
      return a(d);
    }
    l || (u instanceof Promise ? u.then(o, a) : u instanceof Error ? a(u) : o(u));
  }
  function a(s, ...l) {
    t || (t = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Ur = { basename: zK, dirname: MK, extname: UK, join: BK, sep: "/" };
function zK(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  Ss(e);
  let t = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          t = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(t, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        t = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return t === i ? i = s : i < 0 && (i = e.length), e.slice(t, i);
}
function MK(e) {
  if (Ss(e), e.length === 0)
    return ".";
  let n = -1, t = e.length, i;
  for (; --t; )
    if (e.codePointAt(t) === 47) {
      if (i) {
        n = t;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function UK(e) {
  Ss(e);
  let n = e.length, t = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    t < 0 && (s = !0, t = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || t < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === t - 1 && a === i + 1 ? "" : e.slice(a, t);
}
function BK(...e) {
  let n = -1, t;
  for (; ++n < e.length; )
    Ss(e[n]), e[n] && (t = t === void 0 ? e[n] : t + "/" + e[n]);
  return t === void 0 ? "." : qK(t);
}
function qK(e) {
  Ss(e);
  const n = e.codePointAt(0) === 47;
  let t = HK(e, !n);
  return t.length === 0 && !n && (t = "."), t.length > 0 && e.codePointAt(e.length - 1) === 47 && (t += "/"), n ? "/" + t : t;
}
function HK(e, n) {
  let t = "", i = 0, a = -1, o = 0, s = -1, l, u;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (t.length < 2 || i !== 2 || t.codePointAt(t.length - 1) !== 46 || t.codePointAt(t.length - 2) !== 46) {
          if (t.length > 2) {
            if (u = t.lastIndexOf("/"), u !== t.length - 1) {
              u < 0 ? (t = "", i = 0) : (t = t.slice(0, u), i = t.length - 1 - t.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (t.length > 0) {
            t = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (t = t.length > 0 ? t + "/.." : "..", i = 2);
      } else
        t.length > 0 ? t += "/" + e.slice(a + 1, s) : t = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return t;
}
function Ss(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const WK = { cwd: KK };
function KK() {
  return "/";
}
function Sh(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function GK(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!Sh(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return YK(e);
}
function YK(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let t = -1;
  for (; ++t < n.length; )
    if (n.codePointAt(t) === 37 && n.codePointAt(t + 1) === 50) {
      const i = n.codePointAt(t + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const vd = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class f1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let t;
    n ? Sh(n) ? t = { path: n } : typeof n == "string" || JK(n) ? t = { value: n } : t = n : t = {}, this.cwd = "cwd" in t ? "" : WK.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < vd.length; ) {
      const o = vd[i];
      o in t && t[o] !== void 0 && t[o] !== null && (this[o] = o === "history" ? [...t[o]] : t[o]);
    }
    let a;
    for (a in t)
      vd.includes(a) || (this[a] = t[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Ur.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    gd(n, "basename"), yd(n, "basename"), this.path = Ur.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Ur.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    b_(this.basename, "dirname"), this.path = Ur.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Ur.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (yd(n, "extname"), b_(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Ur.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    Sh(n) && (n = GK(n)), gd(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Ur.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    gd(n, "stem"), yd(n, "stem"), this.path = Ur.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, t, i) {
    const a = this.message(n, t, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, t, i) {
    const a = this.message(n, t, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, t, i) {
    const a = new Dt(
      // @ts-expect-error: the overloads are fine.
      n,
      t,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function yd(e, n) {
  if (e && e.includes(Ur.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Ur.sep + "`"
    );
}
function gd(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function b_(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function JK(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const QK = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  }
), XK = {}.hasOwnProperty;
class Qv extends QK {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = LK();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Qv()
    );
    let t = -1;
    for (; ++t < this.attachers.length; ) {
      const i = this.attachers[t];
      n.use(...i);
    }
    return n.data(hd(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, t) {
    return typeof n == "string" ? arguments.length === 2 ? (_d("data", this.frozen), this.namespace[n] = t, this) : XK.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (_d("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [t, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = t.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const t = Xs(n), i = this.parser || this.Parser;
    return kd("parse", i), i(String(t), t);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, t) {
    const i = this;
    return this.freeze(), kd("process", this.parser || this.Parser), bd("process", this.compiler || this.Compiler), t ? a(void 0, t) : new Promise(a);
    function a(o, s) {
      const l = Xs(n), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(u, l, function(d, f, h) {
        if (d || !f || !h)
          return m(d);
        const v = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), x = i.stringify(v, h);
        n9(x) ? h.value = x : h.result = x, m(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(d, f) {
        d || !f ? s(d) : o ? o(f) : t(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let t = !1, i;
    return this.freeze(), kd("processSync", this.parser || this.Parser), bd("processSync", this.compiler || this.Compiler), this.process(n, a), x_("processSync", "process", t), i;
    function a(o, s) {
      t = !0, g_(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, t, i) {
    __(n), this.freeze();
    const a = this.transformers;
    return !i && typeof t == "function" && (i = t, t = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const u = Xs(t);
      a.run(n, u, m);
      function m(d, f, h) {
        const v = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        d ? l(d) : s ? s(v) : i(void 0, v, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, t) {
    let i = !1, a;
    return this.run(n, t, o), x_("runSync", "run", i), a;
    function o(s, l) {
      g_(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, t) {
    this.freeze();
    const i = Xs(t), a = this.compiler || this.Compiler;
    return bd("stringify", a), __(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...t) {
    const i = this.attachers, a = this.namespace;
    if (_d("use", this.frozen), n != null) if (typeof n == "function")
      u(n, t);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        u(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [d, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          u(d, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = hd(!0, a.settings, m.settings));
    }
    function l(m) {
      let d = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++d < m.length; ) {
          const f = m[d];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function u(m, d) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...d]);
      else if (d.length > 0) {
        let [v, ...x] = d;
        const S = i[h][1];
        xh(S) && xh(v) && (v = hd(!0, S, v)), i[h] = [m, v, ...x];
      }
    }
  }
}
const ZK = new Qv().freeze();
function kd(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function bd(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function _d(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function __(e) {
  if (!xh(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function x_(e, n, t) {
  if (!t)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function Xs(e) {
  return e9(e) ? e : new f1(e);
}
function e9(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function n9(e) {
  return typeof e == "string" || t9(e);
}
function t9(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const r9 = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", S_ = [], N_ = { allowDangerousHtml: !0 }, i9 = /^(https?|ircs?|mailto|xmpp)$/i, a9 = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function o9(e) {
  const n = e.allowedElements, t = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || S_, u = e.remarkPlugins || S_, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...N_ } : N_, d = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || s9, v = ZK().use(zW).use(u).use(DK, m).use(l), x = new f1();
  typeof i == "string" && (x.value = i);
  for (const y of a9)
    Object.hasOwn(e, y.from) && ("" + y.from + (y.to ? "use `" + y.to + "` instead" : "remove it") + r9 + y.id, void 0);
  const S = v.parse(x);
  let N = v.runSync(S, x);
  return a && (N = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      N.type === "root" ? N.children : [N]
    )
  }), p1(N, j), g6(N, {
    Fragment: ze.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: ze.jsx,
    jsxs: ze.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function j(y, q, E) {
    if (y.type === "raw" && E && typeof q == "number")
      return d ? E.children.splice(q, 1) : E.children[q] = { type: "text", value: y.value }, q;
    if (y.type === "element") {
      let C;
      for (C in dd)
        if (Object.hasOwn(dd, C) && Object.hasOwn(y.properties, C)) {
          const T = y.properties[C], U = dd[C];
          (U === null || U.includes(y.tagName)) && (y.properties[C] = h(String(T || ""), C, y));
        }
    }
    if (y.type === "element") {
      let C = n ? !n.includes(y.tagName) : s ? s.includes(y.tagName) : !1;
      if (!C && t && typeof q == "number" && (C = !t(y, q, E)), C && E && typeof q == "number")
        return f && y.children ? E.children.splice(q, 1, ...y.children) : E.children.splice(q, 1), q;
    }
  }
}
function s9(e) {
  const n = e.indexOf(":"), t = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || t > -1 && n > t || i > -1 && n > i || // It is a protocol, it should be allowed.
    i9.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var xd = { exports: {} }, lo = {}, j_;
function l9() {
  if (j_) return lo;
  j_ = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return lo.Fragment = t, lo.jsx = s, lo.jsxs = s, lo;
}
var Zs = {}, w_;
function c9() {
  return w_ || (w_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    Zs.Fragment = i, Zs.jsx = Un, Zs.jsxs = Bn;
  }()), Zs;
}
var C_;
function u9() {
  return C_ || (C_ = 1, process.env.NODE_ENV === "production" ? xd.exports = l9() : xd.exports = c9()), xd.exports;
}
var ie = u9();
const d9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, m9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, p9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, f9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "or" }, value: { kind: "ListValue", values: [{ kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "containsIgnoreCase" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }] } }] }, { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "containsIgnoreCase" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }] } }] }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, h9 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, v9 = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": d9,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": m9,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": p9,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      issues(\n        first:$first\n        after:$after\n        filter: {\n          or: [\n            { title: { containsIgnoreCase: $issueQuery } }\n            { description: { containsIgnoreCase: $issueQuery } }\n          ]\n        }\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": f9,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": h9
};
function Ns(e) {
  return v9[e] ?? {};
}
const y9 = Ns(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      issues(
        first:$first
        after:$after
        filter: {
          or: [
            { title: { containsIgnoreCase: $issueQuery } }
            { description: { containsIgnoreCase: $issueQuery } }
          ]
        }
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), g9 = Ns(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), el = ({
  title: e,
  children: n
}) => /* @__PURE__ */ ie.jsxs(_, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ ie.jsx(A.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), k9 = "_issueAvatar_kc0sw_1", b9 = "_issueField_kc0sw_9", _9 = "_issueDescription_kc0sw_12", nl = {
  issueAvatar: k9,
  issueField: b9,
  issueDescription: _9
}, h1 = ({ issue: e }) => /* @__PURE__ */ ie.jsxs(ie.Fragment, { children: [
  /* @__PURE__ */ ie.jsx(el, { title: "Assignee", children: /* @__PURE__ */ ie.jsxs(
    _,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: nl.issueAvatar,
      children: [
        /* @__PURE__ */ ie.jsx(
          zh,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ ie.jsx(A.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ ie.jsx(el, { title: "Team", children: /* @__PURE__ */ ie.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: nl.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ ie.jsx(el, { title: "Project", children: /* @__PURE__ */ ie.jsx(
    A.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: nl.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ ie.jsx(el, { title: "Description", children: /* @__PURE__ */ ie.jsx(o9, { className: nl.issueDescription, children: e.description }) })
] }), x9 = /* @__PURE__ */ ie.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ ie.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ ie.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ ie.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), S9 = /* @__PURE__ */ ie.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ ie.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ie.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ ie.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), N9 = /* @__PURE__ */ ie.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ ie.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ie.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ie.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), j9 = /* @__PURE__ */ ie.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ ie.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ie.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ie.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), w9 = /* @__PURE__ */ ie.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ ie.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), v1 = {
  0: x9,
  1: w9,
  2: j9,
  3: N9,
  4: S9
}, C9 = (e) => e in v1, tc = ({ priority: e }) => C9(e) ? v1[e] : /* @__PURE__ */ ie.jsx(En, { "data-testid": "defaultPriorityTag", children: e }), F9 = (e, n) => /* @__PURE__ */ ie.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ ie.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), I9 = (e, n) => /* @__PURE__ */ ie.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ ie.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ ie.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), $9 = (e, n) => /* @__PURE__ */ ie.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ ie.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ ie.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), E9 = (e, n) => /* @__PURE__ */ ie.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ie.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), T9 = (e, n) => /* @__PURE__ */ ie.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ie.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), O9 = (e, n) => /* @__PURE__ */ ie.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ie.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), Nh = {
  backlog: (e, n) => F9(e, n),
  unstarted: (e, n) => I9(e, n),
  started: (e, n) => $9(e, n),
  done: (e, n) => E9(e, n),
  canceled: (e, n) => T9(e, n),
  completed: (e, n) => O9(e, n)
}, R9 = (e) => e in Nh, rc = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: t = "linear-backlog-icon"
}) => R9(e) ? Nh[e](n, t) : Nh.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), D9 = "_wrapper_e0qj3_1", P9 = "_resultTitle_e0qj3_21", A9 = "_resultTooltipTitle_e0qj3_28", L9 = "_resultLinkIcon_e0qj3_31", co = {
  wrapper: D9,
  resultTitle: P9,
  resultTooltipTitle: A9,
  resultLinkIcon: L9
}, V9 = ({
  issue: e
}) => {
  const [n, t] = oe(!1);
  return /* @__PURE__ */ ie.jsx(
    Je,
    {
      side: "left",
      content: /* @__PURE__ */ ie.jsxs(_, { flexDirection: "column", gap: "300", className: co.wrapper, children: [
        /* @__PURE__ */ ie.jsxs(_, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ ie.jsxs(_, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ ie.jsx(
              rc,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ ie.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ ie.jsx(tc, { priority: e.priority })
          ] }),
          /* @__PURE__ */ ie.jsx(En, { children: e.state.name })
        ] }),
        /* @__PURE__ */ ie.jsxs(_, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ ie.jsx(
            A.Heading,
            {
              variant: "heading-3",
              className: co.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ ie.jsx(h1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ ie.jsx(
        pt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: co.result,
          onMouseEnter: () => t(!0),
          onMouseLeave: () => t(!1),
          "data-testid": "selectionListItemWrapper",
          children: /* @__PURE__ */ ie.jsxs(
            _,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ ie.jsxs(_, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ie.jsx(
                    rc,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ ie.jsx(A.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ ie.jsx(tc, { priority: e.priority })
                ] }),
                /* @__PURE__ */ ie.jsx(A.Paragraph, { variant: "4", className: co.resultTitle, children: e.title }),
                n && /* @__PURE__ */ ie.jsx(
                  he,
                  {
                    className: co.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, z9 = "_loader_13xpk_1", M9 = "_dropdown_13xpk_8", U9 = "_loadMore_13xpk_13", Sd = {
  loader: z9,
  dropdown: M9,
  loadMore: U9
}, B9 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [t, i] = oe(), [a, o] = oe([]), [s, l] = oe(""), [u, m] = oe(!1), { useLazyQuery: d } = un(), [f, { data: h, loading: v, networkStatus: x }] = d(
    y9,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  Va(
    () => {
      !v && s !== "" && x === hr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), qe(() => {
    v || o([]);
  }, [s]), qe(() => {
    if (h && Object.keys(h).length > 0) {
      const N = h.Linear.issues.edges.map(
        ({ node: E }) => E
      ), j = a.filter(
        (E) => !n.find((C) => C.id === E.id)
      ), y = j.filter(
        (E) => !N.find(
          (C) => C.id === E.id
        )
      ), q = N.filter(
        (E) => !n.find((C) => C.id === E.id)
      );
      n.length > 0 ? o(
        u ? [...y, ...q] : q
      ) : h?.Linear?.issues?.edges && o(
        u ? [...j, ...N] : N
      ), h.Linear.issues.pageInfo.hasNextPage && m(!1), i(h.Linear.issues?.pageInfo);
    }
  }, [h, n]);
  const S = () => {
    !v && s !== "" && x === hr.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: t?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ ie.jsx(_, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ ie.jsxs(
    yi,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (N) => N?.title,
      onChange: (N) => e(N.selectedValues[0]),
      dropdownProps: { className: Sd.dropdown },
      filter: {
        value: s,
        onChange: (N) => {
          const j = N.target.value;
          l(j);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((N) => /* @__PURE__ */ ie.jsx(V9, { issue: N }, N.id)),
        t?.hasNextPage && !v && s !== "" && a.length && /* @__PURE__ */ ie.jsx(
          _,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => S(),
            className: Sd.loadMore,
            children: /* @__PURE__ */ ie.jsx(A.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        v && s !== "" && /* @__PURE__ */ ie.jsx(_, { justifyContent: "center", className: Sd.loader, children: /* @__PURE__ */ ie.jsx(cn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ ie.jsx(
          _,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ie.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !v && /* @__PURE__ */ ie.jsx(
          _,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ie.jsx(A.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, q9 = "_collapse_su0f9_1", H9 = "_collapseHeader_su0f9_8", W9 = "_collapseContent_su0f9_31", K9 = "_url_su0f9_35", G9 = "_externalLink_su0f9_51", Y9 = "_emptyState_su0f9_55", hi = {
  collapse: q9,
  collapseHeader: H9,
  collapseContent: W9,
  url: K9,
  externalLink: G9,
  emptyState: Y9
}, J9 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: t,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (d, f) => ({ ...d, [f.id]: !1 }),
    {}
  ), [l, u] = oe(s), { track: m } = hn();
  return n ? /* @__PURE__ */ ie.jsx(
    _,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ ie.jsx(cn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ ie.jsxs(
    _,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ ie.jsx(
          A.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: hi.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ ie.jsx(
          Rt,
          {
            slotEnd: /* @__PURE__ */ ie.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: hi.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ ie.jsxs(
    _,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((d) => {
          const f = l[d.id];
          return /* @__PURE__ */ ie.jsxs(
            pr,
            {
              "data-testid": "collapseCard",
              onToggle: () => u({ ...l, [d.id]: !l[d.id] }),
              isOpen: f,
              className: hi.collapse,
              children: [
                /* @__PURE__ */ ie.jsx(pr.Header, { className: hi.collapseHeader, children: /* @__PURE__ */ ie.jsxs(_, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ ie.jsxs(_, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ ie.jsxs(_, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ ie.jsx(Je, { content: /* @__PURE__ */ ie.jsx(_, { children: d.state.name }), children: /* @__PURE__ */ ie.jsx(_, { alignSelf: "center", children: /* @__PURE__ */ ie.jsx(
                        rc,
                        {
                          type: d.state.type,
                          color: d.state.color,
                          name: d.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ ie.jsxs(
                        A.ExternalLink,
                        {
                          className: hi.url,
                          href: d.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            d.identifier,
                            /* @__PURE__ */ ie.jsx(he, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ ie.jsx(Je, { content: /* @__PURE__ */ ie.jsx(_, { children: d.priorityLabel }), children: /* @__PURE__ */ ie.jsx(_, { alignSelf: "center", children: /* @__PURE__ */ ie.jsx(tc, { priority: d.priority }) }) })
                    ] }),
                    /* @__PURE__ */ ie.jsx(En, { children: d.state.name })
                  ] }),
                  d.title
                ] }) }),
                /* @__PURE__ */ ie.jsx(pr.Content, { className: hi.collapseContent, children: /* @__PURE__ */ ie.jsxs(_, { flexDirection: "column", gap: "300", children: [
                  d?.labels && d?.labels?.edges?.length > 0 && /* @__PURE__ */ ie.jsx(
                    _,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: d.labels?.edges.map((h) => /* @__PURE__ */ ie.jsx(En, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ ie.jsx(h1, { issue: d }),
                  /* @__PURE__ */ ie.jsx(
                    qn,
                    {
                      slotStart: /* @__PURE__ */ ie.jsx(he, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => t(d.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ ie.jsxs(
                    Rt,
                    {
                      slotEnd: /* @__PURE__ */ ie.jsx(he, { name: "external-link" }),
                      variant: "tertiary",
                      className: hi.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: d.id
                        });
                      },
                      navigate: () => window.open(d.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        d.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            d.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ ie.jsx(
          qn,
          {
            slotStart: /* @__PURE__ */ ie.jsx(he, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ ie.jsx(
          Rt,
          {
            slotEnd: /* @__PURE__ */ ie.jsx(he, { name: "external-link" }),
            variant: "tertiary",
            className: hi.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, Q9 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((t) => `- ${t}`).join(""),
    ordered_list: (e, n) => `
` + n().map((t) => `1. ${t}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, y1 = (e, n) => {
  const t = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => y1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return t(
    a(e, i(e, n))
  );
}, X9 = "_modalBody_iv3ua_1", Z9 = "_error_iv3ua_5", e7 = "_dropdown_iv3ua_16", sa = {
  modalBody: X9,
  error: Z9,
  dropdown: e7
}, n7 = Ns(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), t7 = Ns(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), r7 = Ns(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), i7 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: t,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: u } = un(), { control: m, handleSubmit: d, reset: f } = br(), [h, v] = oe([]), [x, S] = oe(), [N, j] = oe([]), [y, q] = oe(), [E, C] = oe([]), [T, U] = oe(), [Z, Q] = oe([]), [ee, J] = oe(), [K, D] = oe([]), [G, ne] = oe(), [de, ge] = oe(!1), { useMutation: ce } = un(), { track: ve } = hn(), [H, { loading: be }] = ce(
    n7,
    {
      onError: () => u({
        title: "Creation was not successful",
        text: "Please try again later or contact your admin.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }),
      onCompleted: (Ne) => {
        const We = {
          identifier: Ne.Linear?.issueCreate?.issue?.identifier,
          url: Ne.Linear?.issueCreate?.issue?.url
        };
        Ne.Linear && !be && Ne.Linear?.issueCreate?.issue?.id && (a(Ne.Linear?.issueCreate?.issue?.id), Ve(We), ge(!1), u({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${Ne.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), ve("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    je,
    { data: W, loading: Ue, error: Me }
  ] = l(t7, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ne) => {
      const We = Ne.Linear.teams.edges.map(
        ({ node: Oe }) => Oe
      );
      v(We), Q(Ne.Linear.issuePriorityValues), s(`${p7}${Ne.Linear.organization.urlKey}`);
    }
  }), [De, { data: Be, loading: Ee }] = l(r7, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => u({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: (Ne) => {
      const We = Ne?.Linear?.team?.projects?.edges?.map(
        ({ node: fe }) => fe
      );
      j(We);
      const Oe = Ne?.Linear?.team?.states?.edges?.map(
        ({ node: fe }) => fe
      );
      C(Oe);
      const ue = Ne?.Linear?.team?.templates?.edges?.map(
        ({ node: fe }) => fe
      );
      D(
        ue.filter(
          (fe) => fe.type === "issue"
        )
      );
    }
  }), Ve = (Ne) => {
    t(!1), q(void 0), S(void 0), U(void 0), J(void 0), ne(void 0), Ne && (e(Ne), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Re = (Ne) => {
    W && !Ue && (H({
      variables: {
        issueTitle: Ne.title,
        issueDescription: Ne?.description,
        teamId: Ne.team.id,
        projectId: Ne?.project?.id,
        statusId: Ne?.status?.id,
        priority: Ne?.priority?.priority
      }
    }), ge(!0));
  };
  qe(() => {
    n && je();
  }, [n]);
  const tn = () => {
    ve("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ ie.jsxs(
    St,
    {
      isOpen: n,
      onClose: () => {
        tn(), Ve();
      },
      children: [
        /* @__PURE__ */ ie.jsx(
          Nt,
          {
            title: "Create new Linear issue",
            onClose: () => {
              tn(), Ve();
            }
          }
        ),
        /* @__PURE__ */ ie.jsx(
          jt,
          {
            className: sa.modalBody,
            "data-testid": "createIssueModalBody",
            children: Me ? /* @__PURE__ */ ie.jsx(_n, { error: Me }) : /* @__PURE__ */ ie.jsx("form", { onSubmit: d(Re), id: "issueCreationForm", children: /* @__PURE__ */ ie.jsxs(Kt, { children: [
              /* @__PURE__ */ ie.jsx(en, { span: 3, children: /* @__PURE__ */ ie.jsx(
                Bt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: Ne, onChange: We },
                    fieldState: { error: Oe }
                  }) => /* @__PURE__ */ ie.jsx(
                    Dn,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: Oe?.message ?? null
                      },
                      children: /* @__PURE__ */ ie.jsx(
                        yi,
                        {
                          dropdownProps: { className: sa.dropdown },
                          placeholder: "Select Linear team",
                          className: ht({ [sa.error]: Oe }),
                          getItemTitleByValue: (ue) => ue?.name,
                          onChange: (ue) => {
                            q(void 0), U(void 0), J(void 0), ne(void 0), S(ue.selectedValues[0]), De({
                              variables: { teamId: ue.selectedValues[0].id }
                            }), We(ue.selectedValues[0]);
                          },
                          value: x ? [Ne] : void 0,
                          children: h?.map((ue) => /* @__PURE__ */ ie.jsx(
                            pt.Item,
                            {
                              value: ue,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ie.jsx(A.Paragraph, { children: ue.name })
                            },
                            ue.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ie.jsx(en, { span: 3, children: /* @__PURE__ */ ie.jsx(
                Bt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: Ne, onChange: We } }) => {
                    const Oe = Ee ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ ie.jsx(Dn, { label: "Project", children: /* @__PURE__ */ ie.jsx(
                      yi,
                      {
                        dropdownProps: { className: sa.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (ue) => ue?.name,
                        disabled: x === void 0,
                        placeholder: x ? "Select Linear project" : "Select a Team first",
                        onChange: (ue) => {
                          q(ue.selectedValues[0]), We(ue.selectedValues[0]);
                        },
                        value: y ? [Ne] : Oe,
                        children: /* @__PURE__ */ ie.jsxs(ie.Fragment, { children: [
                          Ee && /* @__PURE__ */ ie.jsx(
                            _,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ie.jsx(cn, { size: 24 })
                            }
                          ),
                          Be && !Ee && N.map((ue) => /* @__PURE__ */ ie.jsx(
                            pt.Item,
                            {
                              value: ue,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ie.jsx(A.Paragraph, { children: ue.name })
                            },
                            ue.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ie.jsx(en, { span: 6, children: /* @__PURE__ */ ie.jsx(Dn, { label: "Template", children: /* @__PURE__ */ ie.jsx(
                yi,
                {
                  clearable: !0,
                  dropdownProps: { className: sa.dropdown },
                  disabled: !x || Ee,
                  placeholder: x ? "Select template" : "Select a Team first",
                  getItemTitleByValue: (Ne) => Ne?.name,
                  onChange: (Ne) => {
                    if (Ne.selectedValues.length > 0) {
                      ne(Ne.selectedValues[0]);
                      const We = JSON.parse(
                        Ne.selectedValues[0].templateData
                      ), Oe = Z.filter(
                        (Le) => Le.priority === We.priority
                      );
                      J(
                        Oe ? Oe[0] : void 0
                      );
                      const ue = E.filter(
                        (Le) => Le.id === We.stateId
                      );
                      U(
                        ue ? ue[0] : void 0
                      );
                      const fe = N.filter(
                        (Le) => Le.id === We.projectId
                      );
                      q(
                        fe ? fe[0] : void 0
                      );
                      const we = We.description;
                      f({
                        title: We?.title,
                        priority: Oe[0],
                        status: ue[0],
                        project: fe[0],
                        description: we ? y1(we, Q9) : "",
                        team: x
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: x
                      }), q(void 0), J(void 0), U(void 0), ne(void 0);
                  },
                  value: G ? [G] : void 0,
                  children: K?.map((Ne) => /* @__PURE__ */ ie.jsx(
                    pt.Item,
                    {
                      value: Ne,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ ie.jsx(A.Paragraph, { children: Ne.name })
                    },
                    Ne.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ ie.jsx(en, { span: 6, children: /* @__PURE__ */ ie.jsx(
                Bt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: Ne, value: We },
                    fieldState: { error: Oe }
                  }) => /* @__PURE__ */ ie.jsx(
                    fr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: We || "",
                        onChange: Ne
                      },
                      meta: {
                        error: Oe?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ie.jsx(en, { span: 3, children: /* @__PURE__ */ ie.jsx(
                Bt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: Ne, onChange: We } }) => {
                    const Oe = Ee ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ie.jsx(Dn, { label: "Status", children: /* @__PURE__ */ ie.jsx(
                      yi,
                      {
                        dropdownProps: { className: sa.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (ue) => ue?.name,
                        disabled: x === void 0,
                        placeholder: x ? "Select Issue status" : "Select a Team first",
                        onChange: (ue) => {
                          U(ue.selectedValues[0]), We(ue.selectedValues[0]);
                        },
                        value: T ? [Ne] : Oe,
                        children: /* @__PURE__ */ ie.jsxs(ie.Fragment, { children: [
                          Ee && /* @__PURE__ */ ie.jsx(
                            _,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ie.jsx(cn, { size: 24 })
                            }
                          ),
                          Be && !Ee && E.map((ue) => /* @__PURE__ */ ie.jsx(
                            pt.Item,
                            {
                              value: ue,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ie.jsxs(
                                _,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ie.jsx(
                                      rc,
                                      {
                                        type: ue.type,
                                        color: ue.color,
                                        name: ue.name
                                      }
                                    ),
                                    /* @__PURE__ */ ie.jsx(A.Paragraph, { children: ue.name })
                                  ]
                                }
                              )
                            },
                            ue.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ie.jsx(en, { span: 3, children: /* @__PURE__ */ ie.jsx(
                Bt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: Ne, onChange: We } }) => {
                    const Oe = Ue ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ie.jsx(Dn, { label: "Priority", children: /* @__PURE__ */ ie.jsx(
                      yi,
                      {
                        clearable: !0,
                        getItemTitleByValue: (ue) => ue?.label,
                        disabled: x === void 0,
                        placeholder: x ? "Select Issue priority" : "Select a Team first",
                        onChange: (ue) => {
                          J(ue.selectedValues[0]), We(ue.selectedValues[0]);
                        },
                        value: ee ? [Ne] : Oe,
                        children: /* @__PURE__ */ ie.jsxs(ie.Fragment, { children: [
                          Ee && /* @__PURE__ */ ie.jsx(
                            _,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ie.jsx(cn, { size: 24 })
                            }
                          ),
                          W && !Ue && Z.map((ue) => /* @__PURE__ */ ie.jsx(
                            pt.Item,
                            {
                              value: ue,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ie.jsxs(
                                _,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ie.jsx(
                                      tc,
                                      {
                                        priority: ue.priority
                                      }
                                    ),
                                    /* @__PURE__ */ ie.jsx(A.Paragraph, { children: ue.label })
                                  ]
                                }
                              )
                            },
                            ue.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ie.jsx(en, { children: /* @__PURE__ */ ie.jsx(
                Bt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: Ne, value: We },
                    fieldState: { error: Oe }
                  }) => /* @__PURE__ */ ie.jsx(
                    WF,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: We || "",
                        onChange: Ne
                      },
                      meta: {
                        error: Oe?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ ie.jsx(
          Et,
          {
            confirmOnClick: d(Re),
            confirmProps: {
              disabled: be || !W,
              isLoading: de || Ue || Ee,
              loadingIndicator: /* @__PURE__ */ ie.jsx(cn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              tn(), Ve();
            }
          }
        )
      ]
    }
  );
}, a7 = "_modalWrapper_4kh9u_1", o7 = "_copyButton_4kh9u_6", s7 = "_copyWrapper_4kh9u_15", l7 = "_copyField_4kh9u_24", c7 = "_externalLink_4kh9u_47", u7 = "_externalLinkIcon_4kh9u_52", d7 = "_textWrapper_4kh9u_56", Ii = {
  modalWrapper: a7,
  copyButton: o7,
  copyWrapper: s7,
  copyField: l7,
  externalLink: c7,
  externalLinkIcon: u7,
  textWrapper: d7
}, m7 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: t
}) => /* @__PURE__ */ ie.jsxs(
  St,
  {
    isOpen: !!n && e,
    className: Ii.modalWrapper,
    onClose: () => t(!1),
    children: [
      /* @__PURE__ */ ie.jsx(
        Nt,
        {
          title: "Issue creation successful",
          onClose: () => t(!1)
        }
      ),
      /* @__PURE__ */ ie.jsx(jt, { children: /* @__PURE__ */ ie.jsxs(
        _,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ ie.jsxs(A.Paragraph, { className: Ii.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ ie.jsxs(
                A.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: Ii.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ ie.jsx(he, { name: "external-link", className: Ii.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ ie.jsx(Dn, { label: "Linear issue link", children: /* @__PURE__ */ ie.jsxs(
              _,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: Ii.copyWrapper,
                children: [
                  /* @__PURE__ */ ie.jsx(
                    Or,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: Ii.copyField
                    }
                  ),
                  /* @__PURE__ */ ie.jsx(
                    KF,
                    {
                      className: Ii.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ ie.jsx(
        Et,
        {
          cancelOnClick: () => t(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), p7 = "https://linear.app/", f7 = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = oe([]), [a, o] = oe([]), [s, l] = oe(!1), [u, m] = oe(!1), [d, f] = oe(!1), [h, v] = oe(), { useLazyQuery: x } = un(), [S, N] = oe(""), j = n?.enableCreateIssue, y = !!n?.enableUnlinkAll, { track: q } = hn(), {
    loading: E,
    data: C,
    error: T,
    store: U
  } = Lh(e?.conversationId ?? null), [
    Z,
    {
      data: Q,
      loading: ee,
      networkStatus: J,
      error: K
    }
  ] = x(g9, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  qe(() => {
    !E && !T && C && C?.linear?.issues?.length > 0 && (o(C.linear.issues), Z({
      variables: {
        linkedIssues: C.linear.issues
      }
    }));
  }, [C, E, T]), qe(() => {
    Q && Q?.Linear && !ee && J === hr.ready && Object.keys(Q).length > 0 && i(Q.Linear.issues?.edges?.map(({ node: de }) => de));
  }, [Q, ee, J]);
  const D = (de) => {
    de && de?.team?.organization?.urlKey && q("linear:link:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: de.id
    });
    const ge = (ce) => ce.id === de?.id;
    t.some((ce) => ce && ge(ce)) || (C && a.length === 0 && o([]), U({
      linear: {
        issues: [...a, de.id]
      }
    }));
  }, G = (de) => {
    const ge = C?.linear.issues.filter((ce) => ce !== de) || [];
    q("linear:unlink:issue:clicked", {
      linearInstanceUrl: S,
      linearIssueKey: de
    }), i(t.filter(({ id: ce }) => ce !== de)), o(ge), U({
      linear: {
        issues: ge
      }
    });
  }, ne = () => {
    l(!1), i([]), o([]), U({
      linear: {
        issues: []
      }
    });
  };
  return !E && !ee && (K || T) ? /* @__PURE__ */ ie.jsx(_n, { error: K || T }) : /* @__PURE__ */ ie.jsxs(_, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ ie.jsxs(
      St,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ ie.jsx(
            Nt,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ ie.jsx(jt, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ ie.jsx(
            Et,
            {
              confirmOnClick: () => ne(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ie.jsx(
      i7,
      {
        isCreateIssueModalOpen: u,
        setIsCreateIssueModalOpen: (de) => m(de),
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        addToLinkedIssueIds: (de) => {
          U({
            linear: {
              issues: [...a, de]
            }
          });
        },
        setCreatedIssue: (de) => v(de),
        organizationUrl: S,
        setOrganizationUrl: (de) => N(de)
      }
    ),
    /* @__PURE__ */ ie.jsx(
      m7,
      {
        isCreationSuccessfulModalOpen: d,
        setIsCreationSuccessfulModalOpen: (de) => f(de),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ ie.jsxs(
      _,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          j && /* @__PURE__ */ ie.jsxs(ie.Fragment, { children: [
            /* @__PURE__ */ ie.jsx(
              qn,
              {
                variant: "primary",
                onClick: () => {
                  q("linear:create:new:issue:clicked", {
                    linearInstanceUrl: S
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ ie.jsx(A.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ ie.jsx(B9, { handleSelect: D, linkedIssues: t })
        ]
      }
    ),
    /* @__PURE__ */ ie.jsx(
      J9,
      {
        linkedIssues: t,
        isLoading: ee,
        handleUnlinkIssue: G,
        showUnlinkAllModal: (de) => l(de),
        showUnlinkAllButton: y,
        organizationUrl: S
      }
    )
  ] });
}, h7 = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: mc
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Nd = { exports: {} }, uo = {}, F_;
function v7() {
  if (F_) return uo;
  F_ = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return uo.Fragment = t, uo.jsx = s, uo.jsxs = s, uo;
}
var tl = {}, I_;
function y7() {
  return I_ || (I_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    tl.Fragment = i, tl.jsx = Un, tl.jsxs = Bn;
  }()), tl;
}
var $_;
function g7() {
  return $_ || ($_ = 1, process.env.NODE_ENV === "production" ? Nd.exports = v7() : Nd.exports = y7()), Nd.exports;
}
var Te = g7();
const k7 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, b7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, _7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, x7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, S7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, N7 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": k7,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": b7,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": _7,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": x7,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": S7
};
function Kc(e) {
  return N7[e] ?? {};
}
const j7 = Kc(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), w7 = Kc(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), C7 = Kc(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), F7 = Kc(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function jd(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const I7 = "_wrapper_27vny_1", $7 = "_copyIcon_27vny_12", mo = {
  wrapper: I7,
  copyIcon: $7
}, E7 = ({
  customer: e
}) => {
  const { isCopied: n, copy: t } = jd(), { isCopied: i, copy: a } = jd(), { isCopied: o, copy: s } = jd();
  if (!e)
    return null;
  const l = 14, {
    email: u,
    properties: m,
    metadata: d,
    birthday: f,
    created_at: h,
    enrolled: v,
    enrolled_at: x,
    referral_url: S
  } = e, N = f ? Tn(f).isSame(Date.now(), "day") : !1, { name: j, first_name: y, last_name: q } = m ?? {}, E = j ?? (`${y} ${q}`.trim() || "A customer has no name"), C = d?.shopify_source_url ? d.shopify_source_url.startsWith("https://") ? d.shopify_source_url : `https://${d.shopify_source_url}` : "";
  return /* @__PURE__ */ Te.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Te.jsxs(_, { className: mo.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsxs(
      _,
      {
        justifyContent: "space-between",
        className: mo.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-2", children: E }),
          N && /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Te.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", color: "secondary", children: Tn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    v && /* @__PURE__ */ Te.jsx(_, { gap: "200", children: /* @__PURE__ */ Te.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Tn(x).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Te.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(_, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Te.jsx(he, { size: l, name: "mail" }),
        /* @__PURE__ */ Te.jsx(A.ExternalLink, { href: `mailto:${u}`, children: u })
      ] }),
      /* @__PURE__ */ Te.jsx(Je, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Te.jsx(
        he,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => t(u),
          className: mo.copyIcon
        }
      ) })
    ] }),
    C && /* @__PURE__ */ Te.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(_, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Te.jsx(he, { size: l, name: "link" }),
        /* @__PURE__ */ Te.jsx(Je, { content: "Shopify shop", children: /* @__PURE__ */ Te.jsx(
          A.ExternalLink,
          {
            href: C,
            target: "_blank",
            rel: "noreferrer",
            children: C.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Te.jsx(Je, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Te.jsx(
        he,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(C),
          className: mo.copyIcon
        }
      ) })
    ] }),
    S && /* @__PURE__ */ Te.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(_, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Te.jsx(he, { size: l, name: "external-link" }),
        /* @__PURE__ */ Te.jsx(Je, { content: "Referral link", children: /* @__PURE__ */ Te.jsx(
          A.ExternalLink,
          {
            href: S,
            target: "_blank",
            rel: "noreferrer",
            children: S.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Te.jsx(Je, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Te.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(S),
          className: mo.copyIcon
        }
      ) })
    ] })
  ] }) });
}, T7 = "_list_1q5b5_5", O7 = "_listItem_1q5b5_8", R7 = "_listItemEdit_1q5b5_15", D7 = "_notificationText_1q5b5_19", Fa = {
  list: T7,
  listItem: O7,
  listItemEdit: R7,
  notificationText: D7
}, P7 = "_modalBody_1clhs_1", A7 = {
  modalBody: P7
}, L7 = ({
  isOpen: e,
  points: n,
  merchantId: t,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = hn(), [u, m] = oe(n), [d, f] = oe(""), [h, v] = oe(), [x, { loading: S }] = o(
    C7,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), J();
      }
    }
  ), [N, { loading: j }] = o(F7), y = S || j, q = !!h, E = n === u ? "Change the value to update the points" : "", C = isNaN(u), T = C ? "Points can not be empty" : "", U = u > n && u - n > 1e6, Z = U ? "Points can not exceed 1,000,000" : "", Q = () => {
    u > n && x({
      variables: {
        input: {
          points: u - n,
          reason: d
        },
        merchantId: t
      }
    }).catch((K) => {
      const D = K?.networkError;
      (D ? D?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : (l("loyaltylion:add:points:failed"), v(["Failed to add points, try again later."]));
    }), u < n && N({
      variables: {
        input: {
          points: n - u,
          reason: d
        },
        merchantId: t
      }
    }).then((K) => {
      K.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), J()) : "errors" in K && (l("loyaltylion:remove:points:failed"), v(
        K.errors?.map((D) => D.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), v(["Failed to remove points, try again later."]);
    });
  }, ee = () => {
    C && m(n), f(""), i();
  }, J = () => {
    a(), ee();
  };
  return /* @__PURE__ */ Te.jsxs(
    St,
    {
      isOpen: e,
      onClose: ee,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Te.jsx(Nt, { title: "Change points", onClose: ee }),
        /* @__PURE__ */ Te.jsxs(jt, { className: A7.modalBody, children: [
          /* @__PURE__ */ Te.jsxs(Kt, { children: [
            /* @__PURE__ */ Te.jsx(en, { span: 6, children: /* @__PURE__ */ Te.jsx(
              fr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: Z || T,
                  warning: E
                },
                input: {
                  name: "points",
                  value: u.toString(),
                  onChange: (K) => m(K?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Te.jsx(en, { span: 6, children: /* @__PURE__ */ Te.jsx(
              fr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: d,
                  onChange: (K) => f(K?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !y && q && /* @__PURE__ */ Te.jsx(_, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Te.jsx(He, { children: h?.map((K, D) => /* @__PURE__ */ Te.jsx(
            He.Item,
            {
              variant: "dense",
              title: K,
              contentLeft: /* @__PURE__ */ Te.jsx(
                he,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            D
          )) }) })
        ] }),
        /* @__PURE__ */ Te.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => Q(),
            confirmProps: {
              isLoading: y,
              disabled: C || U || n === u,
              loadingIndicator: /* @__PURE__ */ Te.jsx(cn, { size: 16 })
            },
            cancelOnClick: ee
          }
        )
      ]
    }
  );
}, V7 = ({
  label: e,
  points: n,
  setIsModalOpen: t
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Te.jsx(He.Text, { variant: "dense", className: Fa.listItem, children: /* @__PURE__ */ Te.jsxs(_, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Te.jsxs(_, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(he, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Te.jsx(A.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Te.jsxs(_, { gap: "200", alignItems: "center", children: [
      t && /* @__PURE__ */ Te.jsx(Je, { content: "Edit points", children: /* @__PURE__ */ Te.jsx(
        he,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Fa.listItemEdit,
          onClick: () => t(!0)
        }
      ) }),
      /* @__PURE__ */ Te.jsx(zn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, z7 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [t, i] = oe(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: u
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: u ?? 0
    }
  ];
  return /* @__PURE__ */ Te.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Te.jsx(He, { className: Fa.list, children: m.map(({ id: d, points: f, label: h, setIsModalOpen: v }) => /* @__PURE__ */ Te.jsx(
      V7,
      {
        points: f,
        label: h,
        setIsModalOpen: v
      },
      d
    )) }),
    /* @__PURE__ */ Te.jsx(
      L7,
      {
        isOpen: t,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, M7 = "_reward_1wxia_1", U7 = {
  reward: M7
}, B7 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: t,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Te.jsx(_, { gap: "100", flexDirection: "column", className: U7.reward, children: /* @__PURE__ */ Te.jsx(Je, { content: a ?? "No description", children: /* @__PURE__ */ Te.jsxs(_, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Te.jsxs(_, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Te.jsx(he, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Te.jsxs(zn, { size: "small", variant: "info", children: [
        t ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Te.jsxs(_, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(he, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Te.jsx(
        A.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, q7 = ({ customer: e }) => {
  const { useQuery: n } = un(), [t, i] = oe(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(w7, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  return qe(() => {
    if (l?.LoyaltyLion) {
      const u = l.LoyaltyLion?.getAvailableRewards?.rewards;
      u && i(u);
    }
  }, [l]), s ? Zo({ errors: s.graphQLErrors }) ? /* @__PURE__ */ Te.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Fa.notificationText,
      children: "No rewards found"
    }
  ) : LN({ errors: s.graphQLErrors }) ? /* @__PURE__ */ Te.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Fa.notificationText,
      children: "You don't have permissions to view rewards"
    }
  ) : /* @__PURE__ */ Te.jsx(_n, { error: s }) : /* @__PURE__ */ Te.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Te.jsx(A.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Te.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(cn, {}) }) : /* @__PURE__ */ Te.jsx(_, { gap: "200", flexDirection: "column", children: t?.map((u) => /* @__PURE__ */ Te.jsx(B7, { reward: u }, u.id)) })
  ] });
}, H7 = ({ customer: e }) => {
  const { blocked: n, guest: t, insights_segment: i } = e ?? {}, a = n || t || i, o = 14;
  return a ? /* @__PURE__ */ Te.jsxs(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Te.jsx(_, { alignItems: "start", children: /* @__PURE__ */ Te.jsx(En, { children: /* @__PURE__ */ Te.jsxs(_, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(
        he,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    t && /* @__PURE__ */ Te.jsx(_, { alignItems: "start", children: /* @__PURE__ */ Te.jsx(En, { children: /* @__PURE__ */ Te.jsxs(_, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(he, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Te.jsx(_, { alignItems: "start", children: /* @__PURE__ */ Te.jsx(Je, { content: "Insights segment", children: /* @__PURE__ */ Te.jsx(En, { children: /* @__PURE__ */ Te.jsxs(_, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Te.jsx(he, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, W7 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = un(), { track: i } = hn(), [a, o] = oe(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: u,
    showPointsBalance: m,
    showAvailableRewards: d
  } = n, f = !l && !u && !m && !d, {
    loading: h,
    error: v,
    data: x,
    refetch: S
  } = t(j7, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return qe(() => {
    if (x && !h) {
      const N = (x?.LoyaltyLion?.getCustomers).customers;
      N && N.length > 0 && (o(N[0]), i("loyaltylion:customer:received"));
    }
  }, [x, h]), s?.email ? v ? Zo({
    errors: v.graphQLErrors
  }) ? /* @__PURE__ */ Te.jsxs(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Fa.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Te.jsx(_n, { error: v }) : h ? /* @__PURE__ */ Te.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Te.jsx(cn, {}) }) : f ? /* @__PURE__ */ Te.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Te.jsx(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Te.jsxs(Te.Fragment, { children: [
        l && /* @__PURE__ */ Te.jsx(E7, { customer: a }),
        u && /* @__PURE__ */ Te.jsx(H7, { customer: a }),
        m && /* @__PURE__ */ Te.jsx(
          z7,
          {
            customer: a,
            refetchCustomerData: S
          }
        ),
        d && /* @__PURE__ */ Te.jsx(q7, { customer: a })
      ] }) : /* @__PURE__ */ Te.jsx(_, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Te.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, K7 = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    required: !0,
    secret: !0,
    type: "basicAuthInput",
    defaultValue: "",
    additionalProperties: {
      username: {
        label: "Token"
      },
      password: {
        label: "Secret"
      }
    }
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var wd = { exports: {} }, po = {}, E_;
function G7() {
  if (E_) return po;
  E_ = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return po.Fragment = t, po.jsx = s, po.jsxs = s, po;
}
var rl = {}, T_;
function Y7() {
  return T_ || (T_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    rl.Fragment = i, rl.jsx = Un, rl.jsxs = Bn;
  }()), rl;
}
var O_;
function J7() {
  return O_ || (O_ = 1, process.env.NODE_ENV === "production" ? wd.exports = G7() : wd.exports = Y7()), wd.exports;
}
var gn = J7();
const Q7 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, X7 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": Q7
};
function Z7(e) {
  return X7[e] ?? {};
}
const {
  entries: g1,
  setPrototypeOf: R_,
  isFrozen: eG,
  getPrototypeOf: nG,
  getOwnPropertyDescriptor: tG
} = Object;
let {
  freeze: Ht,
  seal: vr,
  create: k1
} = Object, {
  apply: jh,
  construct: wh
} = typeof Reflect < "u" && Reflect;
Ht || (Ht = function(e) {
  return e;
});
vr || (vr = function(e) {
  return e;
});
jh || (jh = function(e, n, t) {
  return e.apply(n, t);
});
wh || (wh = function(e, n) {
  return new e(...n);
});
const il = Wt(Array.prototype.forEach), rG = Wt(Array.prototype.lastIndexOf), D_ = Wt(Array.prototype.pop), fo = Wt(Array.prototype.push), iG = Wt(Array.prototype.splice), El = Wt(String.prototype.toLowerCase), Cd = Wt(String.prototype.toString), P_ = Wt(String.prototype.match), ho = Wt(String.prototype.replace), aG = Wt(String.prototype.indexOf), oG = Wt(String.prototype.trim), Nr = Wt(Object.prototype.hasOwnProperty), Pt = Wt(RegExp.prototype.test), vo = sG(TypeError);
function Wt(e) {
  return function(n) {
    for (var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
      i[a - 1] = arguments[a];
    return jh(e, n, i);
  };
}
function sG(e) {
  return function() {
    for (var n = arguments.length, t = new Array(n), i = 0; i < n; i++)
      t[i] = arguments[i];
    return wh(e, t);
  };
}
function In(e, n) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : El;
  R_ && R_(e, null);
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = t(a);
      o !== a && (eG(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function lG(e) {
  for (let n = 0; n < e.length; n++)
    Nr(e, n) || (e[n] = null);
  return e;
}
function Ti(e) {
  const n = k1(null);
  for (const [t, i] of g1(e))
    Nr(e, t) && (Array.isArray(i) ? n[t] = lG(i) : i && typeof i == "object" && i.constructor === Object ? n[t] = Ti(i) : n[t] = i);
  return n;
}
function yo(e, n) {
  for (; e !== null; ) {
    const i = tG(e, n);
    if (i) {
      if (i.get)
        return Wt(i.get);
      if (typeof i.value == "function")
        return Wt(i.value);
    }
    e = nG(e);
  }
  function t() {
    return null;
  }
  return t;
}
const A_ = Ht(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Fd = Ht(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Id = Ht(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), cG = Ht(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), $d = Ht(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), uG = Ht(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), L_ = Ht(["#text"]), V_ = Ht(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Ed = Ht(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), z_ = Ht(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), al = Ht(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), dG = vr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), mG = vr(/<%[\w\W]*|[\w\W]*%>/gm), pG = vr(/\$\{[\w\W]*/gm), fG = vr(/^data-[\-\w.\u00B7-\uFFFF]+$/), hG = vr(/^aria-[\-\w]+$/), b1 = vr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), vG = vr(/^(?:\w+script|data):/i), yG = vr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), _1 = vr(/^html$/i), gG = vr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var M_ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: hG,
  ATTR_WHITESPACE: yG,
  CUSTOM_ELEMENT: gG,
  DATA_ATTR: fG,
  DOCTYPE_NAME: _1,
  ERB_EXPR: mG,
  IS_ALLOWED_URI: b1,
  IS_SCRIPT_OR_DATA: vG,
  MUSTACHE_EXPR: dG,
  TMPLIT_EXPR: pG
});
const go = {
  element: 1,
  text: 3,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9
}, kG = function() {
  return typeof window > "u" ? null : window;
}, bG = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let t = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (t = n.getAttribute(i));
  const a = "dompurify" + (t ? "#" + t : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, U_ = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function x1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : kG();
  const n = (O) => x1(O);
  if (n.version = "3.2.4", n.removed = [], !e || !e.document || e.document.nodeType !== go.document || !e.Element)
    return n.isSupported = !1, n;
  let {
    document: t
  } = e;
  const i = t, a = i.currentScript, {
    DocumentFragment: o,
    HTMLTemplateElement: s,
    Node: l,
    Element: u,
    NodeFilter: m,
    NamedNodeMap: d = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: f,
    DOMParser: h,
    trustedTypes: v
  } = e, x = u.prototype, S = yo(x, "cloneNode"), N = yo(x, "remove"), j = yo(x, "nextSibling"), y = yo(x, "childNodes"), q = yo(x, "parentNode");
  if (typeof s == "function") {
    const O = t.createElement("template");
    O.content && O.content.ownerDocument && (t = O.content.ownerDocument);
  }
  let E, C = "";
  const {
    implementation: T,
    createNodeIterator: U,
    createDocumentFragment: Z,
    getElementsByTagName: Q
  } = t, {
    importNode: ee
  } = i;
  let J = U_();
  n.isSupported = typeof g1 == "function" && typeof q == "function" && T && T.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: K,
    ERB_EXPR: D,
    TMPLIT_EXPR: G,
    DATA_ATTR: ne,
    ARIA_ATTR: de,
    IS_SCRIPT_OR_DATA: ge,
    ATTR_WHITESPACE: ce,
    CUSTOM_ELEMENT: ve
  } = M_;
  let {
    IS_ALLOWED_URI: H
  } = M_, be = null;
  const je = In({}, [...A_, ...Fd, ...Id, ...$d, ...L_]);
  let W = null;
  const Ue = In({}, [...V_, ...Ed, ...z_, ...al]);
  let Me = Object.seal(k1(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), De = null, Be = null, Ee = !0, Ve = !0, Re = !1, tn = !0, Ne = !1, We = !0, Oe = !1, ue = !1, fe = !1, we = !1, Le = !1, Fe = !1, ln = !0, F = !1;
  const b = "user-content-";
  let $ = !0, Y = !1, X = {}, R = null;
  const B = In({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let te = null;
  const pe = In({}, ["audio", "video", "img", "source", "image", "track"]);
  let _e = null;
  const Ze = In({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), dn = "http://www.w3.org/1998/Math/MathML", nn = "http://www.w3.org/2000/svg", rn = "http://www.w3.org/1999/xhtml";
  let fn = rn, mn = !1, vn = null;
  const Qe = In({}, [dn, nn, rn], Cd);
  let yn = In({}, ["mi", "mo", "mn", "ms", "mtext"]), Pe = In({}, ["annotation-xml"]);
  const sn = In({}, ["title", "style", "font", "a", "script"]);
  let an = null;
  const jn = ["application/xhtml+xml", "text/html"], Hn = "text/html";
  let on = null, Pn = null;
  const wn = t.createElement("form"), xn = function(O) {
    return O instanceof RegExp || O instanceof Function;
  }, Vn = function() {
    let O = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Pn && Pn === O)) {
      if ((!O || typeof O != "object") && (O = {}), O = Ti(O), an = // eslint-disable-next-line unicorn/prefer-includes
      jn.indexOf(O.PARSER_MEDIA_TYPE) === -1 ? Hn : O.PARSER_MEDIA_TYPE, on = an === "application/xhtml+xml" ? Cd : El, be = Nr(O, "ALLOWED_TAGS") ? In({}, O.ALLOWED_TAGS, on) : je, W = Nr(O, "ALLOWED_ATTR") ? In({}, O.ALLOWED_ATTR, on) : Ue, vn = Nr(O, "ALLOWED_NAMESPACES") ? In({}, O.ALLOWED_NAMESPACES, Cd) : Qe, _e = Nr(O, "ADD_URI_SAFE_ATTR") ? In(Ti(Ze), O.ADD_URI_SAFE_ATTR, on) : Ze, te = Nr(O, "ADD_DATA_URI_TAGS") ? In(Ti(pe), O.ADD_DATA_URI_TAGS, on) : pe, R = Nr(O, "FORBID_CONTENTS") ? In({}, O.FORBID_CONTENTS, on) : B, De = Nr(O, "FORBID_TAGS") ? In({}, O.FORBID_TAGS, on) : {}, Be = Nr(O, "FORBID_ATTR") ? In({}, O.FORBID_ATTR, on) : {}, X = Nr(O, "USE_PROFILES") ? O.USE_PROFILES : !1, Ee = O.ALLOW_ARIA_ATTR !== !1, Ve = O.ALLOW_DATA_ATTR !== !1, Re = O.ALLOW_UNKNOWN_PROTOCOLS || !1, tn = O.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ne = O.SAFE_FOR_TEMPLATES || !1, We = O.SAFE_FOR_XML !== !1, Oe = O.WHOLE_DOCUMENT || !1, we = O.RETURN_DOM || !1, Le = O.RETURN_DOM_FRAGMENT || !1, Fe = O.RETURN_TRUSTED_TYPE || !1, fe = O.FORCE_BODY || !1, ln = O.SANITIZE_DOM !== !1, F = O.SANITIZE_NAMED_PROPS || !1, $ = O.KEEP_CONTENT !== !1, Y = O.IN_PLACE || !1, H = O.ALLOWED_URI_REGEXP || b1, fn = O.NAMESPACE || rn, yn = O.MATHML_TEXT_INTEGRATION_POINTS || yn, Pe = O.HTML_INTEGRATION_POINTS || Pe, Me = O.CUSTOM_ELEMENT_HANDLING || {}, O.CUSTOM_ELEMENT_HANDLING && xn(O.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Me.tagNameCheck = O.CUSTOM_ELEMENT_HANDLING.tagNameCheck), O.CUSTOM_ELEMENT_HANDLING && xn(O.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Me.attributeNameCheck = O.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), O.CUSTOM_ELEMENT_HANDLING && typeof O.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (Me.allowCustomizedBuiltInElements = O.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ne && (Ve = !1), Le && (we = !0), X && (be = In({}, L_), W = [], X.html === !0 && (In(be, A_), In(W, V_)), X.svg === !0 && (In(be, Fd), In(W, Ed), In(W, al)), X.svgFilters === !0 && (In(be, Id), In(W, Ed), In(W, al)), X.mathMl === !0 && (In(be, $d), In(W, z_), In(W, al))), O.ADD_TAGS && (be === je && (be = Ti(be)), In(be, O.ADD_TAGS, on)), O.ADD_ATTR && (W === Ue && (W = Ti(W)), In(W, O.ADD_ATTR, on)), O.ADD_URI_SAFE_ATTR && In(_e, O.ADD_URI_SAFE_ATTR, on), O.FORBID_CONTENTS && (R === B && (R = Ti(R)), In(R, O.FORBID_CONTENTS, on)), $ && (be["#text"] = !0), Oe && In(be, ["html", "head", "body"]), be.table && (In(be, ["tbody"]), delete De.tbody), O.TRUSTED_TYPES_POLICY) {
        if (typeof O.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw vo('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof O.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw vo('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        E = O.TRUSTED_TYPES_POLICY, C = E.createHTML("");
      } else
        E === void 0 && (E = bG(v, a)), E !== null && typeof C == "string" && (C = E.createHTML(""));
      Ht && Ht(O), Pn = O;
    }
  }, Mn = In({}, [...Fd, ...Id, ...cG]), Sn = In({}, [...$d, ...uG]), Cn = function(O) {
    let V = q(O);
    (!V || !V.tagName) && (V = {
      namespaceURI: fn,
      tagName: "template"
    });
    const z = El(O.tagName), ae = El(V.tagName);
    return vn[O.namespaceURI] ? O.namespaceURI === nn ? V.namespaceURI === rn ? z === "svg" : V.namespaceURI === dn ? z === "svg" && (ae === "annotation-xml" || yn[ae]) : !!Mn[z] : O.namespaceURI === dn ? V.namespaceURI === rn ? z === "math" : V.namespaceURI === nn ? z === "math" && Pe[ae] : !!Sn[z] : O.namespaceURI === rn ? V.namespaceURI === nn && !Pe[ae] || V.namespaceURI === dn && !yn[ae] ? !1 : !Sn[z] && (sn[z] || !Mn[z]) : !!(an === "application/xhtml+xml" && vn[O.namespaceURI]) : !1;
  }, On = function(O) {
    fo(n.removed, {
      element: O
    });
    try {
      q(O).removeChild(O);
    } catch {
      N(O);
    }
  }, Ln = function(O, V) {
    try {
      fo(n.removed, {
        attribute: V.getAttributeNode(O),
        from: V
      });
    } catch {
      fo(n.removed, {
        attribute: null,
        from: V
      });
    }
    if (V.removeAttribute(O), O === "is")
      if (we || Le)
        try {
          On(V);
        } catch {
        }
      else
        try {
          V.setAttribute(O, "");
        } catch {
        }
  }, Un = function(O) {
    let V = null, z = null;
    if (fe)
      O = "<remove></remove>" + O;
    else {
      const Se = P_(O, /^[\r\n\t ]+/);
      z = Se && Se[0];
    }
    an === "application/xhtml+xml" && fn === rn && (O = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + O + "</body></html>");
    const ae = E ? E.createHTML(O) : O;
    if (fn === rn)
      try {
        V = new h().parseFromString(ae, an);
      } catch {
      }
    if (!V || !V.documentElement) {
      V = T.createDocument(fn, "template", null);
      try {
        V.documentElement.innerHTML = mn ? C : ae;
      } catch {
      }
    }
    const Ie = V.body || V.documentElement;
    return O && z && Ie.insertBefore(t.createTextNode(z), Ie.childNodes[0] || null), fn === rn ? Q.call(V, Oe ? "html" : "body")[0] : Oe ? V.documentElement : Ie;
  }, Bn = function(O) {
    return U.call(
      O.ownerDocument || O,
      O,
      // eslint-disable-next-line no-bitwise
      m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION,
      null
    );
  }, r = function(O) {
    return O instanceof f && (typeof O.nodeName != "string" || typeof O.textContent != "string" || typeof O.removeChild != "function" || !(O.attributes instanceof d) || typeof O.removeAttribute != "function" || typeof O.setAttribute != "function" || typeof O.namespaceURI != "string" || typeof O.insertBefore != "function" || typeof O.hasChildNodes != "function");
  }, c = function(O) {
    return typeof l == "function" && O instanceof l;
  };
  function p(O, V, z) {
    il(O, (ae) => {
      ae.call(n, V, z, Pn);
    });
  }
  const k = function(O) {
    let V = null;
    if (p(J.beforeSanitizeElements, O, null), r(O))
      return On(O), !0;
    const z = on(O.nodeName);
    if (p(J.uponSanitizeElement, O, {
      tagName: z,
      allowedTags: be
    }), O.hasChildNodes() && !c(O.firstElementChild) && Pt(/<[/\w]/g, O.innerHTML) && Pt(/<[/\w]/g, O.textContent) || O.nodeType === go.progressingInstruction || We && O.nodeType === go.comment && Pt(/<[/\w]/g, O.data))
      return On(O), !0;
    if (!be[z] || De[z]) {
      if (!De[z] && L(z) && (Me.tagNameCheck instanceof RegExp && Pt(Me.tagNameCheck, z) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(z)))
        return !1;
      if ($ && !R[z]) {
        const ae = q(O) || O.parentNode, Ie = y(O) || O.childNodes;
        if (Ie && ae) {
          const Se = Ie.length;
          for (let re = Se - 1; re >= 0; --re) {
            const Xe = S(Ie[re], !0);
            Xe.__removalCount = (O.__removalCount || 0) + 1, ae.insertBefore(Xe, j(O));
          }
        }
      }
      return On(O), !0;
    }
    return O instanceof u && !Cn(O) || (z === "noscript" || z === "noembed" || z === "noframes") && Pt(/<\/no(script|embed|frames)/i, O.innerHTML) ? (On(O), !0) : (Ne && O.nodeType === go.text && (V = O.textContent, il([K, D, G], (ae) => {
      V = ho(V, ae, " ");
    }), O.textContent !== V && (fo(n.removed, {
      element: O.cloneNode()
    }), O.textContent = V)), p(J.afterSanitizeElements, O, null), !1);
  }, P = function(O, V, z) {
    if (ln && (V === "id" || V === "name") && (z in t || z in wn))
      return !1;
    if (!(Ve && !Be[V] && Pt(ne, V)) && !(Ee && Pt(de, V))) {
      if (!W[V] || Be[V]) {
        if (
          // First condition does a very basic check if a) it's basically a valid custom element tagname AND
          // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
          !(L(O) && (Me.tagNameCheck instanceof RegExp && Pt(Me.tagNameCheck, O) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(O)) && (Me.attributeNameCheck instanceof RegExp && Pt(Me.attributeNameCheck, V) || Me.attributeNameCheck instanceof Function && Me.attributeNameCheck(V)) || // Alternative, second condition checks if it's an `is`-attribute, AND
          // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
          V === "is" && Me.allowCustomizedBuiltInElements && (Me.tagNameCheck instanceof RegExp && Pt(Me.tagNameCheck, z) || Me.tagNameCheck instanceof Function && Me.tagNameCheck(z)))
        ) return !1;
      } else if (!_e[V] && !Pt(H, ho(z, ce, "")) && !((V === "src" || V === "xlink:href" || V === "href") && O !== "script" && aG(z, "data:") === 0 && te[O]) && !(Re && !Pt(ge, ho(z, ce, ""))) && z)
        return !1;
    }
    return !0;
  }, L = function(O) {
    return O !== "annotation-xml" && P_(O, ve);
  }, I = function(O) {
    p(J.beforeSanitizeAttributes, O, null);
    const {
      attributes: V
    } = O;
    if (!V || r(O))
      return;
    const z = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: W,
      forceKeepAttr: void 0
    };
    let ae = V.length;
    for (; ae--; ) {
      const Ie = V[ae], {
        name: Se,
        namespaceURI: re,
        value: Xe
      } = Ie, $n = on(Se);
      let Nn = Se === "value" ? Xe : oG(Xe);
      if (z.attrName = $n, z.attrValue = Nn, z.keepAttr = !0, z.forceKeepAttr = void 0, p(J.uponSanitizeAttribute, O, z), Nn = z.attrValue, F && ($n === "id" || $n === "name") && (Ln(Se, O), Nn = b + Nn), We && Pt(/((--!?|])>)|<\/(style|title)/i, Nn)) {
        Ln(Se, O);
        continue;
      }
      if (z.forceKeepAttr || (Ln(Se, O), !z.keepAttr))
        continue;
      if (!tn && Pt(/\/>/i, Nn)) {
        Ln(Se, O);
        continue;
      }
      Ne && il([K, D, G], (FF) => {
        Nn = ho(Nn, FF, " ");
      });
      const Ey = on(O.nodeName);
      if (P(Ey, $n, Nn)) {
        if (E && typeof v == "object" && typeof v.getAttributeType == "function" && !re)
          switch (v.getAttributeType(Ey, $n)) {
            case "TrustedHTML": {
              Nn = E.createHTML(Nn);
              break;
            }
            case "TrustedScriptURL": {
              Nn = E.createScriptURL(Nn);
              break;
            }
          }
        try {
          re ? O.setAttributeNS(re, Se, Nn) : O.setAttribute(Se, Nn), r(O) ? On(O) : D_(n.removed);
        } catch {
        }
      }
    }
    p(J.afterSanitizeAttributes, O, null);
  }, w = function O(V) {
    let z = null;
    const ae = Bn(V);
    for (p(J.beforeSanitizeShadowDOM, V, null); z = ae.nextNode(); )
      p(J.uponSanitizeShadowNode, z, null), k(z), I(z), z.content instanceof o && O(z.content);
    p(J.afterSanitizeShadowDOM, V, null);
  };
  return n.sanitize = function(O) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = null, ae = null, Ie = null, Se = null;
    if (mn = !O, mn && (O = "<!-->"), typeof O != "string" && !c(O))
      if (typeof O.toString == "function") {
        if (O = O.toString(), typeof O != "string")
          throw vo("dirty is not a string, aborting");
      } else
        throw vo("toString is not a function");
    if (!n.isSupported)
      return O;
    if (ue || Vn(V), n.removed = [], typeof O == "string" && (Y = !1), Y) {
      if (O.nodeName) {
        const $n = on(O.nodeName);
        if (!be[$n] || De[$n])
          throw vo("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (O instanceof l)
      z = Un("<!---->"), ae = z.ownerDocument.importNode(O, !0), ae.nodeType === go.element && ae.nodeName === "BODY" || ae.nodeName === "HTML" ? z = ae : z.appendChild(ae);
    else {
      if (!we && !Ne && !Oe && // eslint-disable-next-line unicorn/prefer-includes
      O.indexOf("<") === -1)
        return E && Fe ? E.createHTML(O) : O;
      if (z = Un(O), !z)
        return we ? null : Fe ? C : "";
    }
    z && fe && On(z.firstChild);
    const re = Bn(Y ? O : z);
    for (; Ie = re.nextNode(); )
      k(Ie), I(Ie), Ie.content instanceof o && w(Ie.content);
    if (Y)
      return O;
    if (we) {
      if (Le)
        for (Se = Z.call(z.ownerDocument); z.firstChild; )
          Se.appendChild(z.firstChild);
      else
        Se = z;
      return (W.shadowroot || W.shadowrootmode) && (Se = ee.call(i, Se, !0)), Se;
    }
    let Xe = Oe ? z.outerHTML : z.innerHTML;
    return Oe && be["!doctype"] && z.ownerDocument && z.ownerDocument.doctype && z.ownerDocument.doctype.name && Pt(_1, z.ownerDocument.doctype.name) && (Xe = "<!DOCTYPE " + z.ownerDocument.doctype.name + `>
` + Xe), Ne && il([K, D, G], ($n) => {
      Xe = ho(Xe, $n, " ");
    }), E && Fe ? E.createHTML(Xe) : Xe;
  }, n.setConfig = function() {
    let O = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Vn(O), ue = !0;
  }, n.clearConfig = function() {
    Pn = null, ue = !1;
  }, n.isValidAttribute = function(O, V, z) {
    Pn || Vn({});
    const ae = on(O), Ie = on(V);
    return P(ae, Ie, z);
  }, n.addHook = function(O, V) {
    typeof V == "function" && fo(J[O], V);
  }, n.removeHook = function(O, V) {
    if (V !== void 0) {
      const z = rG(J[O], V);
      return z === -1 ? void 0 : iG(J[O], z, 1)[0];
    }
    return D_(J[O]);
  }, n.removeHooks = function(O) {
    J[O] = [];
  }, n.removeAllHooks = function() {
    J = U_();
  }, n;
}
var _G = x1();
const xG = "_messageContainer_1rxr4_1", SG = "_chip_1rxr4_7", NG = "_chipLabel_1rxr4_10", jG = "_chipValue_1rxr4_13", ol = {
  messageContainer: xG,
  chip: SG,
  chipLabel: NG,
  chipValue: jG
}, B_ = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, wG = ({
  messages: e,
  customFields: n,
  attachments: t,
  conversationContext: i
}) => {
  qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: u,
      email: m,
      phone_number: d
    } = i.customer;
    return s ?? l ?? u ?? m ?? d ?? o;
  };
  return /* @__PURE__ */ gn.jsxs(_, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ gn.jsx(_, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ gn.jsxs(_, { gap: "100", children: [
      /* @__PURE__ */ gn.jsx(Je, { content: "Conversation Attributes", children: /* @__PURE__ */ gn.jsx(
        zh,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ gn.jsx(_, { alignItems: "center", children: /* @__PURE__ */ gn.jsx(En, { className: ol.chip, children: /* @__PURE__ */ gn.jsxs(_, { gap: "100", children: [
        /* @__PURE__ */ gn.jsxs(Yn, { className: ol.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ gn.jsx(Yn, { className: ol.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ gn.jsx(
      _,
      {
        className: ol.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? B_[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? B_[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ gn.jsxs(_, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ gn.jsxs(_, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ gn.jsx(A.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ gn.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ gn.jsx(GF, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ gn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: _G.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    t && /* @__PURE__ */ gn.jsx(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: t.map((o, s) => /* @__PURE__ */ gn.jsx(
      YF,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ gn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, CG = "_conversation_1draa_1", FG = "_conversationSubLine_1draa_9", IG = "_modal_1draa_14", Td = {
  conversation: CG,
  conversationSubLine: FG,
  modal: IG
}, $G = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), EG = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, t]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: t?.value ? t.value.toString() : ""
})), TG = ({
  conversation: e,
  conversationContext: n
}) => {
  const [t, i] = oe(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ gn.jsxs(_, { className: Td.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ gn.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ gn.jsxs(_, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ gn.jsxs(_, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ gn.jsx(A.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ gn.jsx(zn, { size: "small", variant: "info", children: Tn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ gn.jsx(
          A.Heading,
          {
            variant: "heading-4",
            className: Td.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ gn.jsx(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ gn.jsx(En, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ gn.jsx(Je, { content: "Show conversation preview", children: /* @__PURE__ */ gn.jsx(
        lr,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ gn.jsxs(
      St,
      {
        isOpen: t,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: Td.modal,
        children: [
          /* @__PURE__ */ gn.jsx(
            Nt,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ gn.jsx(jt, { children: /* @__PURE__ */ gn.jsx(
            wG,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: $G(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: EG(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, OG = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: t
}) => {
  const [i, a] = oe(!1), o = t > 0 ? t : 1, s = e?.length > o, l = Zn(
    () => e?.sort((u, m) => m?.created_at.localeCompare(u?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ gn.jsxs(_, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((u, m) => /* @__PURE__ */ gn.jsx(
      TG,
      {
        conversation: u,
        conversationContext: n
      },
      `${m}-${u?.id}`
    )),
    s && /* @__PURE__ */ gn.jsxs(
      qn,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, RG = Z7(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), DG = ({
  conversationContext: e,
  settings: n
}) => {
  const [t, i] = oe([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((d) => !!d).map((d) => `'${d}'`).join(","), { useQuery: s } = un(), { data: l, loading: u, error: m } = s(RG, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return qe(() => {
    if (l?.Miuros) {
      const d = l?.Miuros?.findTickets?.data;
      d && i(d);
    }
  }, [l]), m ? /* @__PURE__ */ gn.jsx(_n, { error: m }) : u ? /* @__PURE__ */ gn.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ gn.jsx(cn, {}) }) : t?.length === 0 ? /* @__PURE__ */ gn.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ gn.jsx(
    OG,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: t,
      conversationContext: e
    }
  );
}, PG = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    placeholder: "Insert client ID",
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client Secret",
    placeholder: "Insert client secret",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: mc
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    placeholder: "Enter number",
    required: !0,
    defaultValue: "1",
    secret: !1,
    type: "input",
    customValidation: (e) => isNaN(Number.parseInt(e)) ? "Please enter a number" : void 0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Od = { exports: {} }, ko = {}, q_;
function AG() {
  if (q_) return ko;
  q_ = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return ko.Fragment = t, ko.jsx = s, ko.jsxs = s, ko;
}
var sl = {}, H_;
function LG() {
  return H_ || (H_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    sl.Fragment = i, sl.jsx = Un, sl.jsxs = Bn;
  }()), sl;
}
var W_;
function VG() {
  return W_ || (W_ = 1, process.env.NODE_ENV === "production" ? Od.exports = AG() : Od.exports = LG()), Od.exports;
}
var Ce = VG();
const zG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, MG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, UG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, BG = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": zG,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": MG,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": UG
};
function Xv(e) {
  return BG[e] ?? {};
}
const qG = Xv(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), HG = Xv(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), WG = Xv(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function Ch(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const KG = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, S1 = "DD MMM YYYY @ HH:mm", GG = "_list_2c4dq_1", YG = "_listItem_2c4dq_4", JG = "_copyIcon_2c4dq_12", Mi = {
  list: GG,
  listItem: YG,
  copyIcon: JG
}, Fh = ({
  address: e,
  icon: n,
  title: t,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = Ch(), l = 14, {
    first_name: u,
    last_name: m,
    address1: d,
    address2: f,
    city: h,
    zip: v,
    country_code: x
  } = e ?? {}, S = `${u} ${m}`.trim() || void 0, N = `${h} ${v}`.trim() || void 0, j = [S, d, f, N, x].filter(
    Boolean
  );
  return /* @__PURE__ */ Ce.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ce.jsxs(_, { gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(he, { size: l, name: n }),
      i ? /* @__PURE__ */ Ce.jsx(cn, { size: l }) : /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "column", children: [
        t && /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: t }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: j.map((y, q) => /* @__PURE__ */ Ce.jsx(Yn, { children: y }, q)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ce.jsxs(_, { gap: "100", children: [
      a && /* @__PURE__ */ Ce.jsx(Je, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: l,
          name: "exclamation",
          className: Mi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ce.jsx(Je, { content: `Copy ${t ? t.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(j.join(", ")),
          className: Mi.copyIcon
        }
      ) })
    ] })
  ] });
}, QG = "_wrapper_1nher_1", XG = {
  wrapper: QG
}, ZG = ({
  customer: e,
  store: n
}) => {
  const { track: t } = hn(), { isCopied: i, copy: a } = Ch(), { isCopied: o, copy: s } = Ch(), { useQuery: l } = un(), [u, m] = oe(!1), [d, f] = oe(), h = e?.id, { loading: v, error: x } = l(HG, {
    skip: !h,
    variables: {
      customerId: h?.toString()
    },
    onCompleted(Q) {
      const ee = Q?.Recharge?.getAddresses;
      ee?.addresses && ee?.addresses.length > 0 && !v ? (f(ee.addresses[0]), t("recharge:profile:received"), ee.addresses.length > 1 ? m(!0) : m(!1)) : f(void 0);
    }
  });
  if (x)
    return /* @__PURE__ */ Ce.jsx(_n, { error: x });
  if (!e)
    return null;
  const {
    id: S,
    phone: N,
    email: j,
    first_name: y,
    last_name: q,
    created_at: E,
    has_valid_payment_method: C
  } = e, T = 14, U = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${S}` : null, Z = `${y || ""} ${q || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ce.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(_, { className: XG.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-2", children: Z }),
    E && /* @__PURE__ */ Ce.jsxs(_, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: Tn(E).format(S1) })
    ] }),
    j && /* @__PURE__ */ Ce.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(he, { size: T, name: "mail" }),
        /* @__PURE__ */ Ce.jsx(A.ExternalLink, { href: `mailto:${j}`, children: j })
      ] }),
      /* @__PURE__ */ Ce.jsx(Je, { content: "Copy email", children: /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: T,
          name: i ? "done" : "copy",
          onClick: () => a(j),
          className: Mi.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Ce.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(he, { size: T, name: "phone" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: N })
      ] }),
      /* @__PURE__ */ Ce.jsx(Je, { content: "Copy phone number", children: /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: T,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: Mi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ce.jsx(
      Fh,
      {
        address: d,
        icon: "home",
        isLoading: v,
        hasMultipleAddresses: u
      }
    ),
    /* @__PURE__ */ Ce.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(he, { size: T, name: "credit-card" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ce.jsx(
        he,
        {
          size: T,
          name: C ? "check-circle" : "close-circle-filled",
          color: C ? "green.500" : "red.500"
        }
      )
    ] }),
    U && /* @__PURE__ */ Ce.jsxs(_, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(he, { size: T, name: "external-link" }),
      /* @__PURE__ */ Ce.jsx(
        A.ExternalLink,
        {
          href: U,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => t("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, e8 = "_order_1dlaa_1", n8 = "_orderIsOpen_1dlaa_9", t8 = "_orderHeader_1dlaa_12", r8 = "_note_1dlaa_16", ll = {
  order: e8,
  orderIsOpen: n8,
  orderHeader: t8,
  note: r8
}, i8 = ({
  order: e,
  isOpenByDefault: n,
  store: t
}) => {
  const { track: i } = hn(), [a, o] = oe(n), {
    id: s,
    status: l,
    charge: u,
    currency: m,
    note: d,
    created_at: f,
    billing_address: h,
    shipping_address: v,
    total_price: x,
    is_prepaid: S
  } = e, N = 14, j = t ? `https://${t.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, y = u?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ce.jsxs(
    _,
    {
      className: ht(ll.order, {
        [ll.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ce.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ll.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ce.jsxs(_, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ce.jsx(_, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: Tn(f).format(S1) }) }),
                /* @__PURE__ */ Ce.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ce.jsx(
                lr,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ce.jsxs(_, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          d && /* @__PURE__ */ Ce.jsx(Je, { content: "Note", children: /* @__PURE__ */ Ce.jsx(
            A.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: ll.note,
              children: d
            }
          ) }),
          l && /* @__PURE__ */ Ce.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: N, name: "activity" }),
            /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: KG(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: N, name: "credit-card" }),
            /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: S ? "Yes" : "No" })
            ] })
          ] }),
          y && /* @__PURE__ */ Ce.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: N, name: "cog" }),
            /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: y })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(he, { size: N, name: "chart-bar" }),
            /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ce.jsxs(A.Paragraph, { variant: "4", children: [
                x,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsx(
            Fh,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            Fh,
            {
              address: v,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          j && /* @__PURE__ */ Ce.jsx(
            Rt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(j, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ce.jsx(he, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, a8 = ({
  customerId: e,
  store: n
}) => {
  const { track: t } = hn(), { useQuery: i } = un(), [a, o] = oe([]), { loading: s, error: l } = i(WG, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    },
    onCompleted(m) {
      const d = m?.Recharge?.getOrders;
      d?.orders && d?.orders.length > 0 && !s ? o(d.orders) : o([]);
    }
  });
  if (!e)
    return null;
  if (l)
    return /* @__PURE__ */ Ce.jsx(_n, { error: l });
  const u = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !s && /* @__PURE__ */ Ce.jsx(zn, { variant: "success", size: "small", children: a.length })
    ] }),
    /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "column", children: [
      s && /* @__PURE__ */ Ce.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(cn, {}) }),
      !s && a.length === 0 && /* @__PURE__ */ Ce.jsx(
        _,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ce.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !s && a.length > 0 && /* @__PURE__ */ Ce.jsx(_, { gap: "200", flexDirection: "column", children: a.map((m, d) => /* @__PURE__ */ Ce.jsx(
        i8,
        {
          order: m,
          isOpenByDefault: d === 0,
          store: n
        },
        `${d}-${m.id}`
      )) }),
      u && /* @__PURE__ */ Ce.jsx(
        Rt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(u, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ce.jsx(he, { name: "external-link" }),
          onClick: () => t("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, o8 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: t
  } = e, i = t ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ce.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ce.jsxs(He, { className: Mi.list, children: [
      /* @__PURE__ */ Ce.jsx(He.Text, { variant: "dense", className: Mi.listItem, children: /* @__PURE__ */ Ce.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ce.jsx(He.Text, { variant: "dense", className: Mi.listItem, children: /* @__PURE__ */ Ce.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ce.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, s8 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = un(), [i, a] = oe(), [o, s] = oe(), l = e?.customer?.email, u = n.displayCustomerDetails ?? !1, m = n.displaysubscriptionOverview ?? !1, d = n.displayOrders ?? !1, f = !u && !m && !d, { loading: h, error: v } = t(qG, {
    skip: !l,
    variables: {
      email: l
    },
    onCompleted(x) {
      const S = x?.Recharge?.getCustomers, N = x?.Recharge?.getStore;
      S?.customers && S?.customers?.length > 0 && !h ? a(S.customers[0]) : a(void 0), N?.store && !h ? s(N.store) : s(void 0);
    }
  });
  return v ? Ph({ errors: v.graphQLErrors }) ? /* @__PURE__ */ Ce.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Ah({ errors: v.graphQLErrors }) ? /* @__PURE__ */ Ce.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Recharge. Please contact your administrator."
    }
  ) : /* @__PURE__ */ Ce.jsx(_n, { error: v }) : h ? /* @__PURE__ */ Ce.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(cn, {}) }) : i ? f ? /* @__PURE__ */ Ce.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ce.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        u && /* @__PURE__ */ Ce.jsx(ZG, { customer: i, store: o }),
        m && /* @__PURE__ */ Ce.jsx(o8, { customer: i }),
        d && /* @__PURE__ */ Ce.jsx(a8, { customerId: i.id, store: o })
      ]
    }
  ) : /* @__PURE__ */ Ce.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, l8 = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    placeholder: "Insert the Admin API token for Recharge",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var cl = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function N1(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Rd = { exports: {} }, bo = {}, K_;
function c8() {
  if (K_) return bo;
  K_ = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return bo.Fragment = t, bo.jsx = s, bo.jsxs = s, bo;
}
var ul = {}, G_;
function u8() {
  return G_ || (G_ = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    ul.Fragment = i, ul.jsx = Un, ul.jsxs = Bn;
  }()), ul;
}
var Y_;
function d8() {
  return Y_ || (Y_ = 1, process.env.NODE_ENV === "production" ? Rd.exports = c8() : Rd.exports = u8()), Rd.exports;
}
var Ui = d8();
function m8(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Dd, J_;
function Ci() {
  if (J_) return Dd;
  J_ = 1;
  var e = Array.isArray;
  return Dd = e, Dd;
}
var Pd, Q_;
function j1() {
  if (Q_) return Pd;
  Q_ = 1;
  var e = typeof cl == "object" && cl && cl.Object === Object && cl;
  return Pd = e, Pd;
}
var Ad, X_;
function ei() {
  if (X_) return Ad;
  X_ = 1;
  var e = j1(), n = typeof self == "object" && self && self.Object === Object && self, t = e || n || Function("return this")();
  return Ad = t, Ad;
}
var Ld, Z_;
function js() {
  if (Z_) return Ld;
  Z_ = 1;
  var e = ei(), n = e.Symbol;
  return Ld = n, Ld;
}
var Vd, ex;
function p8() {
  if (ex) return Vd;
  ex = 1;
  var e = js(), n = Object.prototype, t = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = t.call(s, a), u = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var d = i.call(s);
    return m && (l ? s[a] = u : delete s[a]), d;
  }
  return Vd = o, Vd;
}
var zd, nx;
function f8() {
  if (nx) return zd;
  nx = 1;
  var e = Object.prototype, n = e.toString;
  function t(i) {
    return n.call(i);
  }
  return zd = t, zd;
}
var Md, tx;
function Ba() {
  if (tx) return Md;
  tx = 1;
  var e = js(), n = p8(), t = f8(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : t(l);
  }
  return Md = s, Md;
}
var Ud, rx;
function Ji() {
  if (rx) return Ud;
  rx = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Ud = e, Ud;
}
var Bd, ix;
function Zv() {
  if (ix) return Bd;
  ix = 1;
  var e = Ba(), n = Ji(), t = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == t;
  }
  return Bd = i, Bd;
}
var qd, ax;
function h8() {
  if (ax) return qd;
  ax = 1;
  var e = Ci(), n = Zv(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !t.test(o) || s != null && o in Object(s);
  }
  return qd = a, qd;
}
var Hd, ox;
function qa() {
  if (ox) return Hd;
  ox = 1;
  function e(n) {
    var t = typeof n;
    return n != null && (t == "object" || t == "function");
  }
  return Hd = e, Hd;
}
var Wd, sx;
function w1() {
  if (sx) return Wd;
  sx = 1;
  var e = Ba(), n = qa(), t = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var u = e(l);
    return u == i || u == a || u == t || u == o;
  }
  return Wd = s, Wd;
}
var Kd, lx;
function v8() {
  if (lx) return Kd;
  lx = 1;
  var e = ei(), n = e["__core-js_shared__"];
  return Kd = n, Kd;
}
var Gd, cx;
function y8() {
  if (cx) return Gd;
  cx = 1;
  var e = v8(), n = function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  }();
  function t(i) {
    return !!n && n in i;
  }
  return Gd = t, Gd;
}
var Yd, ux;
function C1() {
  if (ux) return Yd;
  ux = 1;
  var e = Function.prototype, n = e.toString;
  function t(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return Yd = t, Yd;
}
var Jd, dx;
function g8() {
  if (dx) return Jd;
  dx = 1;
  var e = w1(), n = y8(), t = qa(), i = C1(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, u = s.toString, m = l.hasOwnProperty, d = RegExp(
    "^" + u.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!t(h) || n(h))
      return !1;
    var v = e(h) ? d : o;
    return v.test(i(h));
  }
  return Jd = f, Jd;
}
var Qd, mx;
function k8() {
  if (mx) return Qd;
  mx = 1;
  function e(n, t) {
    return n?.[t];
  }
  return Qd = e, Qd;
}
var Xd, px;
function Qi() {
  if (px) return Xd;
  px = 1;
  var e = g8(), n = k8();
  function t(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Xd = t, Xd;
}
var Zd, fx;
function Gc() {
  if (fx) return Zd;
  fx = 1;
  var e = Qi(), n = e(Object, "create");
  return Zd = n, Zd;
}
var em, hx;
function b8() {
  if (hx) return em;
  hx = 1;
  var e = Gc();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return em = n, em;
}
var nm, vx;
function _8() {
  if (vx) return nm;
  vx = 1;
  function e(n) {
    var t = this.has(n) && delete this.__data__[n];
    return this.size -= t ? 1 : 0, t;
  }
  return nm = e, nm;
}
var tm, yx;
function x8() {
  if (yx) return tm;
  yx = 1;
  var e = Gc(), n = "__lodash_hash_undefined__", t = Object.prototype, i = t.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return tm = a, tm;
}
var rm, gx;
function S8() {
  if (gx) return rm;
  gx = 1;
  var e = Gc(), n = Object.prototype, t = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : t.call(o, a);
  }
  return rm = i, rm;
}
var im, kx;
function N8() {
  if (kx) return im;
  kx = 1;
  var e = Gc(), n = "__lodash_hash_undefined__";
  function t(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return im = t, im;
}
var am, bx;
function j8() {
  if (bx) return am;
  bx = 1;
  var e = b8(), n = _8(), t = x8(), i = S8(), a = N8();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, am = o, am;
}
var om, _x;
function w8() {
  if (_x) return om;
  _x = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return om = e, om;
}
var sm, xx;
function F1() {
  if (xx) return sm;
  xx = 1;
  function e(n, t) {
    return n === t || n !== n && t !== t;
  }
  return sm = e, sm;
}
var lm, Sx;
function Yc() {
  if (Sx) return lm;
  Sx = 1;
  var e = F1();
  function n(t, i) {
    for (var a = t.length; a--; )
      if (e(t[a][0], i))
        return a;
    return -1;
  }
  return lm = n, lm;
}
var cm, Nx;
function C8() {
  if (Nx) return cm;
  Nx = 1;
  var e = Yc(), n = Array.prototype, t = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : t.call(o, s, 1), --this.size, !0;
  }
  return cm = i, cm;
}
var um, jx;
function F8() {
  if (jx) return um;
  jx = 1;
  var e = Yc();
  function n(t) {
    var i = this.__data__, a = e(i, t);
    return a < 0 ? void 0 : i[a][1];
  }
  return um = n, um;
}
var dm, wx;
function I8() {
  if (wx) return dm;
  wx = 1;
  var e = Yc();
  function n(t) {
    return e(this.__data__, t) > -1;
  }
  return dm = n, dm;
}
var mm, Cx;
function $8() {
  if (Cx) return mm;
  Cx = 1;
  var e = Yc();
  function n(t, i) {
    var a = this.__data__, o = e(a, t);
    return o < 0 ? (++this.size, a.push([t, i])) : a[o][1] = i, this;
  }
  return mm = n, mm;
}
var pm, Fx;
function Jc() {
  if (Fx) return pm;
  Fx = 1;
  var e = w8(), n = C8(), t = F8(), i = I8(), a = $8();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, pm = o, pm;
}
var fm, Ix;
function ey() {
  if (Ix) return fm;
  Ix = 1;
  var e = Qi(), n = ei(), t = e(n, "Map");
  return fm = t, fm;
}
var hm, $x;
function E8() {
  if ($x) return hm;
  $x = 1;
  var e = j8(), n = Jc(), t = ey();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || n)(),
      string: new e()
    };
  }
  return hm = i, hm;
}
var vm, Ex;
function T8() {
  if (Ex) return vm;
  Ex = 1;
  function e(n) {
    var t = typeof n;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? n !== "__proto__" : n === null;
  }
  return vm = e, vm;
}
var ym, Tx;
function Qc() {
  if (Tx) return ym;
  Tx = 1;
  var e = T8();
  function n(t, i) {
    var a = t.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return ym = n, ym;
}
var gm, Ox;
function O8() {
  if (Ox) return gm;
  Ox = 1;
  var e = Qc();
  function n(t) {
    var i = e(this, t).delete(t);
    return this.size -= i ? 1 : 0, i;
  }
  return gm = n, gm;
}
var km, Rx;
function R8() {
  if (Rx) return km;
  Rx = 1;
  var e = Qc();
  function n(t) {
    return e(this, t).get(t);
  }
  return km = n, km;
}
var bm, Dx;
function D8() {
  if (Dx) return bm;
  Dx = 1;
  var e = Qc();
  function n(t) {
    return e(this, t).has(t);
  }
  return bm = n, bm;
}
var _m, Px;
function P8() {
  if (Px) return _m;
  Px = 1;
  var e = Qc();
  function n(t, i) {
    var a = e(this, t), o = a.size;
    return a.set(t, i), this.size += a.size == o ? 0 : 1, this;
  }
  return _m = n, _m;
}
var xm, Ax;
function I1() {
  if (Ax) return xm;
  Ax = 1;
  var e = E8(), n = O8(), t = R8(), i = D8(), a = P8();
  function o(s) {
    var l = -1, u = s == null ? 0 : s.length;
    for (this.clear(); ++l < u; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = t, o.prototype.has = i, o.prototype.set = a, xm = o, xm;
}
var Sm, Lx;
function A8() {
  if (Lx) return Sm;
  Lx = 1;
  var e = I1(), n = "Expected a function";
  function t(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], u = o.cache;
      if (u.has(l))
        return u.get(l);
      var m = i.apply(this, s);
      return o.cache = u.set(l, m) || u, m;
    };
    return o.cache = new (t.Cache || e)(), o;
  }
  return t.Cache = e, Sm = t, Sm;
}
var Nm, Vx;
function L8() {
  if (Vx) return Nm;
  Vx = 1;
  var e = A8(), n = 500;
  function t(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return Nm = t, Nm;
}
var jm, zx;
function V8() {
  if (zx) return jm;
  zx = 1;
  var e = L8(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, u, m) {
      o.push(u ? m.replace(t, "$1") : l || s);
    }), o;
  });
  return jm = i, jm;
}
var wm, Mx;
function $1() {
  if (Mx) return wm;
  Mx = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = t(n[i], i, n);
    return o;
  }
  return wm = e, wm;
}
var Cm, Ux;
function z8() {
  if (Ux) return Cm;
  Ux = 1;
  var e = js(), n = $1(), t = Ci(), i = Zv(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (t(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var u = l + "";
    return u == "0" && 1 / l == -1 / 0 ? "-0" : u;
  }
  return Cm = s, Cm;
}
var Fm, Bx;
function M8() {
  if (Bx) return Fm;
  Bx = 1;
  var e = z8();
  function n(t) {
    return t == null ? "" : e(t);
  }
  return Fm = n, Fm;
}
var Im, qx;
function Ha() {
  if (qx) return Im;
  qx = 1;
  var e = Ci(), n = h8(), t = V8(), i = M8();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : t(i(o));
  }
  return Im = a, Im;
}
var $m, Hx;
function Xc() {
  if (Hx) return $m;
  Hx = 1;
  var e = Zv();
  function n(t) {
    if (typeof t == "string" || e(t))
      return t;
    var i = t + "";
    return i == "0" && 1 / t == -1 / 0 ? "-0" : i;
  }
  return $m = n, $m;
}
var Em, Wx;
function E1() {
  if (Wx) return Em;
  Wx = 1;
  var e = Ha(), n = Xc();
  function t(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Em = t, Em;
}
var Tm, Kx;
function T1() {
  if (Kx) return Tm;
  Kx = 1;
  var e = Qi(), n = function() {
    try {
      var t = e(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  }();
  return Tm = n, Tm;
}
var Om, Gx;
function O1() {
  if (Gx) return Om;
  Gx = 1;
  var e = T1();
  function n(t, i, a) {
    i == "__proto__" && e ? e(t, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : t[i] = a;
  }
  return Om = n, Om;
}
var Rm, Yx;
function ny() {
  if (Yx) return Rm;
  Yx = 1;
  var e = O1(), n = F1(), t = Object.prototype, i = t.hasOwnProperty;
  function a(o, s, l) {
    var u = o[s];
    (!(i.call(o, s) && n(u, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Rm = a, Rm;
}
var Dm, Jx;
function ty() {
  if (Jx) return Dm;
  Jx = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function t(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Dm = t, Dm;
}
var Pm, Qx;
function U8() {
  if (Qx) return Pm;
  Qx = 1;
  var e = ny(), n = Ha(), t = ty(), i = qa(), a = Xc();
  function o(s, l, u, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var d = -1, f = l.length, h = f - 1, v = s; v != null && ++d < f; ) {
      var x = a(l[d]), S = u;
      if (x === "__proto__" || x === "constructor" || x === "prototype")
        return s;
      if (d != h) {
        var N = v[x];
        S = m ? m(N, x, v) : void 0, S === void 0 && (S = i(N) ? N : t(l[d + 1]) ? [] : {});
      }
      e(v, x, S), v = v[x];
    }
    return s;
  }
  return Pm = o, Pm;
}
var Am, Xx;
function B8() {
  if (Xx) return Am;
  Xx = 1;
  var e = E1(), n = U8(), t = Ha();
  function i(a, o, s) {
    for (var l = -1, u = o.length, m = {}; ++l < u; ) {
      var d = o[l], f = e(a, d);
      s(f, d) && n(m, t(d, a), f);
    }
    return m;
  }
  return Am = i, Am;
}
var Lm, Zx;
function q8() {
  if (Zx) return Lm;
  Zx = 1;
  function e(n, t) {
    return n != null && t in Object(n);
  }
  return Lm = e, Lm;
}
var Vm, eS;
function H8() {
  if (eS) return Vm;
  eS = 1;
  var e = Ba(), n = Ji(), t = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return Vm = i, Vm;
}
var zm, nS;
function ry() {
  if (nS) return zm;
  nS = 1;
  var e = H8(), n = Ji(), t = Object.prototype, i = t.hasOwnProperty, a = t.propertyIsEnumerable, o = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return zm = o, zm;
}
var Mm, tS;
function iy() {
  if (tS) return Mm;
  tS = 1;
  var e = 9007199254740991;
  function n(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return Mm = n, Mm;
}
var Um, rS;
function W8() {
  if (rS) return Um;
  rS = 1;
  var e = Ha(), n = ry(), t = Ci(), i = ty(), a = iy(), o = Xc();
  function s(l, u, m) {
    u = e(u, l);
    for (var d = -1, f = u.length, h = !1; ++d < f; ) {
      var v = o(u[d]);
      if (!(h = l != null && m(l, v)))
        break;
      l = l[v];
    }
    return h || ++d != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(v, f) && (t(l) || n(l)));
  }
  return Um = s, Um;
}
var Bm, iS;
function K8() {
  if (iS) return Bm;
  iS = 1;
  var e = q8(), n = W8();
  function t(i, a) {
    return i != null && n(i, a, e);
  }
  return Bm = t, Bm;
}
var qm, aS;
function G8() {
  if (aS) return qm;
  aS = 1;
  var e = B8(), n = K8();
  function t(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return qm = t, qm;
}
var Hm, oS;
function ay() {
  if (oS) return Hm;
  oS = 1;
  function e(n, t) {
    for (var i = -1, a = t.length, o = n.length; ++i < a; )
      n[o + i] = t[i];
    return n;
  }
  return Hm = e, Hm;
}
var Wm, sS;
function Y8() {
  if (sS) return Wm;
  sS = 1;
  var e = js(), n = ry(), t = Ci(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return t(o) || n(o) || !!(i && o && o[i]);
  }
  return Wm = a, Wm;
}
var Km, lS;
function J8() {
  if (lS) return Km;
  lS = 1;
  var e = ay(), n = Y8();
  function t(i, a, o, s, l) {
    var u = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++u < m; ) {
      var d = i[u];
      a > 0 && o(d) ? a > 1 ? t(d, a - 1, o, s, l) : e(l, d) : s || (l[l.length] = d);
    }
    return l;
  }
  return Km = t, Km;
}
var Gm, cS;
function Q8() {
  if (cS) return Gm;
  cS = 1;
  var e = J8();
  function n(t) {
    var i = t == null ? 0 : t.length;
    return i ? e(t, 1) : [];
  }
  return Gm = n, Gm;
}
var Ym, uS;
function X8() {
  if (uS) return Ym;
  uS = 1;
  function e(n, t, i) {
    switch (i.length) {
      case 0:
        return n.call(t);
      case 1:
        return n.call(t, i[0]);
      case 2:
        return n.call(t, i[0], i[1]);
      case 3:
        return n.call(t, i[0], i[1], i[2]);
    }
    return n.apply(t, i);
  }
  return Ym = e, Ym;
}
var Jm, dS;
function Z8() {
  if (dS) return Jm;
  dS = 1;
  var e = X8(), n = Math.max;
  function t(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, u = n(s.length - a, 0), m = Array(u); ++l < u; )
        m[l] = s[a + l];
      l = -1;
      for (var d = Array(a + 1); ++l < a; )
        d[l] = s[l];
      return d[a] = o(m), e(i, this, d);
    };
  }
  return Jm = t, Jm;
}
var Qm, mS;
function eY() {
  if (mS) return Qm;
  mS = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Qm = e, Qm;
}
var Xm, pS;
function R1() {
  if (pS) return Xm;
  pS = 1;
  function e(n) {
    return n;
  }
  return Xm = e, Xm;
}
var Zm, fS;
function nY() {
  if (fS) return Zm;
  fS = 1;
  var e = eY(), n = T1(), t = R1(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : t;
  return Zm = i, Zm;
}
var ep, hS;
function tY() {
  if (hS) return ep;
  hS = 1;
  var e = 800, n = 16, t = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = t(), u = n - (l - s);
      if (s = l, u > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return ep = i, ep;
}
var np, vS;
function rY() {
  if (vS) return np;
  vS = 1;
  var e = nY(), n = tY(), t = n(e);
  return np = t, np;
}
var tp, yS;
function D1() {
  if (yS) return tp;
  yS = 1;
  var e = Q8(), n = Z8(), t = rY();
  function i(a) {
    return t(n(a, void 0, e), a + "");
  }
  return tp = i, tp;
}
var rp, gS;
function iY() {
  if (gS) return rp;
  gS = 1;
  var e = G8(), n = D1(), t = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return rp = t, rp;
}
var aY = iY();
const P1 = /* @__PURE__ */ N1(aY), oY = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function A1(e) {
  const n = P1(e, oY);
  return {
    controller: Tv(n),
    controllerProps: n
  };
}
const sY = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function L1(e) {
  const { controller: n, controllerProps: t } = A1(e), i = {
    ...P1(e, sY),
    required: m8(t.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: t.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: t,
    fieldWrapperProps: i
  };
}
var ip, kS;
function lY() {
  if (kS) return ip;
  kS = 1;
  var e = Jc();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return ip = n, ip;
}
var ap, bS;
function cY() {
  if (bS) return ap;
  bS = 1;
  function e(n) {
    var t = this.__data__, i = t.delete(n);
    return this.size = t.size, i;
  }
  return ap = e, ap;
}
var op, _S;
function uY() {
  if (_S) return op;
  _S = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return op = e, op;
}
var sp, xS;
function dY() {
  if (xS) return sp;
  xS = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return sp = e, sp;
}
var lp, SS;
function mY() {
  if (SS) return lp;
  SS = 1;
  var e = Jc(), n = ey(), t = I1(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var u = l.__data__;
      if (!n || u.length < i - 1)
        return u.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new t(u);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return lp = a, lp;
}
var cp, NS;
function pY() {
  if (NS) return cp;
  NS = 1;
  var e = Jc(), n = lY(), t = cY(), i = uY(), a = dY(), o = mY();
  function s(l) {
    var u = this.__data__ = new e(l);
    this.size = u.size;
  }
  return s.prototype.clear = n, s.prototype.delete = t, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, cp = s, cp;
}
var up, jS;
function fY() {
  if (jS) return up;
  jS = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && t(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return up = e, up;
}
var dp, wS;
function ws() {
  if (wS) return dp;
  wS = 1;
  var e = ny(), n = O1();
  function t(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var u = -1, m = a.length; ++u < m; ) {
      var d = a[u], f = s ? s(o[d], i[d], d, o, i) : void 0;
      f === void 0 && (f = i[d]), l ? n(o, d, f) : e(o, d, f);
    }
    return o;
  }
  return dp = t, dp;
}
var mp, CS;
function hY() {
  if (CS) return mp;
  CS = 1;
  function e(n, t) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = t(i);
    return a;
  }
  return mp = e, mp;
}
var Tl = { exports: {} }, pp, FS;
function vY() {
  if (FS) return pp;
  FS = 1;
  function e() {
    return !1;
  }
  return pp = e, pp;
}
Tl.exports;
var IS;
function V1() {
  return IS || (IS = 1, function(e, n) {
    var t = ei(), i = vY(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? t.Buffer : void 0, u = l ? l.isBuffer : void 0, m = u || i;
    e.exports = m;
  }(Tl, Tl.exports)), Tl.exports;
}
var fp, $S;
function yY() {
  if ($S) return fp;
  $S = 1;
  var e = Ba(), n = iy(), t = Ji(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", u = "[object Function]", m = "[object Map]", d = "[object Number]", f = "[object Object]", h = "[object RegExp]", v = "[object Set]", x = "[object String]", S = "[object WeakMap]", N = "[object ArrayBuffer]", j = "[object DataView]", y = "[object Float32Array]", q = "[object Float64Array]", E = "[object Int8Array]", C = "[object Int16Array]", T = "[object Int32Array]", U = "[object Uint8Array]", Z = "[object Uint8ClampedArray]", Q = "[object Uint16Array]", ee = "[object Uint32Array]", J = {};
  J[y] = J[q] = J[E] = J[C] = J[T] = J[U] = J[Z] = J[Q] = J[ee] = !0, J[i] = J[a] = J[N] = J[o] = J[j] = J[s] = J[l] = J[u] = J[m] = J[d] = J[f] = J[h] = J[v] = J[x] = J[S] = !1;
  function K(D) {
    return t(D) && n(D.length) && !!J[e(D)];
  }
  return fp = K, fp;
}
var hp, ES;
function oy() {
  if (ES) return hp;
  ES = 1;
  function e(n) {
    return function(t) {
      return n(t);
    };
  }
  return hp = e, hp;
}
var Ol = { exports: {} };
Ol.exports;
var TS;
function sy() {
  return TS || (TS = 1, function(e, n) {
    var t = j1(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && t.process, l = function() {
      try {
        var u = a && a.require && a.require("util").types;
        return u || s && s.binding && s.binding("util");
      } catch {
      }
    }();
    e.exports = l;
  }(Ol, Ol.exports)), Ol.exports;
}
var vp, OS;
function gY() {
  if (OS) return vp;
  OS = 1;
  var e = yY(), n = oy(), t = sy(), i = t && t.isTypedArray, a = i ? n(i) : e;
  return vp = a, vp;
}
var yp, RS;
function z1() {
  if (RS) return yp;
  RS = 1;
  var e = hY(), n = ry(), t = Ci(), i = V1(), a = ty(), o = gY(), s = Object.prototype, l = s.hasOwnProperty;
  function u(m, d) {
    var f = t(m), h = !f && n(m), v = !f && !h && i(m), x = !f && !h && !v && o(m), S = f || h || v || x, N = S ? e(m.length, String) : [], j = N.length;
    for (var y in m)
      (d || l.call(m, y)) && !(S && // Safari 9 has enumerable `arguments.length` in strict mode.
      (y == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      v && (y == "offset" || y == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      x && (y == "buffer" || y == "byteLength" || y == "byteOffset") || // Skip index properties.
      a(y, j))) && N.push(y);
    return N;
  }
  return yp = u, yp;
}
var gp, DS;
function ly() {
  if (DS) return gp;
  DS = 1;
  var e = Object.prototype;
  function n(t) {
    var i = t && t.constructor, a = typeof i == "function" && i.prototype || e;
    return t === a;
  }
  return gp = n, gp;
}
var kp, PS;
function M1() {
  if (PS) return kp;
  PS = 1;
  function e(n, t) {
    return function(i) {
      return n(t(i));
    };
  }
  return kp = e, kp;
}
var bp, AS;
function kY() {
  if (AS) return bp;
  AS = 1;
  var e = M1(), n = e(Object.keys, Object);
  return bp = n, bp;
}
var _p, LS;
function bY() {
  if (LS) return _p;
  LS = 1;
  var e = ly(), n = kY(), t = Object.prototype, i = t.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return _p = a, _p;
}
var xp, VS;
function U1() {
  if (VS) return xp;
  VS = 1;
  var e = w1(), n = iy();
  function t(i) {
    return i != null && n(i.length) && !e(i);
  }
  return xp = t, xp;
}
var Sp, zS;
function cy() {
  if (zS) return Sp;
  zS = 1;
  var e = z1(), n = bY(), t = U1();
  function i(a) {
    return t(a) ? e(a) : n(a);
  }
  return Sp = i, Sp;
}
var Np, MS;
function _Y() {
  if (MS) return Np;
  MS = 1;
  var e = ws(), n = cy();
  function t(i, a) {
    return i && e(a, n(a), i);
  }
  return Np = t, Np;
}
var jp, US;
function xY() {
  if (US) return jp;
  US = 1;
  function e(n) {
    var t = [];
    if (n != null)
      for (var i in Object(n))
        t.push(i);
    return t;
  }
  return jp = e, jp;
}
var wp, BS;
function SY() {
  if (BS) return wp;
  BS = 1;
  var e = qa(), n = ly(), t = xY(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return t(s);
    var l = n(s), u = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || u.push(m);
    return u;
  }
  return wp = o, wp;
}
var Cp, qS;
function uy() {
  if (qS) return Cp;
  qS = 1;
  var e = z1(), n = SY(), t = U1();
  function i(a) {
    return t(a) ? e(a, !0) : n(a);
  }
  return Cp = i, Cp;
}
var Fp, HS;
function NY() {
  if (HS) return Fp;
  HS = 1;
  var e = ws(), n = uy();
  function t(i, a) {
    return i && e(a, n(a), i);
  }
  return Fp = t, Fp;
}
var Rl = { exports: {} };
Rl.exports;
var WS;
function jY() {
  return WS || (WS = 1, function(e, n) {
    var t = ei(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? t.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function u(m, d) {
      if (d)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = u;
  }(Rl, Rl.exports)), Rl.exports;
}
var Ip, KS;
function wY() {
  if (KS) return Ip;
  KS = 1;
  function e(n, t) {
    var i = -1, a = n.length;
    for (t || (t = Array(a)); ++i < a; )
      t[i] = n[i];
    return t;
  }
  return Ip = e, Ip;
}
var $p, GS;
function CY() {
  if (GS) return $p;
  GS = 1;
  function e(n, t) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      t(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return $p = e, $p;
}
var Ep, YS;
function B1() {
  if (YS) return Ep;
  YS = 1;
  function e() {
    return [];
  }
  return Ep = e, Ep;
}
var Tp, JS;
function dy() {
  if (JS) return Tp;
  JS = 1;
  var e = CY(), n = B1(), t = Object.prototype, i = t.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Tp = o, Tp;
}
var Op, QS;
function FY() {
  if (QS) return Op;
  QS = 1;
  var e = ws(), n = dy();
  function t(i, a) {
    return e(i, n(i), a);
  }
  return Op = t, Op;
}
var Rp, XS;
function my() {
  if (XS) return Rp;
  XS = 1;
  var e = M1(), n = e(Object.getPrototypeOf, Object);
  return Rp = n, Rp;
}
var Dp, ZS;
function q1() {
  if (ZS) return Dp;
  ZS = 1;
  var e = ay(), n = my(), t = dy(), i = B1(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, t(s)), s = n(s);
    return l;
  } : i;
  return Dp = o, Dp;
}
var Pp, e0;
function IY() {
  if (e0) return Pp;
  e0 = 1;
  var e = ws(), n = q1();
  function t(i, a) {
    return e(i, n(i), a);
  }
  return Pp = t, Pp;
}
var Ap, n0;
function H1() {
  if (n0) return Ap;
  n0 = 1;
  var e = ay(), n = Ci();
  function t(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Ap = t, Ap;
}
var Lp, t0;
function $Y() {
  if (t0) return Lp;
  t0 = 1;
  var e = H1(), n = dy(), t = cy();
  function i(a) {
    return e(a, t, n);
  }
  return Lp = i, Lp;
}
var Vp, r0;
function W1() {
  if (r0) return Vp;
  r0 = 1;
  var e = H1(), n = q1(), t = uy();
  function i(a) {
    return e(a, t, n);
  }
  return Vp = i, Vp;
}
var zp, i0;
function EY() {
  if (i0) return zp;
  i0 = 1;
  var e = Qi(), n = ei(), t = e(n, "DataView");
  return zp = t, zp;
}
var Mp, a0;
function TY() {
  if (a0) return Mp;
  a0 = 1;
  var e = Qi(), n = ei(), t = e(n, "Promise");
  return Mp = t, Mp;
}
var Up, o0;
function OY() {
  if (o0) return Up;
  o0 = 1;
  var e = Qi(), n = ei(), t = e(n, "Set");
  return Up = t, Up;
}
var Bp, s0;
function RY() {
  if (s0) return Bp;
  s0 = 1;
  var e = Qi(), n = ei(), t = e(n, "WeakMap");
  return Bp = t, Bp;
}
var qp, l0;
function py() {
  if (l0) return qp;
  l0 = 1;
  var e = EY(), n = ey(), t = TY(), i = OY(), a = RY(), o = Ba(), s = C1(), l = "[object Map]", u = "[object Object]", m = "[object Promise]", d = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", v = s(e), x = s(n), S = s(t), N = s(i), j = s(a), y = o;
  return (e && y(new e(new ArrayBuffer(1))) != h || n && y(new n()) != l || t && y(t.resolve()) != m || i && y(new i()) != d || a && y(new a()) != f) && (y = function(q) {
    var E = o(q), C = E == u ? q.constructor : void 0, T = C ? s(C) : "";
    if (T)
      switch (T) {
        case v:
          return h;
        case x:
          return l;
        case S:
          return m;
        case N:
          return d;
        case j:
          return f;
      }
    return E;
  }), qp = y, qp;
}
var Hp, c0;
function DY() {
  if (c0) return Hp;
  c0 = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function t(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return Hp = t, Hp;
}
var Wp, u0;
function PY() {
  if (u0) return Wp;
  u0 = 1;
  var e = ei(), n = e.Uint8Array;
  return Wp = n, Wp;
}
var Kp, d0;
function fy() {
  if (d0) return Kp;
  d0 = 1;
  var e = PY();
  function n(t) {
    var i = new t.constructor(t.byteLength);
    return new e(i).set(new e(t)), i;
  }
  return Kp = n, Kp;
}
var Gp, m0;
function AY() {
  if (m0) return Gp;
  m0 = 1;
  var e = fy();
  function n(t, i) {
    var a = i ? e(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.byteLength);
  }
  return Gp = n, Gp;
}
var Yp, p0;
function LY() {
  if (p0) return Yp;
  p0 = 1;
  var e = /\w*$/;
  function n(t) {
    var i = new t.constructor(t.source, e.exec(t));
    return i.lastIndex = t.lastIndex, i;
  }
  return Yp = n, Yp;
}
var Jp, f0;
function VY() {
  if (f0) return Jp;
  f0 = 1;
  var e = js(), n = e ? e.prototype : void 0, t = n ? n.valueOf : void 0;
  function i(a) {
    return t ? Object(t.call(a)) : {};
  }
  return Jp = i, Jp;
}
var Qp, h0;
function zY() {
  if (h0) return Qp;
  h0 = 1;
  var e = fy();
  function n(t, i) {
    var a = i ? e(t.buffer) : t.buffer;
    return new t.constructor(a, t.byteOffset, t.length);
  }
  return Qp = n, Qp;
}
var Xp, v0;
function MY() {
  if (v0) return Xp;
  v0 = 1;
  var e = fy(), n = AY(), t = LY(), i = VY(), a = zY(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", u = "[object Number]", m = "[object RegExp]", d = "[object Set]", f = "[object String]", h = "[object Symbol]", v = "[object ArrayBuffer]", x = "[object DataView]", S = "[object Float32Array]", N = "[object Float64Array]", j = "[object Int8Array]", y = "[object Int16Array]", q = "[object Int32Array]", E = "[object Uint8Array]", C = "[object Uint8ClampedArray]", T = "[object Uint16Array]", U = "[object Uint32Array]";
  function Z(Q, ee, J) {
    var K = Q.constructor;
    switch (ee) {
      case v:
        return e(Q);
      case o:
      case s:
        return new K(+Q);
      case x:
        return n(Q, J);
      case S:
      case N:
      case j:
      case y:
      case q:
      case E:
      case C:
      case T:
      case U:
        return a(Q, J);
      case l:
        return new K();
      case u:
      case f:
        return new K(Q);
      case m:
        return t(Q);
      case d:
        return new K();
      case h:
        return i(Q);
    }
  }
  return Xp = Z, Xp;
}
var Zp, y0;
function UY() {
  if (y0) return Zp;
  y0 = 1;
  var e = qa(), n = Object.create, t = /* @__PURE__ */ function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  }();
  return Zp = t, Zp;
}
var ef, g0;
function BY() {
  if (g0) return ef;
  g0 = 1;
  var e = UY(), n = my(), t = ly();
  function i(a) {
    return typeof a.constructor == "function" && !t(a) ? e(n(a)) : {};
  }
  return ef = i, ef;
}
var nf, k0;
function qY() {
  if (k0) return nf;
  k0 = 1;
  var e = py(), n = Ji(), t = "[object Map]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return nf = i, nf;
}
var tf, b0;
function HY() {
  if (b0) return tf;
  b0 = 1;
  var e = qY(), n = oy(), t = sy(), i = t && t.isMap, a = i ? n(i) : e;
  return tf = a, tf;
}
var rf, _0;
function WY() {
  if (_0) return rf;
  _0 = 1;
  var e = py(), n = Ji(), t = "[object Set]";
  function i(a) {
    return n(a) && e(a) == t;
  }
  return rf = i, rf;
}
var af, x0;
function KY() {
  if (x0) return af;
  x0 = 1;
  var e = WY(), n = oy(), t = sy(), i = t && t.isSet, a = i ? n(i) : e;
  return af = a, af;
}
var of, S0;
function GY() {
  if (S0) return of;
  S0 = 1;
  var e = pY(), n = fY(), t = ny(), i = _Y(), a = NY(), o = jY(), s = wY(), l = FY(), u = IY(), m = $Y(), d = W1(), f = py(), h = DY(), v = MY(), x = BY(), S = Ci(), N = V1(), j = HY(), y = qa(), q = KY(), E = cy(), C = uy(), T = 1, U = 2, Z = 4, Q = "[object Arguments]", ee = "[object Array]", J = "[object Boolean]", K = "[object Date]", D = "[object Error]", G = "[object Function]", ne = "[object GeneratorFunction]", de = "[object Map]", ge = "[object Number]", ce = "[object Object]", ve = "[object RegExp]", H = "[object Set]", be = "[object String]", je = "[object Symbol]", W = "[object WeakMap]", Ue = "[object ArrayBuffer]", Me = "[object DataView]", De = "[object Float32Array]", Be = "[object Float64Array]", Ee = "[object Int8Array]", Ve = "[object Int16Array]", Re = "[object Int32Array]", tn = "[object Uint8Array]", Ne = "[object Uint8ClampedArray]", We = "[object Uint16Array]", Oe = "[object Uint32Array]", ue = {};
  ue[Q] = ue[ee] = ue[Ue] = ue[Me] = ue[J] = ue[K] = ue[De] = ue[Be] = ue[Ee] = ue[Ve] = ue[Re] = ue[de] = ue[ge] = ue[ce] = ue[ve] = ue[H] = ue[be] = ue[je] = ue[tn] = ue[Ne] = ue[We] = ue[Oe] = !0, ue[D] = ue[G] = ue[W] = !1;
  function fe(we, Le, Fe, ln, F, b) {
    var $, Y = Le & T, X = Le & U, R = Le & Z;
    if (Fe && ($ = F ? Fe(we, ln, F, b) : Fe(we)), $ !== void 0)
      return $;
    if (!y(we))
      return we;
    var B = S(we);
    if (B) {
      if ($ = h(we), !Y)
        return s(we, $);
    } else {
      var te = f(we), pe = te == G || te == ne;
      if (N(we))
        return o(we, Y);
      if (te == ce || te == Q || pe && !F) {
        if ($ = X || pe ? {} : x(we), !Y)
          return X ? u(we, a($, we)) : l(we, i($, we));
      } else {
        if (!ue[te])
          return F ? we : {};
        $ = v(we, te, Y);
      }
    }
    b || (b = new e());
    var _e = b.get(we);
    if (_e)
      return _e;
    b.set(we, $), q(we) ? we.forEach(function(nn) {
      $.add(fe(nn, Le, Fe, nn, we, b));
    }) : j(we) && we.forEach(function(nn, rn) {
      $.set(rn, fe(nn, Le, Fe, rn, we, b));
    });
    var Ze = R ? X ? d : m : X ? C : E, dn = B ? void 0 : Ze(we);
    return n(dn || we, function(nn, rn) {
      dn && (rn = nn, nn = we[rn]), t($, rn, fe(nn, Le, Fe, rn, we, b));
    }), $;
  }
  return of = fe, of;
}
var sf, N0;
function YY() {
  if (N0) return sf;
  N0 = 1;
  function e(n) {
    var t = n == null ? 0 : n.length;
    return t ? n[t - 1] : void 0;
  }
  return sf = e, sf;
}
var lf, j0;
function JY() {
  if (j0) return lf;
  j0 = 1;
  function e(n, t, i) {
    var a = -1, o = n.length;
    t < 0 && (t = -t > o ? 0 : o + t), i = i > o ? o : i, i < 0 && (i += o), o = t > i ? 0 : i - t >>> 0, t >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + t];
    return s;
  }
  return lf = e, lf;
}
var cf, w0;
function QY() {
  if (w0) return cf;
  w0 = 1;
  var e = E1(), n = JY();
  function t(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return cf = t, cf;
}
var uf, C0;
function XY() {
  if (C0) return uf;
  C0 = 1;
  var e = Ha(), n = YY(), t = QY(), i = Xc();
  function a(o, s) {
    return s = e(s, o), o = t(o, s), o == null || delete o[i(n(s))];
  }
  return uf = a, uf;
}
var df, F0;
function ZY() {
  if (F0) return df;
  F0 = 1;
  var e = Ba(), n = my(), t = Ji(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, u = s.call(Object);
  function m(d) {
    if (!t(d) || e(d) != i)
      return !1;
    var f = n(d);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == u;
  }
  return df = m, df;
}
var mf, I0;
function eJ() {
  if (I0) return mf;
  I0 = 1;
  var e = ZY();
  function n(t) {
    return e(t) ? void 0 : t;
  }
  return mf = n, mf;
}
var pf, $0;
function nJ() {
  if ($0) return pf;
  $0 = 1;
  var e = $1(), n = GY(), t = XY(), i = Ha(), a = ws(), o = eJ(), s = D1(), l = W1(), u = 1, m = 2, d = 4, f = s(function(h, v) {
    var x = {};
    if (h == null)
      return x;
    var S = !1;
    v = e(v, function(j) {
      return j = i(j, h), S || (S = j.length > 1), j;
    }), a(h, l(h), x), S && (x = n(x, u | m | d, o));
    for (var N = v.length; N--; )
      t(x, v[N]);
    return x;
  });
  return pf = f, pf;
}
nJ();
const Rr = ({
  children: e,
  ...n
}) => {
  const { controller: t, controllerProps: i, fieldWrapperProps: a } = L1(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...u
  } = t.field;
  return /* @__PURE__ */ Ui.jsx(Dn, { ...a, children: /* @__PURE__ */ Ui.jsx(
    yi,
    {
      ...n.componentProps,
      ...u,
      multiple: !1,
      value: u.value ? [u.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: Dn.getStatus(a.meta),
      children: e
    }
  ) });
};
var tJ = R1();
const rJ = /* @__PURE__ */ N1(tJ), ff = ({
  transformValue: e = rJ,
  label: n,
  helpIcon: t,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = A1(a);
  return /* @__PURE__ */ Ui.jsxs(_, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Ui.jsx(
      Rf,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Ui.jsx(JF, { htmlFor: s, helpIcon: t, children: n })
  ] });
}, Jt = (e) => {
  const { controller: n, controllerProps: t, fieldWrapperProps: i } = L1(e);
  return /* @__PURE__ */ Ui.jsx(Dn, { ...i, children: /* @__PURE__ */ Ui.jsx(
    Or,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: t.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: Dn.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._modal_1mprq_1{width:900px}._modal_21e62_1{max-width:900px}._modal_al73g_1{width:600px}._editIcon_1dntr_1,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
const E0 = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
var hf = { exports: {} }, _o = {}, T0;
function iJ() {
  if (T0) return _o;
  T0 = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return _o.Fragment = t, _o.jsx = s, _o.jsxs = s, _o;
}
var dl = {}, O0;
function aJ() {
  return O0 || (O0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    dl.Fragment = i, dl.jsx = Un, dl.jsxs = Bn;
  }()), dl;
}
var R0;
function oJ() {
  return R0 || (R0 = 1, process.env.NODE_ENV === "production" ? hf.exports = iJ() : hf.exports = aJ()), hf.exports;
}
var g = oJ(), da = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(da || {}), Bi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(Bi || {}), Wr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Wr || {}), K1 = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(K1 || {}), Oi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Oi || {}), Br = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Br || {}), Dl = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(Dl || {});
const sJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, lJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, cJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, uJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, dJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, mJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, pJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, fJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refuncLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, hJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, vJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, yJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, gJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, kJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, bJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "readDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "codesCount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, _J = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, xJ = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, SJ = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": sJ,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": lJ,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": cJ,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": uJ,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": dJ,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": mJ,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": pJ,
  "\n  mutation refuncLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": fJ,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": hJ,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": vJ,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": yJ,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": gJ,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n            }\n            suggestedRefund(suggestFullRefund: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": kJ,
  "\n  query readDiscountCodes($first: Int) {\n    Shopify {\n      codeDiscountNodes(first: $first) {\n        nodes {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeApp {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              codesCount {\n                count\n              }\n              codes(first: $first) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": bJ,
  "\n  query getProducts($productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": _J,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": xJ
};
function xr(e) {
  return SJ[e] ?? {};
}
const NJ = xr(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), jJ = xr(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
            }
            suggestedRefund(suggestFullRefund: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  image {
                    url
                  }
                  product {
                    id
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), wJ = xr(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), CJ = xr(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), hy = xr(
  /* GraphQL */
  `
  query getProducts($productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), FJ = xr(
  /* GraphQL */
  `
  query readDiscountCodes($first: Int) {
    Shopify {
      codeDiscountNodes(first: $first) {
        nodes {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeApp {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              codesCount {
                count
              }
              codes(first: $first) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), IJ = xr(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), $J = xr(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), EJ = xr(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), TJ = xr(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), OJ = xr(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), RJ = xr(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), G1 = Si`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, DJ = Si`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, PJ = ({
  conversationContext: e
}) => {
  const { useQuery: n } = un(), t = e.customer?.email, i = e.customer?.phone_number, a = t ? `email:"${t}"` : null, o = i ? `phone:"${i}"` : null, s = a ?? o ?? null, {
    loading: l,
    error: u,
    data: m,
    refetch: d,
    networkStatus: f
  } = n(NJ, {
    skip: !s,
    variables: {
      query: s
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: l,
    customerError: u,
    customerData: m,
    refetchCustomer: d,
    customerNetworkStatus: f
  };
}, AJ = () => {
  const { useLazyQuery: e } = un(), [
    n,
    {
      loading: t,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(jJ);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: t,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Xo(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const LJ = "_list_alvh6_1", VJ = "_listItem_alvh6_4", zJ = "_fullWidth_alvh6_15", MJ = "_boxWrapper_alvh6_19", qt = {
  list: LJ,
  listItem: VJ,
  fullWidth: zJ,
  boxWrapper: MJ
}, UJ = "_modal_1vkwz_1", BJ = "_disabled_1vkwz_5", vf = {
  modal: UJ,
  disabled: BJ
}, D0 = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: Bi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: Bi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: Bi.Unknown
  }
], P0 = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Wr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Wr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Wr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Wr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Wr.Unsubscribed
  }
], qJ = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: t,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = hn(), { useMutation: l, showNotification: u } = un(), [m, d] = oe(), [f, h] = oe(), [v, x] = ib(!0), [S, N] = ib(!0), j = !!m, y = e.customer?.email, q = e.customer?.phone_number, E = e.customer?.given_name, C = e.customer?.family_name, T = {
    email: y ?? "",
    phone: q ?? "",
    firstName: E ?? "",
    lastName: C ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, U = br({
    defaultValues: T
  });
  qe(() => {
    f?.forEach((D) => {
      const G = D?.field?.[0];
      G && (U.setError(G, {
        type: "server",
        message: D.message
      }), U.setFocus(G));
    });
  }, [f, U]);
  const [Z, { error: Q, reset: ee }] = l(OJ, {
    onError: (D) => {
      d(D.message), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (D) => {
      const G = D?.Shopify?.customerCreate?.userErrors || [];
      G.length > 0 ? (h(G), a(!1), u({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), u({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), t(!1));
    }
  }), J = ft(
    (D) => {
      a(!0), d(void 0), Z({
        variables: {
          input: {
            firstName: D.firstName,
            lastName: D.lastName,
            defaultEmailAddress: {
              ...v && { emailAddress: D.email }
            },
            defaultPhoneNumber: {
              ...S && { phoneNumber: D.phone },
              marketingState: D.smsMarketingState,
              marketingOptInLevel: D.smsMarketingOptInLevel
            }
          }
        }
      });
    },
    [Z, a, S, v]
  ), K = () => {
    t(!1), ee(), d(void 0), U.reset(T);
  };
  return /* @__PURE__ */ g.jsxs(St, { isOpen: n, onClose: K, className: vf.modal, children: [
    /* @__PURE__ */ g.jsx(Nt, { title: "Create new customer", onClose: K }),
    /* @__PURE__ */ g.jsx(jt, { children: /* @__PURE__ */ g.jsxs(Kt, { children: [
      /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
        Jt,
        {
          label: "First name",
          name: "firstName",
          control: U.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
        Jt,
        {
          label: "Last name",
          name: "lastName",
          control: U.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
        Jt,
        {
          label: "Email",
          name: "email",
          control: U.control,
          rules: {
            required: v ? "Email is required" : void 0
          },
          componentProps: {
            className: ht({
              [vf.disabled]: !v
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ g.jsx(
                Rf,
                {
                  disabled: !S,
                  name: "hasEmail",
                  value: "email",
                  checked: v,
                  onChange: () => x()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
        Jt,
        {
          label: "Phone",
          name: "phone",
          control: U.control,
          rules: {
            required: S ? "Phone is required" : void 0
          },
          componentProps: {
            className: ht({
              [vf.disabled]: !S
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ g.jsx(
                Rf,
                {
                  disabled: !v,
                  name: "hasPhone",
                  value: "phone",
                  checked: S,
                  onChange: () => N()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
        Rr,
        {
          control: U.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (D, G) => D === G,
            getItemTitleByValue: (D) => {
              const G = P0.find(
                (ne) => ne.value === D
              );
              return /* @__PURE__ */ g.jsxs(
                _,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: G.label }),
                    /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: G.description })
                  ]
                }
              );
            }
          },
          children: P0.map((D) => /* @__PURE__ */ g.jsx(pt.Item, { value: D.value, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: D.label }),
            /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: D.description })
          ] }) }, D.value))
        }
      ) }),
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
        Rr,
        {
          control: U.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (D, G) => D === G,
            getItemTitleByValue: (D) => {
              const G = D0.find(
                (ne) => ne.value === D
              );
              return /* @__PURE__ */ g.jsxs(
                _,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: G.label }),
                    /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: G.description })
                  ]
                }
              );
            }
          },
          children: D0.map((D) => /* @__PURE__ */ g.jsx(pt.Item, { value: D.value, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: D.label }),
            /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: D.description })
          ] }) }, D.value))
        }
      ) }),
      j && /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ g.jsx(he, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ g.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(U.formState.isValid && U.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 })
        },
        confirmOnClick: U.handleSubmit(J),
        cancelOnClick: K,
        confirmName: Q ? "Close" : "Save",
        cancelName: Q ? void 0 : "Cancel"
      }
    )
  ] });
}, HJ = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [t, i] = oe(!1), [a, o] = oe(!1);
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsx(
      qn,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 }),
        slotStart: /* @__PURE__ */ g.jsx(he, { size: 14, name: "user-plus", color: "green.500" }),
        className: qt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ g.jsx(
      qJ,
      {
        isOpen: t,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, vy = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, Ih = "DD MMM YYYY @ HH:mm", WJ = "_wrapper_10fld_1", KJ = "_copyIcon_10fld_7", ml = {
  wrapper: WJ,
  copyIcon: KJ
}, GJ = ({
  customer: e,
  shopifyDomain: n,
  refresh: t,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Xo(), { isCopied: l, copy: u } = Xo(), { track: m } = hn();
  if (!e)
    return null;
  const {
    id: d,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: v,
    tags: x = [],
    verifiedEmail: S
  } = e, N = h?.emailAddress, j = v?.phoneNumber, y = vy(d), q = `https://${n}/admin/customers/${y ?? ""}`, E = i && a === hr.refetch, C = 14;
  return /* @__PURE__ */ g.jsxs(_, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsxs(_, { className: ml.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: f }),
        E ? /* @__PURE__ */ g.jsx(cn, { size: C }) : /* @__PURE__ */ g.jsx(Je, { content: "Reload customer", children: /* @__PURE__ */ g.jsx(
          he,
          {
            size: C,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: d }), t();
            },
            className: ml.copyIcon
          }
        ) })
      ] }),
      N && /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ g.jsxs(_, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ g.jsx(he, { size: C, name: "mail" }),
          /* @__PURE__ */ g.jsx(A.ExternalLink, { href: `mailto:${N}`, children: N }),
          /* @__PURE__ */ g.jsx(
            Je,
            {
              content: S ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ g.jsx(_, { alignItems: "center", children: /* @__PURE__ */ g.jsx(
                he,
                {
                  size: C,
                  color: S ? "green.500" : "red.500",
                  name: S ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ g.jsx(Je, { content: "Copy Email", children: /* @__PURE__ */ g.jsx(
          he,
          {
            size: C,
            name: o ? "done" : "copy",
            onClick: () => s(N),
            className: ml.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ g.jsxs(_, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ g.jsx(he, { size: C, name: "phone" }),
          /* @__PURE__ */ g.jsx(A.ExternalLink, { href: `tel:${j}`, children: j })
        ] }),
        /* @__PURE__ */ g.jsx(Je, { content: "Copy phone number", children: /* @__PURE__ */ g.jsx(
          he,
          {
            size: C,
            name: l ? "done" : "copy",
            onClick: () => u(j),
            className: ml.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ g.jsxs(_, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ g.jsx(he, { size: C, name: "external-link" }),
        /* @__PURE__ */ g.jsx(
          A.ExternalLink,
          {
            href: q,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    x.length > 0 && /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
      /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ g.jsx(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: x.map((T) => /* @__PURE__ */ g.jsx(En, { children: T }, `${d}-${T}`)) })
    ] })
  ] });
}, YJ = "_creationModal_pbe64_1", JJ = "_detailsModal_pbe64_5", QJ = "_percentageSuffix_pbe64_9", yf = {
  creationModal: YJ,
  detailsModal: JJ,
  percentageSuffix: QJ
}, XJ = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, ZJ = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, t = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      case "none":
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: K1.All
    },
    ...t && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [t]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, A0 = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], L0 = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], V0 = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], eQ = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: t, copy: i } = si(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ g.jsxs(He, { children: [
      /* @__PURE__ */ g.jsx(He.Text, { children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ g.jsx(He.Text, { children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ g.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ g.jsx(
            he,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ g.jsx(He.Text, { children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ g.jsx(He.Text, { children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ g.jsx(He.Text, { children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "2", color: "secondary", children: Tn(e?.startsAt).format(lt) })
      ] }) })
    ] }),
    /* @__PURE__ */ g.jsx(Dn, { label: "Discount code", children: /* @__PURE__ */ g.jsx(
      Or,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: t ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, nQ = "shopify-discount-code-form", z0 = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, tQ = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: t } = hn(), { useMutation: i, showNotification: a } = un(), [o, s] = oe(
    []
  ), [l, u] = oe(), m = br({
    mode: "all",
    defaultValues: z0
  });
  qe(() => {
    o?.forEach((C) => {
      const T = C?.field?.[1];
      T && m.setError(T, {
        type: "server",
        message: C.message
      });
    });
  }, [o, m]);
  const d = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), v = Zn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      case "none":
      default:
        return "";
    }
  }, [f]), [
    x,
    {
      loading: S,
      error: N,
      reset: j
    }
  ] = i(RJ, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (C) => {
      const T = C?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (T && T.length > 0)
        s(T);
      else {
        const U = C?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        U && "codes" in U && u(U), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), t("shopify:discount:code:created"), s([]);
      }
    }
  }), y = () => {
    m.setValue("code", XJ(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, q = (C) => {
    x({
      variables: {
        input: ZJ(C)
      }
    });
  }, E = () => {
    m.reset(z0), s([]), j(), u(void 0), n(!1);
  };
  return /* @__PURE__ */ g.jsxs(
    St,
    {
      isOpen: e,
      onClose: E,
      className: ht({
        [yf.creationModal]: !d,
        [yf.detailsModal]: d
      }),
      children: [
        /* @__PURE__ */ g.jsx(
          Nt,
          {
            title: d ? "Discount code details" : "Create new discount code",
            onClose: E
          }
        ),
        /* @__PURE__ */ g.jsxs(jt, { children: [
          d && /* @__PURE__ */ g.jsx(eQ, { codeDiscount: l }),
          !d && /* @__PURE__ */ g.jsxs("form", { noValidate: !0, id: nQ, onSubmit: m.handleSubmit(q), children: [
            /* @__PURE__ */ g.jsx(_, { margin: "0 0 400", children: /* @__PURE__ */ g.jsx(
              hc,
              {
                variant: "info",
                description: /* @__PURE__ */ g.jsx(A.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ g.jsxs(Kt, { children: [
              /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
                Jt,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
                Rr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (C, T) => C === T,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (C) => {
                      const T = A0.find(
                        (U) => U.value === C
                      );
                      return /* @__PURE__ */ g.jsx(_, { margin: "0 0 100", children: /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: A0.map((C) => /* @__PURE__ */ g.jsx(pt.Item, { value: C.value, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
                Jt,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (C) => {
                      if (C) {
                        if (h === "percentage" && (C < 0 || C > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && C < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ g.jsx(
                          _,
                          {
                            alignItems: "center",
                            className: yf.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
                Jt,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: y
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
                Rr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (C, T) => C === T,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (C) => {
                      const T = L0.find(
                        (U) => U.value === C
                      );
                      return /* @__PURE__ */ g.jsx(_, { margin: "0 0 100", children: /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: L0.map((C) => /* @__PURE__ */ g.jsx(pt.Item, { value: C.value, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) }),
              /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
                Jt,
                {
                  name: "minimumRequirementValue",
                  label: v,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (C) => {
                      if (C && f !== "none" && C < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
                Rr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (C, T) => C === T,
                    getItemTitleByValue: (C) => {
                      const T = V0.find(
                        (U) => U.value === C
                      );
                      return /* @__PURE__ */ g.jsx(_, { margin: "0 0 100", children: /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: T?.label }) });
                    }
                  },
                  children: V0.map((C) => /* @__PURE__ */ g.jsx(pt.Item, { value: C.value, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: C.label }),
                    /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: C.description })
                  ] }) }, C.value))
                }
              ) })
            ] })
          ] }),
          N && /* @__PURE__ */ g.jsx(_n, { error: N })
        ] }),
        /* @__PURE__ */ g.jsx(
          Et,
          {
            confirmProps: {
              disabled: !d && !(m.formState.isValid && m.formState.isDirty),
              isLoading: S,
              loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 })
            },
            confirmName: d ? "Close" : "Save",
            confirmOnClick: d ? E : m.handleSubmit(q),
            cancelOnClick: d ? void 0 : E
          }
        )
      ]
    }
  );
}, rQ = ({ code: e }) => {
  const { isCopied: n, copy: t } = Xo();
  return /* @__PURE__ */ g.jsxs(
    _,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ g.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ g.jsx(he, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ g.jsx(
          lr,
          {
            icon: n ? "done" : "copy",
            onClick: () => t(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, iQ = ({
  discountCode: e
}) => {
  const { codeDiscount: n } = e;
  if (!("codes" in n))
    return null;
  const t = "summary" in n, i = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: n.title }),
    t && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: n.summary }),
    /* @__PURE__ */ g.jsx(He, { children: i.map((a) => /* @__PURE__ */ g.jsx(He.Item, { className: qt.listItem, children: /* @__PURE__ */ g.jsx(rQ, { code: a.code }, a.id) }, a.id)) })
  ] });
}, aQ = "_modal_11d6e_1", oQ = "_modalBody_11d6e_4", sQ = "_codeContainer_11d6e_9", gf = {
  modal: aQ,
  modalBody: oQ,
  codeContainer: sQ
}, lQ = [50, 100, 250], Y1 = 50, cQ = {
  maxNumberOfCodesToDisplay: Y1
}, uQ = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { useQuery: t } = un(), [i, a] = oe(
    Y1
  ), [o, s] = oe([]), l = o.length === 0, u = o.length > i, m = br({
    mode: "all",
    defaultValues: cQ
  }), { loading: d, error: f } = t(FJ, {
    variables: {
      first: i
    },
    onCompleted: (v) => {
      const x = v?.Shopify?.codeDiscountNodes?.nodes ?? [];
      x && x.length > 0 && s(x);
    }
  }), h = () => {
    n(!1);
  };
  return /* @__PURE__ */ g.jsxs(St, { isOpen: e, onClose: h, className: gf.modal, children: [
    /* @__PURE__ */ g.jsx(Nt, { title: "Discount codes", onClose: h }),
    /* @__PURE__ */ g.jsxs(jt, { className: gf.modalBody, children: [
      u && /* @__PURE__ */ g.jsx(Kt, { children: /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
        Rr,
        {
          control: m.control,
          label: "Number of codes to display",
          name: "maxNumberOfCodesToDisplay",
          componentProps: {
            placeholder: "Select a number of codes to display",
            onChange: (v) => {
              a(v.selectedValues[0]);
            },
            getItemTitleByValue: (v) => /* @__PURE__ */ g.jsx(_, { margin: "0 0 100", children: /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: v }) })
          },
          children: lQ.map((v) => /* @__PURE__ */ g.jsx(pt.Item, { value: v, children: /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: v }) }, v))
        }
      ) }) }),
      d && /* @__PURE__ */ g.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ g.jsx(cn, {}) }),
      f && /* @__PURE__ */ g.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ g.jsx(A.Paragraph, { children: "Something went wrong while fetching discount codes." }) }),
      !d && l && /* @__PURE__ */ g.jsx(
        Mh,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !d && !f && !l && o.map((v) => /* @__PURE__ */ g.jsx("div", { className: gf.codeContainer, children: /* @__PURE__ */ g.jsx(iQ, { discountCode: v }) }, v.id))
    ] }),
    /* @__PURE__ */ g.jsx(Et, { confirmName: "Close", confirmOnClick: h })
  ] });
}, dQ = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, t] = oe(!1), [i, a] = oe(!1);
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ g.jsxs(_, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ g.jsx(_, { flex: "1", children: /* @__PURE__ */ g.jsx(
          qn,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ g.jsx(_, { flex: "1", children: /* @__PURE__ */ g.jsx(
          qn,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => t(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ g.jsx(
      uQ,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ g.jsx(
      tQ,
      {
        isOpen: n,
        setIsOpen: t
      }
    )
  ] });
}, mQ = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: t } = e, i = (h) => h ? pc(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case da.Invalid:
      case da.NotSubscribed:
      case Wr.NotSubscribed:
        return "red.500";
      case da.Pending:
      case Wr.Pending:
      case da.Unsubscribed:
      case Wr.Unsubscribed:
        return "orange.500";
      case da.Subscribed:
      case Wr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case Bi.SingleOptIn:
      case Bi.ConfirmedOptIn:
        return "green.500";
      case Bi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: u
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: d,
    marketingOptInLevel: f
  } = t ?? {};
  return /* @__PURE__ */ g.jsxs(_, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(he, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ g.jsx(Je, { content: "Last updated at", children: /* @__PURE__ */ g.jsx(zn, { size: "small", variant: "info", children: Tn(l).format(Ih) }) }),
      /* @__PURE__ */ g.jsxs(_, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(Je, { content: "Opt-In state", children: /* @__PURE__ */ g.jsx(En, { color: o(u), children: i(u) }) }),
        /* @__PURE__ */ g.jsx(Je, { content: "Marketing state", children: /* @__PURE__ */ g.jsx(En, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ g.jsx(he, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      d && /* @__PURE__ */ g.jsx(Je, { content: "Last updated at", children: /* @__PURE__ */ g.jsx(zn, { size: "small", variant: "info", children: Tn(d).format(Ih) }) }),
      /* @__PURE__ */ g.jsxs(_, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(Je, { content: "Opt-In state", children: /* @__PURE__ */ g.jsx(En, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ g.jsx(Je, { content: "Marketing state", children: /* @__PURE__ */ g.jsx(En, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, pQ = ({
  ordersData: e
}) => {
  const n = (t) => t?.fulfillments?.length > 0 ? t.fulfillments[0].trackingInfo : [];
  return e.map(({ node: t }) => ({
    id: t.id,
    name: t.name,
    createdAt: new Date(t.createdAt),
    cancelledAt: t.cancelledAt ? new Date(t.cancelledAt) : void 0,
    status: `${t.displayFulfillmentStatus?.toLowerCase()}, ${t.displayFinancialStatus?.toLowerCase()}${t.cancelledAt ? ", cancelled" : ""}`,
    currentTotalPriceSet: t.currentTotalPriceSet,
    value: t.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: t.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: t.shippingAddress,
    billingAddress: t.billingAddress,
    lineItems: t.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: t.id,
      amount: t.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      currency: t.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: t.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: t.suggestedRefund?.suggestedTransactions?.map(
        ({ amountSet: i, gateway: a, parentTransaction: o }) => ({
          amount: i?.presentmentMoney?.amount || "0.00",
          gateway: a || void 0,
          kind: "REFUND",
          orderId: t.id,
          parentId: o?.id
        })
      ),
      shipping: {
        fullRefund: !0
      }
    },
    trackingInfos: n(t),
    tags: t.tags,
    refunds: t.refunds
  }));
}, M0 = [
  {
    value: Br.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Br.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Br.Paid,
    label: "Paid",
    description: "The payment has been completed"
  },
  {
    value: Br.PartiallyPaid,
    label: "Partially Paid",
    description: "The payment has been partially completed"
  },
  {
    value: Br.Refunded,
    label: "Refunded",
    description: "The payment has been refunded"
  },
  {
    value: Br.Voided,
    label: "Voided",
    description: "The payment has been voided"
  },
  {
    value: Br.PartiallyRefunded,
    label: "Partially Refunded",
    description: "The payment has been partially refunded"
  }
], U0 = [
  {
    value: Dl.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: Dl.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: Dl.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], pl = (e) => $h(fQ(e)), $h = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), fQ = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: t, ...i } = n;
    return {
      ...i,
      ...t && { countryCode: t }
    };
  }
  return e;
}, $i = ({
  control: e,
  name: n,
  label: t,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ g.jsx(
  Bt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ g.jsx(
      fr,
      {
        required: a,
        label: t,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), hQ = "_modal_1wlra_1", vQ = {
  modal: hQ
};
function B0(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const q0 = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], H0 = "shopify-shiping-address-form", yQ = ({
  title: e,
  address: n,
  isOpen: t,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: u
}) => {
  const { useMutation: m, showNotification: d } = un(), { track: f } = hn(), [h, v] = oe(!1), [x, S] = oe({}), N = !l, [
    j,
    { error: y, reset: q }
  ] = m(IJ, {
    onError: () => {
      v(!1), d({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (J) => {
      v(!1);
      const K = J?.Shopify?.orderUpdate?.userErrors;
      if (K?.length > 0) {
        const D = K.reduce((G, ne) => (G[ne.field[ne.field.length - 1]] = ne.message, G), {});
        S(D);
      } else
        d({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), u(), ee();
    }
  }), E = ft(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: q0.find(
        (J) => J === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: C, handleSubmit: T, formState: U, reset: Z } = br({
    mode: "all",
    defaultValues: E()
  }), Q = T((J) => {
    if (N) {
      v(!0), o && a && f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: K, ...D } = J, G = { ...D, countryCode: K };
      j({
        variables: {
          input: {
            id: a,
            shippingAddress: G
          }
        }
      });
    } else
      l(J), ee();
  });
  qe(() => {
    t && Z(E());
  }, [t, n, Z, E]);
  const ee = () => {
    Z(E()), S({}), q(), i(!1);
  };
  return /* @__PURE__ */ g.jsxs(
    St,
    {
      isOpen: t,
      onClose: ee,
      className: vQ.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ g.jsx(Nt, { title: e, onClose: () => ee() }),
        /* @__PURE__ */ g.jsx(jt, { children: /* @__PURE__ */ g.jsxs("form", { noValidate: !0, id: H0, onSubmit: Q, children: [
          y && /* @__PURE__ */ g.jsx(_n, { error: y }),
          /* @__PURE__ */ g.jsxs(Kt, { children: [
            /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
              $i,
              {
                required: !0,
                control: C,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
              $i,
              {
                required: !0,
                control: C,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 6, children: /* @__PURE__ */ g.jsx(
              $i,
              {
                control: C,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 6, children: /* @__PURE__ */ g.jsx(
              $i,
              {
                required: !0,
                control: C,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 6, children: /* @__PURE__ */ g.jsx(
              $i,
              {
                control: C,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
              $i,
              {
                required: !0,
                control: C,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 3, children: /* @__PURE__ */ g.jsx(
              $i,
              {
                required: !0,
                control: C,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: x
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 6, children: /* @__PURE__ */ g.jsx(
              Rr,
              {
                name: "countryCodeV2",
                control: C,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (J) => J ? B0(J) : ""
                },
                children: q0.filter((J) => s.includes(J)).map((J) => /* @__PURE__ */ g.jsx(pt.Item, { value: J, children: /* @__PURE__ */ g.jsx(A.Paragraph, { children: B0(J) }) }, J))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ g.jsx(
          Et,
          {
            confirmProps: {
              disabled: !(U.isValid && U.isDirty),
              type: "submit",
              form: H0,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 })
            },
            confirmOnClick: () => {
              y && ee();
            },
            cancelOnClick: () => {
              o && a && !y && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), ee();
            },
            confirmName: y ? "Close" : "Save",
            cancelName: y ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, gQ = "_clickableIcon_33mqm_1", kf = {
  clickableIcon: gQ
}, W0 = ({
  formFieldName: e,
  ...n
}) => {
  const t = Zr(), { field: i } = Tv({
    control: t.control,
    name: e
  });
  return /* @__PURE__ */ g.jsx(
    Eh,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, Eh = ({
  labelText: e,
  address: n,
  orderId: t,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: u,
  openByDefault: m = !1
}) => {
  const [d, f] = oe(!1), [h, v] = oe(m), { isCopied: x, copy: S } = Xo(), { track: N } = hn(), j = 14, y = o && (!!t || !!l), q = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), E = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), C = n?.countryCodeV2 && zF(n.countryCodeV2), T = ft(() => [
    E,
    n?.company,
    n?.address1,
    n?.address2,
    q,
    n?.province,
    C
  ].filter(Boolean).join(`
`), [n, E, q, C]);
  if (!n)
    return null;
  const U = () => {
    i && t && N("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: t
    }), f(!0);
  };
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ g.jsxs(_, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(he, { size: j, name: s, color: "green.500" }),
        /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ g.jsxs(
            _,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => v(!h),
              className: kf.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ g.jsx(
                  he,
                  {
                    size: j,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ g.jsxs(_, { gap: "100", flexDirection: "column", children: [
            E && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: E }),
            n?.company && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: n.address2 }),
            q && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: q }),
            n?.province && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: n.province }),
            C && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: C })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ g.jsxs(_, { gap: "250", flexDirection: "row", children: [
        y && /* @__PURE__ */ g.jsx(Je, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ g.jsx(
          he,
          {
            size: j,
            name: "pen",
            onClick: () => U(),
            className: kf.clickableIcon
          }
        ) }),
        /* @__PURE__ */ g.jsx(Je, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ g.jsx(
          he,
          {
            size: j,
            name: x ? "done" : "copy",
            onClick: () => S(T()),
            className: kf.clickableIcon
          }
        ) })
      ] })
    ] }),
    y && /* @__PURE__ */ g.jsx(
      yQ,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: d,
        setIsOpen: f,
        orderId: t,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: u
      }
    )
  ] });
}, yy = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const t = Zr(), i = Fl({ control: t.control, name: "lineItems" }), a = Fl({
    control: t.control,
    name: "billingAddress"
  }), o = Fl({
    control: t.control,
    name: "shippingAddress"
  }), s = Zn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (m) => n.includes(m.id)
  ) : i, [i, n]), l = Zn(() => !s || s.length === 0 ? 0 : s.reduce((m, d) => {
    const f = d.priceRangeV2?.minVariantPrice?.amount || 0, h = d.quantity || 0;
    return m + f * h;
  }, 0), [s]), u = s?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
      /* @__PURE__ */ g.jsxs(A.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ g.jsx(
        W0,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ g.jsx(
        W0,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: `${l.toFixed(2)} ${u}` })
    ] }),
    /* @__PURE__ */ g.jsx(A.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, kQ = "_productTableHeader_6h6pl_1", bQ = "_productImage_6h6pl_5", Vo = {
  productTableHeader: kQ,
  productImage: bQ
}, gy = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, _Q = ({
  product: e,
  index: n,
  onRemove: t
}) => {
  const i = Zr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), u = gy(e);
  return /* @__PURE__ */ g.jsxs(Jn.Tr, { children: [
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsxs(_, { gap: "200", alignItems: "center", children: [
      u && /* @__PURE__ */ g.jsx(
        es,
        {
          src: u,
          alt: e.title,
          className: Vo.productImage
        }
      ),
      /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(
      Jt,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(_, { justifyContent: "flex-end", children: /* @__PURE__ */ g.jsx(lr, { icon: "trash", variant: "secondary", onClick: t }) }) })
  ] });
}, xQ = ({
  products: e,
  isLoadingProducts: n
}) => {
  const [t, i] = oe(""), a = Zr(), o = Zn(() => {
    if (!t.trim())
      return e;
    const l = t.toLowerCase();
    return e.filter(
      (u) => u.title.toLowerCase().includes(l)
    );
  }, [e, t]), s = !o.length && !n;
  return /* @__PURE__ */ g.jsx(
    Rr,
    {
      noAlert: !0,
      label: "Product selection",
      control: a.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: n ? "Loading products..." : "Select or search products",
        tabIndex: 0,
        getItemTitleByValue: (l) => {
          const u = e.find((m) => m.id === l);
          return u ? /* @__PURE__ */ g.jsx(A.Paragraph, { children: u.title }) : null;
        },
        filter: {
          value: t,
          onChange: (l) => {
            i(l.target.value);
          }
        },
        onToggleDropdown: (l) => {
          !l && t !== "" && i("");
        }
      },
      children: /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
        n && /* @__PURE__ */ g.jsx(pt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ g.jsx(_, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ g.jsx(cn, {}) }) }),
        !n && o.map((l) => {
          const u = l.totalInventory <= 0, m = gy(l);
          return /* @__PURE__ */ g.jsx(
            pt.Item,
            {
              value: l.id,
              isDisabled: u,
              children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ g.jsxs(_, { gap: "200", alignItems: "center", children: [
                  m && /* @__PURE__ */ g.jsx(
                    es,
                    {
                      src: m,
                      alt: l.title,
                      className: Vo.productImage
                    }
                  ),
                  t ? /* @__PURE__ */ g.jsx(
                    QF,
                    {
                      text: l.title,
                      highlight: t
                    }
                  ) : /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: l.title })
                ] }),
                /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "5", children: u ? "Out of stock" : `${l.totalInventory} in stock` })
              ] })
            },
            l.id
          );
        }),
        s && /* @__PURE__ */ g.jsx(pt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ g.jsx(
          Mh,
          {
            title: "No products found",
            description: t ? "Try changing your search criteria." : "No products available."
          }
        ) })
      ] })
    }
  );
}, ky = ({
  isAlreadyLoadedProducts: e = !1,
  contextProducts: n = [],
  selectionMode: t = !1,
  hideDeleteButton: i = !1,
  selectedProductIds: a = [],
  onToggleSelect: o,
  onToggleSelectAll: s
}) => {
  const { useQuery: l } = un(), u = Zr(), m = u.watch("lineItems"), d = u.watch("selectedProductId"), f = m && m?.length > 0, h = t && f ? m.every((q) => a.includes(q?.id)) : !1, v = t && f ? m.some(
    (q) => a.includes(q?.id)
  ) && !h : !1, {
    data: x,
    loading: S,
    error: N
  } = l(hy, {
    skip: e || n.length > 0,
    variables: {
      productCount: 250,
      mediaCount: 1
    }
  }), j = Zn(() => {
    const q = x?.Shopify?.products?.nodes || n;
    return !q || q.length === 0 ? [] : q.filter((E) => !!E).sort((E, C) => E.title.localeCompare(C.title));
  }, [x, n]);
  if (qe(() => {
    if (!d) return;
    const q = j.find(
      (C) => C.id === d
    );
    if (!q) {
      u.setValue("selectedProductId", void 0);
      return;
    }
    const E = m.findIndex(
      (C) => C?.id === q.id
    );
    if (E > -1) {
      const C = u.getValues(`lineItems.${E}.quantity`) || 0, T = [...m];
      T[E] = {
        ...q,
        quantity: C + 1
      }, u.setValue("lineItems", T);
    } else
      u.setValue("lineItems", [
        ...m,
        { ...q, quantity: 1 }
      ]);
    u.setValue("selectedProductId", void 0);
  }, [d, j, u, m]), N)
    return /* @__PURE__ */ g.jsx(_n, { error: N });
  const y = e || S;
  return /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsx(xQ, { products: j, isLoadingProducts: y }),
    !f && !y && /* @__PURE__ */ g.jsx(
      _,
      {
        margin: "200 0",
        justifyContent: "center",
        className: qt.boxWrapper,
        children: /* @__PURE__ */ g.jsx(
          Mh,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    (f || y) && /* @__PURE__ */ g.jsx(_, { margin: "300 0", children: /* @__PURE__ */ g.jsxs(
      Jn,
      {
        hoverable: !0,
        loading: y,
        framed: !1,
        headerWithBackground: !1,
        className: Vo.productTable,
        children: [
          /* @__PURE__ */ g.jsx(Jn.Thead, { className: Vo.productTableHeader, children: /* @__PURE__ */ g.jsxs(Jn.Tr, { children: [
            t && /* @__PURE__ */ g.jsx(Jn.Th, { children: /* @__PURE__ */ g.jsx(
              Ty,
              {
                checked: h,
                indeterminate: v,
                onChange: () => s?.(!h)
              }
            ) }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "Product" }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "In stock" }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "Price" }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "Quantity" }),
            /* @__PURE__ */ g.jsx(Jn.Th, { children: "Total" }),
            !i && /* @__PURE__ */ g.jsx(Jn.Th, {})
          ] }) }),
          /* @__PURE__ */ g.jsx(Jn.Tbody, { children: m?.map((q, E) => {
            if (!t)
              return /* @__PURE__ */ g.jsx(
                _Q,
                {
                  product: q,
                  index: E,
                  onRemove: () => {
                    const D = m.filter(
                      (G, ne) => ne !== E
                    );
                    u.setValue("lineItems", D);
                  }
                },
                `${q?.id}-${E}`
              );
            const C = q, T = C.priceRangeV2.minVariantPrice.amount, U = C.priceRangeV2.minVariantPrice.currencyCode, Z = `lineItems.${E}.quantity`, Q = u.watch(Z) || 0, ee = T * Q, J = gy(C), K = a.includes(C.id);
            return /* @__PURE__ */ g.jsxs(Jn.Tr, { children: [
              /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(
                Ty,
                {
                  checked: K,
                  onChange: () => o?.(C.id, !K)
                }
              ) }),
              /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsxs(_, { gap: "200", alignItems: "center", children: [
                J && /* @__PURE__ */ g.jsx(
                  es,
                  {
                    src: J,
                    alt: C.title,
                    className: Vo.productImage
                  }
                ),
                /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: C.title })
              ] }) }),
              /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: C.totalInventory }) }),
              /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: `${T} ${U}` }) }),
              /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(
                Jt,
                {
                  noLabel: !0,
                  noAlert: !0,
                  name: Z,
                  control: u.control,
                  componentProps: {
                    type: "number",
                    min: 1,
                    max: C.totalInventory,
                    tabIndex: 0
                  }
                },
                `${Z}-${u.watch(Z)}`
              ) }),
              /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: `${ee} ${U}` }) }),
              !i && /* @__PURE__ */ g.jsx(Jn.Td, { children: /* @__PURE__ */ g.jsx(_, { justifyContent: "flex-end", children: /* @__PURE__ */ g.jsx(
                lr,
                {
                  icon: "trash",
                  variant: "secondary",
                  onClick: () => {
                    const D = m.filter(
                      (G, ne) => ne !== E
                    );
                    u.setValue("lineItems", D), K && o?.(C.id, !1);
                  }
                }
              ) }) })
            ] }, `${C.id}-${E}`);
          }) })
        ]
      }
    ) })
  ] });
}, J1 = () => {
  const e = Zr();
  return /* @__PURE__ */ g.jsx(
    Rr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: e.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const t = M0.find(
            (i) => i.value === n
          );
          return t ? /* @__PURE__ */ g.jsxs(
            _,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: t.label }),
                /* @__PURE__ */ g.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  t.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: M0.map((n) => /* @__PURE__ */ g.jsx(pt.Item, { value: n.value, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, Q1 = () => {
  const e = Zr();
  return /* @__PURE__ */ g.jsx(
    Rr,
    {
      label: "Fulfillment Status",
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const t = U0.find(
            (i) => i.value === n
          );
          return t ? /* @__PURE__ */ g.jsxs(_, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: t.label }),
            /* @__PURE__ */ g.jsxs(A.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              t.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: U0.map((n) => /* @__PURE__ */ g.jsx(pt.Item, { value: n.value, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, SQ = "_modal_1mprq_1", NQ = {
  modal: SQ
}, bf = "create-shopify-order-form", jQ = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: t,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = hn(), [u, m] = oe(!1), [
    d,
    f
  ] = oe(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, v = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Br.Pending,
    fulfillmentStatus: void 0
  }, [x, S] = oe([]), N = br({
    mode: "all",
    defaultValues: v
  }), j = N.watch("lineItems").length > 0, y = () => {
    N.reset(v), S([]), i(!1);
  };
  qe(() => {
    x.length > 0 && N.setValue("tags", x, { shouldDirty: !0 });
  }, [x, N]);
  const [q, { error: E }] = o(
    G1,
    {
      onError: () => {
        m(!1), s({
          title: "Something went wrong",
          text: "The order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:failed"), y();
      },
      onCompleted: () => {
        a(), m(!1), s({
          title: "Success",
          text: "The tags change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:succeeded"), y();
      }
    }
  ), [C, { error: T }] = o(
    DJ,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), y();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), y();
      }
    }
  ), U = (Q) => {
    const ee = Q.lineItems.map((D) => ({
      productId: D.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: D.priceRangeV2.maxVariantPrice.amount,
          currencyCode: D.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: D.quantity
    }));
    m(!0);
    const J = pl(Q?.billingAddress), K = pl(
      Q?.shippingAddress
    );
    q({
      variables: {
        order: {
          lineItems: ee,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: Q.customNote,
          tags: Q.tags,
          financialStatus: Q.financialStatus,
          fulfillmentStatus: Q.fulfillmentStatus,
          shippingAddress: K,
          billingAddress: J
        }
      }
    });
  }, Z = (Q) => {
    const ee = Q.lineItems.map((D) => ({
      title: D.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: D.priceRangeV2.maxVariantPrice.amount,
        currencyCode: D.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: D.quantity
    }));
    f(!0);
    const J = pl(Q?.billingAddress), K = pl(
      Q?.shippingAddress
    );
    C({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: Q.customNote,
          tags: Q.tags,
          lineItems: ee,
          shippingAddress: K,
          billingAddress: J
        }
      }
    });
  };
  return /* @__PURE__ */ g.jsxs(
    St,
    {
      isOpen: e,
      onClose: y,
      className: NQ.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ g.jsx(Nt, { title: "Create new order", onClose: y }),
        /* @__PURE__ */ g.jsxs(jt, { children: [
          /* @__PURE__ */ g.jsx(Ev, { ...N, children: /* @__PURE__ */ g.jsx("form", { id: bf, children: /* @__PURE__ */ g.jsxs(Kt, { children: [
            /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(ky, {}) }),
            /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
              Bt,
              {
                name: "tags",
                render: ({ fieldState: { error: Q } }) => /* @__PURE__ */ g.jsx(
                  Dn,
                  {
                    label: "Tags",
                    meta: {
                      error: Q?.message
                    },
                    children: /* @__PURE__ */ g.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (ee) => {
                          ee.key === "Enter" && (ee.preventDefault(), ee.stopPropagation());
                        },
                        children: /* @__PURE__ */ g.jsx(
                          fc,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: x,
                            onChange: (ee) => {
                              S(ee);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 4, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ g.jsx(J1, {}),
              /* @__PURE__ */ g.jsx(Q1, {}),
              /* @__PURE__ */ g.jsx(
                Jt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ g.jsx(en, { span: 2, children: /* @__PURE__ */ g.jsx(Dn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ g.jsx(
              _,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: qt.boxWrapper,
                children: /* @__PURE__ */ g.jsx(yy, {})
              }
            ) }) })
          ] }) }) }),
          (E || T) && /* @__PURE__ */ g.jsx(_n, { error: E || T })
        ] }),
        /* @__PURE__ */ g.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: bf,
              disabled: !j || u,
              isLoading: u,
              loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: N.handleSubmit(U),
            ...t && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                N.handleSubmit(Z)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: bf,
                disabled: !j || d,
                isLoading: d,
                loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, wQ = "_modal_al73g_1", CQ = {
  modal: wQ
}, K0 = [
  {
    label: "Customer",
    value: Oi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Oi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Oi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Oi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Oi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Oi.Staff,
    description: "Staff made an error."
  }
], FQ = ({
  orderId: e,
  isOpen: n,
  orderName: t,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = hn(), { useMutation: u, showNotification: m } = un(), [d, f] = oe([]), h = d.length > 0, v = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, x = br({
    defaultValues: v
  }), [S, { error: N, reset: j }] = u(EJ, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (E) => {
      const C = E.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (C.length > 0)
        o(!1), f(C), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const T = E.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, T ? 0 : 4e3), m({
          title: "Success",
          text: `${T ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), y = ft(
    (E) => {
      o(!0), S({
        variables: E
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), q = () => {
    i(!1), j(), f([]), x.reset(v);
  };
  return /* @__PURE__ */ g.jsxs(St, { isOpen: n, onClose: q, className: CQ.modal, children: [
    /* @__PURE__ */ g.jsx(Nt, { title: `Cancel order ${t}`, onClose: q }),
    /* @__PURE__ */ g.jsx(jt, { children: /* @__PURE__ */ g.jsxs(Kt, { children: [
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
        Rr,
        {
          control: x.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (E, C) => E === C,
            getItemTitleByValue: (E) => {
              if (!E)
                return "";
              const C = K0.find(
                (T) => T.value === E
              );
              return /* @__PURE__ */ g.jsxs(_, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: C.label }),
                /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: C.description })
              ] });
            }
          },
          children: K0.map((E) => /* @__PURE__ */ g.jsx(pt.Item, { value: E.value, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: E.label }),
            /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: E.description })
          ] }) }, E.value))
        }
      ) }),
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(Dn, { required: !0, label: "Refund order", children: /* @__PURE__ */ g.jsx(
        ff,
        {
          control: x.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(Dn, { required: !0, label: "Restock items", children: /* @__PURE__ */ g.jsx(ff, { control: x.control, name: "restock" }) }) }),
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(Dn, { required: !0, label: "Notify the customer", children: /* @__PURE__ */ g.jsx(ff, { control: x.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
        Jt,
        {
          name: "staffNote",
          label: "Staff note",
          control: x.control
        }
      ) }),
      h && /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(_, { gap: "200", flexDirection: "column", children: d.map((E) => /* @__PURE__ */ g.jsxs(
        _,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ g.jsx(he, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: E.code }),
            /* @__PURE__ */ g.jsxs(A.Paragraph, { children: [
              "(",
              E.field?.join(","),
              ") ",
              E.message
            ] })
          ]
        },
        E.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ g.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(x.formState.isValid && x.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 })
        },
        confirmOnClick: x.handleSubmit(y),
        cancelOnClick: q,
        confirmName: N ? "Close" : "Cancel order",
        cancelName: N ? void 0 : "Cancel"
      }
    )
  ] });
}, IQ = ({
  orderId: e,
  orderName: n,
  refetchOrders: t,
  disabled: i
}) => {
  const [a, o] = oe(!1), [s, l] = oe(!1);
  return /* @__PURE__ */ g.jsxs(_, { width: "100%", children: [
    /* @__PURE__ */ g.jsx(
      qn,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ g.jsx(
          he,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: qt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ g.jsx(
      FQ,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: t
      }
    )
  ] });
}, $Q = "_modal_1mprq_1", EQ = {
  modal: $Q
}, TQ = ({
  order: e,
  orderName: n,
  isOpen: t,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: u } = un(), { track: m } = hn(), [d, f] = oe(!1), [h, v] = oe(e?.tags || []), x = "duplicate-shopify-order-form", S = (ee) => ({
    firstName: ee?.firstName,
    lastName: ee?.lastName,
    address1: ee?.address1,
    address2: ee?.address2,
    city: ee?.city,
    provinceCode: ee?.provinceCode,
    zip: ee?.zip,
    countryCode: ee?.countryCodeV2
  }), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: S(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: S(e?.shippingAddress),
    financialStatus: Br.Pending,
    fulfillmentStatus: void 0
  }, j = br({
    mode: "all",
    defaultValues: N
  }), y = j.watch("lineItems").length > 0, { data: q, loading: E } = u(
    hy,
    {
      variables: { productCount: 250, mediaCount: 1 }
    }
  ), C = Zn(() => {
    const ee = q?.Shopify?.products?.nodes;
    return !ee || ee.length === 0 ? [] : ee.filter((J) => !!J).sort((J, K) => J.title.localeCompare(K.title));
  }, [q]);
  qe(() => {
    if (!t || !C?.length || j.getValues("lineItems")?.length)
      return;
    const ee = [];
    e?.lineItems?.forEach((J) => {
      const K = C.find(
        (D) => D.id === J.product?.id
      );
      K && ee.push({ ...K, quantity: J.quantity || 1 });
    }), ee.length > 0 && j.setValue("lineItems", ee, { shouldDirty: !0 });
  }, [t, C, e, j]), qe(() => {
    (h.length > 0 || (j.getValues("tags") || []).length > 0) && j.setValue("tags", h, { shouldDirty: !0 });
  }, [h, j]);
  const [T, { error: U }] = s(
    G1,
    {
      onError: () => {
        f(!1), l({
          title: "Something went wrong",
          text: "The order duplication was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), m("shopify:order:duplicate:failed"), Q();
      },
      onCompleted: () => {
        o(), f(!1), l({
          title: "Success",
          text: "The order was duplicated successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), m("shopify:order:duplicate:succeeded"), Q();
      }
    }
  ), Z = (ee) => {
    const J = ee.lineItems.map((K) => ({
      productId: K.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: K.priceRangeV2.maxVariantPrice.amount,
          currencyCode: K.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: K.quantity
    }));
    f(!0), T({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: J,
          note: ee.customNote,
          tags: ee.tags,
          financialStatus: ee.financialStatus,
          fulfillmentStatus: ee.fulfillmentStatus,
          shippingAddress: $h(ee?.shippingAddress),
          billingAddress: $h(ee?.billingAddress)
        }
      }
    });
  }, Q = () => {
    j.reset(N), v(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ g.jsxs(
    St,
    {
      isOpen: t,
      onClose: Q,
      className: EQ.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ g.jsx(Nt, { title: `Duplicate order ${n}`, onClose: Q }),
        /* @__PURE__ */ g.jsxs(jt, { children: [
          /* @__PURE__ */ g.jsx(Ev, { ...j, children: /* @__PURE__ */ g.jsx("form", { id: x, children: /* @__PURE__ */ g.jsxs(Kt, { children: [
            /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
              ky,
              {
                isAlreadyLoadedProducts: E,
                contextProducts: C
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
              Bt,
              {
                name: "tags",
                render: ({ fieldState: { error: ee } }) => /* @__PURE__ */ g.jsx(
                  Dn,
                  {
                    label: "Tags",
                    meta: {
                      error: ee?.message
                    },
                    children: /* @__PURE__ */ g.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (J) => {
                          J.key === "Enter" && (J.preventDefault(), J.stopPropagation());
                        },
                        children: /* @__PURE__ */ g.jsx(
                          fc,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (J) => {
                              v(J);
                            }
                          },
                          `tags-input-${t}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ g.jsx(en, { span: 4, children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ g.jsx(J1, {}),
              /* @__PURE__ */ g.jsx(Q1, {}),
              /* @__PURE__ */ g.jsx(
                Jt,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ g.jsx(en, { span: 2, children: /* @__PURE__ */ g.jsx(Dn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ g.jsx(
              _,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: qt.boxWrapper,
                children: /* @__PURE__ */ g.jsx(yy, {})
              }
            ) }) })
          ] }) }) }),
          U && /* @__PURE__ */ g.jsx(_n, { error: U })
        ] }),
        /* @__PURE__ */ g.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: x,
              disabled: !y || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(Z)
          }
        )
      ]
    }
  );
}, OQ = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: t = {}
}) => {
  if (!n || n?.length === 0)
    return null;
  const i = Object.values(t).some(
    (a) => a > 0
  );
  return /* @__PURE__ */ g.jsxs(_, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ g.jsx(he, { size: 14, name: "shopify", color: "green.500" }),
      /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    i && /* @__PURE__ */ g.jsx(
      _,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ g.jsx(En, { color: "red.500", children: "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ g.jsx(He, { children: n.map(({ id: a, title: o, quantity: s, variantTitle: l, image: u }) => {
      const m = t[a], d = m > 0, f = m > 1 ? `Refunded (${m} items)` : "Refunded";
      return /* @__PURE__ */ g.jsx(
        He.Item,
        {
          contentLeft: /* @__PURE__ */ g.jsxs(_, { gap: "200", children: [
            /* @__PURE__ */ g.jsx(A.Paragraph, { children: s }),
            /* @__PURE__ */ g.jsx(A.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ g.jsxs(A.Paragraph, { variant: "4", children: [
            o,
            " ",
            l && `(${l})`,
            d && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", color: "red.500", children: f })
          ] }),
          contentRight: u?.url && /* @__PURE__ */ g.jsx(es, { src: `${u?.url}&height=48`, alt: o })
        },
        `list-${e}-${a}`
      );
    }) })
  ] });
}, RQ = Si`
  mutation refuncLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, DQ = "_modal_21e62_1", PQ = {
  modal: DQ
}, G0 = "partial-refund-shopify-order-form", AQ = ({
  order: e,
  orderName: n,
  isOpen: t,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = hn(), { useQuery: u } = un(), [m, d] = oe(!1), [f, h] = oe([]), { data: v, loading: x } = u(
    hy,
    {
      variables: { productCount: 250, mediaCount: 1 }
    }
  ), S = Zn(() => {
    const U = v?.Shopify?.products?.nodes;
    return !U || U.length === 0 ? [] : U.filter((Z) => !!Z).sort((Z, Q) => Z.title.localeCompare(Q.title));
  }, [v]), N = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, j = br({
    mode: "all",
    defaultValues: N
  }), y = f.length > 0, [q, { error: E }] = o(
    RQ,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), T();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), T();
      }
    }
  );
  qe(() => {
    if (!t || !S?.length || j.getValues("lineItems")?.length)
      return;
    const U = [];
    e?.lineItems?.forEach((Z) => {
      const Q = S.find(
        (ee) => ee.id === Z.product?.id
      );
      Q && U.push({ ...Q, quantity: Z.quantity || 1 });
    }), U.length > 0 && (j.setValue("lineItems", U, { shouldDirty: !0 }), h([]));
  }, [t, S, e, j]);
  const C = (U) => {
    d(!0);
    const Z = (U.lineItems || []).filter(
      (Q) => f.includes(Q.id)
    ).map((Q) => {
      const ee = e?.lineItems?.find(
        (D) => D.product?.id === Q.id
      ), J = ee?.quantity || 0, K = Math.max(
        0,
        Math.min(J, Q.quantity || 0)
      );
      return ee && K > 0 ? { lineItemId: ee.id, quantity: K } : void 0;
    }).filter((Q) => !!Q);
    q({
      variables: {
        input: {
          orderId: e.id,
          refundLineItems: Z,
          note: U.customNote || void 0,
          notify: !0
        }
      }
    });
  }, T = () => {
    j.reset(N), d(!1), i(!1);
  };
  return /* @__PURE__ */ g.jsxs(St, { isOpen: t, onClose: T, className: PQ.modal, children: [
    /* @__PURE__ */ g.jsx(Nt, { title: `Refund order ${n}`, onClose: T }),
    /* @__PURE__ */ g.jsxs(jt, { children: [
      /* @__PURE__ */ g.jsx(Ev, { ...j, children: /* @__PURE__ */ g.jsx("form", { id: G0, children: /* @__PURE__ */ g.jsxs(Kt, { children: [
        /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
          ky,
          {
            selectionMode: !0,
            hideDeleteButton: !0,
            isAlreadyLoadedProducts: x,
            contextProducts: S,
            selectedProductIds: f,
            onToggleSelect: (U, Z) => {
              h((Q) => Z ? Array.from(/* @__PURE__ */ new Set([...Q, U])) : Q.filter((ee) => ee !== U));
            },
            onToggleSelectAll: (U) => {
              const Z = (j.getValues("lineItems") || []).map((Q) => Q.id);
              h(U ? Z : []);
            }
          }
        ) }),
        /* @__PURE__ */ g.jsx(en, { span: 4, children: /* @__PURE__ */ g.jsx(_, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ g.jsx(
          Jt,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ g.jsx(en, { span: 2, children: /* @__PURE__ */ g.jsx(Dn, { label: "Details", noAlert: !0, children: /* @__PURE__ */ g.jsx(
          _,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: qt.boxWrapper,
            children: /* @__PURE__ */ g.jsx(
              yy,
              {
                withAddresses: !1,
                selectedProductIds: f
              }
            )
          }
        ) }) })
      ] }) }) }),
      E && /* @__PURE__ */ g.jsx(_n, { error: E })
    ] }),
    /* @__PURE__ */ g.jsx(
      Et,
      {
        confirmProps: {
          type: "submit",
          form: G0,
          disabled: !y || m,
          isLoading: m,
          loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: j.handleSubmit(C)
      }
    )
  ] });
}, LQ = ({
  order: e,
  shopifyId: n,
  orderLink: t,
  refetchOrders: i
}) => {
  const { useMutation: a, showNotification: o, showModal: s } = un(), { track: l } = hn(), { suggestedRefund: u, currencyCode: m, id: d, name: f } = e, [h] = a($J, {
    onError: (S) => {
      setTimeout(() => x(S), 500);
    },
    onCompleted: (S) => {
      const N = S.Shopify?.refundCreate?.userErrors;
      N && N.length > 0 ? x(
        new iI({
          graphQLErrors: N.map((j) => ({
            message: j.message
          }))
        })
      ) : (o({
        title: "Order refunded",
        text: `You refunded order ${f}`,
        icon: "check-circle-filled",
        severity: "success"
      }), i());
    }
  }), v = ft(() => {
    l("shopify:order:refund:requested", { shopifyId: n, orderId: d });
    const { amount: S, ...N } = u;
    s({
      headline: `Refund Order ${f}?`,
      children: /* @__PURE__ */ g.jsxs(A.Paragraph, { children: [
        "You are about to refund ",
        S,
        " ",
        m,
        " to the customer. Are you sure you want to refund the order?"
      ] }),
      confirmLabel: "Confirm order refund",
      confirmVariant: "primary",
      cancelLabel: "Cancel",
      cancelVariant: "secondary",
      onConfirm: () => {
        l("shopify:order:refund:confirmed", { shopifyId: n, orderId: d }), h({
          variables: {
            input: N
          }
        });
      },
      onCancel: () => l("shopify:order:refund:canceled", { shopifyId: n, orderId: d })
    });
  }, [n, d]), x = ft(
    (S) => {
      s({
        headline: "Something went wrong",
        text: "It looks like something went wrong when trying to refund the order. Please create the refund in Shopify directly.",
        confirmLabel: "Close",
        children: /* @__PURE__ */ g.jsxs(_, { flexDirection: "column", children: [
          /* @__PURE__ */ g.jsx(_n, { error: S }),
          /* @__PURE__ */ g.jsx(
            Rt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(t, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ g.jsx(he, { name: "external-link" }),
              children: "View order in Shopify"
            }
          )
        ] }),
        onConfirm: () => {
        }
      });
    },
    [t]
  );
  return /* @__PURE__ */ g.jsx(_, { width: "100%", children: /* @__PURE__ */ g.jsx(
    qn,
    {
      variant: "secondary",
      onClick: v,
      disabled: u?.refundLineItems?.length === 0,
      slotStart: /* @__PURE__ */ g.jsx(he, { size: 14, name: "undo" }),
      className: qt.fullWidth,
      children: "Full refund"
    }
  ) });
}, VQ = "_modal_al73g_1", zQ = {
  modal: VQ
}, MQ = ({
  orderId: e,
  tags: n,
  isOpen: t,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = hn(), { useMutation: s, showNotification: l } = un(), [u, m] = oe(n), [d, f] = oe(!1), h = br({
    defaultValues: {
      tags: n
    }
  });
  qe(() => {
    u && h.setValue("tags", u, { shouldDirty: !0 });
  }, [u]);
  const [v, { error: x, reset: S }] = s(TJ, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), N = ft(
    (y) => {
      f(!0), v({
        variables: {
          input: {
            id: e,
            tags: y.tags
          }
        }
      }).then((q) => {
        h.reset({ tags: q.data.Shopify.orderUpdate.order.tags });
      });
    },
    [e]
  ), j = () => {
    i(!1), S();
  };
  return /* @__PURE__ */ g.jsxs(St, { isOpen: t, onClose: j, className: zQ.modal, children: [
    /* @__PURE__ */ g.jsx(Nt, { title: "Manage tags for order", onClose: j }),
    /* @__PURE__ */ g.jsxs(jt, { children: [
      /* @__PURE__ */ g.jsx(Kt, { children: /* @__PURE__ */ g.jsx(en, { children: /* @__PURE__ */ g.jsx(
        Bt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: y } }) => /* @__PURE__ */ g.jsx(
            Dn,
            {
              label: "Tags",
              meta: {
                error: y?.message
              },
              children: /* @__PURE__ */ g.jsx(
                fc,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (q) => m(q)
                }
              )
            }
          )
        }
      ) }) }),
      x && /* @__PURE__ */ g.jsx(_n, { error: x })
    ] }),
    /* @__PURE__ */ g.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: d,
          loadingIndicator: /* @__PURE__ */ g.jsx(cn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(N),
        cancelOnClick: j,
        confirmName: x ? "Close" : "Save",
        cancelName: x ? void 0 : "Cancel"
      }
    )
  ] });
}, UQ = "_editIcon_1dntr_1", BQ = {
  editIcon: UQ
}, qQ = ({
  orderId: e,
  tags: n,
  refetchOrders: t
}) => {
  const [i, a] = oe(!1), o = 14, s = n.length > 0;
  return /* @__PURE__ */ g.jsxs(g.Fragment, { children: [
    /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ g.jsxs(_, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ g.jsx(he, { size: o, name: "tag", color: "green.500" }),
        /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ g.jsxs(_, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !s && /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            s && n.map((l, u) => /* @__PURE__ */ g.jsx(zn, { size: "small", variant: "primary", children: l }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ g.jsx(_, { gap: "250", flexDirection: "row", children: /* @__PURE__ */ g.jsx(Je, { content: "Edit tags", children: /* @__PURE__ */ g.jsx(
        he,
        {
          size: o,
          name: "pen",
          className: BQ.editIcon,
          onClick: () => a(!0)
        }
      ) }) })
    ] }),
    /* @__PURE__ */ g.jsx(
      MQ,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: t
      }
    )
  ] });
}, HQ = "_icon_cddi1_1", WQ = "_link_cddi1_6", Y0 = {
  icon: HQ,
  link: WQ
}, KQ = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: t } = Xo(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ g.jsx(
    He.Item,
    {
      contentLeft: /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ g.jsx(
        A.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: Y0.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ g.jsx(Je, { content: "Copy tracking code", children: /* @__PURE__ */ g.jsx(
        he,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => t(a.toString()),
          className: Y0.icon
        }
      ) })
    }
  );
}, GQ = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ g.jsxs(_, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ g.jsx(he, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ g.jsx(He, { children: e.map((n) => /* @__PURE__ */ g.jsx(KQ, { trackingInfo: n }, n.number)) })
] }), YQ = "_order_135ze_1", JQ = "_orderIsOpen_135ze_9", QQ = "_orderHeader_135ze_12", _f = {
  order: YQ,
  orderIsOpen: JQ,
  orderHeader: QQ
}, XQ = (e) => {
  const n = [];
  return e.refunds.forEach((t) => {
    const i = t.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...t,
      refundLineItems: {
        ...t.refundLineItems,
        edges: i
      }
    });
  }), n;
}, ZQ = (e) => {
  const n = {}, t = XQ(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), t.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, eX = ({
  order: e,
  shopifyId: n,
  openByDefault: t,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: u,
  displayPartialRefundOrder: m,
  refetchOrders: d
}) => {
  const { track: f } = hn(), [h, v] = oe(!1), [x, S] = oe(!1), [N, j] = oe(t), {
    id: y,
    name: q,
    createdAt: E,
    status: C,
    currentTotalPriceSet: T,
    currencyCode: U,
    lineItems: Z,
    billingAddress: Q,
    shippingAddress: ee,
    trackingInfos: J,
    tags: K
  } = e, D = !!ee, G = vy(y), ne = `https://${l}/admin/orders/${G ?? ""}`, de = T?.shopMoney?.amount ?? 0, ge = C.includes("cancelled"), ce = new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: U
  }).format(de), ve = e?.refunds ? ZQ(e) : {};
  return /* @__PURE__ */ g.jsxs(
    _,
    {
      className: ht(_f.order, {
        [_f.orderIsOpen]: N
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ g.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: _f.orderHeader,
            onClick: () => j(!N),
            children: [
              /* @__PURE__ */ g.jsxs(_, { gap: "100", flexDirection: "column", children: [
                E && /* @__PURE__ */ g.jsx(_, { alignItems: "center", children: /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: Tn(E).format(Ih) }) }),
                /* @__PURE__ */ g.jsxs(A.Paragraph, { variant: "1", children: [
                  "Order ",
                  q
                ] })
              ] }),
              /* @__PURE__ */ g.jsx(
                lr,
                {
                  variant: "tertiary",
                  icon: N ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        N && /* @__PURE__ */ g.jsxs(_, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ g.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ g.jsx(he, { size: 14, name: "activity", color: "green.500" }),
            /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: C })
            ] })
          ] }),
          /* @__PURE__ */ g.jsxs(_, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ g.jsx(he, { size: 14, name: "chart-bar", color: "green.500" }),
            /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: ce })
            ] })
          ] }),
          /* @__PURE__ */ g.jsx(
            qQ,
            {
              orderId: y,
              tags: K,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ g.jsx(
            Eh,
            {
              openByDefault: !D,
              labelText: "Billing address",
              address: Q,
              shippingCountryCodes: i,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ g.jsx(
            Eh,
            {
              openByDefault: D,
              shopifyId: n,
              orderId: y,
              icon: "map-pin",
              labelText: "Shipping address",
              address: ee,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: d
            }
          ),
          /* @__PURE__ */ g.jsx(
            OQ,
            {
              orderId: y,
              lineItems: Z,
              refundedQuantities: ve
            }
          ),
          /* @__PURE__ */ g.jsx(GQ, { trackingInfos: J }),
          (o || m) && /* @__PURE__ */ g.jsxs(_, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ g.jsx(
              LQ,
              {
                order: e,
                shopifyId: n,
                refetchOrders: d,
                orderLink: ne
              }
            ),
            m && /* @__PURE__ */ g.jsx(_, { width: "100%", children: /* @__PURE__ */ g.jsx(
              qn,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => S(!0),
                className: qt.fullWidth,
                children: "Partial refund"
              }
            ) })
          ] }),
          (u || s) && /* @__PURE__ */ g.jsxs(_, { flexDirection: "row", gap: "200", children: [
            u && /* @__PURE__ */ g.jsx(_, { width: "100%", children: /* @__PURE__ */ g.jsx(
              qn,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => v(!0),
                className: qt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ g.jsx(
              IQ,
              {
                orderId: y,
                orderName: q,
                disabled: ge,
                refetchOrders: d
              }
            )
          ] }),
          /* @__PURE__ */ g.jsx(
            Rt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(ne, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ g.jsx(he, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: y
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        h && /* @__PURE__ */ g.jsx(
          TQ,
          {
            order: e,
            shopifyId: n,
            orderName: q,
            isOpen: h,
            setIsOpen: v,
            refetchOrders: d
          }
        ),
        x && /* @__PURE__ */ g.jsx(
          AQ,
          {
            order: e,
            orderName: q,
            isOpen: x,
            setIsOpen: S,
            refetchOrders: () => {
              d();
            }
          }
        )
      ]
    }
  );
}, nX = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: t,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: u,
  shopifyCustomer: m
}) => {
  const { track: d } = hn(), [f, h] = oe([]), [v, x] = oe(!1), S = vy(m?.id), N = `https://${n}/admin/orders?customer_id=${S ?? ""}`, {
    getCustomerOrders: j,
    isCustomerOrdersLoading: y,
    customerOrdersError: q,
    customerOrders: E,
    refetchCustomerOrders: C
  } = AJ();
  return qe(() => {
    !y && S && j({
      variables: {
        query: `customer_id:${S}`
      }
    });
  }, [S]), qe(() => {
    const T = E?.Shopify?.orders?.edges;
    T && h(pQ({ ordersData: T }));
  }, [E]), m ? q ? /* @__PURE__ */ g.jsx(_n, { error: q }) : /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: "Customer orders" }),
      !y && /* @__PURE__ */ g.jsx(zn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ g.jsx(
      qn,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => x(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
      y && /* @__PURE__ */ g.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ g.jsx(cn, {}) }),
      !y && f.length === 0 && /* @__PURE__ */ g.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ g.jsx(A.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !y && f.length > 0 && /* @__PURE__ */ g.jsx(_, { gap: "200", flexDirection: "column", children: f.map((T, U) => /* @__PURE__ */ g.jsx(
        eX,
        {
          order: T,
          openByDefault: U === 0,
          shopifyId: m?.id,
          displayRefund: t,
          displayCancel: i,
          enableEditShippingAddress: u,
          customerCountryCodes: e,
          refetchOrders: C,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${U}-${T.id}`
      )) }),
      /* @__PURE__ */ g.jsx(
        Rt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(N, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ g.jsx(he, { name: "external-link" }),
          onClick: () => d("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ g.jsx(
      jQ,
      {
        isOpen: v,
        setIsOpen: x,
        shopifyCustomer: m,
        refetchCustomerOrders: C,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, tX = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const t = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(t).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ g.jsx(g.Fragment, { children: /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ g.jsxs(He, { className: qt.list, children: [
      /* @__PURE__ */ g.jsx(He.Text, { variant: "dense", className: qt.listItem, children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ g.jsx(He.Text, { variant: "dense", className: qt.listItem, children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, rX = "_segmentName_1dkhk_1", iX = {
  segmentName: rX
}, aX = 100, fl = 10, oX = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: t } = un(), [i, a] = oe([]), [o, s] = oe(fl), [l, u] = oe(!1), m = Zn(
    () => i.filter((S) => S.isMember).length,
    [i]
  ), { loading: d, error: f } = n(
    wJ,
    {
      skip: !e,
      variables: {
        first: aX
      },
      onCompleted: (S) => {
        const N = S?.Shopify?.segments?.edges;
        if (N && N.length > 0) {
          const j = N.map(({ node: y }) => ({
            ...y,
            isMember: !1
          })).sort((y, q) => y.name.localeCompare(q.name));
          a(j), h({
            variables: {
              customerId: e,
              segmentIds: j.map((y) => y.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: v, error: x }
  ] = t(CJ, {
    onCompleted: (S) => {
      const N = S?.Shopify?.customerSegmentMembership?.memberships;
      if (N && N.length > 0) {
        const j = i.map((y) => {
          const q = N.find(
            (E) => E.segmentId === y.id
          );
          return {
            ...y,
            ...q?.isMember && { isMember: q.isMember }
          };
        }).sort(
          (y, q) => y.isMember === q.isMember ? 0 : y.isMember ? -1 : 1
        );
        a(j);
      }
    }
  });
  return qe(() => {
    s(l ? i.length : fl);
  }, [l]), e ? /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ g.jsx(A.Heading, { variant: "heading-3", children: "Segment membership" }),
      !d && /* @__PURE__ */ g.jsx(zn, { variant: "success", size: "small", children: m })
    ] }),
    d && /* @__PURE__ */ g.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ g.jsx(cn, {}) }),
    !d && i.length === 0 && /* @__PURE__ */ g.jsx(A.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ g.jsx(_n, { error: f }),
    x && /* @__PURE__ */ g.jsx(_n, { error: x }),
    !d && i.length > 0 && /* @__PURE__ */ g.jsxs(He, { className: qt.list, children: [
      i.slice(0, o).map(({ id: S, name: N, isMember: j }) => /* @__PURE__ */ g.jsx(He.Text, { className: qt.listItem, children: /* @__PURE__ */ g.jsx(
        Je,
        {
          content: `${j ? "Member of" : "Not a member of"} ${N}`,
          children: /* @__PURE__ */ g.jsxs(_, { justifyContent: "space-between", children: [
            /* @__PURE__ */ g.jsx(A.Paragraph, { variant: "4", className: iX.segmentName, children: N }),
            v && /* @__PURE__ */ g.jsx(cn, { size: 12 }),
            !v && /* @__PURE__ */ g.jsx(_, { children: /* @__PURE__ */ g.jsx(
              he,
              {
                color: j ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, S)),
      i.length > fl && /* @__PURE__ */ g.jsx(_, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ g.jsx(
        qn,
        {
          variant: "secondary",
          onClick: () => u(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - fl} more`
        }
      ) })
    ] })
  ] }) : null;
}, sX = ({
  conversationContext: e,
  settings: n
}) => {
  const {
    isCustomerLoading: t,
    customerError: i,
    customerData: a,
    refetchCustomer: o,
    customerNetworkStatus: s
  } = PJ({ conversationContext: e }), [l, u] = oe(), [m, d] = oe(
    []
  ), f = n.apiHostName, h = n.displayRefundOrder ?? !1, v = n.displayCancelOrder ?? !1, x = n.enableEditShippingAddress ?? !1, S = n.displayEmailMarketingConsent ?? !1, N = n.displayOrdersOverview ?? !1, j = n.displaySegmentMembership ?? !1, y = n.displayDiscountCodeCreation ?? !1, q = n.displayDiscountCodes ?? !1, E = n.displayCreateOrder ?? !1, C = n.displayDuplicateOrder ?? !1, T = n.displayCreateDraftOrder ?? !1, U = n.displayPartialRefundOrder ?? !1;
  if (qe(() => {
    const Z = a?.Shopify?.customers?.edges[0]?.node;
    Z && !t ? (d(
      a?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(Z)) : u(void 0);
  }, [a]), !t && i)
    return /* @__PURE__ */ g.jsx(_n, { error: i, retry: o });
  if (!t && !i && !l) {
    const Z = `https://${f}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ g.jsxs(
      _,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ g.jsx(A.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ g.jsxs(_, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ g.jsx(
              HJ,
              {
                refetchCustomer: o,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ g.jsx(
              Rt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(Z, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ g.jsx(he, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return t && s !== hr.refetch ? /* @__PURE__ */ g.jsx(_, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ g.jsx(cn, {}) }) : /* @__PURE__ */ g.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ g.jsx(
          GJ,
          {
            customer: l,
            shopifyDomain: f,
            refresh: o,
            loading: t,
            networkStatus: s
          }
        ),
        N && /* @__PURE__ */ g.jsx(
          tX,
          {
            totalOrders: l?.numberOfOrders,
            amountSpent: l?.amountSpent
          }
        ),
        j && /* @__PURE__ */ g.jsx(oX, { shopifyId: l?.id }),
        S && /* @__PURE__ */ g.jsx(mQ, { customer: l }),
        q && /* @__PURE__ */ g.jsx(
          dQ,
          {
            displayDiscountCodeCreation: y
          }
        ),
        /* @__PURE__ */ g.jsx(
          nX,
          {
            shopifyCustomer: l,
            shopifyDomain: f,
            displayRefund: h,
            displayCancel: v,
            displayCreateOrder: E,
            displayCreateDraftOrder: T,
            enableEditShippingAddress: x,
            customerCountryCodes: m,
            displayDuplicateOrder: C,
            displayPartialRefundOrder: U
          }
        )
      ]
    }
  );
}, Ct = [];
for (let e = 0; e < 256; ++e)
  Ct.push((e + 256).toString(16).slice(1));
function lX(e, n = 0) {
  return (Ct[e[n + 0]] + Ct[e[n + 1]] + Ct[e[n + 2]] + Ct[e[n + 3]] + "-" + Ct[e[n + 4]] + Ct[e[n + 5]] + "-" + Ct[e[n + 6]] + Ct[e[n + 7]] + "-" + Ct[e[n + 8]] + Ct[e[n + 9]] + "-" + Ct[e[n + 10]] + Ct[e[n + 11]] + Ct[e[n + 12]] + Ct[e[n + 13]] + Ct[e[n + 14]] + Ct[e[n + 15]]).toLowerCase();
}
let xf;
const cX = new Uint8Array(16);
function uX() {
  if (!xf) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    xf = crypto.getRandomValues.bind(crypto);
  }
  return xf(cX);
}
const dX = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), J0 = { randomUUID: dX };
function mX(e, n, t) {
  if (J0.randomUUID && !e)
    return J0.randomUUID();
  e = e || {};
  const i = e.random ?? e.rng?.() ?? uX();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, lX(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._pointer_ls8kj_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_ls8kj_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_ls8kj_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ls8kj_63:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_unsvt_48{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_unsvt_48:hover,._messageIsOpen_unsvt_56{border-color:var(--dixa-color-neutral-400)}._messageHeader_unsvt_60{cursor:pointer}._messageText_unsvt_64{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:hidden;overflow-y:auto;overflow-x:auto}._messageText_unsvt_64::-webkit-scrollbar{width:7px;height:7px}._messageText_unsvt_64::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-200)}._messageText_unsvt_64::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:5px}._buttonLink_unsvt_86{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Sf = { exports: {} }, xo = {}, Q0;
function pX() {
  if (Q0) return xo;
  Q0 = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return xo.Fragment = t, xo.jsx = s, xo.jsxs = s, xo;
}
var hl = {}, X0;
function fX() {
  return X0 || (X0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    hl.Fragment = i, hl.jsx = Un, hl.jsxs = Bn;
  }()), hl;
}
var Z0;
function hX() {
  return Z0 || (Z0 = 1, process.env.NODE_ENV === "production" ? Sf.exports = pX() : Sf.exports = fX()), Sf.exports;
}
var M = hX(), X1 = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(X1 || {}), Th = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Th || {});
const vX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, yX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, gX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, kX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, bX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, _X = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, xX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, SX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, NX = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, jX = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": vX,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": yX,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": gX,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": kX,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": bX,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": _X,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": xX,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": SX,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": NX
};
function pi(e) {
  return jX[e] ?? {};
}
const wX = pi(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), CX = pi(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), FX = pi(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), IX = pi(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), $X = pi(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), EX = pi(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), TX = pi(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), OX = pi(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), RX = pi(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), DX = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: t } = hn(), [i, a] = oe(), [o, s] = oe(), [l, u] = oe(), {
    loading: m,
    error: d,
    data: f,
    refetch: h
  } = n(wX, {
    skip: !e,
    variables: { contactId: e }
  });
  return qe(() => {
    const v = f?.Voyado?.ContactsV_GetContactById;
    !m && v && typeof v == "object" && ("id" in v && t("voyado:profile:received", { hasProfile: !0 }), "attributes" in v && a(v.attributes), "preferences" in v && s(v.preferences), "consents" in v && u(
      v?.consents?.filter(
        (x) => x !== null
      ) || void 0
    )), !m && (!v || typeof v != "object") && t("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Zn(
    () => ({
      isLoading: m,
      error: d,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [d, i, o, l]
  );
};
function Pl(e = !1, n) {
  const [t, i] = oe(e);
  return qe(() => {
    const a = t ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, t]), { isCopied: t, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const PX = {
  count: 0,
  items: []
}, AX = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: t } = hn(), [i, a] = oe(PX), {
    loading: o,
    error: s,
    data: l
  } = n(IX, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const u = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, d = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (d?.count ?? 0) + (u?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...u.items ?? [],
          ...d.items ?? []
        ]
      };
      a(f), t("voyado:messages:received", {
        emailsReceived: u.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: d.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, LX = {
  count: 0,
  totalCount: 0,
  items: []
}, VX = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), { track: t } = hn(), [i, a] = oe(
    LX
  ), {
    loading: o,
    error: s,
    data: l
  } = n($X, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return qe(() => {
    const u = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && u) {
      a(
        u
      );
      const { count: m } = u;
      m && t("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, zX = ({
  conversationContext: e
}) => {
  const { useQuery: n } = un(), [t, i] = oe(void 0), [a, o] = oe(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: u,
    error: m,
    data: d,
    refetch: f
  } = n(FX, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return qe(() => {
    const h = d?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [d?.Voyado, u]), {
    isLoading: u,
    contactId: t,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, MX = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: t } = un(), [i, a] = oe(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: u
  } = t(CX, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const d = m?.memberlevel;
      a({
        levelName: d?.levelName,
        remainingToUpgrade: d?.remainingToUpgrade,
        basedOnRewardPoints: d?.basedOnRewardPoints,
        levelId: d?.levelId,
        latestChange: d?.latestChange,
        expires: d?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Zn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: u
    }),
    [o, s, i, u]
  );
}, UX = "_pointer_ls8kj_48", BX = "_list_ls8kj_53", qX = "_listItem_ls8kj_63", nt = {
  pointer: UX,
  list: BX,
  listItem: qX
};
var Cs = (e) => e.type === "checkbox", Ai = (e) => e instanceof Date, Mt = (e) => e == null;
const Z1 = (e) => typeof e == "object";
var ot = (e) => !Mt(e) && !Array.isArray(e) && Z1(e) && !Ai(e), eF = (e) => ot(e) && e.target ? Cs(e.target) ? e.target.checked : e.target.value : e, HX = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, nF = (e, n) => e.has(HX(n)), WX = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return ot(n) && n.hasOwnProperty("isPrototypeOf");
}, by = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function It(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(by && (e instanceof Blob || i)) && (t || ot(e)))
    if (n = t ? [] : {}, !t && !WX(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = It(e[a]));
  else
    return e;
  return n;
}
var Zc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], rt = (e) => e === void 0, Ge = (e, n, t) => {
  if (!n || !ot(e))
    return t;
  const i = Zc(n.split(/[,[\].]+?/)).reduce((a, o) => Mt(a) ? a : a[o], e);
  return rt(i) || i === e ? rt(e[n]) ? t : e[n] : i;
}, ir = (e) => typeof e == "boolean", _y = (e) => /^\w*$/.test(e), tF = (e) => Zc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Kn = (e, n, t) => {
  let i = -1;
  const a = _y(n) ? [n] : tF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = t;
    if (i !== s) {
      const m = e[l];
      u = ot(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const ic = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ai = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, KX = xe.createContext(null), xy = () => xe.useContext(KX);
var rF = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Fr.all && (n._proxyFormState[s] = !i || Fr.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function GX(e) {
  const n = xy(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = xe.useState(t._formState), u = xe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = xe.useRef(a);
  return m.current = a, xe.useEffect(() => t._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), xe.useEffect(() => {
    u.current.isValid && t._setValid(!0);
  }, [t]), xe.useMemo(() => rF(s, t, u.current, !1), [s, t]);
}
var Gr = (e) => typeof e == "string", iF = (e, n, t, i, a) => Gr(e) ? (i && n.watch.add(e), Ge(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ge(t, o))) : (i && (n.watchAll = !0), t);
function aF(e) {
  const n = xy(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = xe.useRef(i), u = xe.useRef(a);
  l.current = i, xe.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(iF(l.current, t._names, f.values || t._formValues, !1, u.current))
  }), [t, o, s]);
  const [m, d] = xe.useState(t._getWatch(i, a));
  return xe.useEffect(() => t._removeUnmounted()), m;
}
function YX(e) {
  const n = xy(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = nF(a._names.array, t), l = aF({
    control: a,
    name: t,
    defaultValue: Ge(a._formValues, t, Ge(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), u = GX({
    control: a,
    name: t,
    exact: !0
  }), m = xe.useRef(e), d = xe.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...ir(e.disabled) ? { disabled: e.disabled } : {}
  })), f = xe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ge(u.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ge(u.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ge(u.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ge(u.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Ge(u.errors, t)
    }
  }), [u, t]), h = xe.useCallback((N) => d.current.onChange({
    target: {
      value: eF(N),
      name: t
    },
    type: ic.CHANGE
  }), [t]), v = xe.useCallback(() => d.current.onBlur({
    target: {
      value: Ge(a._formValues, t),
      name: t
    },
    type: ic.BLUR
  }), [t, a._formValues]), x = xe.useCallback((N) => {
    const j = Ge(a._fields, t);
    j && N && (j._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, t]), S = xe.useMemo(() => ({
    name: t,
    value: l,
    ...ir(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: x
  }), [t, i, u.disabled, h, v, x, l]);
  return xe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...ir(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const j = (y, q) => {
      const E = Ge(a._fields, y);
      E && E._f && (E._f.mount = q);
    };
    if (j(t, !0), N) {
      const y = It(Ge(a._options.defaultValues, t));
      Kn(a._defaultValues, t, y), rt(Ge(a._formValues, t)) && Kn(a._formValues, t, y);
    }
    return !s && a.register(t), () => {
      (s ? N && !a._state.action : N) ? a.unregister(t) : j(t, !1);
    };
  }, [t, a, s, o]), xe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), xe.useMemo(() => ({
    field: S,
    formState: u,
    fieldState: f
  }), [S, u, f]);
}
const eN = (e) => e.render(YX(e));
var JX = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, zo = (e) => Array.isArray(e) ? e : [e], nN = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const t of e)
        t.next && t.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((t) => t !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Oh = (e) => Mt(e) || !Z1(e);
function ki(e, n) {
  if (Oh(e) || Oh(n))
    return e === n;
  if (Ai(e) && Ai(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Ai(o) && Ai(s) || ot(o) && ot(s) || Array.isArray(o) && Array.isArray(s) ? !ki(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Lt = (e) => ot(e) && !Object.keys(e).length, Sy = (e) => e.type === "file", Ir = (e) => typeof e == "function", ac = (e) => {
  if (!by)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, oF = (e) => e.type === "select-multiple", Ny = (e) => e.type === "radio", QX = (e) => Ny(e) || Cs(e), Nf = (e) => ac(e) && e.isConnected;
function XX(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = rt(e) ? i++ : e[n[i++]];
  return e;
}
function ZX(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !rt(e[n]))
      return !1;
  return !0;
}
function gt(e, n) {
  const t = Array.isArray(n) ? n : _y(n) ? [n] : tF(n), i = t.length === 1 ? e : XX(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (ot(i) && Lt(i) || Array.isArray(i) && ZX(i)) && gt(e, t.slice(0, -1)), e;
}
var sF = (e) => {
  for (const n in e)
    if (Ir(e[n]))
      return !0;
  return !1;
};
function oc(e, n = {}) {
  const t = Array.isArray(e);
  if (ot(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || ot(e[i]) && !sF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, oc(e[i], n[i])) : Mt(e[i]) || (n[i] = !0);
  return n;
}
function lF(e, n, t) {
  const i = Array.isArray(e);
  if (ot(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || ot(e[a]) && !sF(e[a]) ? rt(n) || Oh(t[a]) ? t[a] = Array.isArray(e[a]) ? oc(e[a], []) : { ...oc(e[a]) } : lF(e[a], Mt(n) ? {} : n[a], t[a]) : t[a] = !ki(e[a], n[a]);
  return t;
}
var So = (e, n) => lF(e, n, oc(n));
const tN = {
  value: !1,
  isValid: !1
}, rN = { value: !0, isValid: !0 };
var cF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !rt(e[0].attributes.value) ? rt(e[0].value) || e[0].value === "" ? rN : { value: e[0].value, isValid: !0 } : rN
    ) : tN;
  }
  return tN;
}, uF = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => rt(e) ? e : n ? e === "" ? NaN : e && +e : t && Gr(e) ? new Date(e) : i ? i(e) : e;
const iN = {
  isValid: !1,
  value: null
};
var dF = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, iN) : iN;
function aN(e) {
  const n = e.ref;
  return Sy(n) ? n.files : Ny(n) ? dF(e.refs).value : oF(n) ? [...n.selectedOptions].map(({ value: t }) => t) : Cs(n) ? cF(e.refs).value : uF(rt(n.value) ? e.ref.value : n.value, e);
}
var eZ = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Ge(n, o);
    s && Kn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, sc = (e) => e instanceof RegExp, No = (e) => rt(e) ? e : sc(e) ? e.source : ot(e) ? sc(e.value) ? e.value.source : e.value : e, oN = (e) => ({
  isOnSubmit: !e || e === Fr.onSubmit,
  isOnBlur: e === Fr.onBlur,
  isOnChange: e === Fr.onChange,
  isOnAll: e === Fr.all,
  isOnTouch: e === Fr.onTouched
});
const sN = "AsyncFunction";
var nZ = (e) => !!e && !!e.validate && !!(Ir(e.validate) && e.validate.constructor.name === sN || ot(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === sN)), tZ = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), lN = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Mo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Ge(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Mo(l, n))
          break;
      } else if (ot(l) && Mo(l, n))
        break;
    }
  }
};
function cN(e, n, t) {
  const i = Ge(e, t);
  if (i || _y(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ge(n, o), l = Ge(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var rZ = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return Lt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Fr.all));
}, iZ = (e, n, t) => !e || !n || e === n || zo(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), aZ = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, oZ = (e, n) => !Zc(Ge(e, n)).length && gt(e, n), sZ = (e, n, t) => {
  const i = zo(Ge(e, t));
  return Kn(i, "root", n[t]), Kn(e, t, i), e;
}, Al = (e) => Gr(e);
function uN(e, n, t = "validate") {
  if (Al(e) || Array.isArray(e) && e.every(Al) || ir(e) && !e)
    return {
      type: t,
      message: Al(e) ? e : "",
      ref: n
    };
}
var la = (e) => ot(e) && !sc(e) ? e : {
  value: e,
  message: ""
}, dN = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: v, validate: x, name: S, valueAsNumber: N, mount: j } = e._f, y = Ge(t, S);
  if (!j || n.has(S))
    return {};
  const q = l ? l[0] : s, E = (K) => {
    a && q.reportValidity && (q.setCustomValidity(ir(K) ? "" : K || ""), q.reportValidity());
  }, C = {}, T = Ny(s), U = Cs(s), Z = T || U, Q = (N || Sy(s)) && rt(s.value) && rt(y) || ac(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ee = JX.bind(null, S, i, C), J = (K, D, G, ne = ai.maxLength, de = ai.minLength) => {
    const ge = K ? D : G;
    C[S] = {
      type: K ? ne : de,
      message: ge,
      ref: s,
      ...ee(K ? ne : de, ge)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Z && (Q || Mt(y)) || ir(y) && !y || U && !cF(l).isValid || T && !dF(l).isValid)) {
    const { value: K, message: D } = Al(u) ? { value: !!u, message: u } : la(u);
    if (K && (C[S] = {
      type: ai.required,
      message: D,
      ref: q,
      ...ee(ai.required, D)
    }, !i))
      return E(D), C;
  }
  if (!Q && (!Mt(f) || !Mt(h))) {
    let K, D;
    const G = la(h), ne = la(f);
    if (!Mt(y) && !isNaN(y)) {
      const de = s.valueAsNumber || y && +y;
      Mt(G.value) || (K = de > G.value), Mt(ne.value) || (D = de < ne.value);
    } else {
      const de = s.valueAsDate || new Date(y), ge = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ce = s.type == "time", ve = s.type == "week";
      Gr(G.value) && y && (K = ce ? ge(y) > ge(G.value) : ve ? y > G.value : de > new Date(G.value)), Gr(ne.value) && y && (D = ce ? ge(y) < ge(ne.value) : ve ? y < ne.value : de < new Date(ne.value));
    }
    if ((K || D) && (J(!!K, G.message, ne.message, ai.max, ai.min), !i))
      return E(C[S].message), C;
  }
  if ((m || d) && !Q && (Gr(y) || o && Array.isArray(y))) {
    const K = la(m), D = la(d), G = !Mt(K.value) && y.length > +K.value, ne = !Mt(D.value) && y.length < +D.value;
    if ((G || ne) && (J(G, K.message, D.message), !i))
      return E(C[S].message), C;
  }
  if (v && !Q && Gr(y)) {
    const { value: K, message: D } = la(v);
    if (sc(K) && !y.match(K) && (C[S] = {
      type: ai.pattern,
      message: D,
      ref: s,
      ...ee(ai.pattern, D)
    }, !i))
      return E(D), C;
  }
  if (x) {
    if (Ir(x)) {
      const K = await x(y, t), D = uN(K, q);
      if (D && (C[S] = {
        ...D,
        ...ee(ai.validate, D.message)
      }, !i))
        return E(D.message), C;
    } else if (ot(x)) {
      let K = {};
      for (const D in x) {
        if (!Lt(K) && !i)
          break;
        const G = uN(await x[D](y, t), q, D);
        G && (K = {
          ...G,
          ...ee(D, G.message)
        }, E(G.message), i && (C[S] = K));
      }
      if (!Lt(K) && (C[S] = {
        ref: q,
        ...K
      }, !i))
        return C;
    }
  }
  return E(!0), C;
};
const lZ = {
  mode: Fr.onSubmit,
  reValidateMode: Fr.onChange,
  shouldFocusError: !0
};
function cZ(e = {}) {
  let n = {
    ...lZ,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ir(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = ot(n.defaultValues) || ot(n.values) ? It(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : It(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: nN(),
    state: nN()
  }, v = oN(n.mode), x = oN(n.reValidateMode), S = n.criteriaMode === Fr.all, N = (F) => (b) => {
    clearTimeout(m), m = setTimeout(F, b);
  }, j = async (F) => {
    if (!n.disabled && (d.isValid || f.isValid || F)) {
      const b = n.resolver ? Lt((await Q()).errors) : await J(i, !0);
      b !== t.isValid && h.state.next({
        isValid: b
      });
    }
  }, y = (F, b) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((F || Array.from(l.mount)).forEach(($) => {
      $ && (b ? Kn(t.validatingFields, $, b) : gt(t.validatingFields, $));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !Lt(t.validatingFields)
    }));
  }, q = (F, b = [], $, Y, X = !0, R = !0) => {
    if (Y && $ && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Ge(i, F))) {
        const B = $(Ge(i, F), Y.argA, Y.argB);
        X && Kn(i, F, B);
      }
      if (R && Array.isArray(Ge(t.errors, F))) {
        const B = $(Ge(t.errors, F), Y.argA, Y.argB);
        X && Kn(t.errors, F, B), oZ(t.errors, F);
      }
      if ((d.touchedFields || f.touchedFields) && R && Array.isArray(Ge(t.touchedFields, F))) {
        const B = $(Ge(t.touchedFields, F), Y.argA, Y.argB);
        X && Kn(t.touchedFields, F, B);
      }
      (d.dirtyFields || f.dirtyFields) && (t.dirtyFields = So(a, o)), h.state.next({
        name: F,
        isDirty: D(F, b),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Kn(o, F, b);
  }, E = (F, b) => {
    Kn(t.errors, F, b), h.state.next({
      errors: t.errors
    });
  }, C = (F) => {
    t.errors = F, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, T = (F, b, $, Y) => {
    const X = Ge(i, F);
    if (X) {
      const R = Ge(o, F, rt($) ? Ge(a, F) : $);
      rt(R) || Y && Y.defaultChecked || b ? Kn(o, F, b ? R : aN(X._f)) : de(F, R), s.mount && j();
    }
  }, U = (F, b, $, Y, X) => {
    let R = !1, B = !1;
    const te = {
      name: F
    };
    if (!n.disabled) {
      if (!$ || Y) {
        (d.isDirty || f.isDirty) && (B = t.isDirty, t.isDirty = te.isDirty = D(), R = B !== te.isDirty);
        const pe = ki(Ge(a, F), b);
        B = !!Ge(t.dirtyFields, F), pe ? gt(t.dirtyFields, F) : Kn(t.dirtyFields, F, !0), te.dirtyFields = t.dirtyFields, R = R || (d.dirtyFields || f.dirtyFields) && B !== !pe;
      }
      if ($) {
        const pe = Ge(t.touchedFields, F);
        pe || (Kn(t.touchedFields, F, $), te.touchedFields = t.touchedFields, R = R || (d.touchedFields || f.touchedFields) && pe !== $);
      }
      R && X && h.state.next(te);
    }
    return R ? te : {};
  }, Z = (F, b, $, Y) => {
    const X = Ge(t.errors, F), R = (d.isValid || f.isValid) && ir(b) && t.isValid !== b;
    if (n.delayError && $ ? (u = N(() => E(F, $)), u(n.delayError)) : (clearTimeout(m), u = null, $ ? Kn(t.errors, F, $) : gt(t.errors, F)), ($ ? !ki(X, $) : X) || !Lt(Y) || R) {
      const B = {
        ...Y,
        ...R && ir(b) ? { isValid: b } : {},
        errors: t.errors,
        name: F
      };
      t = {
        ...t,
        ...B
      }, h.state.next(B);
    }
  }, Q = async (F) => {
    y(F, !0);
    const b = await n.resolver(o, n.context, eZ(F || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(F), b;
  }, ee = async (F) => {
    const { errors: b } = await Q(F);
    if (F)
      for (const $ of F) {
        const Y = Ge(b, $);
        Y ? Kn(t.errors, $, Y) : gt(t.errors, $);
      }
    else
      t.errors = b;
    return b;
  }, J = async (F, b, $ = {
    valid: !0
  }) => {
    for (const Y in F) {
      const X = F[Y];
      if (X) {
        const { _f: R, ...B } = X;
        if (R) {
          const te = l.array.has(R.name), pe = X._f && nZ(X._f);
          pe && d.validatingFields && y([Y], !0);
          const _e = await dN(X, l.disabled, o, S, n.shouldUseNativeValidation && !b, te);
          if (pe && d.validatingFields && y([Y]), _e[R.name] && ($.valid = !1, b))
            break;
          !b && (Ge(_e, R.name) ? te ? sZ(t.errors, _e, R.name) : Kn(t.errors, R.name, _e[R.name]) : gt(t.errors, R.name));
        }
        !Lt(B) && await J(B, b, $);
      }
    }
    return $.valid;
  }, K = () => {
    for (const F of l.unMount) {
      const b = Ge(i, F);
      b && (b._f.refs ? b._f.refs.every(($) => !Nf($)) : !Nf(b._f.ref)) && Ve(F);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, D = (F, b) => !n.disabled && (F && b && Kn(o, F, b), !ki(je(), a)), G = (F, b, $) => iF(F, l, {
    ...s.mount ? o : rt(b) ? a : Gr(F) ? { [F]: b } : b
  }, $, b), ne = (F) => Zc(Ge(s.mount ? o : a, F, n.shouldUnregister ? Ge(a, F, []) : [])), de = (F, b, $ = {}) => {
    const Y = Ge(i, F);
    let X = b;
    if (Y) {
      const R = Y._f;
      R && (!R.disabled && Kn(o, F, uF(b, R)), X = ac(R.ref) && Mt(b) ? "" : b, oF(R.ref) ? [...R.ref.options].forEach((B) => B.selected = X.includes(B.value)) : R.refs ? Cs(R.ref) ? R.refs.length > 1 ? R.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(X) ? !!X.find((te) => te === B.value) : X === B.value)) : R.refs[0] && (R.refs[0].checked = !!X) : R.refs.forEach((B) => B.checked = B.value === X) : Sy(R.ref) ? R.ref.value = "" : (R.ref.value = X, R.ref.type || h.state.next({
        name: F,
        values: It(o)
      })));
    }
    ($.shouldDirty || $.shouldTouch) && U(F, X, $.shouldTouch, $.shouldDirty, !0), $.shouldValidate && be(F);
  }, ge = (F, b, $) => {
    for (const Y in b) {
      const X = b[Y], R = `${F}.${Y}`, B = Ge(i, R);
      (l.array.has(F) || ot(X) || B && !B._f) && !Ai(X) ? ge(R, X, $) : de(R, X, $);
    }
  }, ce = (F, b, $ = {}) => {
    const Y = Ge(i, F), X = l.array.has(F), R = It(b);
    Kn(o, F, R), X ? (h.array.next({
      name: F,
      values: It(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && $.shouldDirty && h.state.next({
      name: F,
      dirtyFields: So(a, o),
      isDirty: D(F, R)
    })) : Y && !Y._f && !Mt(R) ? ge(F, R, $) : de(F, R, $), lN(F, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? F : void 0,
      values: It(o)
    });
  }, ve = async (F) => {
    s.mount = !0;
    const b = F.target;
    let $ = b.name, Y = !0;
    const X = Ge(i, $), R = (B) => {
      Y = Number.isNaN(B) || Ai(B) && isNaN(B.getTime()) || ki(B, Ge(o, $, B));
    };
    if (X) {
      let B, te;
      const pe = b.type ? aN(X._f) : eF(F), _e = F.type === ic.BLUR || F.type === ic.FOCUS_OUT, Ze = !tZ(X._f) && !n.resolver && !Ge(t.errors, $) && !X._f.deps || aZ(_e, Ge(t.touchedFields, $), t.isSubmitted, x, v), dn = lN($, l, _e);
      Kn(o, $, pe), _e ? (X._f.onBlur && X._f.onBlur(F), u && u(0)) : X._f.onChange && X._f.onChange(F);
      const nn = U($, pe, _e), rn = !Lt(nn) || dn;
      if (!_e && h.state.next({
        name: $,
        type: F.type,
        values: It(o)
      }), Ze)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? _e && j() : _e || j()), rn && h.state.next({ name: $, ...dn ? {} : nn });
      if (!_e && dn && h.state.next({ ...t }), n.resolver) {
        const { errors: fn } = await Q([$]);
        if (R(pe), Y) {
          const mn = cN(t.errors, i, $), vn = cN(fn, i, mn.name || $);
          B = vn.error, $ = vn.name, te = Lt(fn);
        }
      } else
        y([$], !0), B = (await dN(X, l.disabled, o, S, n.shouldUseNativeValidation))[$], y([$]), R(pe), Y && (B ? te = !1 : (d.isValid || f.isValid) && (te = await J(i, !0)));
      Y && (X._f.deps && be(X._f.deps), Z($, te, B, nn));
    }
  }, H = (F, b) => {
    if (Ge(t.errors, b) && F.focus)
      return F.focus(), 1;
  }, be = async (F, b = {}) => {
    let $, Y;
    const X = zo(F);
    if (n.resolver) {
      const R = await ee(rt(F) ? F : X);
      $ = Lt(R), Y = F ? !X.some((B) => Ge(R, B)) : $;
    } else F ? (Y = (await Promise.all(X.map(async (R) => {
      const B = Ge(i, R);
      return await J(B && B._f ? { [R]: B } : B);
    }))).every(Boolean), !(!Y && !t.isValid) && j()) : Y = $ = await J(i);
    return h.state.next({
      ...!Gr(F) || (d.isValid || f.isValid) && $ !== t.isValid ? {} : { name: F },
      ...n.resolver || !F ? { isValid: $ } : {},
      errors: t.errors
    }), b.shouldFocus && !Y && Mo(i, H, F ? X : l.mount), Y;
  }, je = (F) => {
    const b = {
      ...s.mount ? o : a
    };
    return rt(F) ? b : Gr(F) ? Ge(b, F) : F.map(($) => Ge(b, $));
  }, W = (F, b) => ({
    invalid: !!Ge((b || t).errors, F),
    isDirty: !!Ge((b || t).dirtyFields, F),
    error: Ge((b || t).errors, F),
    isValidating: !!Ge(t.validatingFields, F),
    isTouched: !!Ge((b || t).touchedFields, F)
  }), Ue = (F) => {
    F && zo(F).forEach((b) => gt(t.errors, b)), h.state.next({
      errors: F ? t.errors : {}
    });
  }, Me = (F, b, $) => {
    const Y = (Ge(i, F, { _f: {} })._f || {}).ref, X = Ge(t.errors, F) || {}, { ref: R, message: B, type: te, ...pe } = X;
    Kn(t.errors, F, {
      ...pe,
      ...b,
      ref: Y
    }), h.state.next({
      name: F,
      errors: t.errors,
      isValid: !1
    }), $ && $.shouldFocus && Y && Y.focus && Y.focus();
  }, De = (F, b) => Ir(F) ? h.state.subscribe({
    next: ($) => F(G(void 0, b), $)
  }) : G(F, b, !0), Be = (F) => h.state.subscribe({
    next: (b) => {
      iZ(F.name, b.name, F.exact) && rZ(b, F.formState || d, Fe, F.reRenderRoot) && F.callback({
        values: { ...o },
        ...t,
        ...b
      });
    }
  }).unsubscribe, Ee = (F) => (s.mount = !0, f = {
    ...f,
    ...F.formState
  }, Be({
    ...F,
    formState: f
  })), Ve = (F, b = {}) => {
    for (const $ of F ? zo(F) : l.mount)
      l.mount.delete($), l.array.delete($), b.keepValue || (gt(i, $), gt(o, $)), !b.keepError && gt(t.errors, $), !b.keepDirty && gt(t.dirtyFields, $), !b.keepTouched && gt(t.touchedFields, $), !b.keepIsValidating && gt(t.validatingFields, $), !n.shouldUnregister && !b.keepDefaultValue && gt(a, $);
    h.state.next({
      values: It(o)
    }), h.state.next({
      ...t,
      ...b.keepDirty ? { isDirty: D() } : {}
    }), !b.keepIsValid && j();
  }, Re = ({ disabled: F, name: b }) => {
    (ir(F) && s.mount || F || l.disabled.has(b)) && (F ? l.disabled.add(b) : l.disabled.delete(b));
  }, tn = (F, b = {}) => {
    let $ = Ge(i, F);
    const Y = ir(b.disabled) || ir(n.disabled);
    return Kn(i, F, {
      ...$ || {},
      _f: {
        ...$ && $._f ? $._f : { ref: { name: F } },
        name: F,
        mount: !0,
        ...b
      }
    }), l.mount.add(F), $ ? Re({
      disabled: ir(b.disabled) ? b.disabled : n.disabled,
      name: F
    }) : T(F, !0, b.value), {
      ...Y ? { disabled: b.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!b.required,
        min: No(b.min),
        max: No(b.max),
        minLength: No(b.minLength),
        maxLength: No(b.maxLength),
        pattern: No(b.pattern)
      } : {},
      name: F,
      onChange: ve,
      onBlur: ve,
      ref: (X) => {
        if (X) {
          tn(F, b), $ = Ge(i, F);
          const R = rt(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, B = QX(R), te = $._f.refs || [];
          if (B ? te.find((pe) => pe === R) : R === $._f.ref)
            return;
          Kn(i, F, {
            _f: {
              ...$._f,
              ...B ? {
                refs: [
                  ...te.filter(Nf),
                  R,
                  ...Array.isArray(Ge(a, F)) ? [{}] : []
                ],
                ref: { type: R.type, name: F }
              } : { ref: R }
            }
          }), T(F, !1, void 0, R);
        } else
          $ = Ge(i, F, {}), $._f && ($._f.mount = !1), (n.shouldUnregister || b.shouldUnregister) && !(nF(l.array, F) && s.action) && l.unMount.add(F);
      }
    };
  }, Ne = () => n.shouldFocusError && Mo(i, H, l.mount), We = (F) => {
    ir(F) && (h.state.next({ disabled: F }), Mo(i, (b, $) => {
      const Y = Ge(i, $);
      Y && (b.disabled = Y._f.disabled || F, Array.isArray(Y._f.refs) && Y._f.refs.forEach((X) => {
        X.disabled = Y._f.disabled || F;
      }));
    }, 0, !1));
  }, Oe = (F, b) => async ($) => {
    let Y;
    $ && ($.preventDefault && $.preventDefault(), $.persist && $.persist());
    let X = It(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: B } = await Q();
      t.errors = R, X = B;
    } else
      await J(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Kn(X, R, void 0);
    if (gt(t.errors, "root"), Lt(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await F(X, $);
      } catch (R) {
        Y = R;
      }
    } else
      b && await b({ ...t.errors }, $), Ne(), setTimeout(Ne);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Lt(t.errors) && !Y,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), Y)
      throw Y;
  }, ue = (F, b = {}) => {
    Ge(i, F) && (rt(b.defaultValue) ? ce(F, It(Ge(a, F))) : (ce(F, b.defaultValue), Kn(a, F, It(b.defaultValue))), b.keepTouched || gt(t.touchedFields, F), b.keepDirty || (gt(t.dirtyFields, F), t.isDirty = b.defaultValue ? D(F, It(Ge(a, F))) : D()), b.keepError || (gt(t.errors, F), d.isValid && j()), h.state.next({ ...t }));
  }, fe = (F, b = {}) => {
    const $ = F ? It(F) : a, Y = It($), X = Lt(F), R = X ? a : Y;
    if (b.keepDefaultValues || (a = $), !b.keepValues) {
      if (b.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(So(a, o))
        ]);
        for (const te of Array.from(B))
          Ge(t.dirtyFields, te) ? Kn(R, te, Ge(o, te)) : ce(te, Ge(R, te));
      } else {
        if (by && rt(F))
          for (const B of l.mount) {
            const te = Ge(i, B);
            if (te && te._f) {
              const pe = Array.isArray(te._f.refs) ? te._f.refs[0] : te._f.ref;
              if (ac(pe)) {
                const _e = pe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const B of l.mount)
          ce(B, Ge(R, B));
      }
      o = It(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: b.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!b.keepIsValid || !!b.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: b.keepSubmitCount ? t.submitCount : 0,
      isDirty: X ? !1 : b.keepDirty ? t.isDirty : !!(b.keepDefaultValues && !ki(F, a)),
      isSubmitted: b.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: X ? {} : b.keepDirtyValues ? b.keepDefaultValues && o ? So(a, o) : t.dirtyFields : b.keepDefaultValues && F ? So(a, F) : b.keepDirty ? t.dirtyFields : {},
      touchedFields: b.keepTouched ? t.touchedFields : {},
      errors: b.keepErrors ? t.errors : {},
      isSubmitSuccessful: b.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, we = (F, b) => fe(Ir(F) ? F(o) : F, b), Le = (F, b = {}) => {
    const $ = Ge(i, F), Y = $ && $._f;
    if (Y) {
      const X = Y.refs ? Y.refs[0] : Y.ref;
      X.focus && (X.focus(), b.shouldSelect && Ir(X.select) && X.select());
    }
  }, Fe = (F) => {
    t = {
      ...t,
      ...F
    };
  }, ln = {
    control: {
      register: tn,
      unregister: Ve,
      getFieldState: W,
      handleSubmit: Oe,
      setError: Me,
      _subscribe: Be,
      _runSchema: Q,
      _getWatch: G,
      _getDirty: D,
      _setValid: j,
      _setFieldArray: q,
      _setDisabledField: Re,
      _setErrors: C,
      _getFieldArray: ne,
      _reset: fe,
      _resetDefaultValues: () => Ir(n.defaultValues) && n.defaultValues().then((F) => {
        we(F, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: K,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(F) {
        s = F;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(F) {
        l = F;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(F) {
        n = {
          ...n,
          ...F
        };
      }
    },
    subscribe: Ee,
    trigger: be,
    register: tn,
    handleSubmit: Oe,
    watch: De,
    setValue: ce,
    getValues: je,
    reset: we,
    resetField: ue,
    clearErrors: Ue,
    unregister: Ve,
    setError: Me,
    setFocus: Le,
    getFieldState: W
  };
  return {
    ...ln,
    formControl: ln
  };
}
function uZ(e = {}) {
  const n = xe.useRef(void 0), t = xe.useRef(void 0), [i, a] = xe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ir(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Ir(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : cZ(e),
    formState: i
  }, e.formControl && e.defaultValues && !Ir(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, xe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), xe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), xe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), xe.useEffect(() => {
    e.values && !ki(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), xe.useEffect(() => {
    e.errors && !Lt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), xe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), xe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = rF(i, o), n.current;
}
const dZ = "_modalBody_1clhs_1", mZ = {
  modalBody: dZ
}, pZ = ({
  isOpen: e,
  onClose: n,
  pointsAccount: t,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = un(), { track: l } = hn(), u = t?.id, m = t?.balance ?? 0, d = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: v } = uZ({
    defaultValues: d,
    mode: "onChange"
  }), x = aF({ control: f }), S = parseInt(x?.balance ?? "0", 10), N = m === S, j = N ? "Change the value to update the points" : "", y = S < 0, q = y ? "Points can not be negative" : "", E = x.description === "", C = E ? "Description can not be empty" : "";
  qe(() => {
    S > m ? h(
      "transactionType",
      Th.Addition
    ) : S < m && h(
      "transactionType",
      Th.Deduction
    );
  }, [m, S, h]);
  const [T, { loading: U, error: Z, reset: Q }] = o(RX, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), ee = () => {
    if (u) {
      const K = mX();
      T({
        variables: {
          input: {
            accountId: u,
            transactionId: K,
            amount: Math.abs(S - m),
            transactionType: x.transactionType,
            description: x.description,
            source: X1.UpdateBalance
          }
        }
      }).then(async (D) => {
        D?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), J());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, J = () => {
    v(d), Q(), n();
  };
  return /* @__PURE__ */ M.jsxs(
    St,
    {
      isOpen: e,
      onClose: J,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ M.jsx(Nt, { title: "Update points balance", onClose: J }),
        /* @__PURE__ */ M.jsxs(jt, { className: mZ.modalBody, children: [
          /* @__PURE__ */ M.jsxs(Kt, { children: [
            /* @__PURE__ */ M.jsx(en, { span: 6, children: /* @__PURE__ */ M.jsx(
              eN,
              {
                name: "balance",
                control: f,
                render: ({ field: K }) => /* @__PURE__ */ M.jsx(
                  fr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: j || q
                    },
                    input: {
                      ...K,
                      value: K.value.toString(),
                      onChange: (D) => K.onChange(D)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ M.jsx(en, { span: 6, children: /* @__PURE__ */ M.jsx(
              eN,
              {
                name: "description",
                control: f,
                render: ({ field: K }) => /* @__PURE__ */ M.jsx(
                  fr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: K,
                    meta: {
                      warning: C
                    }
                  }
                )
              }
            ) })
          ] }),
          Z && /* @__PURE__ */ M.jsx(_n, { error: Z })
        ] }),
        /* @__PURE__ */ M.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => ee(),
            confirmProps: {
              isLoading: U,
              disabled: N || y || E,
              loadingIndicator: /* @__PURE__ */ M.jsx(cn, { size: 16 })
            },
            cancelOnClick: J
          }
        )
      ]
    }
  );
}, fZ = "_wrapper_1ge6c_1", hZ = "_block_1ge6c_12", mN = {
  wrapper: fZ,
  block: hZ
}, vZ = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: t } = un(), { isCopied: i, copy: a } = Pl(), { isCopied: o, copy: s } = Pl(), { isCopied: l, copy: u } = Pl(), [m, d] = oe(!1), [f, h] = oe(), [v, x] = oe(!1), {
    loading: S,
    data: N,
    refetch: j
  } = t(TX, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  qe(() => {
    if (N) {
      const ne = N?.Voyado?.PointAccountV_GetPointAccounts;
      ne && ne?.length > 0 && h(ne[0]);
    }
  }, [N]);
  const y = !!f?.id, q = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: E,
    lastName: C,
    street: T,
    zipCode: U,
    city: Z,
    country: Q,
    isRegistrationCompleted: ee,
    email: J,
    mobilePhone: K
  } = e, D = 14, G = `${E || ""} ${C || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ M.jsxs(_, { flexDirection: "column", className: mN.wrapper, children: [
    /* @__PURE__ */ M.jsxs(
      _,
      {
        justifyContent: "space-between",
        className: mN.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: G }),
          S && /* @__PURE__ */ M.jsx(cn, { size: 12 }),
          y && !S && /* @__PURE__ */ M.jsxs(_, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ M.jsxs(zn, { size: "small", variant: "warning", children: [
              q,
              " points"
            ] }),
            /* @__PURE__ */ M.jsx(Je, { content: "Update points balance", children: /* @__PURE__ */ M.jsx(
              he,
              {
                name: "pen",
                size: 12,
                onClick: () => d(!0),
                className: nt.pointer
              }
            ) }),
            v && /* @__PURE__ */ M.jsx(Je, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ M.jsx(
              he,
              {
                name: "info",
                size: 12,
                className: nt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (T || Z || U || Q || K || J) && /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", children: [
      K && /* @__PURE__ */ M.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(he, { size: D, name: "phone" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: K })
        ] }),
        /* @__PURE__ */ M.jsx(
          he,
          {
            size: D,
            name: o ? "done" : "copy",
            onClick: () => s(K),
            className: nt.pointer
          }
        )
      ] }),
      J && /* @__PURE__ */ M.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(he, { size: D, name: "mail" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: J })
        ] }),
        /* @__PURE__ */ M.jsx(
          he,
          {
            size: D,
            name: i ? "done" : "copy",
            onClick: () => a(J),
            className: nt.pointer
          }
        )
      ] }),
      (T || Z || U || Q) && /* @__PURE__ */ M.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(_, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(he, { size: D, name: "home" }),
          /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ M.jsx(Yn, { children: T }),
            /* @__PURE__ */ M.jsxs(Yn, { children: [
              U,
              " ",
              Z
            ] }),
            /* @__PURE__ */ M.jsx(Yn, { children: Q })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(
          he,
          {
            size: D,
            name: l ? "done" : "copy",
            onClick: () => u(`${T}, ${U} ${Z}, ${Q}`),
            className: nt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsxs(_, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(he, { size: D, name: "sign-in" }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ M.jsx(
          he,
          {
            name: ee ? "check-circle-filled" : "close-circle-filled",
            color: ee ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    y && /* @__PURE__ */ M.jsx(
      pZ,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => d(!1),
        setHasPointsBeenUpdated: x,
        refetchPointsQuery: j
      }
    )
  ] });
}, yZ = "_list_yud4a_7", gZ = "_listItem_yud4a_11", kZ = "_listItemTooltip_yud4a_15", bZ = "_listItemTimestamp_yud4a_18", vl = {
  list: yZ,
  listItem: gZ,
  listItemTooltip: kZ,
  listItemTimestamp: bZ
}, _Z = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ M.jsx(He, { className: vl.list, children: e.map((n, t) => /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: vl.listItem, children: /* @__PURE__ */ M.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ M.jsx(Je, { content: n?.comment, children: /* @__PURE__ */ M.jsxs(
      _,
      {
        gap: "200",
        alignItems: "center",
        className: ht({
          [vl.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { className: vl.listItemTimestamp, children: Tn(n.date).format(lt) }),
          n?.comment && /* @__PURE__ */ M.jsx(he, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ M.jsx(
      he,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, t)) })
] }), xZ = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, t = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Tn(e.latestChange).format(lt) : null, o = e?.expires ? `${Tn(e.expires).fromNow()} (${Tn(e.expires).format(lt)})` : null, s = !n && !a && !t && !i && !o;
  return /* @__PURE__ */ M.jsx(_, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(_, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ M.jsx(Je, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ M.jsx(
        he,
        {
          name: "question",
          size: 14,
          className: nt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ M.jsx(_, { flexDirection: "column", children: /* @__PURE__ */ M.jsxs(He, { className: nt.list, children: [
      s && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Je, { content: "", children: /* @__PURE__ */ M.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ M.jsx(zn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Je, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ M.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ M.jsx(zn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      t && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Je, { content: "", children: /* @__PURE__ */ M.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ M.jsx(zn, { variant: "success", size: "small", children: t })
      ] }) }) }),
      a && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Je, { content: "", children: /* @__PURE__ */ M.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: nt.listItem, children: /* @__PURE__ */ M.jsx(Je, { content: "", children: /* @__PURE__ */ M.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, SZ = "_tagHover_kzbzk_1", NZ = "_channelUnsubscribed_kzbzk_6", pN = {
  tagHover: SZ,
  channelUnsubscribed: NZ
}, jf = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: t,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = hn(), { useMutation: l } = un(), [u, m] = oe(!1), [d, { loading: f }] = l(OX), h = async ({
    newPreference: x,
    isSubscribed: S,
    channelType: N
  }) => {
    m(!0), (await d({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...x
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? S ? s("voyado:channel:unsubscribe:succeeded", { channel: N }) : s("voyado:channel:subscribe:succeeded", { channel: N }) : S ? s("voyado:channel:unsubscribe:failed", { channel: N }) : s("voyado:channel:subscribe:failed", { channel: N }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, v = u || f;
  return /* @__PURE__ */ M.jsx(Je, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ M.jsx(
    En,
    {
      className: pN.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ M.jsxs(
        _,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: ht({
            [pN.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            v ? /* @__PURE__ */ M.jsx(cn, { size: 16 }) : /* @__PURE__ */ M.jsx(he, { size: 16, name: t }),
            n
          ]
        }
      )
    }
  ) });
}, jZ = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: t
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ M.jsx(_, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        jf,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      ),
      /* @__PURE__ */ M.jsx(
        jf,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      ),
      /* @__PURE__ */ M.jsx(
        jf,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: t
        }
      )
    ] })
  ] }) });
}, wZ = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: t,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: u,
    refetch: m,
    attributes: d,
    preferences: f,
    consents: h
  } = DX({ contactId: e }), {
    isLoading: v,
    error: x,
    memberLevel: S
  } = MX({ contactId: e, skip: !s }), N = v || l, j = Zn(
    () => h?.filter(
      (y) => y !== null
    ),
    [h]
  );
  return u || x ? Zo({
    errors: u?.graphQLErrors || x?.graphQLErrors || []
  }) ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ M.jsx(_n, { error: u || x }) : !t && !i && !a && !o && !s ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : N ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    t && /* @__PURE__ */ M.jsx(
      vZ,
      {
        contactAttributes: d,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ M.jsx(xZ, { memberLevel: S }),
    i && /* @__PURE__ */ M.jsx(
      jZ,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ M.jsx(_Z, { contactConsents: j })
  ] });
}, Rh = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, CZ = "_list_zu4s7_1", FZ = "_listItem_zu4s7_4", IZ = "_listSum_zu4s7_7", yl = {
  list: CZ,
  listItem: FZ,
  listSum: IZ
}, $Z = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: t
}) => /* @__PURE__ */ M.jsxs(He, { className: yl.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ M.jsx(He.Text, { variant: "dense", className: yl.listItem, children: /* @__PURE__ */ M.jsx(Je, { content: s, children: /* @__PURE__ */ M.jsxs(_, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ M.jsxs(_, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ M.jsx(_, { flex: "auto", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ M.jsx(_, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Rh(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ M.jsx(
    He.Text,
    {
      variant: "dense",
      className: ht(yl.listItem, yl.listSum),
      children: /* @__PURE__ */ M.jsxs(_, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: Rh(t, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), EZ = "_transaction_1kr8d_1", TZ = "_transactionIsOpen_1kr8d_9", OZ = "_transactionHeader_1kr8d_12", RZ = "_transactionHeaderSubLine_1kr8d_15", DZ = "_transactionHeaderAlignItemRight_1kr8d_19", ca = {
  transaction: EZ,
  transactionIsOpen: TZ,
  transactionHeader: OZ,
  transactionHeaderSubLine: RZ,
  transactionHeaderAlignItemRight: DZ
}, PZ = ({
  transaction: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: u,
    lineItems: m,
    localCurrency: d,
    localNetPriceSum: f
  } = e, h = d ?? "", v = f ?? 0, x = m?.length ? m : [];
  return /* @__PURE__ */ M.jsxs(
    _,
    {
      className: ht(ca.transaction, {
        [ca.transactionIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ca.transactionHeader,
            onClick: () => i(!t),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ M.jsxs(_, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ M.jsxs(_, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ M.jsx(zn, { size: "small", variant: "info", children: Tn(o).format(lt) }),
                  /* @__PURE__ */ M.jsxs(
                    A.Heading,
                    {
                      variant: "heading-4",
                      className: ca.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ M.jsxs(
                  _,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ca.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-4", children: Rh(v, h) }),
                      /* @__PURE__ */ M.jsxs(
                        A.Heading,
                        {
                          variant: "heading-4",
                          className: ca.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ M.jsx(_, { flexDirection: "column", children: /* @__PURE__ */ M.jsx(
                lr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(
          _,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ M.jsx(Vh, {}),
              /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-2", children: s }),
                u && /* @__PURE__ */ M.jsx(En, { children: /* @__PURE__ */ M.jsx(_, { alignItems: "center", children: u }) }),
                /* @__PURE__ */ M.jsx(
                  $Z,
                  {
                    lineItems: x,
                    localCurrency: h,
                    localNetPriceSum: v
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, AZ = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: t,
    transactions: i
  } = VX({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return t ? /* @__PURE__ */ M.jsx(_n, { error: t }) : /* @__PURE__ */ M.jsxs(
    _,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ M.jsx(zn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          s === 0 && /* @__PURE__ */ M.jsx(_, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, u) => /* @__PURE__ */ M.jsx(
            PZ,
            {
              transaction: l,
              openByDefault: u === 0
            },
            u
          ))
        ] })
      ]
    }
  );
}, LZ = "_message_unsvt_48", VZ = "_messageIsOpen_unsvt_56", zZ = "_messageHeader_unsvt_60", MZ = "_messageText_unsvt_64", UZ = "_buttonLink_unsvt_86", jo = {
  message: LZ,
  messageIsOpen: VZ,
  messageHeader: zZ,
  messageText: MZ,
  buttonLink: UZ
}, wf = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Cf = (e, n) => n && e in wf && n in wf[e] ? wf[e][n] : null, BZ = ({
  message: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n), { track: a } = hn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: u,
    isTransactional: m,
    status: d,
    messageLink: f,
    messageText: h
  } = e, v = l ? Cf("type", l) : null, x = u ? Cf("source", u) : null, S = d ? Cf("status", d) : null, N = l?.replace("Message", "");
  return /* @__PURE__ */ M.jsxs(
    _,
    {
      className: ht(jo.message, {
        [jo.messageIsOpen]: t
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: jo.messageHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ M.jsxs(_, { gap: "200", alignItems: "center", children: [
                  v && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                    /* @__PURE__ */ M.jsx(he, { name: v, size: 16 }),
                    " ",
                    N
                  ] }),
                  s && /* @__PURE__ */ M.jsx(zn, { size: "small", variant: "info", children: Tn(s).format(lt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ M.jsx(
                lr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(_, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ M.jsx(Vh, {}),
          /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            S && /* @__PURE__ */ M.jsx(En, { children: /* @__PURE__ */ M.jsxs(_, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(he, { name: S }),
              " ",
              d
            ] }) }),
            x && /* @__PURE__ */ M.jsx(En, { children: /* @__PURE__ */ M.jsxs(_, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(he, { name: x }),
              " ",
              u
            ] }) }),
            m && /* @__PURE__ */ M.jsx(En, { children: /* @__PURE__ */ M.jsxs(_, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ M.jsx(he, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", className: jo.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ M.jsx(
            Rt,
            {
              slotEnd: /* @__PURE__ */ M.jsx(he, { name: "external-link" }),
              variant: "tertiary",
              className: jo.buttonLink,
              navigate: () => {
                N && a("voyado:message:external-link:opened", {
                  channel: N.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, qZ = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: t,
    lastMessages: i
  } = AX({ contactId: e });
  if (!e)
    return null;
  if (t)
    return /* @__PURE__ */ M.jsx(_n, { error: t });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ M.jsx(zn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ M.jsx(_, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      l && o?.map((u, m) => /* @__PURE__ */ M.jsx(
        BZ,
        {
          message: u || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ M.jsx(_, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, eu = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, fN = ({
  labelText: e,
  address: n,
  icon: t = "home"
}) => {
  const { isCopied: i, copy: a } = Pl(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = ft(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ M.jsxs(_, { justifyContent: "space-between", children: [
    /* @__PURE__ */ M.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(he, { size: l, name: t, color: "green.500" }),
      /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ M.jsx(Je, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ M.jsx(
      he,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: nt.pointer
      }
    ) })
  ] });
}, HZ = "_order_19t4p_1", WZ = "_orderIsOpen_19t4p_9", KZ = "_orderHeader_19t4p_12", GZ = "_orderIconColor_19t4p_15", qr = {
  order: HZ,
  orderIsOpen: WZ,
  orderHeader: KZ,
  orderIconColor: GZ
}, YZ = "_delivery_1m9nb_1", JZ = "_deliveryCode_1m9nb_4", Ff = {
  delivery: YZ,
  deliveryCode: JZ
}, QZ = ({
  delivery: e
}) => {
  const { isCopied: n, copy: t } = si();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ M.jsxs(_, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ M.jsx(
      he,
      {
        size: l,
        name: "eye",
        className: qr.orderIconColor
      }
    ),
    /* @__PURE__ */ M.jsxs(_, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ M.jsx(
        Je,
        {
          content: /* @__PURE__ */ M.jsxs(A.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Tn(s).format(lt)
          ] }),
          children: /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ M.jsx(
              A.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ M.jsxs(
                  _,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: Ff.delivery,
                    children: [
                      /* @__PURE__ */ M.jsx(he, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ M.jsx(
              A.Paragraph,
              {
                variant: "4",
                className: ht(Ff.delivery, Ff.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ M.jsx(Je, { content: "Copy tracking code", children: /* @__PURE__ */ M.jsx(
      he,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => t(a.toString()),
        className: nt.pointer
      }
    ) })
  ] });
}, XZ = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        he,
        {
          size: 14,
          name: "file-text",
          className: qr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: t?.map((i, a) => /* @__PURE__ */ M.jsx(He.Item, { className: nt.listItem, children: /* @__PURE__ */ M.jsxs(
      _,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ M.jsxs(_, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ M.jsx(_, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ M.jsxs(
            _,
            {
              gap: "100",
              flexDirection: "column",
              className: nt.listItemAlignRight,
              children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: eu({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, ZZ = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        he,
        {
          size: 14,
          name: "tag",
          className: qr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: t?.map((i) => /* @__PURE__ */ M.jsx(
      He.Item,
      {
        className: nt.listItem,
        contentLeft: /* @__PURE__ */ M.jsxs(_, { gap: "200", children: [
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ M.jsx(
          Je,
          {
            content: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ M.jsx(_, { children: /* @__PURE__ */ M.jsx(zn, { size: "small", variant: "info", children: eu({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ M.jsx(
          es,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, eee = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const t = e?.items ?? [];
  return /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ M.jsxs(_, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ M.jsx(
        he,
        {
          size: 14,
          name: "credit-card",
          className: qr.orderIconColor
        }
      ),
      /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ M.jsx(He, { className: nt.list, children: t?.map((i, a) => /* @__PURE__ */ M.jsx(
      He.Item,
      {
        className: nt.listItem,
        children: /* @__PURE__ */ M.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ M.jsxs(_, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ M.jsxs(
                _,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: nt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "5", children: Tn(i?.paidAt).format(lt) }),
                    /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: eu({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, nee = ({
  order: e,
  openByDefault: n
}) => {
  const [t, i] = oe(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: u,
    createdAt: m,
    lastChangedAt: d,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: v,
    totalPrice: x
  } = e, S = 14;
  return /* @__PURE__ */ M.jsxs(
    _,
    {
      className: ht(qr.order, {
        [qr.orderIsOpen]: t
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ M.jsxs(
          _,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: qr.orderHeader,
            onClick: () => i(!t),
            children: [
              /* @__PURE__ */ M.jsxs(_, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ M.jsx(_, { alignItems: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: Tn(m).format(lt) }) }),
                /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ M.jsx(
                lr,
                {
                  variant: "tertiary",
                  icon: t ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        t && /* @__PURE__ */ M.jsxs(_, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ M.jsxs(_, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              he,
              {
                size: S,
                name: "activity",
                className: qr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(_, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ M.jsxs(_, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ M.jsx(Je, { content: "Internal status", children: /* @__PURE__ */ M.jsx(zn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ M.jsx(Je, { content: "External status", children: /* @__PURE__ */ M.jsx(zn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: s }) }) }),
                /* @__PURE__ */ M.jsx(Je, { content: "Last updated at", children: /* @__PURE__ */ M.jsx(A.Paragraph, { as: "span", variant: "5", children: Tn(d).format(lt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsxs(_, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              he,
              {
                size: S,
                name: "chart-bar",
                className: qr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(_, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: eu({
                value: x,
                currencyCode: l
              }) })
            ] })
          ] }),
          u && /* @__PURE__ */ M.jsxs(_, { gap: "250", children: [
            /* @__PURE__ */ M.jsx(
              he,
              {
                size: S,
                name: "channels",
                className: qr.orderIconColor
              }
            ),
            /* @__PURE__ */ M.jsxs(_, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", children: /* @__PURE__ */ M.jsx(zn, { size: "small", variant: "info", children: /* @__PURE__ */ M.jsx(M.Fragment, { children: u }) }) })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx(fN, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ M.jsx(
            fN,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: v
            }
          ),
          /* @__PURE__ */ M.jsx(QZ, { delivery: e.delivery }),
          /* @__PURE__ */ M.jsx(ZZ, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ M.jsx(XZ, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ M.jsx(
            eee,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, tee = ({
  error: e,
  itemCount: n,
  children: t
}) => e ? n === 0 || Zo({ errors: e.graphQLErrors }) ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ M.jsx(_n, { error: e }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: t }), ree = ({
  contactId: e
}) => {
  const { useQuery: n } = un(), [t, i] = oe([]), { track: a } = hn(), {
    loading: o,
    error: s,
    data: l
  } = n(EX, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return qe(() => {
    if (l?.Voyado) {
      const u = l?.Voyado.Orders_GetAllByContact;
      if (!o && u?.items) {
        i(u.items);
        const { totalCount: m } = u;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ M.jsxs(_, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ M.jsx(A.Heading, { variant: "heading-3", children: "Orders" }),
      t.length > 0 && /* @__PURE__ */ M.jsx(zn, { size: "small", variant: "success", children: t.length })
    ] }),
    o ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsx(tee, { error: s, itemCount: t.length, children: t.map((u, m) => /* @__PURE__ */ M.jsx(
      nee,
      {
        order: u,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, iee = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: t, contactId: i, hasMultipleContacts: a, error: o } = zX({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: u,
    showPreferences: m,
    showAudiences: d,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: v,
    showOrders: x
  } = n;
  return s ? /* @__PURE__ */ M.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ M.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? Zo({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ M.jsx(_n, { error: o }) : !u && !m && !d && !f && !h && !v ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : t ? /* @__PURE__ */ M.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ M.jsx(cn, {}) }) : /* @__PURE__ */ M.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ M.jsx(wZ, { contactId: i, settings: n }),
        h && /* @__PURE__ */ M.jsx(qZ, { contactId: i }),
        v && /* @__PURE__ */ M.jsx(AZ, { contactId: i }),
        x && /* @__PURE__ */ M.jsx(ree, { contactId: i }),
        !l && /* @__PURE__ */ M.jsx(_, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ M.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, aee = [
  {
    key: "voyadoApiKey",
    label: "API key",
    placeholder: "API key from Voyado",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "apiHostName",
    label: "API URL",
    placeholder: "The URL of the Voyado API",
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://"
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._copyIcon_nr4rl_48{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_nr4rl_53{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_nr4rl_63{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_nr4rl_63:last-child{border-bottom:none}._channelHeadline_yeqqp_1{padding:var(--dixa-size-spacer-200);border-bottom:var(--dixa-size-border-200) solid var(--dixa-color-neutral-200)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var If = { exports: {} }, wo = {}, hN;
function oee() {
  if (hN) return wo;
  hN = 1;
  var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, u, m) {
    var d, f = {}, h = null, v = null;
    m !== void 0 && (h = "" + m), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (v = u.ref);
    for (d in u) i.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (l && l.defaultProps) for (d in u = l.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: n, type: l, key: h, ref: v, props: f, _owner: a.current };
  }
  return wo.Fragment = t, wo.jsx = s, wo.jsxs = s, wo;
}
var gl = {}, vN;
function see() {
  return vN || (vN = 1, process.env.NODE_ENV !== "production" && function() {
    var e = xe, n = Symbol.for("react.element"), t = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), l = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), v = Symbol.for("react.offscreen"), x = Symbol.iterator, S = "@@iterator";
    function N(r) {
      if (r === null || typeof r != "object")
        return null;
      var c = x && r[x] || r[S];
      return typeof c == "function" ? c : null;
    }
    var j = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(r) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), k = 1; k < c; k++)
          p[k - 1] = arguments[k];
        q("error", r, p);
      }
    }
    function q(r, c, p) {
      {
        var k = j.ReactDebugCurrentFrame, P = k.getStackAddendum();
        P !== "" && (c += "%s", p = p.concat([P]));
        var L = p.map(function(I) {
          return String(I);
        });
        L.unshift("Warning: " + c), Function.prototype.apply.call(console[r], console, L);
      }
    }
    var E = !1, C = !1, T = !1, U = !1, Z = !1, Q;
    Q = Symbol.for("react.module.reference");
    function ee(r) {
      return !!(typeof r == "string" || typeof r == "function" || r === i || r === o || Z || r === a || r === m || r === d || U || r === v || E || C || T || typeof r == "object" && r !== null && (r.$$typeof === h || r.$$typeof === f || r.$$typeof === s || r.$$typeof === l || r.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      r.$$typeof === Q || r.getModuleId !== void 0));
    }
    function J(r, c, p) {
      var k = r.displayName;
      if (k)
        return k;
      var P = c.displayName || c.name || "";
      return P !== "" ? p + "(" + P + ")" : p;
    }
    function K(r) {
      return r.displayName || "Context";
    }
    function D(r) {
      if (r == null)
        return null;
      if (typeof r.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof r == "function")
        return r.displayName || r.name || null;
      if (typeof r == "string")
        return r;
      switch (r) {
        case i:
          return "Fragment";
        case t:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case l:
            var c = r;
            return K(c) + ".Consumer";
          case s:
            var p = r;
            return K(p._context) + ".Provider";
          case u:
            return J(r, r.render, "ForwardRef");
          case f:
            var k = r.displayName || null;
            return k !== null ? k : D(r.type) || "Memo";
          case h: {
            var P = r, L = P._payload, I = P._init;
            try {
              return D(I(L));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var G = Object.assign, ne = 0, de, ge, ce, ve, H, be, je;
    function W() {
    }
    W.__reactDisabledLog = !0;
    function Ue() {
      {
        if (ne === 0) {
          de = console.log, ge = console.info, ce = console.warn, ve = console.error, H = console.group, be = console.groupCollapsed, je = console.groupEnd;
          var r = {
            configurable: !0,
            enumerable: !0,
            value: W,
            writable: !0
          };
          Object.defineProperties(console, {
            info: r,
            log: r,
            warn: r,
            error: r,
            group: r,
            groupCollapsed: r,
            groupEnd: r
          });
        }
        ne++;
      }
    }
    function Me() {
      {
        if (ne--, ne === 0) {
          var r = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: G({}, r, {
              value: de
            }),
            info: G({}, r, {
              value: ge
            }),
            warn: G({}, r, {
              value: ce
            }),
            error: G({}, r, {
              value: ve
            }),
            group: G({}, r, {
              value: H
            }),
            groupCollapsed: G({}, r, {
              value: be
            }),
            groupEnd: G({}, r, {
              value: je
            })
          });
        }
        ne < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var De = j.ReactCurrentDispatcher, Be;
    function Ee(r, c, p) {
      {
        if (Be === void 0)
          try {
            throw Error();
          } catch (P) {
            var k = P.stack.trim().match(/\n( *(at )?)/);
            Be = k && k[1] || "";
          }
        return `
` + Be + r;
      }
    }
    var Ve = !1, Re;
    {
      var tn = typeof WeakMap == "function" ? WeakMap : Map;
      Re = new tn();
    }
    function Ne(r, c) {
      if (!r || Ve)
        return "";
      {
        var p = Re.get(r);
        if (p !== void 0)
          return p;
      }
      var k;
      Ve = !0;
      var P = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var L;
      L = De.current, De.current = null, Ue();
      try {
        if (c) {
          var I = function() {
            throw Error();
          };
          if (Object.defineProperty(I.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(I, []);
            } catch (re) {
              k = re;
            }
            Reflect.construct(r, [], I);
          } else {
            try {
              I.call();
            } catch (re) {
              k = re;
            }
            r.call(I.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (re) {
            k = re;
          }
          r();
        }
      } catch (re) {
        if (re && k && typeof re.stack == "string") {
          for (var w = re.stack.split(`
`), O = k.stack.split(`
`), V = w.length - 1, z = O.length - 1; V >= 1 && z >= 0 && w[V] !== O[z]; )
            z--;
          for (; V >= 1 && z >= 0; V--, z--)
            if (w[V] !== O[z]) {
              if (V !== 1 || z !== 1)
                do
                  if (V--, z--, z < 0 || w[V] !== O[z]) {
                    var ae = `
` + w[V].replace(" at new ", " at ");
                    return r.displayName && ae.includes("<anonymous>") && (ae = ae.replace("<anonymous>", r.displayName)), typeof r == "function" && Re.set(r, ae), ae;
                  }
                while (V >= 1 && z >= 0);
              break;
            }
        }
      } finally {
        Ve = !1, De.current = L, Me(), Error.prepareStackTrace = P;
      }
      var Ie = r ? r.displayName || r.name : "", Se = Ie ? Ee(Ie) : "";
      return typeof r == "function" && Re.set(r, Se), Se;
    }
    function We(r, c, p) {
      return Ne(r, !1);
    }
    function Oe(r) {
      var c = r.prototype;
      return !!(c && c.isReactComponent);
    }
    function ue(r, c, p) {
      if (r == null)
        return "";
      if (typeof r == "function")
        return Ne(r, Oe(r));
      if (typeof r == "string")
        return Ee(r);
      switch (r) {
        case m:
          return Ee("Suspense");
        case d:
          return Ee("SuspenseList");
      }
      if (typeof r == "object")
        switch (r.$$typeof) {
          case u:
            return We(r.render);
          case f:
            return ue(r.type, c, p);
          case h: {
            var k = r, P = k._payload, L = k._init;
            try {
              return ue(L(P), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var fe = Object.prototype.hasOwnProperty, we = {}, Le = j.ReactDebugCurrentFrame;
    function Fe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        Le.setExtraStackFrame(p);
      } else
        Le.setExtraStackFrame(null);
    }
    function ln(r, c, p, k, P) {
      {
        var L = Function.call.bind(fe);
        for (var I in r)
          if (L(r, I)) {
            var w = void 0;
            try {
              if (typeof r[I] != "function") {
                var O = Error((k || "React class") + ": " + p + " type `" + I + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[I] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw O.name = "Invariant Violation", O;
              }
              w = r[I](c, I, k, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (V) {
              w = V;
            }
            w && !(w instanceof Error) && (Fe(P), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", k || "React class", p, I, typeof w), Fe(null)), w instanceof Error && !(w.message in we) && (we[w.message] = !0, Fe(P), y("Failed %s type: %s", p, w.message), Fe(null));
          }
      }
    }
    var F = Array.isArray;
    function b(r) {
      return F(r);
    }
    function $(r) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && r[Symbol.toStringTag] || r.constructor.name || "Object";
        return p;
      }
    }
    function Y(r) {
      try {
        return X(r), !1;
      } catch {
        return !0;
      }
    }
    function X(r) {
      return "" + r;
    }
    function R(r) {
      if (Y(r))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $(r)), X(r);
    }
    var B = j.ReactCurrentOwner, te = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, pe, _e;
    function Ze(r) {
      if (fe.call(r, "ref")) {
        var c = Object.getOwnPropertyDescriptor(r, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.ref !== void 0;
    }
    function dn(r) {
      if (fe.call(r, "key")) {
        var c = Object.getOwnPropertyDescriptor(r, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return r.key !== void 0;
    }
    function nn(r, c) {
      typeof r.ref == "string" && B.current;
    }
    function rn(r, c) {
      {
        var p = function() {
          pe || (pe = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function fn(r, c) {
      {
        var p = function() {
          _e || (_e = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(r, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var mn = function(r, c, p, k, P, L, I) {
      var w = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: r,
        key: c,
        ref: p,
        props: I,
        // Record the component responsible for creating this element.
        _owner: L
      };
      return w._store = {}, Object.defineProperty(w._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(w, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: k
      }), Object.defineProperty(w, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: P
      }), Object.freeze && (Object.freeze(w.props), Object.freeze(w)), w;
    };
    function vn(r, c, p, k, P) {
      {
        var L, I = {}, w = null, O = null;
        p !== void 0 && (R(p), w = "" + p), dn(c) && (R(c.key), w = "" + c.key), Ze(c) && (O = c.ref, nn(c));
        for (L in c)
          fe.call(c, L) && !te.hasOwnProperty(L) && (I[L] = c[L]);
        if (r && r.defaultProps) {
          var V = r.defaultProps;
          for (L in V)
            I[L] === void 0 && (I[L] = V[L]);
        }
        if (w || O) {
          var z = typeof r == "function" ? r.displayName || r.name || "Unknown" : r;
          w && rn(I, z), O && fn(I, z);
        }
        return mn(r, w, O, P, k, B.current, I);
      }
    }
    var Qe = j.ReactCurrentOwner, yn = j.ReactDebugCurrentFrame;
    function Pe(r) {
      if (r) {
        var c = r._owner, p = ue(r.type, r._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var sn;
    sn = !1;
    function an(r) {
      return typeof r == "object" && r !== null && r.$$typeof === n;
    }
    function jn() {
      {
        if (Qe.current) {
          var r = D(Qe.current.type);
          if (r)
            return `

Check the render method of \`` + r + "`.";
        }
        return "";
      }
    }
    function Hn(r) {
      return "";
    }
    var on = {};
    function Pn(r) {
      {
        var c = jn();
        if (!c) {
          var p = typeof r == "string" ? r : r.displayName || r.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function wn(r, c) {
      {
        if (!r._store || r._store.validated || r.key != null)
          return;
        r._store.validated = !0;
        var p = Pn(c);
        if (on[p])
          return;
        on[p] = !0;
        var k = "";
        r && r._owner && r._owner !== Qe.current && (k = " It was passed a child from " + D(r._owner.type) + "."), Pe(r), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, k), Pe(null);
      }
    }
    function xn(r, c) {
      {
        if (typeof r != "object")
          return;
        if (b(r))
          for (var p = 0; p < r.length; p++) {
            var k = r[p];
            an(k) && wn(k, c);
          }
        else if (an(r))
          r._store && (r._store.validated = !0);
        else if (r) {
          var P = N(r);
          if (typeof P == "function" && P !== r.entries)
            for (var L = P.call(r), I; !(I = L.next()).done; )
              an(I.value) && wn(I.value, c);
        }
      }
    }
    function Vn(r) {
      {
        var c = r.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var k = D(c);
          ln(p, r.props, "prop", k, r);
        } else if (c.PropTypes !== void 0 && !sn) {
          sn = !0;
          var P = D(c);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", P || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mn(r) {
      {
        for (var c = Object.keys(r.props), p = 0; p < c.length; p++) {
          var k = c[p];
          if (k !== "children" && k !== "key") {
            Pe(r), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", k), Pe(null);
            break;
          }
        }
        r.ref !== null && (Pe(r), y("Invalid attribute `ref` supplied to `React.Fragment`."), Pe(null));
      }
    }
    var Sn = {};
    function Cn(r, c, p, k, P, L) {
      {
        var I = ee(r);
        if (!I) {
          var w = "";
          (r === void 0 || typeof r == "object" && r !== null && Object.keys(r).length === 0) && (w += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var O = Hn();
          O ? w += O : w += jn();
          var V;
          r === null ? V = "null" : b(r) ? V = "array" : r !== void 0 && r.$$typeof === n ? (V = "<" + (D(r.type) || "Unknown") + " />", w = " Did you accidentally export a JSX literal instead of a component?") : V = typeof r, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", V, w);
        }
        var z = vn(r, c, p, P, L);
        if (z == null)
          return z;
        if (I) {
          var ae = c.children;
          if (ae !== void 0)
            if (k)
              if (b(ae)) {
                for (var Ie = 0; Ie < ae.length; Ie++)
                  xn(ae[Ie], r);
                Object.freeze && Object.freeze(ae);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(ae, r);
        }
        if (fe.call(c, "key")) {
          var Se = D(r), re = Object.keys(c).filter(function(Nn) {
            return Nn !== "key";
          }), Xe = re.length > 0 ? "{key: someKey, " + re.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Sn[Se + Xe]) {
            var $n = re.length > 0 ? "{" + re.join(": ..., ") + ": ...}" : "{}";
            y(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Xe, Se, $n, Se), Sn[Se + Xe] = !0;
          }
        }
        return r === i ? Mn(z) : Vn(z), z;
      }
    }
    function On(r, c, p) {
      return Cn(r, c, p, !0);
    }
    function Ln(r, c, p) {
      return Cn(r, c, p, !1);
    }
    var Un = Ln, Bn = On;
    gl.Fragment = i, gl.jsx = Un, gl.jsxs = Bn;
  }()), gl;
}
var yN;
function lee() {
  return yN || (yN = 1, process.env.NODE_ENV === "production" ? If.exports = oee() : If.exports = see()), If.exports;
}
var le = lee();
const cee = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "account_status" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "accepts_sms_marketing" } }, { kind: "Field", name: { kind: "Name", value: "accepts_email_marketing" } }, { kind: "Field", name: { kind: "Name", value: "channels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "suppressions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "province_code" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }] } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "response_messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "keyword" } }, { kind: "Field", name: { kind: "Name", value: "flowId" } }, { kind: "Field", name: { kind: "Name", value: "timestamp" } }] } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }, { kind: "Field", name: { kind: "Name", value: "converted" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "last_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_promotional_sent" } }, { kind: "Field", name: { kind: "Name", value: "last_delivered" } }, { kind: "Field", name: { kind: "Name", value: "last_opened" } }, { kind: "Field", name: { kind: "Name", value: "last_engaged" } }, { kind: "Field", name: { kind: "Name", value: "last_converted" } }, { kind: "Field", name: { kind: "Name", value: "last_spam" } }, { kind: "Field", name: { kind: "Name", value: "campaigns" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "opened" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "clicked" } }] } }, { kind: "Field", name: { kind: "Name", value: "flows" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "converted" } }, { kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, uee = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              account_status\n              default_language\n              dafault_currency\n              accepts_sms_marketing\n              accepts_email_marketing\n              channels {\n                sms {\n                  marketing {\n                    consent\n                    timestamp\n                  }\n                }\n                email {\n                  marketing {\n                    consent\n                    timestamp\n                    suppressions {\n                      timestamp\n                      timestamp\n                    }\n                  }\n                }\n              }\n              tags\n              address {\n                address1\n                address2\n                city\n                company\n                state\n                zip\n                province_code\n                country_code\n                phone_number\n              }\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n              }\n              yotpo_sms {\n                last_engaged\n                last_converted\n                last_sent\n                response_messages {\n                  id\n                  keyword\n                  flowId\n                  timestamp\n                }\n                campaigns {\n                  converted\n                  id\n                  clicked\n                }\n                flows {\n                  id\n                  opened\n                  clicked\n                  converted\n                }\n              }\n              yotpo_email {\n                last_sent\n                last_promotional_sent\n                last_delivered\n                last_opened\n                last_engaged\n                last_converted\n                last_spam\n                campaigns {\n                  opened\n                  id\n                  clicked\n                }\n                flows {\n                  converted\n                  id\n                }\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": cee
};
function dee(e) {
  return uee[e] ?? {};
}
const mee = dee(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              account_status
              default_language
              dafault_currency
              accepts_sms_marketing
              accepts_email_marketing
              channels {
                sms {
                  marketing {
                    consent
                    timestamp
                  }
                }
                email {
                  marketing {
                    consent
                    timestamp
                    suppressions {
                      timestamp
                      timestamp
                    }
                  }
                }
              }
              tags
              address {
                address1
                address2
                city
                company
                state
                zip
                province_code
                country_code
                phone_number
              }
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
              }
              yotpo_sms {
                last_engaged
                last_converted
                last_sent
                response_messages {
                  id
                  keyword
                  flowId
                  timestamp
                }
                campaigns {
                  converted
                  id
                  clicked
                }
                flows {
                  id
                  opened
                  clicked
                  converted
                }
              }
              yotpo_email {
                last_sent
                last_promotional_sent
                last_delivered
                last_opened
                last_engaged
                last_converted
                last_spam
                campaigns {
                  opened
                  id
                  clicked
                }
                flows {
                  converted
                  id
                }
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), pee = "_copyIcon_nr4rl_48", fee = "_list_nr4rl_53", hee = "_listItem_nr4rl_63", Jr = {
  copyIcon: pee,
  list: fee,
  listItem: hee
}, Fn = ({
  description: e,
  content: n,
  tooltip: t
}) => {
  if (n == null)
    return null;
  const i = BF(n);
  return /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Jr.listItem, children: /* @__PURE__ */ le.jsx(Je, { content: t, children: /* @__PURE__ */ le.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: e }),
    i ? n : AN(n)
  ] }) }) });
}, gN = ({
  channel: e
}) => {
  const n = (a) => pc(a.replace("_", " "));
  if (!e?.marketing)
    return null;
  const { marketing: t } = e, i = "suppressions" in t && !!t.suppressions;
  return /* @__PURE__ */ le.jsxs(le.Fragment, { children: [
    /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Jr.listItem, children: /* @__PURE__ */ le.jsxs(_, { justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Consent" }),
      /* @__PURE__ */ le.jsxs(_, { gap: "100", alignItems: "center", children: [
        t?.timestamp && /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Tn(t?.timestamp).format(lt) }),
        t?.consent && /* @__PURE__ */ le.jsx(zn, { variant: "primary", size: "small", children: n(t?.consent) })
      ] })
    ] }) }),
    i && /* @__PURE__ */ le.jsx(He.Text, { variant: "dense", className: Jr.listItem, children: /* @__PURE__ */ le.jsxs(_, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Suppressions" }),
      /* @__PURE__ */ le.jsxs(_, { gap: "100", alignItems: "center", children: [
        t.suppressions?.timestamp && /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "5", color: "secondary", children: Tn(t.suppressions?.timestamp).format(
          lt
        ) }),
        t.suppressions?.suppression_reason && /* @__PURE__ */ le.jsx(zn, { variant: "warning", size: "small", children: t.suppressions?.suppression_reason })
      ] })
    ] }) })
  ] });
}, vee = "_channelHeadline_yeqqp_1", kN = {
  channelHeadline: vee
}, yee = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { channels: n } = e, { yotpo_email: t, yotpo_sms: i } = e;
  return /* @__PURE__ */ le.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Channels" }),
    /* @__PURE__ */ le.jsxs(_, { flexDirection: "column", children: [
      /* @__PURE__ */ le.jsxs(_, { gap: "100", className: kN.channelHeadline, children: [
        /* @__PURE__ */ le.jsx(he, { name: "mail" }),
        /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-4", children: "EMAIL" })
      ] }),
      /* @__PURE__ */ le.jsxs(He, { className: Jr.list, children: [
        /* @__PURE__ */ le.jsx(gN, { channel: n?.email }),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the customer's last email was sent.",
            content: t?.last_sent
          }
        ),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last promotional sent",
            tooltip: "The timestamp for when the customer's last promotional email was sent.",
            content: t?.last_promotional_sent
          }
        ),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last delivered",
            tooltip: "The timestamp for when the customer's last email was delivered.",
            content: t?.last_delivered
          }
        ),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last opened",
            tooltip: "The timestamp for when the customer's last email was opened.",
            content: t?.last_opened
          }
        ),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via email.",
            content: t?.last_engaged
          }
        ),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via email.",
            content: t?.last_converted
          }
        ),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last spam",
            tooltip: "The timestamp for when the customer's last email was marked as spam.",
            content: t?.last_spam
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ le.jsxs(_, { flexDirection: "column", children: [
      /* @__PURE__ */ le.jsxs(_, { gap: "100", className: kN.channelHeadline, children: [
        /* @__PURE__ */ le.jsx(he, { name: "sms" }),
        /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-4", children: "SMS" })
      ] }),
      /* @__PURE__ */ le.jsxs(He, { className: Jr.list, children: [
        /* @__PURE__ */ le.jsx(gN, { channel: n?.sms }),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last engaged",
            tooltip: "The timestamp for when the customer was last engaged via SMS.",
            content: i?.last_engaged
          }
        ),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last sent",
            tooltip: "The timestamp for when the last SMS was sent to the customer.",
            content: i?.last_sent
          }
        ),
        /* @__PURE__ */ le.jsx(
          Fn,
          {
            description: "Last converted",
            tooltip: "The timestamp for when the customer last converted via SMS.",
            content: i?.last_converted
          }
        )
      ] })
    ] })
  ] });
}, gee = "_wrapper_1xucg_1", kee = "_externalLink_1xucg_7", $f = {
  wrapper: gee,
  externalLink: kee
}, bee = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: t } = si(), { isCopied: i, copy: a } = si(), { isCopied: o, copy: s } = si();
  if (!e)
    return null;
  const {
    first_name: l,
    last_name: u,
    address: m,
    email: d,
    phone_number: f,
    account_created_at: h,
    account_status: v,
    accepts_sms_marketing: x,
    accepts_email_marketing: S
  } = e, N = 14, j = `${l || ""} ${u || ""}`.trim() || "A customer has no name", {
    address1: y,
    address2: q,
    city: E,
    company: C,
    state: T,
    zip: U,
    province_code: Z,
    country_code: Q
  } = m || {}, ee = [
    y,
    q,
    [U, E].filter(Boolean).join(", "),
    [Q, T, Z].filter(Boolean).join(", "),
    C
  ].filter(Boolean);
  return /* @__PURE__ */ le.jsx(_, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ le.jsxs(_, { className: $f.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ le.jsx(
      _,
      {
        justifyContent: "space-between",
        className: $f.block,
        alignItems: "center",
        children: /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-2", children: j })
      }
    ),
    h && /* @__PURE__ */ le.jsxs(_, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: Tn(h).format(lt) })
    ] }),
    d && /* @__PURE__ */ le.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(he, { size: N, name: "mail" }),
        /* @__PURE__ */ le.jsx("span", { className: $f.externalLink, children: d })
      ] }),
      /* @__PURE__ */ le.jsx(Je, { content: "Copy email", children: /* @__PURE__ */ le.jsx(_, { alignItems: "center", children: /* @__PURE__ */ le.jsx(
        he,
        {
          size: N,
          name: n ? "done" : "copy",
          onClick: () => t(d),
          className: Jr.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ le.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(he, { size: N, name: "phone" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: f })
      ] }),
      /* @__PURE__ */ le.jsx(Je, { content: "Copy phone number", children: /* @__PURE__ */ le.jsx(_, { alignItems: "center", children: /* @__PURE__ */ le.jsx(
        he,
        {
          size: N,
          name: i ? "done" : "copy",
          onClick: () => a(f),
          className: Jr.copyIcon
        }
      ) }) })
    ] }),
    (y || E || C || T || U || Q) && /* @__PURE__ */ le.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(_, { gap: "200", children: [
        /* @__PURE__ */ le.jsx(he, { size: N, name: "home" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", children: ee.map((J) => /* @__PURE__ */ le.jsx(Yn, { children: J }, J)) })
      ] }),
      /* @__PURE__ */ le.jsx(Je, { content: "Copy address", children: /* @__PURE__ */ le.jsx(_, { alignItems: "center", children: /* @__PURE__ */ le.jsx(
        he,
        {
          size: N,
          name: o ? "done" : "copy",
          onClick: () => s(ee.join(", ")),
          className: Jr.copyIcon
        }
      ) }) })
    ] }),
    /* @__PURE__ */ le.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(he, { size: N, name: "sms" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Accepts sms marketing" })
      ] }),
      /* @__PURE__ */ le.jsx(
        he,
        {
          name: x ? "check-circle-filled" : "close-circle-filled",
          color: x ? "green.500" : "red.500"
        }
      )
    ] }),
    /* @__PURE__ */ le.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(he, { size: N, name: "paper-plane" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Accepts email marketing" })
      ] }),
      /* @__PURE__ */ le.jsx(
        he,
        {
          name: S ? "check-circle-filled" : "close-circle-filled",
          color: S ? "green.500" : "red.500"
        }
      )
    ] }),
    v && /* @__PURE__ */ le.jsxs(_, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ le.jsxs(_, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ le.jsx(he, { size: N, name: "yotpo", color: "rgb(0, 66, 228)" }),
        /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", children: "Account status" })
      ] }),
      /* @__PURE__ */ le.jsx(En, { children: pc(v) })
    ] })
  ] }) });
}, _ee = ({
  loyalty: e
}) => /* @__PURE__ */ le.jsxs(_, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ le.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ le.jsxs(He, { className: Jr.list, children: [
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Points expire date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.points_expire_date
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), xee = ({ tags: e }) => {
  const n = e?.split(","), t = n && n.length > 0;
  return /* @__PURE__ */ le.jsxs(_, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "Tags" }),
    !t && /* @__PURE__ */ le.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No tags available" }) }),
    t && /* @__PURE__ */ le.jsx(_, { gap: "200", flexWrap: "wrap", children: n.map((i, a) => /* @__PURE__ */ le.jsx(En, { children: i }, a)) })
  ] });
}, See = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ le.jsxs(_, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ le.jsx(_, { justifyContent: "center", children: /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ le.jsxs(He, { className: Jr.list, children: [
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: e.sentiment_avg_site
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Tn(e.last_review_date).format(
          lt
        )
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: e.last_sentiment
      }
    ),
    /* @__PURE__ */ le.jsx(
      Fn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ le.jsx(
          _,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, t) => /* @__PURE__ */ le.jsx(zn, { variant: "info", size: "small", children: /* @__PURE__ */ le.jsx(le.Fragment, { children: n }) }, t))
          }
        )
      }
    )
  ] })
] }), Nee = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: t } = un(), { track: i } = hn(), [a, o] = oe(), [s, l] = oe(!1), u = e?.customer?.email, m = e?.customer?.phone_number, d = !u && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, v = n?.showTags ?? !1, x = n?.showChannels ?? !1, S = n?.showUserGeneratedContent ?? !1, N = n?.displayLoyalty ?? !1, j = n?.displayEmailData ?? !1, y = n?.displaySmsData ?? !1, q = n?.displaySubscriptions ?? !1, E = !h && !v && !x && !S && !N && !j && !y && !q, {
    loading: C,
    error: T,
    data: U
  } = t(mee, {
    skip: !u || !f,
    variables: {
      ...u && { email: u },
      ...!u && m && { phone_number: m },
      storeId: f
    }
  });
  return qe(() => {
    const Z = U?.Yotpo?.getCustomers;
    Z?.customers && (Z?.customers?.length > 0 ? (o(Z?.customers[0]), l(!1), i("yotpo:customer:received")) : l(!0));
  }, [U?.Yotpo, C]), d ? /* @__PURE__ */ le.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : s ? /* @__PURE__ */ le.jsx(_, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) }) : E ? /* @__PURE__ */ le.jsx(
    _,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-features",
      children: /* @__PURE__ */ le.jsx(A.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
    }
  ) : T ? Ph({ errors: T.graphQLErrors }) ? /* @__PURE__ */ le.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      variant: "4",
      "data-testid": "widget-downstream-api-forbidden-error",
      children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
    }
  ) : Ah({ errors: T.graphQLErrors }) ? /* @__PURE__ */ le.jsx(
    A.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      variant: "4",
      "data-testid": "widget-downstream-api-authorization-error",
      children: "The integration could not authorize against Yotpo. Please contact your administrator."
    }
  ) : /* @__PURE__ */ le.jsx(_n, { error: T }) : C ? /* @__PURE__ */ le.jsx(_, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ le.jsx(cn, {}) }) : /* @__PURE__ */ le.jsxs(
    _,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ le.jsx(bee, { customerDetails: a }),
        v && /* @__PURE__ */ le.jsx(xee, { tags: a?.tags }),
        x && /* @__PURE__ */ le.jsx(yee, { customerDetails: a }),
        S && /* @__PURE__ */ le.jsx(
          See,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        N && /* @__PURE__ */ le.jsx(_ee, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
};
var Fs = (e) => e.type === "checkbox", Li = (e) => e instanceof Date, Ut = (e) => e == null;
const mF = (e) => typeof e == "object";
var st = (e) => !Ut(e) && !Array.isArray(e) && mF(e) && !Li(e), pF = (e) => st(e) && e.target ? Fs(e.target) ? e.target.checked : e.target.value : e, jee = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, fF = (e, n) => e.has(jee(n)), wee = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return st(n) && n.hasOwnProperty("isPrototypeOf");
}, jy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function $t(e) {
  let n;
  const t = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(jy && (e instanceof Blob || i)) && (t || st(e)))
    if (n = t ? [] : {}, !t && !wee(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = $t(e[a]));
  else
    return e;
  return n;
}
var nu = (e) => Array.isArray(e) ? e.filter(Boolean) : [], it = (e) => e === void 0, Ye = (e, n, t) => {
  if (!n || !st(e))
    return t;
  const i = nu(n.split(/[,[\].]+?/)).reduce((a, o) => Ut(a) ? a : a[o], e);
  return it(i) || i === e ? it(e[n]) ? t : e[n] : i;
}, ar = (e) => typeof e == "boolean", wy = (e) => /^\w*$/.test(e), hF = (e) => nu(e.replace(/["|']|\]/g, "").split(/\.|\[/)), Gn = (e, n, t) => {
  let i = -1;
  const a = wy(n) ? [n] : hF(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let u = t;
    if (i !== s) {
      const m = e[l];
      u = st(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = u, e = e[l];
  }
};
const lc = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, $r = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, oi = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Cee = xe.createContext(null), Cy = () => xe.useContext(Cee);
var vF = (e, n, t, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== $r.all && (n._proxyFormState[s] = !i || $r.all), t && (t[s] = !0), e[s];
      }
    });
  return a;
};
function Fee(e) {
  const n = Cy(), { control: t = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = xe.useState(t._formState), u = xe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = xe.useRef(a);
  return m.current = a, xe.useEffect(() => t._subscribe({
    name: m.current,
    formState: u.current,
    exact: o,
    callback: (d) => {
      !i && l({
        ...t._formState,
        ...d
      });
    }
  }), [t, i, o]), xe.useEffect(() => {
    u.current.isValid && t._setValid(!0);
  }, [t]), xe.useMemo(() => vF(s, t, u.current, !1), [s, t]);
}
var Yr = (e) => typeof e == "string", yF = (e, n, t, i, a) => Yr(e) ? (i && n.watch.add(e), Ye(t, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), Ye(t, o))) : (i && (n.watchAll = !0), t);
function gF(e) {
  const n = Cy(), { control: t = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = xe.useRef(i), u = xe.useRef(a);
  l.current = i, xe.useEffect(() => t._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && d(yF(l.current, t._names, f.values || t._formValues, !1, u.current))
  }), [t, o, s]);
  const [m, d] = xe.useState(t._getWatch(i, a));
  return xe.useEffect(() => t._removeUnmounted()), m;
}
function Iee(e) {
  const n = Cy(), { name: t, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = fF(a._names.array, t), l = gF({
    control: a,
    name: t,
    defaultValue: Ye(a._formValues, t, Ye(a._defaultValues, t, e.defaultValue)),
    exact: !0
  }), u = Fee({
    control: a,
    name: t,
    exact: !0
  }), m = xe.useRef(e), d = xe.useRef(a.register(t, {
    ...e.rules,
    value: l,
    ...ar(e.disabled) ? { disabled: e.disabled } : {}
  })), f = xe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Ye(u.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Ye(u.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Ye(u.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Ye(u.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Ye(u.errors, t)
    }
  }), [u, t]), h = xe.useCallback((N) => d.current.onChange({
    target: {
      value: pF(N),
      name: t
    },
    type: lc.CHANGE
  }), [t]), v = xe.useCallback(() => d.current.onBlur({
    target: {
      value: Ye(a._formValues, t),
      name: t
    },
    type: lc.BLUR
  }), [t, a._formValues]), x = xe.useCallback((N) => {
    const j = Ye(a._fields, t);
    j && N && (j._f.ref = {
      focus: () => N.focus(),
      select: () => N.select(),
      setCustomValidity: (y) => N.setCustomValidity(y),
      reportValidity: () => N.reportValidity()
    });
  }, [a._fields, t]), S = xe.useMemo(() => ({
    name: t,
    value: l,
    ...ar(i) || u.disabled ? { disabled: u.disabled || i } : {},
    onChange: h,
    onBlur: v,
    ref: x
  }), [t, i, u.disabled, h, v, x, l]);
  return xe.useEffect(() => {
    const N = a._options.shouldUnregister || o;
    a.register(t, {
      ...m.current.rules,
      ...ar(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const j = (y, q) => {
      const E = Ye(a._fields, y);
      E && E._f && (E._f.mount = q);
    };
    if (j(t, !0), N) {
      const y = $t(Ye(a._options.defaultValues, t));
      Gn(a._defaultValues, t, y), it(Ye(a._formValues, t)) && Gn(a._formValues, t, y);
    }
    return !s && a.register(t), () => {
      (s ? N && !a._state.action : N) ? a.unregister(t) : j(t, !1);
    };
  }, [t, a, s, o]), xe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: t
    });
  }, [i, t, a]), xe.useMemo(() => ({
    field: S,
    formState: u,
    fieldState: f
  }), [S, u, f]);
}
const bN = (e) => e.render(Iee(e));
var $ee = (e, n, t, i, a) => n ? {
  ...t[e],
  types: {
    ...t[e] && t[e].types ? t[e].types : {},
    [i]: a || !0
  }
} : {}, Uo = (e) => Array.isArray(e) ? e : [e], _N = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const t of e)
        t.next && t.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((t) => t !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Dh = (e) => Ut(e) || !mF(e);
function bi(e, n) {
  if (Dh(e) || Dh(n))
    return e === n;
  if (Li(e) && Li(n))
    return e.getTime() === n.getTime();
  const t = Object.keys(e), i = Object.keys(n);
  if (t.length !== i.length)
    return !1;
  for (const a of t) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Li(o) && Li(s) || st(o) && st(s) || Array.isArray(o) && Array.isArray(s) ? !bi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Vt = (e) => st(e) && !Object.keys(e).length, Fy = (e) => e.type === "file", Er = (e) => typeof e == "function", cc = (e) => {
  if (!jy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, kF = (e) => e.type === "select-multiple", Iy = (e) => e.type === "radio", Eee = (e) => Iy(e) || Fs(e), Ef = (e) => cc(e) && e.isConnected;
function Tee(e, n) {
  const t = n.slice(0, -1).length;
  let i = 0;
  for (; i < t; )
    e = it(e) ? i++ : e[n[i++]];
  return e;
}
function Oee(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !it(e[n]))
      return !1;
  return !0;
}
function kt(e, n) {
  const t = Array.isArray(n) ? n : wy(n) ? [n] : hF(n), i = t.length === 1 ? e : Tee(e, t), a = t.length - 1, o = t[a];
  return i && delete i[o], a !== 0 && (st(i) && Vt(i) || Array.isArray(i) && Oee(i)) && kt(e, t.slice(0, -1)), e;
}
var bF = (e) => {
  for (const n in e)
    if (Er(e[n]))
      return !0;
  return !1;
};
function uc(e, n = {}) {
  const t = Array.isArray(e);
  if (st(e) || t)
    for (const i in e)
      Array.isArray(e[i]) || st(e[i]) && !bF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, uc(e[i], n[i])) : Ut(e[i]) || (n[i] = !0);
  return n;
}
function _F(e, n, t) {
  const i = Array.isArray(e);
  if (st(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || st(e[a]) && !bF(e[a]) ? it(n) || Dh(t[a]) ? t[a] = Array.isArray(e[a]) ? uc(e[a], []) : { ...uc(e[a]) } : _F(e[a], Ut(n) ? {} : n[a], t[a]) : t[a] = !bi(e[a], n[a]);
  return t;
}
var Co = (e, n) => _F(e, n, uc(n));
const xN = {
  value: !1,
  isValid: !1
}, SN = { value: !0, isValid: !0 };
var xF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !it(e[0].attributes.value) ? it(e[0].value) || e[0].value === "" ? SN : { value: e[0].value, isValid: !0 } : SN
    ) : xN;
  }
  return xN;
}, SF = (e, { valueAsNumber: n, valueAsDate: t, setValueAs: i }) => it(e) ? e : n ? e === "" ? NaN : e && +e : t && Yr(e) ? new Date(e) : i ? i(e) : e;
const NN = {
  isValid: !1,
  value: null
};
var NF = (e) => Array.isArray(e) ? e.reduce((n, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : n, NN) : NN;
function jN(e) {
  const n = e.ref;
  return Fy(n) ? n.files : Iy(n) ? NF(e.refs).value : kF(n) ? [...n.selectedOptions].map(({ value: t }) => t) : Fs(n) ? xF(e.refs).value : SF(it(n.value) ? e.ref.value : n.value, e);
}
var Ree = (e, n, t, i) => {
  const a = {};
  for (const o of e) {
    const s = Ye(n, o);
    s && Gn(a, o, s._f);
  }
  return {
    criteriaMode: t,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, dc = (e) => e instanceof RegExp, Fo = (e) => it(e) ? e : dc(e) ? e.source : st(e) ? dc(e.value) ? e.value.source : e.value : e, wN = (e) => ({
  isOnSubmit: !e || e === $r.onSubmit,
  isOnBlur: e === $r.onBlur,
  isOnChange: e === $r.onChange,
  isOnAll: e === $r.all,
  isOnTouch: e === $r.onTouched
});
const CN = "AsyncFunction";
var Dee = (e) => !!e && !!e.validate && !!(Er(e.validate) && e.validate.constructor.name === CN || st(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === CN)), Pee = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), FN = (e, n, t) => !t && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Bo = (e, n, t, i) => {
  for (const a of t || Object.keys(e)) {
    const o = Ye(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Bo(l, n))
          break;
      } else if (st(l) && Bo(l, n))
        break;
    }
  }
};
function IN(e, n, t) {
  const i = Ye(e, t);
  if (i || wy(t))
    return {
      error: i,
      name: t
    };
  const a = t.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = Ye(n, o), l = Ye(e, o);
    if (s && !Array.isArray(s) && t !== o)
      return { name: t };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: t
  };
}
var Aee = (e, n, t, i) => {
  t(e);
  const { name: a, ...o } = e;
  return Vt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || $r.all));
}, Lee = (e, n, t) => !e || !n || e === n || Uo(e).some((i) => i && (t ? i === n : i.startsWith(n) || n.startsWith(i))), Vee = (e, n, t, i, a) => a.isOnAll ? !1 : !t && a.isOnTouch ? !(n || e) : (t ? i.isOnBlur : a.isOnBlur) ? !e : (t ? i.isOnChange : a.isOnChange) ? e : !0, zee = (e, n) => !nu(Ye(e, n)).length && kt(e, n), Mee = (e, n, t) => {
  const i = Uo(Ye(e, t));
  return Gn(i, "root", n[t]), Gn(e, t, i), e;
}, Ll = (e) => Yr(e);
function $N(e, n, t = "validate") {
  if (Ll(e) || Array.isArray(e) && e.every(Ll) || ar(e) && !e)
    return {
      type: t,
      message: Ll(e) ? e : "",
      ref: n
    };
}
var ua = (e) => st(e) && !dc(e) ? e : {
  value: e,
  message: ""
}, EN = async (e, n, t, i, a, o) => {
  const { ref: s, refs: l, required: u, maxLength: m, minLength: d, min: f, max: h, pattern: v, validate: x, name: S, valueAsNumber: N, mount: j } = e._f, y = Ye(t, S);
  if (!j || n.has(S))
    return {};
  const q = l ? l[0] : s, E = (K) => {
    a && q.reportValidity && (q.setCustomValidity(ar(K) ? "" : K || ""), q.reportValidity());
  }, C = {}, T = Iy(s), U = Fs(s), Z = T || U, Q = (N || Fy(s)) && it(s.value) && it(y) || cc(s) && s.value === "" || y === "" || Array.isArray(y) && !y.length, ee = $ee.bind(null, S, i, C), J = (K, D, G, ne = oi.maxLength, de = oi.minLength) => {
    const ge = K ? D : G;
    C[S] = {
      type: K ? ne : de,
      message: ge,
      ref: s,
      ...ee(K ? ne : de, ge)
    };
  };
  if (o ? !Array.isArray(y) || !y.length : u && (!Z && (Q || Ut(y)) || ar(y) && !y || U && !xF(l).isValid || T && !NF(l).isValid)) {
    const { value: K, message: D } = Ll(u) ? { value: !!u, message: u } : ua(u);
    if (K && (C[S] = {
      type: oi.required,
      message: D,
      ref: q,
      ...ee(oi.required, D)
    }, !i))
      return E(D), C;
  }
  if (!Q && (!Ut(f) || !Ut(h))) {
    let K, D;
    const G = ua(h), ne = ua(f);
    if (!Ut(y) && !isNaN(y)) {
      const de = s.valueAsNumber || y && +y;
      Ut(G.value) || (K = de > G.value), Ut(ne.value) || (D = de < ne.value);
    } else {
      const de = s.valueAsDate || new Date(y), ge = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), ce = s.type == "time", ve = s.type == "week";
      Yr(G.value) && y && (K = ce ? ge(y) > ge(G.value) : ve ? y > G.value : de > new Date(G.value)), Yr(ne.value) && y && (D = ce ? ge(y) < ge(ne.value) : ve ? y < ne.value : de < new Date(ne.value));
    }
    if ((K || D) && (J(!!K, G.message, ne.message, oi.max, oi.min), !i))
      return E(C[S].message), C;
  }
  if ((m || d) && !Q && (Yr(y) || o && Array.isArray(y))) {
    const K = ua(m), D = ua(d), G = !Ut(K.value) && y.length > +K.value, ne = !Ut(D.value) && y.length < +D.value;
    if ((G || ne) && (J(G, K.message, D.message), !i))
      return E(C[S].message), C;
  }
  if (v && !Q && Yr(y)) {
    const { value: K, message: D } = ua(v);
    if (dc(K) && !y.match(K) && (C[S] = {
      type: oi.pattern,
      message: D,
      ref: s,
      ...ee(oi.pattern, D)
    }, !i))
      return E(D), C;
  }
  if (x) {
    if (Er(x)) {
      const K = await x(y, t), D = $N(K, q);
      if (D && (C[S] = {
        ...D,
        ...ee(oi.validate, D.message)
      }, !i))
        return E(D.message), C;
    } else if (st(x)) {
      let K = {};
      for (const D in x) {
        if (!Vt(K) && !i)
          break;
        const G = $N(await x[D](y, t), q, D);
        G && (K = {
          ...G,
          ...ee(D, G.message)
        }, E(G.message), i && (C[S] = K));
      }
      if (!Vt(K) && (C[S] = {
        ref: q,
        ...K
      }, !i))
        return C;
    }
  }
  return E(!0), C;
};
const Uee = {
  mode: $r.onSubmit,
  reValidateMode: $r.onChange,
  shouldFocusError: !0
};
function Bee(e = {}) {
  let n = {
    ...Uee,
    ...e
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Er(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = st(n.defaultValues) || st(n.values) ? $t(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : $t(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, u, m = 0;
  const d = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...d
  };
  const h = {
    array: _N(),
    state: _N()
  }, v = wN(n.mode), x = wN(n.reValidateMode), S = n.criteriaMode === $r.all, N = (F) => (b) => {
    clearTimeout(m), m = setTimeout(F, b);
  }, j = async (F) => {
    if (!n.disabled && (d.isValid || f.isValid || F)) {
      const b = n.resolver ? Vt((await Q()).errors) : await J(i, !0);
      b !== t.isValid && h.state.next({
        isValid: b
      });
    }
  }, y = (F, b) => {
    !n.disabled && (d.isValidating || d.validatingFields || f.isValidating || f.validatingFields) && ((F || Array.from(l.mount)).forEach(($) => {
      $ && (b ? Gn(t.validatingFields, $, b) : kt(t.validatingFields, $));
    }), h.state.next({
      validatingFields: t.validatingFields,
      isValidating: !Vt(t.validatingFields)
    }));
  }, q = (F, b = [], $, Y, X = !0, R = !0) => {
    if (Y && $ && !n.disabled) {
      if (s.action = !0, R && Array.isArray(Ye(i, F))) {
        const B = $(Ye(i, F), Y.argA, Y.argB);
        X && Gn(i, F, B);
      }
      if (R && Array.isArray(Ye(t.errors, F))) {
        const B = $(Ye(t.errors, F), Y.argA, Y.argB);
        X && Gn(t.errors, F, B), zee(t.errors, F);
      }
      if ((d.touchedFields || f.touchedFields) && R && Array.isArray(Ye(t.touchedFields, F))) {
        const B = $(Ye(t.touchedFields, F), Y.argA, Y.argB);
        X && Gn(t.touchedFields, F, B);
      }
      (d.dirtyFields || f.dirtyFields) && (t.dirtyFields = Co(a, o)), h.state.next({
        name: F,
        isDirty: D(F, b),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      Gn(o, F, b);
  }, E = (F, b) => {
    Gn(t.errors, F, b), h.state.next({
      errors: t.errors
    });
  }, C = (F) => {
    t.errors = F, h.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, T = (F, b, $, Y) => {
    const X = Ye(i, F);
    if (X) {
      const R = Ye(o, F, it($) ? Ye(a, F) : $);
      it(R) || Y && Y.defaultChecked || b ? Gn(o, F, b ? R : jN(X._f)) : de(F, R), s.mount && j();
    }
  }, U = (F, b, $, Y, X) => {
    let R = !1, B = !1;
    const te = {
      name: F
    };
    if (!n.disabled) {
      if (!$ || Y) {
        (d.isDirty || f.isDirty) && (B = t.isDirty, t.isDirty = te.isDirty = D(), R = B !== te.isDirty);
        const pe = bi(Ye(a, F), b);
        B = !!Ye(t.dirtyFields, F), pe ? kt(t.dirtyFields, F) : Gn(t.dirtyFields, F, !0), te.dirtyFields = t.dirtyFields, R = R || (d.dirtyFields || f.dirtyFields) && B !== !pe;
      }
      if ($) {
        const pe = Ye(t.touchedFields, F);
        pe || (Gn(t.touchedFields, F, $), te.touchedFields = t.touchedFields, R = R || (d.touchedFields || f.touchedFields) && pe !== $);
      }
      R && X && h.state.next(te);
    }
    return R ? te : {};
  }, Z = (F, b, $, Y) => {
    const X = Ye(t.errors, F), R = (d.isValid || f.isValid) && ar(b) && t.isValid !== b;
    if (n.delayError && $ ? (u = N(() => E(F, $)), u(n.delayError)) : (clearTimeout(m), u = null, $ ? Gn(t.errors, F, $) : kt(t.errors, F)), ($ ? !bi(X, $) : X) || !Vt(Y) || R) {
      const B = {
        ...Y,
        ...R && ar(b) ? { isValid: b } : {},
        errors: t.errors,
        name: F
      };
      t = {
        ...t,
        ...B
      }, h.state.next(B);
    }
  }, Q = async (F) => {
    y(F, !0);
    const b = await n.resolver(o, n.context, Ree(F || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return y(F), b;
  }, ee = async (F) => {
    const { errors: b } = await Q(F);
    if (F)
      for (const $ of F) {
        const Y = Ye(b, $);
        Y ? Gn(t.errors, $, Y) : kt(t.errors, $);
      }
    else
      t.errors = b;
    return b;
  }, J = async (F, b, $ = {
    valid: !0
  }) => {
    for (const Y in F) {
      const X = F[Y];
      if (X) {
        const { _f: R, ...B } = X;
        if (R) {
          const te = l.array.has(R.name), pe = X._f && Dee(X._f);
          pe && d.validatingFields && y([Y], !0);
          const _e = await EN(X, l.disabled, o, S, n.shouldUseNativeValidation && !b, te);
          if (pe && d.validatingFields && y([Y]), _e[R.name] && ($.valid = !1, b))
            break;
          !b && (Ye(_e, R.name) ? te ? Mee(t.errors, _e, R.name) : Gn(t.errors, R.name, _e[R.name]) : kt(t.errors, R.name));
        }
        !Vt(B) && await J(B, b, $);
      }
    }
    return $.valid;
  }, K = () => {
    for (const F of l.unMount) {
      const b = Ye(i, F);
      b && (b._f.refs ? b._f.refs.every(($) => !Ef($)) : !Ef(b._f.ref)) && Ve(F);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, D = (F, b) => !n.disabled && (F && b && Gn(o, F, b), !bi(je(), a)), G = (F, b, $) => yF(F, l, {
    ...s.mount ? o : it(b) ? a : Yr(F) ? { [F]: b } : b
  }, $, b), ne = (F) => nu(Ye(s.mount ? o : a, F, n.shouldUnregister ? Ye(a, F, []) : [])), de = (F, b, $ = {}) => {
    const Y = Ye(i, F);
    let X = b;
    if (Y) {
      const R = Y._f;
      R && (!R.disabled && Gn(o, F, SF(b, R)), X = cc(R.ref) && Ut(b) ? "" : b, kF(R.ref) ? [...R.ref.options].forEach((B) => B.selected = X.includes(B.value)) : R.refs ? Fs(R.ref) ? R.refs.length > 1 ? R.refs.forEach((B) => (!B.defaultChecked || !B.disabled) && (B.checked = Array.isArray(X) ? !!X.find((te) => te === B.value) : X === B.value)) : R.refs[0] && (R.refs[0].checked = !!X) : R.refs.forEach((B) => B.checked = B.value === X) : Fy(R.ref) ? R.ref.value = "" : (R.ref.value = X, R.ref.type || h.state.next({
        name: F,
        values: $t(o)
      })));
    }
    ($.shouldDirty || $.shouldTouch) && U(F, X, $.shouldTouch, $.shouldDirty, !0), $.shouldValidate && be(F);
  }, ge = (F, b, $) => {
    for (const Y in b) {
      const X = b[Y], R = `${F}.${Y}`, B = Ye(i, R);
      (l.array.has(F) || st(X) || B && !B._f) && !Li(X) ? ge(R, X, $) : de(R, X, $);
    }
  }, ce = (F, b, $ = {}) => {
    const Y = Ye(i, F), X = l.array.has(F), R = $t(b);
    Gn(o, F, R), X ? (h.array.next({
      name: F,
      values: $t(o)
    }), (d.isDirty || d.dirtyFields || f.isDirty || f.dirtyFields) && $.shouldDirty && h.state.next({
      name: F,
      dirtyFields: Co(a, o),
      isDirty: D(F, R)
    })) : Y && !Y._f && !Ut(R) ? ge(F, R, $) : de(F, R, $), FN(F, l) && h.state.next({ ...t }), h.state.next({
      name: s.mount ? F : void 0,
      values: $t(o)
    });
  }, ve = async (F) => {
    s.mount = !0;
    const b = F.target;
    let $ = b.name, Y = !0;
    const X = Ye(i, $), R = (B) => {
      Y = Number.isNaN(B) || Li(B) && isNaN(B.getTime()) || bi(B, Ye(o, $, B));
    };
    if (X) {
      let B, te;
      const pe = b.type ? jN(X._f) : pF(F), _e = F.type === lc.BLUR || F.type === lc.FOCUS_OUT, Ze = !Pee(X._f) && !n.resolver && !Ye(t.errors, $) && !X._f.deps || Vee(_e, Ye(t.touchedFields, $), t.isSubmitted, x, v), dn = FN($, l, _e);
      Gn(o, $, pe), _e ? (X._f.onBlur && X._f.onBlur(F), u && u(0)) : X._f.onChange && X._f.onChange(F);
      const nn = U($, pe, _e), rn = !Vt(nn) || dn;
      if (!_e && h.state.next({
        name: $,
        type: F.type,
        values: $t(o)
      }), Ze)
        return (d.isValid || f.isValid) && (n.mode === "onBlur" ? _e && j() : _e || j()), rn && h.state.next({ name: $, ...dn ? {} : nn });
      if (!_e && dn && h.state.next({ ...t }), n.resolver) {
        const { errors: fn } = await Q([$]);
        if (R(pe), Y) {
          const mn = IN(t.errors, i, $), vn = IN(fn, i, mn.name || $);
          B = vn.error, $ = vn.name, te = Vt(fn);
        }
      } else
        y([$], !0), B = (await EN(X, l.disabled, o, S, n.shouldUseNativeValidation))[$], y([$]), R(pe), Y && (B ? te = !1 : (d.isValid || f.isValid) && (te = await J(i, !0)));
      Y && (X._f.deps && be(X._f.deps), Z($, te, B, nn));
    }
  }, H = (F, b) => {
    if (Ye(t.errors, b) && F.focus)
      return F.focus(), 1;
  }, be = async (F, b = {}) => {
    let $, Y;
    const X = Uo(F);
    if (n.resolver) {
      const R = await ee(it(F) ? F : X);
      $ = Vt(R), Y = F ? !X.some((B) => Ye(R, B)) : $;
    } else F ? (Y = (await Promise.all(X.map(async (R) => {
      const B = Ye(i, R);
      return await J(B && B._f ? { [R]: B } : B);
    }))).every(Boolean), !(!Y && !t.isValid) && j()) : Y = $ = await J(i);
    return h.state.next({
      ...!Yr(F) || (d.isValid || f.isValid) && $ !== t.isValid ? {} : { name: F },
      ...n.resolver || !F ? { isValid: $ } : {},
      errors: t.errors
    }), b.shouldFocus && !Y && Bo(i, H, F ? X : l.mount), Y;
  }, je = (F) => {
    const b = {
      ...s.mount ? o : a
    };
    return it(F) ? b : Yr(F) ? Ye(b, F) : F.map(($) => Ye(b, $));
  }, W = (F, b) => ({
    invalid: !!Ye((b || t).errors, F),
    isDirty: !!Ye((b || t).dirtyFields, F),
    error: Ye((b || t).errors, F),
    isValidating: !!Ye(t.validatingFields, F),
    isTouched: !!Ye((b || t).touchedFields, F)
  }), Ue = (F) => {
    F && Uo(F).forEach((b) => kt(t.errors, b)), h.state.next({
      errors: F ? t.errors : {}
    });
  }, Me = (F, b, $) => {
    const Y = (Ye(i, F, { _f: {} })._f || {}).ref, X = Ye(t.errors, F) || {}, { ref: R, message: B, type: te, ...pe } = X;
    Gn(t.errors, F, {
      ...pe,
      ...b,
      ref: Y
    }), h.state.next({
      name: F,
      errors: t.errors,
      isValid: !1
    }), $ && $.shouldFocus && Y && Y.focus && Y.focus();
  }, De = (F, b) => Er(F) ? h.state.subscribe({
    next: ($) => F(G(void 0, b), $)
  }) : G(F, b, !0), Be = (F) => h.state.subscribe({
    next: (b) => {
      Lee(F.name, b.name, F.exact) && Aee(b, F.formState || d, Fe, F.reRenderRoot) && F.callback({
        values: { ...o },
        ...t,
        ...b
      });
    }
  }).unsubscribe, Ee = (F) => (s.mount = !0, f = {
    ...f,
    ...F.formState
  }, Be({
    ...F,
    formState: f
  })), Ve = (F, b = {}) => {
    for (const $ of F ? Uo(F) : l.mount)
      l.mount.delete($), l.array.delete($), b.keepValue || (kt(i, $), kt(o, $)), !b.keepError && kt(t.errors, $), !b.keepDirty && kt(t.dirtyFields, $), !b.keepTouched && kt(t.touchedFields, $), !b.keepIsValidating && kt(t.validatingFields, $), !n.shouldUnregister && !b.keepDefaultValue && kt(a, $);
    h.state.next({
      values: $t(o)
    }), h.state.next({
      ...t,
      ...b.keepDirty ? { isDirty: D() } : {}
    }), !b.keepIsValid && j();
  }, Re = ({ disabled: F, name: b }) => {
    (ar(F) && s.mount || F || l.disabled.has(b)) && (F ? l.disabled.add(b) : l.disabled.delete(b));
  }, tn = (F, b = {}) => {
    let $ = Ye(i, F);
    const Y = ar(b.disabled) || ar(n.disabled);
    return Gn(i, F, {
      ...$ || {},
      _f: {
        ...$ && $._f ? $._f : { ref: { name: F } },
        name: F,
        mount: !0,
        ...b
      }
    }), l.mount.add(F), $ ? Re({
      disabled: ar(b.disabled) ? b.disabled : n.disabled,
      name: F
    }) : T(F, !0, b.value), {
      ...Y ? { disabled: b.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!b.required,
        min: Fo(b.min),
        max: Fo(b.max),
        minLength: Fo(b.minLength),
        maxLength: Fo(b.maxLength),
        pattern: Fo(b.pattern)
      } : {},
      name: F,
      onChange: ve,
      onBlur: ve,
      ref: (X) => {
        if (X) {
          tn(F, b), $ = Ye(i, F);
          const R = it(X.value) && X.querySelectorAll && X.querySelectorAll("input,select,textarea")[0] || X, B = Eee(R), te = $._f.refs || [];
          if (B ? te.find((pe) => pe === R) : R === $._f.ref)
            return;
          Gn(i, F, {
            _f: {
              ...$._f,
              ...B ? {
                refs: [
                  ...te.filter(Ef),
                  R,
                  ...Array.isArray(Ye(a, F)) ? [{}] : []
                ],
                ref: { type: R.type, name: F }
              } : { ref: R }
            }
          }), T(F, !1, void 0, R);
        } else
          $ = Ye(i, F, {}), $._f && ($._f.mount = !1), (n.shouldUnregister || b.shouldUnregister) && !(fF(l.array, F) && s.action) && l.unMount.add(F);
      }
    };
  }, Ne = () => n.shouldFocusError && Bo(i, H, l.mount), We = (F) => {
    ar(F) && (h.state.next({ disabled: F }), Bo(i, (b, $) => {
      const Y = Ye(i, $);
      Y && (b.disabled = Y._f.disabled || F, Array.isArray(Y._f.refs) && Y._f.refs.forEach((X) => {
        X.disabled = Y._f.disabled || F;
      }));
    }, 0, !1));
  }, Oe = (F, b) => async ($) => {
    let Y;
    $ && ($.preventDefault && $.preventDefault(), $.persist && $.persist());
    let X = $t(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: R, values: B } = await Q();
      t.errors = R, X = B;
    } else
      await J(i);
    if (l.disabled.size)
      for (const R of l.disabled)
        Gn(X, R, void 0);
    if (kt(t.errors, "root"), Vt(t.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await F(X, $);
      } catch (R) {
        Y = R;
      }
    } else
      b && await b({ ...t.errors }, $), Ne(), setTimeout(Ne);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Vt(t.errors) && !Y,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), Y)
      throw Y;
  }, ue = (F, b = {}) => {
    Ye(i, F) && (it(b.defaultValue) ? ce(F, $t(Ye(a, F))) : (ce(F, b.defaultValue), Gn(a, F, $t(b.defaultValue))), b.keepTouched || kt(t.touchedFields, F), b.keepDirty || (kt(t.dirtyFields, F), t.isDirty = b.defaultValue ? D(F, $t(Ye(a, F))) : D()), b.keepError || (kt(t.errors, F), d.isValid && j()), h.state.next({ ...t }));
  }, fe = (F, b = {}) => {
    const $ = F ? $t(F) : a, Y = $t($), X = Vt(F), R = X ? a : Y;
    if (b.keepDefaultValues || (a = $), !b.keepValues) {
      if (b.keepDirtyValues) {
        const B = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Co(a, o))
        ]);
        for (const te of Array.from(B))
          Ye(t.dirtyFields, te) ? Gn(R, te, Ye(o, te)) : ce(te, Ye(R, te));
      } else {
        if (jy && it(F))
          for (const B of l.mount) {
            const te = Ye(i, B);
            if (te && te._f) {
              const pe = Array.isArray(te._f.refs) ? te._f.refs[0] : te._f.ref;
              if (cc(pe)) {
                const _e = pe.closest("form");
                if (_e) {
                  _e.reset();
                  break;
                }
              }
            }
          }
        for (const B of l.mount)
          ce(B, Ye(R, B));
      }
      o = $t(R), h.array.next({
        values: { ...R }
      }), h.state.next({
        values: { ...R }
      });
    }
    l = {
      mount: b.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !d.isValid || !!b.keepIsValid || !!b.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: b.keepSubmitCount ? t.submitCount : 0,
      isDirty: X ? !1 : b.keepDirty ? t.isDirty : !!(b.keepDefaultValues && !bi(F, a)),
      isSubmitted: b.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: X ? {} : b.keepDirtyValues ? b.keepDefaultValues && o ? Co(a, o) : t.dirtyFields : b.keepDefaultValues && F ? Co(a, F) : b.keepDirty ? t.dirtyFields : {},
      touchedFields: b.keepTouched ? t.touchedFields : {},
      errors: b.keepErrors ? t.errors : {},
      isSubmitSuccessful: b.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, we = (F, b) => fe(Er(F) ? F(o) : F, b), Le = (F, b = {}) => {
    const $ = Ye(i, F), Y = $ && $._f;
    if (Y) {
      const X = Y.refs ? Y.refs[0] : Y.ref;
      X.focus && (X.focus(), b.shouldSelect && Er(X.select) && X.select());
    }
  }, Fe = (F) => {
    t = {
      ...t,
      ...F
    };
  }, ln = {
    control: {
      register: tn,
      unregister: Ve,
      getFieldState: W,
      handleSubmit: Oe,
      setError: Me,
      _subscribe: Be,
      _runSchema: Q,
      _getWatch: G,
      _getDirty: D,
      _setValid: j,
      _setFieldArray: q,
      _setDisabledField: Re,
      _setErrors: C,
      _getFieldArray: ne,
      _reset: fe,
      _resetDefaultValues: () => Er(n.defaultValues) && n.defaultValues().then((F) => {
        we(F, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: K,
      _disableForm: We,
      _subjects: h,
      _proxyFormState: d,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(F) {
        s = F;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(F) {
        l = F;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return n;
      },
      set _options(F) {
        n = {
          ...n,
          ...F
        };
      }
    },
    subscribe: Ee,
    trigger: be,
    register: tn,
    handleSubmit: Oe,
    watch: De,
    setValue: ce,
    getValues: je,
    reset: we,
    resetField: ue,
    clearErrors: Ue,
    unregister: Ve,
    setError: Me,
    setFocus: Le,
    getFieldState: W
  };
  return {
    ...ln,
    formControl: ln
  };
}
function qee(e = {}) {
  const n = xe.useRef(void 0), t = xe.useRef(void 0), [i, a] = xe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Er(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Er(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : Bee(e),
    formState: i
  }, e.formControl && e.defaultValues && !Er(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, xe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), xe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), xe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), xe.useEffect(() => {
    e.values && !bi(e.values, t.current) ? (o._reset(e.values, o._options.resetOptions), t.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), xe.useEffect(() => {
    e.errors && !Vt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), xe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), xe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = vF(i, o), n.current;
}
const Hee = "_settingsWrapper_1ycvy_1", Wee = "_settingsWrapperHeader_1ycvy_6", Kee = "_settingsWrapperContent_1ycvy_10", Gee = "_settingsWrapperContentCode_1ycvy_18", Yee = "_settingsWrapperContentCURL_1ycvy_26", Io = {
  settingsWrapper: Hee,
  settingsWrapperHeader: Wee,
  settingsWrapperContent: Kee,
  settingsWrapperContentCode: Gee,
  settingsWrapperContentCURL: Yee
}, Jee = ({
  handleChangeText: e
}) => {
  const [n, t] = oe(!1), { isCopied: i, copy: a } = si(), { control: o } = qee({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = gF({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", u = ft(() => {
    const m = s.storeId, d = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${d ? ` \\
  --data '{"secret":"${d}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ le.jsx(le.Fragment, { children: /* @__PURE__ */ le.jsx(en, { span: 6, children: /* @__PURE__ */ le.jsxs(_, { flexDirection: "column", className: Io.settingsWrapper, children: [
    /* @__PURE__ */ le.jsxs(
      _,
      {
        gap: "200",
        alignItems: "center",
        className: Io.settingsWrapperHeader,
        onClick: () => t(!n),
        children: [
          /* @__PURE__ */ le.jsx(A.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ le.jsx(he, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ le.jsxs(
      _,
      {
        flexDirection: "column",
        className: Io.settingsWrapperContent,
        children: [
          /* @__PURE__ */ le.jsx(_, { margin: "0 0 400", children: /* @__PURE__ */ le.jsx(
            hc,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ le.jsxs("ol", { children: [
                /* @__PURE__ */ le.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ le.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ le.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ le.jsx("span", { className: Io.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ le.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ le.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ le.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ le.jsx(
            bN,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ le.jsx(
                fr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (d) => {
                      m.onChange(d), e({
                        target: {
                          name: "yotpoStoreId",
                          value: d?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ le.jsx(
            bN,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ le.jsx(
                fr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ le.jsxs(le.Fragment, { children: [
            /* @__PURE__ */ le.jsx(Dn, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ le.jsx(
              _,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: Io.settingsWrapperContentCURL,
                children: u()
              }
            ) }),
            /* @__PURE__ */ le.jsx(_, { alignContent: "start", children: /* @__PURE__ */ le.jsx(
              Je,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ le.jsx(
                  qn,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(u()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, Qee = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: Jee
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showChannels",
    label: "Show email and sms channels",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], jF = () => ({
  SHOPIFY: {
    widget: sX,
    icon: "shopify",
    iconColors: {
      contentColor: "rgb(148, 190, 69)",
      backgroundColor: "rgba(148, 190, 69, 0.1)"
    },
    settingsConfiguration: [
      {
        key: "apiAccessToken",
        label: "API Access Token",
        placeholder: "API access token from Shopify",
        required: !0,
        secret: !0,
        type: "input"
      },
      {
        key: "apiHostName",
        label: "API host name",
        placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
        required: !0,
        secret: !1,
        type: "input",
        prefix: "https://",
        customValidation: (n) => PN(n)
      },
      ...E0 ? [...E0] : []
    ]
  },
  JIRA: {
    widget: F5,
    icon: "jira",
    iconColors: {
      contentColor: "rgb(38, 132, 255)",
      backgroundColor: "rgba(38, 132, 255, 0.075)"
    },
    settingsConfiguration: [
      ...Eb ? [...Eb] : []
    ]
  },
  GITHUB: {
    widget: oB,
    icon: "github",
    iconColors: {
      contentColor: "rgb(87, 96, 106)",
      backgroundColor: "rgba(221, 244, 255, 0.75)"
    },
    settingsConfiguration: [...sB]
  },
  MIUROS: {
    widget: DG,
    icon: "miuros",
    iconColors: {
      contentColor: "rgb(246, 135, 179)",
      backgroundColor: "rgba(246, 135, 179, 0.15)"
    },
    settingsConfiguration: [...PG]
  },
  KLAVIYO: {
    widget: Uq,
    icon: "klaviyo",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [...Bq]
  },
  LINEAR: {
    widget: f7,
    icon: "linear",
    iconColors: {
      contentColor: "rgb(94, 106, 210)",
      backgroundColor: "rgba(94, 106, 210, 0.15)"
    },
    settingsConfiguration: [...h7]
  },
  VOYADO: {
    widget: iee,
    icon: "voyado",
    iconColors: {
      contentColor: "rgb(0, 0, 0)",
      backgroundColor: "rgba(0, 0, 0, 0.075)"
    },
    settingsConfiguration: [...aee]
  },
  LOYALTYLION: {
    widget: W7,
    icon: "loyaltylion",
    iconColors: {
      contentColor: "rgb(36, 31, 79)",
      backgroundColor: "rgba(36, 31, 79, 0.075)"
    },
    settingsConfiguration: [...K7]
  },
  RECHARGE: {
    widget: s8,
    icon: "recharge",
    iconColors: {
      contentColor: "rgb(57, 1, 241)",
      backgroundColor: "rgba(57, 1, 241, 0.075)"
    },
    settingsConfiguration: [...l8]
  },
  BRAZE: {
    widget: yU,
    icon: "braze",
    iconColors: {
      contentColor: "rgb(48, 2, 102)",
      backgroundColor: "rgba(48, 2, 102, 0.075)"
    },
    settingsConfiguration: [...gU]
  },
  YOTPO: {
    widget: Nee,
    icon: "yotpo",
    iconColors: {
      contentColor: "rgb(0, 66, 228)",
      backgroundColor: "rgba(0, 66, 228, 0.075)"
    },
    settingsConfiguration: [...Qee]
  }
}), Xee = (e) => {
  switch (e) {
    case "input":
    case "hidden":
      return "";
    case "switch":
      return !1;
    default:
      return;
  }
}, Zee = (e, n) => {
  switch (n) {
    case "input":
    case "hidden":
    case "select":
      return e;
    case "switch":
      return e === "true" ? !0 : e === "false" ? !1 : void 0;
    default:
      return;
  }
}, wF = ({
  key: e,
  configuration: n,
  settingType: t,
  settingDefault: i
}) => {
  const a = n?.find(
    (l) => l.key === e
  ), o = Zee(a?.value, t), s = i !== void 0 ? i : Xee(
    t
  );
  return o !== void 0 ? o : s;
}, ene = (e) => {
  const n = jF();
  return e.map(
    ({ id: t, type: i, name: a, settings: o, misconfigured: s }) => {
      const u = n[i], { settingsConfiguration: m } = u, d = m?.filter(({ secret: f }) => !f)?.map(
        ({
          key: f,
          type: h,
          defaultValue: v
        }) => ({
          key: f,
          value: wF({
            key: f,
            configuration: o,
            settingType: h,
            settingDefault: v
          })
        })
      );
      return {
        id: t,
        type: i,
        name: a,
        settings: d,
        misconfigured: s,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget
      };
    }
  );
}, Jne = ({
  configuration: e,
  conversationContext: n,
  showNotification: t,
  onToggleFn: i,
  isOpenFn: a,
  isMinimized: o
}) => {
  const { track: s } = hn(), { isLoading: l, widgets: u } = BM(
    e.baseUrl
  ), [m, d] = oe([]);
  qe(() => {
    if (u?.length && !l) {
      const y = u.filter((q) => e.featureFlags[q.type]).filter((q) => q.enabled);
      d(
        // Mapping the widget from the backend (`widgets`) to our
        // `widgetDefinitions` configuration
        ene(y)
      );
    }
  }, [l]);
  const f = {
    headline: "",
    text: "",
    onConfirm: () => j(),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [h, v] = oe(f), [x, S] = oe(!1), N = (y) => {
    S(!0), v(y);
  }, j = () => {
    S(!1), v(f);
  };
  return /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    m.sort((y, q) => y.name.localeCompare(q.name)).map(
      ({
        id: y,
        name: q,
        type: E,
        widget: C,
        settings: T,
        misconfigured: U,
        icon: Z,
        iconColors: Q
      }) => {
        const ee = `partner-integration-${y}`, J = `partner-integration-${E}`, K = /* @__PURE__ */ ze.jsx(zh, { icon: Z, color: Q }), D = T?.reduce(
          (G, ne) => (G[ne.key] = ne.value, G),
          {}
        );
        return o ? /* @__PURE__ */ ze.jsx("div", { className: "icon-holder", children: K }, `partner-icon-${y}`) : /* @__PURE__ */ ze.jsxs(
          pr,
          {
            onToggle: () => {
              s(
                a(ee) ? "widget:collapse:closed" : "widget:collapse:opened",
                {
                  widgetId: y,
                  widgetType: E.toLowerCase()
                }
              ), i(ee);
            },
            isOpen: a(ee),
            className: J,
            children: [
              /* @__PURE__ */ ze.jsx(pr.Header, { avatar: K, children: q }),
              /* @__PURE__ */ ze.jsx(pr.Content, { children: U ? /* @__PURE__ */ ze.jsx(_n, { isMisconfigured: !0 }) : /* @__PURE__ */ ze.jsx(
                VN.Provider,
                {
                  value: {
                    onError: (G, ne) => console.warn(
                      `Something went wrong with a partner widget of type '${E}' and id '${y}'`,
                      G,
                      ne
                    )
                  },
                  children: /* @__PURE__ */ ze.jsx(
                    cC,
                    {
                      integrationId: y,
                      type: E,
                      configuration: e,
                      showNotification: t,
                      showModal: N,
                      children: qF(C, {
                        conversationContext: n,
                        settings: D
                      })
                    }
                  )
                }
              ) })
            ]
          },
          ee
        );
      }
    ),
    /* @__PURE__ */ ze.jsx(
      uC,
      {
        isOpen: x,
        setIsOpen: S,
        headline: h.headline,
        text: h.text,
        confirmLabel: h.confirmLabel,
        confirmVariant: h.confirmVariant,
        cancelLabel: h.cancelLabel,
        cancelVariant: h.cancelVariant,
        onConfirm: h.onConfirm ? () => {
          try {
            h.onConfirm && h.onConfirm();
          } finally {
            S(!1), v(f);
          }
        } : void 0,
        onCancel: h.onCancel ? () => {
          try {
            h.onCancel && h.onCancel();
          } finally {
            S(!1), v(f);
          }
        } : void 0,
        children: h.children
      }
    )
  ] });
}, nne = "FULL_ACCESS", tne = "2", rne = ({
  type: e,
  baseUrl: n
}) => {
  const t = `${e}-partner-widget-${Date.now().toString()}`, i = n.replace("partner-integrations", "api"), a = () => {
    let l;
    try {
      l = JSON.parse(localStorage.authData);
    } catch {
    }
    return l?.access_token || "";
  };
  return {
    deleteDixaApiToken: (l) => fetch(`${i}/v1/auth/api-tokens/${l}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      }
    }).then((u) => u.json()),
    createDixaApiToken: () => fetch(`${i}/v1/auth/api-tokens-v2`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Basic ${window.btoa(`token:${a()}`)}`
      },
      body: JSON.stringify({
        name: t,
        scopes: [nne],
        version: tne
      })
    }).then((l) => l.json())
  };
}, ine = "dixaApiToken", $y = "dixaApiTokenId", CF = "dixaApiTokenName", TN = (e) => [$y, CF].every(
  (t) => e.find((i) => i?.key === t)
);
function ane({
  token: e,
  settings: n
}) {
  if (n.length === 0)
    return [];
  const t = one(e), i = (o, s) => o?.find((l) => l?.key === s);
  return n.map((o) => {
    const s = o && i(t, o.key);
    return i(n, o?.key) && s ? s : o;
  });
}
const one = (e) => [
  {
    key: ine,
    value: e.value,
    secret: !0
  },
  {
    key: $y,
    value: e.id,
    secret: !1
  },
  {
    key: CF,
    value: e.name,
    secret: !1
  }
], sne = Si`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        settings {
          key
          value
        }
      }
    }
  }
`, lne = Si`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        settings {
          key
          value
        }
      }
    }
  }
`, cne = Si`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        settings {
          key
          value
        }
      }
    }
  }
`, une = Si`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, dne = "_wrapper_1lmim_1", mne = "_wrapperBox_1lmim_4", pne = "_wrapperBoxErrorBorder_1lmim_9", Tf = {
  wrapper: dne,
  wrapperBox: mne,
  wrapperBoxErrorBorder: pne
}, fne = ({
  required: e,
  readOnly: n,
  isSecret: t,
  isCreationMode: i,
  label: a,
  settings: o,
  widgetSettingsKey: s,
  meta: l,
  handleEditSecret: u,
  handleChangeText: m
}) => {
  const f = o?.find(
    (q) => q.type === "basicAuthInput"
  )?.additionalProperties, { username: h, password: v } = f, x = `Insert your ${h.label.toLowerCase()}`, S = `Insert your ${v.label.toLowerCase()}`, [N, j] = oe({
    username: "",
    password: ""
  }), y = ft(
    (q) => {
      m({
        target: {
          name: s,
          value: q
        }
      });
    },
    [s, m]
  );
  return qe(() => {
    y(
      N.username !== "" && N.password !== "" ? window.btoa(`${N.username}:${N.password}`) : ""
    );
  }, [N]), /* @__PURE__ */ ze.jsx(
    Dn,
    {
      required: e,
      label: a,
      meta: l,
      className: Tf.wrapper,
      children: /* @__PURE__ */ ze.jsxs(
        _,
        {
          gap: "300",
          flexDirection: "column",
          className: ht(Tf.wrapperBox, {
            [Tf.wrapperBoxErrorBorder]: !!l?.error
          }),
          children: [
            /* @__PURE__ */ ze.jsx(
              fr,
              {
                noAlert: !0,
                required: e,
                label: h.label,
                readOnly: n,
                placeholder: x,
                input: {
                  name: s,
                  value: N.username,
                  onChange: (q) => j({
                    username: q?.target.value ?? "",
                    password: N.password
                  })
                },
                ...t && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            ),
            /* @__PURE__ */ ze.jsx(
              fr,
              {
                noAlert: !0,
                required: e,
                label: v.label,
                readOnly: n,
                placeholder: S,
                input: {
                  name: s,
                  value: N.password,
                  onChange: (q) => j({
                    username: N.username,
                    password: q?.target.value ?? ""
                  })
                },
                ...t && !i && {
                  prefix: {
                    type: "button",
                    button: {
                      icon: "close",
                      onClick: () => u(!1, s)
                    }
                  }
                }
              }
            )
          ]
        }
      )
    }
  );
};
function hne({
  isSecret: e,
  widgetSettingsKey: n,
  label: t,
  required: i,
  readOnly: a,
  placeholder: o,
  handleChangeText: s,
  handleChangeBoolean: l,
  handleChangeSelect: u,
  handleEditSecret: m,
  getValueByKey: d,
  isEditingField: f,
  errors: h,
  type: v,
  isCreationMode: x,
  prefix: S,
  integrationId: N,
  integrationType: j,
  configuration: y,
  settings: q,
  otherProps: E
}) {
  const C = v === "custom" && E?.component, T = d(n)?.value;
  return C ? /* @__PURE__ */ ze.jsx(
    C,
    {
      configuration: y,
      integrationId: N,
      integrationType: j,
      label: t,
      settings: q,
      getValueByKey: d,
      widgetSettingsKey: n,
      handleChangeSelect: u,
      handleChangeText: s,
      handleChangeBoolean: l
    }
  ) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
    /* @__PURE__ */ ze.jsx(en, { span: 3, children: /* @__PURE__ */ ze.jsx(
      vne,
      {
        widgetSettingsKey: n,
        label: t,
        isEditingField: f,
        handleEditSecret: m,
        isCreationMode: x,
        children: v === "input" ? /* @__PURE__ */ ze.jsx(
          fr,
          {
            required: i,
            readOnly: a,
            label: t,
            placeholder: o,
            input: {
              name: n,
              value: T,
              onChange: s
            },
            meta: { error: h[n] },
            prefix: S,
            ...e && !x && {
              prefix: {
                type: "button",
                button: {
                  icon: "close",
                  onClick: () => m(!1, n)
                }
              }
            }
          }
        ) : v === "basicAuthInput" ? /* @__PURE__ */ ze.jsx(
          fne,
          {
            required: i,
            readOnly: a,
            isSecret: e,
            isCreationMode: x,
            label: t,
            widgetSettingsKey: n,
            settings: q,
            meta: { error: h[n] },
            handleEditSecret: m,
            handleChangeText: s
          }
        ) : v === "switch" ? /* @__PURE__ */ ze.jsx(Dn, { label: t, children: /* @__PURE__ */ ze.jsx(
          zN,
          {
            input: {
              name: n,
              value: "",
              checked: T,
              onChange: l
            }
          }
        ) }) : v === "select" ? /* @__PURE__ */ ze.jsx(Dn, { label: t, children: /* @__PURE__ */ ze.jsx(
          yi,
          {
            required: i,
            clearable: !0,
            placeholder: o,
            readOnly: a,
            onChange: (U) => u(n, U),
            getItemTitleByValue: (U) => U ? /* @__PURE__ */ ze.jsx(A.Paragraph, { children: U.label }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {}),
            value: T ? [
              {
                label: (E?.selectItems || []).find(
                  (U) => U.value === T
                )?.label,
                value: T
              }
            ] : [],
            equalityFn: (U, Z) => U.value === Z.value,
            children: (E?.selectItems || []).map((U) => /* @__PURE__ */ ze.jsx(pt.Item, { value: U, children: U.label }, U.value))
          }
        ) }) : /* @__PURE__ */ ze.jsx(ze.Fragment, {})
      }
    ) }),
    /* @__PURE__ */ ze.jsx(en, { span: 3 })
  ] });
}
function vne({
  widgetSettingsKey: e,
  label: n,
  isEditingField: t,
  handleEditSecret: i,
  children: a,
  isCreationMode: o
}) {
  return t || o ? a : /* @__PURE__ */ ze.jsx(Dn, { label: n, children: /* @__PURE__ */ ze.jsxs(
    qn,
    {
      "data-testid": `secret-field-button-${e}`,
      variant: "secondary",
      icon: "pen",
      onClick: () => i(!0, e),
      children: [
        "Update ",
        n
      ]
    }
  ) });
}
const qo = "partner-integrations-widget-name-form-field", ON = ({
  settingsFromBackend: e,
  settingsConfiguration: n,
  creating: t = !1
}) => n.filter(({ type: i }) => i !== "custom").map(
  ({
    key: i,
    required: a,
    secret: o,
    type: s,
    defaultValue: l,
    customValidation: u
  }) => ({
    key: i,
    value: wF({
      key: i,
      configuration: e,
      settingType: s,
      settingDefault: l
    }),
    required: a,
    secret: o,
    // The property `isEditing` is used in order to show/hide the input field in
    // case it is a secret setting. However, when we create a widget we _always_
    // want to show the input field because it will be the first time that the user
    // enters a value for it.
    //
    // We have two scenarios here:
    // 1) When initializing
    //   - the setting is secret=true so we set isEditing=false and hide the input.
    //   - the setting is secret=false, so we set isEditing=true and show the input.
    // 2) We create a widget (creating=true), so we set isEditing=true in
    //    order to show the input.
    isEditing: t ? !0 : !o,
    type: s,
    ...u && { customValidation: u }
  })
), yne = ({
  initialValues: e,
  onSubmit: n
}) => {
  const [t, i] = oe(
    e || {
      enabled: !1,
      name: "",
      settings: []
    }
  ), [a, o] = oe({}), s = (E) => i(E), l = (E) => !E || E === "", u = (E) => {
    const { [E]: C, ...T } = a;
    o(T);
  }, m = (E) => ({
    ...E,
    settings: E.settings.filter(({ isEditing: C }) => C).map(({ key: C, value: T, secret: U }) => ({
      key: C,
      value: T,
      secret: U
    }))
  }), d = {
    input: "This can not be empty",
    basicAuthInput: "Please insert a value for both fields"
  }, f = (E) => {
    if (!E)
      return;
    const {
      target: { name: C, value: T }
    } = E;
    a[C] && !l(T) && u(C), i({
      ...t,
      settings: t.settings.map(
        (U) => U.key === C ? { ...U, value: T } : U
      )
    });
  }, h = (E) => {
    if (!E)
      return;
    const {
      target: { name: C, checked: T }
    } = E;
    i({
      ...t,
      settings: t.settings.map(
        (U) => U.key === C ? { ...U, value: T } : U
      )
    });
  }, v = (E, C) => {
    if (!C)
      return;
    const { selectedValues: T } = C, U = T?.[0];
    if (U) {
      const Z = t.settings.map(
        (Q) => Q.key === E ? { ...Q, value: U?.value } : Q
      );
      i({
        ...t,
        settings: Z
      });
    } else {
      const Z = t.settings.filter(
        (Q) => Q.key !== E
      );
      i({
        ...t,
        settings: Z
      });
    }
  }, x = (E) => {
    i({
      ...t,
      enabled: E
    });
  }, S = (E) => {
    if (!E)
      return;
    const {
      target: { value: C }
    } = E;
    a[qo] && !l(C) && u(qo), i({
      ...t,
      name: C
    });
  }, N = (E, C) => {
    const { settings: T } = t, U = T.map((Z) => Z.key === C ? {
      ...Z,
      isEditing: E,
      ...!E && { value: "" }
    } : Z);
    a[C] && !E && u(C), i({
      ...t,
      settings: U
    });
  }, j = (E) => t.settings.find(
    (C) => C.key === E
  ), y = async (E) => {
    E.preventDefault(), q() && n(m(t));
  }, q = () => {
    const E = {}, { name: C, settings: T } = t;
    return l(C) && (E[qo] = d.input), T.forEach(
      ({ key: U, value: Z, required: Q, isEditing: ee, type: J, customValidation: K }) => {
        if (Q && ee)
          if (K) {
            const D = K(Z);
            typeof D == "string" && (E[U] = D);
          } else
            typeof Z == "string" && l(Z) && (E[U] = d[J]);
      }
    ), o(E), !Object.keys(E)?.length;
  };
  return {
    formData: t,
    errors: a,
    handleIsEnabled: x,
    handleChangeText: f,
    handleChangeBoolean: h,
    handleChangeSelect: v,
    handleEditSecret: N,
    handleChangeName: S,
    handleSubmit: y,
    getSettingValueByKey: j,
    initializeFormData: s,
    validate: q
  };
}, gne = [
  "GITHUB",
  "JIRA",
  "LINEAR"
], RN = "The configuration of the integration is not correct. Please check the settings.", kne = ({
  integrationId: e,
  type: n,
  handleRedirect: t,
  showNotification: i,
  configuration: a,
  additionalParameters: o,
  automationCouplingState: s
}) => {
  const { track: l } = hn(), { deleteDixaApiToken: u, createDixaApiToken: m } = rne({
    type: n,
    baseUrl: a.baseUrl
  }), f = lI().pathname.match(
    /^\/settings\/integrations\/partner-widget\/[a-zA-Z0-9]*\/create$/
  ), h = !e && !!n && !!f, v = gne.includes(n), [x, S] = oe(), [N, j] = oe(!1), [y, q] = oe(!1), [E, C] = oe(!1), [T, U] = oe(null), ee = jF()[n].settingsConfiguration, J = ee.filter(({ type: Oe }) => Oe !== "hidden").filter(({ hideOnCreate: Oe }) => h ? !Oe : !0), K = n === "SHOPIFY", D = K && Object.keys(o?.shopify ?? {}).length > 0, G = K && D ? o?.shopify?.["partner-integrations-widget-name-form-field"] : null, {
    error: ne,
    loading: de,
    data: ge,
    refetch: ce
  } = aI(sne, {
    variables: {
      id: e
    },
    // skip wants either `true` to literally skip the query,
    // or `undefined` to run the query. A simple `false` will
    // still run the query, therefore checking here for the
    // negated `integrationId` instead.
    skip: !e,
    onCompleted: (Oe) => {
      Object.keys(Oe).length === 0 ? C(!0) : C(!1);
    }
  }), [ve, { error: H }] = Oy(
    h ? cne : lne,
    {
      onError: (Oe) => {
        S(Oe), j(!1), i({
          title: "Something went wrong",
          text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: (Oe) => {
        if (j(!1), Object.keys(Oe).length !== 0) {
          if (h && t(Oe?.Management?.createWidgetConfiguration?.id), !h) {
            const ue = Oe?.Management?.updateWidgetConfiguration;
            ue.misconfigured ? U(
              ue?.misconfigurationCause ?? RN
            ) : U(null);
          }
          i({
            title: `${h ? "Creating" : "Updating"} was successful`,
            text: `${h ? "Creating" : "Updating"} the widget was successful.`,
            icon: "check-circle-filled",
            severity: "success"
          });
        } else
          i({
            title: "Something went wrong",
            text: `The ${h ? "creation" : "update"} of the widget was not successful.`,
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
      }
    }
  ), [be] = Oy(une, {
    onError: (Oe) => {
      S(Oe), j(!1), i({
        title: "Something went wrong",
        text: "The deletion of the widget was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: () => {
      j(!1), t(), i({
        title: "Deletion was successful",
        text: "The deletion of the widget was successful.",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), {
    formData: je,
    handleIsEnabled: W,
    errors: Ue,
    handleChangeText: Me,
    handleChangeBoolean: De,
    handleChangeSelect: Be,
    handleEditSecret: Ee,
    handleChangeName: Ve,
    handleSubmit: Re,
    getSettingValueByKey: tn,
    initializeFormData: Ne
  } = yne({
    onSubmit: async (Oe) => {
      h ? l("settings:create:submitted", { widgetType: n }) : e && l("settings:view:change:submitted", {
        widgetId: e,
        widgetType: n
      }), j(!0);
      const ue = Oe.settings.map(
        (Fe) => typeof Fe.value == "boolean" ? { ...Fe, value: Fe.value.toString() } : Fe
      ), fe = TN(ue) && h;
      let we = [];
      if (fe) {
        const Fe = await m().catch(
          (ln) => {
            j(!1), console.warn("API-Token (creation) error resonse", ln), i({
              title: "Something went wrong",
              text: "The creation of the API-Token was not successful and therefore the widget creation was aborted. Please try again later.",
              icon: "exclamation-triangle-filled",
              severity: "warning"
            });
          }
        );
        Fe?.data && (we = ane({
          token: Fe.data,
          settings: ue
        }));
      }
      const Le = {
        ...Oe,
        settings: [
          ...we.length > 0 ? we : ue
        ]
      };
      (fe && we.length > 1 || !fe && we.length === 0) && (ve({
        variables: {
          ...!h && { id: e },
          ...h && { type: n },
          ...Le
        }
      }), ue.forEach(
        (Fe) => Fe.secret && Ee(!1, Fe.key)
      ));
    },
    ...h && {
      initialValues: {
        enabled: !1,
        name: G ?? "",
        settings: ON({
          settingsFromBackend: [
            ...K && D ? [
              {
                key: "apiHostName",
                value: o?.shopify?.apiHostName
              }
            ] : []
          ],
          settingsConfiguration: ee,
          creating: !0
        })
      }
    }
  });
  qe(() => {
    const Oe = ge?.Management?.widgetConfigurations[0];
    if (Oe) {
      const ue = ON({
        settingsFromBackend: Oe.settings,
        settingsConfiguration: ee
      });
      Ne({
        enabled: !!Oe.enabled,
        name: Oe.name,
        settings: ue
      }), Oe.misconfigured ? U(
        Oe?.misconfigurationCause ?? RN
      ) : U(null);
    }
  }, [ge]);
  const We = Zn(() => s ? !s.isCoupled : !0, [s]);
  return ne || H || x ? /* @__PURE__ */ ze.jsx(
    _n,
    {
      error: ne || x,
      retry: ne ? ce : void 0
    }
  ) : N || de ? /* @__PURE__ */ ze.jsx(cn, { "data-testid": "widget-settings-loading" }) : E ? /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
    "A widget with the id ",
    /* @__PURE__ */ ze.jsx(En, { children: e }),
    " does not exist."
  ] }) : /* @__PURE__ */ ze.jsxs("form", { children: [
    T && /* @__PURE__ */ ze.jsx(_, { margin: "0 0 400", children: /* @__PURE__ */ ze.jsx(
      hc,
      {
        variant: "fail",
        headline: "This integration is misconfigured",
        description: /* @__PURE__ */ ze.jsxs(_, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ ze.jsx(A.Paragraph, { children: T }),
          /* @__PURE__ */ ze.jsxs(_, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ ze.jsx(A.Heading, { variant: "heading-3", children: "Additional information" }),
            /* @__PURE__ */ ze.jsx(A.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })
          ] })
        ] })
      }
    ) }),
    /* @__PURE__ */ ze.jsxs(
      Kt,
      {
        "data-testid": `widget-settings-form-${e ?? "create-new"}`,
        children: [
          /* @__PURE__ */ ze.jsx(en, { children: /* @__PURE__ */ ze.jsx(Dn, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ze.jsx(
            zN,
            {
              input: {
                name: "enabled",
                checked: je.enabled,
                value: "dummy",
                onChange: (Oe) => W(Oe.target.checked)
              }
            }
          ) }) }),
          /* @__PURE__ */ ze.jsx(en, { span: 3, children: /* @__PURE__ */ ze.jsx(
            fr,
            {
              required: !0,
              label: "Widget name",
              placeholder: "Insert the name of the widget",
              input: {
                name: qo,
                value: je.name,
                onChange: Ve
              },
              meta: {
                error: Ue[qo]
              }
            }
          ) }),
          /* @__PURE__ */ ze.jsx(en, { span: 3 }),
          J?.map(
            ({
              key: Oe,
              secret: ue,
              label: fe,
              placeholder: we = "",
              required: Le = !1,
              type: Fe,
              prefix: ln,
              readOnly: F,
              ...b
            }) => {
              const { settings: $ } = je, Y = $.find(
                (X) => X.key === Oe
              );
              return /* @__PURE__ */ ze.jsx(HF, { children: /* @__PURE__ */ ze.jsx(
                hne,
                {
                  widgetSettingsKey: Oe,
                  isEditingField: !!Y?.isEditing,
                  handleEditSecret: Ee,
                  handleChangeText: Me,
                  handleChangeBoolean: De,
                  handleChangeSelect: Be,
                  getValueByKey: tn,
                  isSecret: ue,
                  label: fe,
                  placeholder: we,
                  required: Le,
                  errors: Ue,
                  type: Fe,
                  isCreationMode: h,
                  prefix: ln,
                  integrationId: e,
                  integrationType: n,
                  configuration: a,
                  readOnly: F,
                  settings: ee,
                  otherProps: b
                }
              ) }, Oe);
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ze.jsxs(_, { margin: "300 0 0 0", children: [
      /* @__PURE__ */ ze.jsx(qn, { onClick: Re, children: "Submit" }),
      !h && /* @__PURE__ */ ze.jsx(
        Je,
        {
          content: "The widget is used in automations",
          disabled: We,
          children: /* @__PURE__ */ ze.jsx(
            qn,
            {
              style: { marginLeft: 20 },
              icon: "trash",
              variant: "secondary",
              onClick: () => {
                e && l("settings:view:delete:requested", {
                  widgetId: e,
                  widgetType: n
                }), q(!0);
              },
              disabled: !We,
              isLoading: s?.isLoading,
              children: "Delete"
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ ze.jsx(
      uC,
      {
        isOpen: y,
        setIsOpen: q,
        confirmVariant: v ? "danger" : "primary",
        confirmLabel: "Yes",
        cancelLabel: "No",
        onCancel: () => {
          e && l("settings:view:delete:canceled", {
            widgetId: e,
            widgetType: n
          });
        },
        onConfirm: () => {
          if (e && l("settings:view:delete:confirmed", {
            widgetId: e,
            widgetType: n
          }), TN(je.settings)) {
            const Oe = je.settings.find(
              ({ key: ue }) => ue === $y
            )?.value;
            Oe && u(Oe).catch((ue) => {
              console.warn("API-Token (deletion) error response", ue), i({
                title: "Something went wrong",
                text: "The deletion of the API-Token was not successful. Please have a look in Settings > Integrations > Api-Tokens to find your token and remove it manually.",
                icon: "exclamation-triangle-filled",
                severity: "warning"
              });
            });
          }
          be({
            variables: {
              id: e
            }
          });
        },
        children: /* @__PURE__ */ ze.jsx(_, { children: v ? /* @__PURE__ */ ze.jsxs(_, { gap: "400", children: [
          /* @__PURE__ */ ze.jsx(
            he,
            {
              size: 24,
              name: "exclamation-triangle-filled",
              color: "red.500"
            }
          ),
          /* @__PURE__ */ ze.jsxs(_, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ ze.jsxs(A.Heading, { withMarginBottom: !0, children: [
              "By deleting the ",
              n,
              " integration, all links between Dixa and ",
              n,
              " are also deleted."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "All data in ",
              n,
              " stays untouched."
            ] }),
            /* @__PURE__ */ ze.jsxs(A.Paragraph, { children: [
              "Are you sure you want to delete the ",
              n,
              " ",
              'integration "',
              je.name,
              '"?'
            ] })
          ] })
        ] }) : /* @__PURE__ */ ze.jsxs(ze.Fragment, { children: [
          "Are you sure you want to delete the ",
          n,
          ' integration "',
          je.name,
          '"?'
        ] }) })
      }
    )
  ] });
}, Qne = ({
  configuration: e,
  additionalParameters: n,
  integrationId: t,
  type: i,
  handleRedirect: a,
  showNotification: o,
  automationCouplingState: s
}) => /* @__PURE__ */ ze.jsx(
  VN.Provider,
  {
    value: {
      onError: (l, u) => console.warn(
        `Something went wrong with the partner widget settings of type ${i} and id ${t}`,
        l,
        u
      )
    },
    children: /* @__PURE__ */ ze.jsx(
      cC,
      {
        integrationId: t,
        type: i,
        configuration: e,
        showNotification: o,
        children: /* @__PURE__ */ ze.jsx(
          kne,
          {
            configuration: e,
            additionalParameters: n,
            integrationId: t,
            type: i,
            handleRedirect: a,
            showNotification: o,
            automationCouplingState: s
          }
        )
      }
    )
  }
);
var kl = { exports: {} }, DN;
function bne() {
  if (DN) return kl.exports;
  DN = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(C, T, U) {
    return Function.prototype.apply.call(C, T, U);
  }, t;
  e && typeof e.ownKeys == "function" ? t = e.ownKeys : Object.getOwnPropertySymbols ? t = function(C) {
    return Object.getOwnPropertyNames(C).concat(Object.getOwnPropertySymbols(C));
  } : t = function(C) {
    return Object.getOwnPropertyNames(C);
  };
  function i(E) {
    console && console.warn && console.warn(E);
  }
  var a = Number.isNaN || function(C) {
    return C !== C;
  };
  function o() {
    o.init.call(this);
  }
  kl.exports = o, kl.exports.once = j, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(E) {
    if (typeof E != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof E);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(E) {
      if (typeof E != "number" || E < 0 || a(E))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + E + ".");
      s = E;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(C) {
    if (typeof C != "number" || C < 0 || a(C))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + C + ".");
    return this._maxListeners = C, this;
  };
  function u(E) {
    return E._maxListeners === void 0 ? o.defaultMaxListeners : E._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return u(this);
  }, o.prototype.emit = function(C) {
    for (var T = [], U = 1; U < arguments.length; U++) T.push(arguments[U]);
    var Z = C === "error", Q = this._events;
    if (Q !== void 0)
      Z = Z && Q.error === void 0;
    else if (!Z)
      return !1;
    if (Z) {
      var ee;
      if (T.length > 0 && (ee = T[0]), ee instanceof Error)
        throw ee;
      var J = new Error("Unhandled error." + (ee ? " (" + ee.message + ")" : ""));
      throw J.context = ee, J;
    }
    var K = Q[C];
    if (K === void 0)
      return !1;
    if (typeof K == "function")
      n(K, this, T);
    else
      for (var D = K.length, G = x(K, D), U = 0; U < D; ++U)
        n(G[U], this, T);
    return !0;
  };
  function m(E, C, T, U) {
    var Z, Q, ee;
    if (l(T), Q = E._events, Q === void 0 ? (Q = E._events = /* @__PURE__ */ Object.create(null), E._eventsCount = 0) : (Q.newListener !== void 0 && (E.emit(
      "newListener",
      C,
      T.listener ? T.listener : T
    ), Q = E._events), ee = Q[C]), ee === void 0)
      ee = Q[C] = T, ++E._eventsCount;
    else if (typeof ee == "function" ? ee = Q[C] = U ? [T, ee] : [ee, T] : U ? ee.unshift(T) : ee.push(T), Z = u(E), Z > 0 && ee.length > Z && !ee.warned) {
      ee.warned = !0;
      var J = new Error("Possible EventEmitter memory leak detected. " + ee.length + " " + String(C) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      J.name = "MaxListenersExceededWarning", J.emitter = E, J.type = C, J.count = ee.length, i(J);
    }
    return E;
  }
  o.prototype.addListener = function(C, T) {
    return m(this, C, T, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(C, T) {
    return m(this, C, T, !0);
  };
  function d() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(E, C, T) {
    var U = { fired: !1, wrapFn: void 0, target: E, type: C, listener: T }, Z = d.bind(U);
    return Z.listener = T, U.wrapFn = Z, Z;
  }
  o.prototype.once = function(C, T) {
    return l(T), this.on(C, f(this, C, T)), this;
  }, o.prototype.prependOnceListener = function(C, T) {
    return l(T), this.prependListener(C, f(this, C, T)), this;
  }, o.prototype.removeListener = function(C, T) {
    var U, Z, Q, ee, J;
    if (l(T), Z = this._events, Z === void 0)
      return this;
    if (U = Z[C], U === void 0)
      return this;
    if (U === T || U.listener === T)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete Z[C], Z.removeListener && this.emit("removeListener", C, U.listener || T));
    else if (typeof U != "function") {
      for (Q = -1, ee = U.length - 1; ee >= 0; ee--)
        if (U[ee] === T || U[ee].listener === T) {
          J = U[ee].listener, Q = ee;
          break;
        }
      if (Q < 0)
        return this;
      Q === 0 ? U.shift() : S(U, Q), U.length === 1 && (Z[C] = U[0]), Z.removeListener !== void 0 && this.emit("removeListener", C, J || T);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(C) {
    var T, U, Z;
    if (U = this._events, U === void 0)
      return this;
    if (U.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : U[C] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete U[C]), this;
    if (arguments.length === 0) {
      var Q = Object.keys(U), ee;
      for (Z = 0; Z < Q.length; ++Z)
        ee = Q[Z], ee !== "removeListener" && this.removeAllListeners(ee);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (T = U[C], typeof T == "function")
      this.removeListener(C, T);
    else if (T !== void 0)
      for (Z = T.length - 1; Z >= 0; Z--)
        this.removeListener(C, T[Z]);
    return this;
  };
  function h(E, C, T) {
    var U = E._events;
    if (U === void 0)
      return [];
    var Z = U[C];
    return Z === void 0 ? [] : typeof Z == "function" ? T ? [Z.listener || Z] : [Z] : T ? N(Z) : x(Z, Z.length);
  }
  o.prototype.listeners = function(C) {
    return h(this, C, !0);
  }, o.prototype.rawListeners = function(C) {
    return h(this, C, !1);
  }, o.listenerCount = function(E, C) {
    return typeof E.listenerCount == "function" ? E.listenerCount(C) : v.call(E, C);
  }, o.prototype.listenerCount = v;
  function v(E) {
    var C = this._events;
    if (C !== void 0) {
      var T = C[E];
      if (typeof T == "function")
        return 1;
      if (T !== void 0)
        return T.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? t(this._events) : [];
  };
  function x(E, C) {
    for (var T = new Array(C), U = 0; U < C; ++U)
      T[U] = E[U];
    return T;
  }
  function S(E, C) {
    for (; C + 1 < E.length; C++)
      E[C] = E[C + 1];
    E.pop();
  }
  function N(E) {
    for (var C = new Array(E.length), T = 0; T < C.length; ++T)
      C[T] = E[T].listener || E[T];
    return C;
  }
  function j(E, C) {
    return new Promise(function(T, U) {
      function Z(ee) {
        E.removeListener(C, Q), U(ee);
      }
      function Q() {
        typeof E.removeListener == "function" && E.removeListener("error", Z), T([].slice.call(arguments));
      }
      q(E, C, Q, { once: !0 }), C !== "error" && y(E, Z, { once: !0 });
    });
  }
  function y(E, C, T) {
    typeof E.on == "function" && q(E, "error", C, T);
  }
  function q(E, C, T, U) {
    if (typeof E.on == "function")
      U.once ? E.once(C, T) : E.on(C, T);
    else if (typeof E.addEventListener == "function")
      E.addEventListener(C, function Z(Q) {
        U.once && E.removeEventListener(C, Z), T(Q);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof E);
  }
  return kl.exports;
}
var _ne = bne();
function Xne() {
  const e = new _ne.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  LM as GraphQLClientProvider,
  uC as IntegrationModal,
  Jne as PartnerIntegrations,
  Qne as PartnerIntegrationsSettings,
  cne as createWidgetConfigurationMutation,
  une as deleteWidgetConfigurationMutation,
  sne as getWidgetConfigurationByIdQuery,
  jF as getWidgetDefinitions,
  Xne as initializePartnerEventEmitter,
  lne as updateWidgetConfigurationMutation,
  BM as usePartnerIntegrationWidgetConfigurations
};
